/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LoginImport } from './routes/login'
import { Route as ChangePasswordImport } from './routes/change-password'
import { Route as AuthImport } from './routes/_auth'
import { Route as AuthIndexImport } from './routes/_auth/index'
import { Route as AuthSyncScopusImport } from './routes/_auth/sync-scopus'
import { Route as AuthSyncBibtexImport } from './routes/_auth/sync-bibtex'
import { Route as AuthTravelTravelImport } from './routes/_auth/travel/_travel'
import { Route as AuthResearchPerfEvalLayoutImport } from './routes/_auth/research-perf-eval/_layout'
import { Route as AuthResearchCenterResearchCenterImport } from './routes/_auth/research-center/_research-center'
import { Route as AuthReportReportImport } from './routes/_auth/report/_report'
import { Route as AuthPublisherPublisherImport } from './routes/_auth/publisher/_publisher'
import { Route as AuthMinimalStandardsLayoutImport } from './routes/_auth/minimal-standards/_layout'
import { Route as AuthJournalJournalImport } from './routes/_auth/journal/_journal'
import { Route as AuthGovEvaluationLayoutImport } from './routes/_auth/gov-evaluation/_layout'
import { Route as AuthEvaluationLayoutImport } from './routes/_auth/evaluation/_layout'
import { Route as AuthConferenceConferenceImport } from './routes/_auth/conference/_conference'
import { Route as AuthAuthorAuthorImport } from './routes/_auth/author/_author'
import { Route as AuthAdministrationAdministrationImport } from './routes/_auth/administration/_administration'
import { Route as AuthTravelTravelIndexImport } from './routes/_auth/travel/_travel/index'
import { Route as AuthResearchPerfEvalLayoutIndexImport } from './routes/_auth/research-perf-eval/_layout/index'
import { Route as AuthResearchCenterResearchCenterIndexImport } from './routes/_auth/research-center/_research-center/index'
import { Route as AuthReportReportIndexImport } from './routes/_auth/report/_report/index'
import { Route as AuthPublisherPublisherIndexImport } from './routes/_auth/publisher/_publisher/index'
import { Route as AuthMinimalStandardsLayoutIndexImport } from './routes/_auth/minimal-standards/_layout/index'
import { Route as AuthJournalJournalIndexImport } from './routes/_auth/journal/_journal/index'
import { Route as AuthGovEvaluationLayoutIndexImport } from './routes/_auth/gov-evaluation/_layout/index'
import { Route as AuthEvaluationLayoutIndexImport } from './routes/_auth/evaluation/_layout/index'
import { Route as AuthConferenceConferenceIndexImport } from './routes/_auth/conference/_conference/index'
import { Route as AuthAuthorAuthorIndexImport } from './routes/_auth/author/_author/index'
import { Route as AuthAdministrationAdministrationIndexImport } from './routes/_auth/administration/_administration/index'
import { Route as AuthResearchCenterResearchCenterCreateImport } from './routes/_auth/research-center/_research-center/create'
import { Route as AuthReportReportAnalyticsImport } from './routes/_auth/report/_report/analytics'
import { Route as AuthPublisherPublisherCreateImport } from './routes/_auth/publisher/_publisher/create'
import { Route as AuthJournalJournalCreateImport } from './routes/_auth/journal/_journal/create'
import { Route as AuthConferenceConferenceCreateImport } from './routes/_auth/conference/_conference/create'
import { Route as AuthAuthorAuthorWosIsiReportImport } from './routes/_auth/author/_author/wos-isi-report'
import { Route as AuthTravelTravelSettingsIndexImport } from './routes/_auth/travel/_travel/settings/index'
import { Route as AuthTravelTravelRequestsIndexImport } from './routes/_auth/travel/_travel/requests/index'
import { Route as AuthTravelTravelRegistryIndexImport } from './routes/_auth/travel/_travel/registry/index'
import { Route as AuthTravelTravelDocumentsIndexImport } from './routes/_auth/travel/_travel/documents/index'
import { Route as AuthTravelTravelDaysIndexImport } from './routes/_auth/travel/_travel/days/index'
import { Route as AuthTravelTravelBoardRequestsIndexImport } from './routes/_auth/travel/_travel/board-requests/index'
import { Route as AuthTravelTravelApprovalsIndexImport } from './routes/_auth/travel/_travel/approvals/index'
import { Route as AuthTravelTravelAnalyticsIndexImport } from './routes/_auth/travel/_travel/analytics/index'
import { Route as AuthTravelTravelRequestsCreateImport } from './routes/_auth/travel/_travel/requests/create'
import { Route as AuthResearchPerfEvalLayoutEvaluationIdLayoutImport } from './routes/_auth/research-perf-eval/_layout/$evaluationId/_layout'
import { Route as AuthResearchCenterResearchCenterResearchCenterIdLayoutImport } from './routes/_auth/research-center/_research-center/$researchCenterId/_layout'
import { Route as AuthPublisherPublisherPublisherIdLayoutImport } from './routes/_auth/publisher/_publisher/$publisherId/_layout'
import { Route as AuthJournalJournalJournalIdLayoutImport } from './routes/_auth/journal/_journal/$journalId/_layout'
import { Route as AuthGovEvaluationLayoutEvaluationIdLayoutImport } from './routes/_auth/gov-evaluation/_layout/$evaluationId/_layout'
import { Route as AuthEvaluationLayoutEvaluationIdFacultySummaryResultsImport } from './routes/_auth/evaluation/_layout/$evaluationId/faculty-summary-results'
import { Route as AuthEvaluationLayoutEvaluationIdDepartmentSummaryResultsImport } from './routes/_auth/evaluation/_layout/$evaluationId/department-summary-results'
import { Route as AuthEvaluationLayoutEvaluationIdLayoutImport } from './routes/_auth/evaluation/_layout/$evaluationId/_layout'
import { Route as AuthConferenceConferenceConferenceIdLayoutImport } from './routes/_auth/conference/_conference/$conferenceId/_layout'
import { Route as AuthAuthorAuthorTranslationTranslationImport } from './routes/_auth/author/_author/translation/_translation'
import { Route as AuthAuthorAuthorTechnologicalTransferTechnologicalTransferImport } from './routes/_auth/author/_author/technological-transfer/_technologicalTransfer'
import { Route as AuthAuthorAuthorReviewReviewImport } from './routes/_auth/author/_author/review/_review'
import { Route as AuthAuthorAuthorProjectProjectImport } from './routes/_auth/author/_author/project/_project'
import { Route as AuthAuthorAuthorProceedingProceedingImport } from './routes/_auth/author/_author/proceeding/_proceeding'
import { Route as AuthAuthorAuthorPresentationPresentationImport } from './routes/_auth/author/_author/presentation/_presentation'
import { Route as AuthAuthorAuthorPatentPatentImport } from './routes/_auth/author/_author/patent/_patent'
import { Route as AuthAuthorAuthorMobilityMobilityImport } from './routes/_auth/author/_author/mobility/_mobility'
import { Route as AuthAuthorAuthorEditorialTeamEditorialTeamImport } from './routes/_auth/author/_author/editorial-team/_editorialTeam'
import { Route as AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeImport } from './routes/_auth/author/_author/doctoral-committee/_doctoralCommittee'
import { Route as AuthAuthorAuthorDictionaryDictionaryImport } from './routes/_auth/author/_author/dictionary/_dictionary'
import { Route as AuthAuthorAuthorCourseCourseImport } from './routes/_auth/author/_author/course/_course'
import { Route as AuthAuthorAuthorCommitteeCommitteeImport } from './routes/_auth/author/_author/committee/_committee'
import { Route as AuthAuthorAuthorChapterChapterImport } from './routes/_auth/author/_author/chapter/_chapter'
import { Route as AuthAuthorAuthorBookBookImport } from './routes/_auth/author/_author/book/_book'
import { Route as AuthAuthorAuthorAwardAwardImport } from './routes/_auth/author/_author/award/_award'
import { Route as AuthAuthorAuthorArticleArticleImport } from './routes/_auth/author/_author/article/_article'
import { Route as AuthAuthorAuthorAbstractAbstractImport } from './routes/_auth/author/_author/abstract/_abstract'
import { Route as AuthAdministrationAdministrationUserDocumentsUserDocumentsImport } from './routes/_auth/administration/_administration/user-documents/_user-documents'
import { Route as AuthAdministrationAdministrationUniversityConfigUniversityConfigImport } from './routes/_auth/administration/_administration/university-config/_university-config'
import { Route as AuthAdministrationAdministrationLocalAccountsLocalAccountsImport } from './routes/_auth/administration/_administration/local-accounts/_local-accounts'
import { Route as AuthAdministrationAdministrationLegalHolidayLegalHolidayImport } from './routes/_auth/administration/_administration/legal-holiday/_legal-holiday'
import { Route as AuthAdministrationAdministrationFacultyFacultyImport } from './routes/_auth/administration/_administration/faculty/_faculty'
import { Route as AuthAdministrationAdministrationDisciplineDisciplineImport } from './routes/_auth/administration/_administration/discipline/_discipline'
import { Route as AuthAdministrationAdministrationDepartmentDepartmentImport } from './routes/_auth/administration/_administration/department/_department'
import { Route as AuthResearchPerfEvalLayoutEvaluationIdLayoutIndexImport } from './routes/_auth/research-perf-eval/_layout/$evaluationId/_layout/index'
import { Route as AuthResearchCenterResearchCenterResearchCenterIdLayoutIndexImport } from './routes/_auth/research-center/_research-center/$researchCenterId/_layout/index'
import { Route as AuthPublisherPublisherPublisherIdLayoutIndexImport } from './routes/_auth/publisher/_publisher/$publisherId/_layout/index'
import { Route as AuthJournalJournalJournalIdLayoutIndexImport } from './routes/_auth/journal/_journal/$journalId/_layout/index'
import { Route as AuthGovEvaluationLayoutEvaluationIdLayoutIndexImport } from './routes/_auth/gov-evaluation/_layout/$evaluationId/_layout/index'
import { Route as AuthEvaluationLayoutEvaluationIdLayoutIndexImport } from './routes/_auth/evaluation/_layout/$evaluationId/_layout/index'
import { Route as AuthConferenceConferenceConferenceIdLayoutIndexImport } from './routes/_auth/conference/_conference/$conferenceId/_layout/index'
import { Route as AuthAuthorAuthorTranslationTranslationIndexImport } from './routes/_auth/author/_author/translation/_translation/index'
import { Route as AuthAuthorAuthorTechnologicalTransferTechnologicalTransferIndexImport } from './routes/_auth/author/_author/technological-transfer/_technologicalTransfer/index'
import { Route as AuthAuthorAuthorReviewReviewIndexImport } from './routes/_auth/author/_author/review/_review/index'
import { Route as AuthAuthorAuthorProjectProjectIndexImport } from './routes/_auth/author/_author/project/_project/index'
import { Route as AuthAuthorAuthorProceedingProceedingIndexImport } from './routes/_auth/author/_author/proceeding/_proceeding/index'
import { Route as AuthAuthorAuthorPresentationPresentationIndexImport } from './routes/_auth/author/_author/presentation/_presentation/index'
import { Route as AuthAuthorAuthorPatentPatentIndexImport } from './routes/_auth/author/_author/patent/_patent/index'
import { Route as AuthAuthorAuthorMobilityMobilityIndexImport } from './routes/_auth/author/_author/mobility/_mobility/index'
import { Route as AuthAuthorAuthorEditorialTeamEditorialTeamIndexImport } from './routes/_auth/author/_author/editorial-team/_editorialTeam/index'
import { Route as AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeIndexImport } from './routes/_auth/author/_author/doctoral-committee/_doctoralCommittee/index'
import { Route as AuthAuthorAuthorDictionaryDictionaryIndexImport } from './routes/_auth/author/_author/dictionary/_dictionary/index'
import { Route as AuthAuthorAuthorCourseCourseIndexImport } from './routes/_auth/author/_author/course/_course/index'
import { Route as AuthAuthorAuthorCommitteeCommitteeIndexImport } from './routes/_auth/author/_author/committee/_committee/index'
import { Route as AuthAuthorAuthorChapterChapterIndexImport } from './routes/_auth/author/_author/chapter/_chapter/index'
import { Route as AuthAuthorAuthorBookBookIndexImport } from './routes/_auth/author/_author/book/_book/index'
import { Route as AuthAuthorAuthorAwardAwardIndexImport } from './routes/_auth/author/_author/award/_award/index'
import { Route as AuthAuthorAuthorArticleArticleIndexImport } from './routes/_auth/author/_author/article/_article/index'
import { Route as AuthAuthorAuthorAbstractAbstractIndexImport } from './routes/_auth/author/_author/abstract/_abstract/index'
import { Route as AuthAdministrationAdministrationUserDocumentsUserDocumentsIndexImport } from './routes/_auth/administration/_administration/user-documents/_user-documents/index'
import { Route as AuthAdministrationAdministrationUniversityConfigUniversityConfigIndexImport } from './routes/_auth/administration/_administration/university-config/_university-config/index'
import { Route as AuthAdministrationAdministrationLocalAccountsLocalAccountsIndexImport } from './routes/_auth/administration/_administration/local-accounts/_local-accounts/index'
import { Route as AuthAdministrationAdministrationLegalHolidayLegalHolidayIndexImport } from './routes/_auth/administration/_administration/legal-holiday/_legal-holiday/index'
import { Route as AuthAdministrationAdministrationFacultyFacultyIndexImport } from './routes/_auth/administration/_administration/faculty/_faculty/index'
import { Route as AuthAdministrationAdministrationDisciplineDisciplineIndexImport } from './routes/_auth/administration/_administration/discipline/_discipline/index'
import { Route as AuthAdministrationAdministrationDepartmentDepartmentIndexImport } from './routes/_auth/administration/_administration/department/_department/index'
import { Route as AuthTravelTravelRequestsRequestIdLayoutImport } from './routes/_auth/travel/_travel/requests/$requestId/_layout'
import { Route as AuthResearchCenterResearchCenterResearchCenterIdLayoutEditImport } from './routes/_auth/research-center/_research-center/$researchCenterId/_layout/edit'
import { Route as AuthResearchCenterResearchCenterResearchCenterIdLayoutCreateImport } from './routes/_auth/research-center/_research-center/$researchCenterId/_layout/create'
import { Route as AuthPublisherPublisherPublisherIdLayoutEditImport } from './routes/_auth/publisher/_publisher/$publisherId/_layout/edit'
import { Route as AuthMinimalStandardsLayoutReportGatherGatherImport } from './routes/_auth/minimal-standards/_layout/report/gather/_gather'
import { Route as AuthJournalJournalJournalIdLayoutImpactFactorImport } from './routes/_auth/journal/_journal/$journalId/_layout/impact-factor'
import { Route as AuthJournalJournalJournalIdLayoutEditImport } from './routes/_auth/journal/_journal/$journalId/_layout/edit'
import { Route as AuthJournalJournalJournalIdLayoutArticleInfluenceScoreImport } from './routes/_auth/journal/_journal/$journalId/_layout/article-influence-score'
import { Route as AuthConferenceConferenceConferenceIdLayoutEditImport } from './routes/_auth/conference/_conference/$conferenceId/_layout/edit'
import { Route as AuthAuthorAuthorTranslationTranslationSearchClaimableImport } from './routes/_auth/author/_author/translation/_translation/search-claimable'
import { Route as AuthAuthorAuthorTranslationTranslationCreateImport } from './routes/_auth/author/_author/translation/_translation/create'
import { Route as AuthAuthorAuthorTechnologicalTransferTechnologicalTransferSearchClaimableImport } from './routes/_auth/author/_author/technological-transfer/_technologicalTransfer/search-claimable'
import { Route as AuthAuthorAuthorTechnologicalTransferTechnologicalTransferCreateImport } from './routes/_auth/author/_author/technological-transfer/_technologicalTransfer/create'
import { Route as AuthAuthorAuthorReviewReviewSearchClaimableImport } from './routes/_auth/author/_author/review/_review/search-claimable'
import { Route as AuthAuthorAuthorReviewReviewCreateImport } from './routes/_auth/author/_author/review/_review/create'
import { Route as AuthAuthorAuthorProjectProjectSearchClaimableImport } from './routes/_auth/author/_author/project/_project/search-claimable'
import { Route as AuthAuthorAuthorProjectProjectCreateImport } from './routes/_auth/author/_author/project/_project/create'
import { Route as AuthAuthorAuthorProceedingProceedingSearchClaimableImport } from './routes/_auth/author/_author/proceeding/_proceeding/search-claimable'
import { Route as AuthAuthorAuthorProceedingProceedingCreateImport } from './routes/_auth/author/_author/proceeding/_proceeding/create'
import { Route as AuthAuthorAuthorPresentationPresentationCreateImport } from './routes/_auth/author/_author/presentation/_presentation/create'
import { Route as AuthAuthorAuthorPatentPatentSearchClaimableImport } from './routes/_auth/author/_author/patent/_patent/search-claimable'
import { Route as AuthAuthorAuthorPatentPatentCreateImport } from './routes/_auth/author/_author/patent/_patent/create'
import { Route as AuthAuthorAuthorMobilityMobilityCreateImport } from './routes/_auth/author/_author/mobility/_mobility/create'
import { Route as AuthAuthorAuthorEditorialTeamEditorialTeamCreateImport } from './routes/_auth/author/_author/editorial-team/_editorialTeam/create'
import { Route as AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeCreateImport } from './routes/_auth/author/_author/doctoral-committee/_doctoralCommittee/create'
import { Route as AuthAuthorAuthorDictionaryDictionaryCreateImport } from './routes/_auth/author/_author/dictionary/_dictionary/create'
import { Route as AuthAuthorAuthorCourseCourseCreateImport } from './routes/_auth/author/_author/course/_course/create'
import { Route as AuthAuthorAuthorCommitteeCommitteeCreateImport } from './routes/_auth/author/_author/committee/_committee/create'
import { Route as AuthAuthorAuthorChapterChapterSearchClaimableImport } from './routes/_auth/author/_author/chapter/_chapter/search-claimable'
import { Route as AuthAuthorAuthorChapterChapterCreateImport } from './routes/_auth/author/_author/chapter/_chapter/create'
import { Route as AuthAuthorAuthorBookBookSearchClaimableImport } from './routes/_auth/author/_author/book/_book/search-claimable'
import { Route as AuthAuthorAuthorBookBookCreateImport } from './routes/_auth/author/_author/book/_book/create'
import { Route as AuthAuthorAuthorAwardAwardCreateImport } from './routes/_auth/author/_author/award/_award/create'
import { Route as AuthAuthorAuthorArticleArticleSearchClaimableImport } from './routes/_auth/author/_author/article/_article/search-claimable'
import { Route as AuthAuthorAuthorArticleArticleCreateImport } from './routes/_auth/author/_author/article/_article/create'
import { Route as AuthAuthorAuthorAbstractAbstractSearchClaimableImport } from './routes/_auth/author/_author/abstract/_abstract/search-claimable'
import { Route as AuthAuthorAuthorAbstractAbstractCreateImport } from './routes/_auth/author/_author/abstract/_abstract/create'
import { Route as AuthAdministrationAdministrationFacultyFacultyCreateImport } from './routes/_auth/administration/_administration/faculty/_faculty/create'
import { Route as AuthAdministrationAdministrationDisciplineDisciplineCreateImport } from './routes/_auth/administration/_administration/discipline/_discipline/create'
import { Route as AuthAdministrationAdministrationDepartmentDepartmentCreateImport } from './routes/_auth/administration/_administration/department/_department/create'
import { Route as AuthTravelTravelRequestsRequestIdLayoutIndexImport } from './routes/_auth/travel/_travel/requests/$requestId/_layout/index'
import { Route as AuthMinimalStandardsLayoutReportGatherGatherIndexImport } from './routes/_auth/minimal-standards/_layout/report/gather/_gather/index'
import { Route as AuthTravelTravelRequestsRequestIdLayoutEditImport } from './routes/_auth/travel/_travel/requests/$requestId/_layout/edit'
import { Route as AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutImport } from './routes/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout'
import { Route as AuthAuthorAuthorTranslationTranslationTranslationIdLayoutImport } from './routes/_auth/author/_author/translation/_translation/$translationId/_layout'
import { Route as AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutImport } from './routes/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout'
import { Route as AuthAuthorAuthorReviewReviewReviewIdLayoutImport } from './routes/_auth/author/_author/review/_review/$reviewId/_layout'
import { Route as AuthAuthorAuthorProjectProjectProjectIdLayoutImport } from './routes/_auth/author/_author/project/_project/$projectId/_layout'
import { Route as AuthAuthorAuthorProceedingProceedingProceedingIdLayoutImport } from './routes/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout'
import { Route as AuthAuthorAuthorPresentationPresentationPresentationIdLayoutImport } from './routes/_auth/author/_author/presentation/_presentation/$presentationId/_layout'
import { Route as AuthAuthorAuthorPatentPatentPatentIdLayoutImport } from './routes/_auth/author/_author/patent/_patent/$patentId/_layout'
import { Route as AuthAuthorAuthorMobilityMobilityMobilityIdLayoutImport } from './routes/_auth/author/_author/mobility/_mobility/$mobilityId/_layout'
import { Route as AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutImport } from './routes/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout'
import { Route as AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutImport } from './routes/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout'
import { Route as AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutImport } from './routes/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout'
import { Route as AuthAuthorAuthorCourseCourseCourseIdLayoutImport } from './routes/_auth/author/_author/course/_course/$courseId/_layout'
import { Route as AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutImport } from './routes/_auth/author/_author/committee/_committee/$committeeId/_layout'
import { Route as AuthAuthorAuthorChapterChapterChapterIdLayoutImport } from './routes/_auth/author/_author/chapter/_chapter/$chapterId/_layout'
import { Route as AuthAuthorAuthorBookBookBookIdLayoutImport } from './routes/_auth/author/_author/book/_book/$bookId/_layout'
import { Route as AuthAuthorAuthorAwardAwardAwardIdLayoutImport } from './routes/_auth/author/_author/award/_award/$awardId/_layout'
import { Route as AuthAuthorAuthorArticleArticleArticleIdLayoutImport } from './routes/_auth/author/_author/article/_article/$articleId/_layout'
import { Route as AuthAuthorAuthorAbstractAbstractAbstractIdLayoutImport } from './routes/_auth/author/_author/abstract/_abstract/$abstractId/_layout'
import { Route as AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutImport } from './routes/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout'
import { Route as AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutImport } from './routes/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout'
import { Route as AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutImport } from './routes/_auth/administration/_administration/department/_department/$departmentId/_layout'
import { Route as AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutIndexImport } from './routes/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/index'
import { Route as AuthAuthorAuthorTranslationTranslationTranslationIdLayoutIndexImport } from './routes/_auth/author/_author/translation/_translation/$translationId/_layout/index'
import { Route as AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutIndexImport } from './routes/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout/index'
import { Route as AuthAuthorAuthorReviewReviewReviewIdLayoutIndexImport } from './routes/_auth/author/_author/review/_review/$reviewId/_layout/index'
import { Route as AuthAuthorAuthorProjectProjectProjectIdLayoutIndexImport } from './routes/_auth/author/_author/project/_project/$projectId/_layout/index'
import { Route as AuthAuthorAuthorProceedingProceedingProceedingIdLayoutIndexImport } from './routes/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/index'
import { Route as AuthAuthorAuthorPresentationPresentationPresentationIdLayoutIndexImport } from './routes/_auth/author/_author/presentation/_presentation/$presentationId/_layout/index'
import { Route as AuthAuthorAuthorPatentPatentPatentIdLayoutIndexImport } from './routes/_auth/author/_author/patent/_patent/$patentId/_layout/index'
import { Route as AuthAuthorAuthorMobilityMobilityMobilityIdLayoutIndexImport } from './routes/_auth/author/_author/mobility/_mobility/$mobilityId/_layout/index'
import { Route as AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutIndexImport } from './routes/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout/index'
import { Route as AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutIndexImport } from './routes/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout/index'
import { Route as AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutIndexImport } from './routes/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout/index'
import { Route as AuthAuthorAuthorCourseCourseCourseIdLayoutIndexImport } from './routes/_auth/author/_author/course/_course/$courseId/_layout/index'
import { Route as AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutIndexImport } from './routes/_auth/author/_author/committee/_committee/$committeeId/_layout/index'
import { Route as AuthAuthorAuthorChapterChapterChapterIdLayoutIndexImport } from './routes/_auth/author/_author/chapter/_chapter/$chapterId/_layout/index'
import { Route as AuthAuthorAuthorBookBookBookIdLayoutIndexImport } from './routes/_auth/author/_author/book/_book/$bookId/_layout/index'
import { Route as AuthAuthorAuthorAwardAwardAwardIdLayoutIndexImport } from './routes/_auth/author/_author/award/_award/$awardId/_layout/index'
import { Route as AuthAuthorAuthorArticleArticleArticleIdLayoutIndexImport } from './routes/_auth/author/_author/article/_article/$articleId/_layout/index'
import { Route as AuthAuthorAuthorAbstractAbstractAbstractIdLayoutIndexImport } from './routes/_auth/author/_author/abstract/_abstract/$abstractId/_layout/index'
import { Route as AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutIndexImport } from './routes/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout/index'
import { Route as AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutIndexImport } from './routes/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout/index'
import { Route as AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutIndexImport } from './routes/_auth/administration/_administration/department/_department/$departmentId/_layout/index'
import { Route as AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherImport } from './routes/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather'
import { Route as AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutImport } from './routes/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode/_layout'
import { Route as AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherImport } from './routes/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather'
import { Route as AuthAuthorAuthorTranslationTranslationTranslationIdLayoutEditImport } from './routes/_auth/author/_author/translation/_translation/$translationId/_layout/edit'
import { Route as AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutEditImport } from './routes/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout/edit'
import { Route as AuthAuthorAuthorReviewReviewReviewIdLayoutEditImport } from './routes/_auth/author/_author/review/_review/$reviewId/_layout/edit'
import { Route as AuthAuthorAuthorProjectProjectProjectIdLayoutEditImport } from './routes/_auth/author/_author/project/_project/$projectId/_layout/edit'
import { Route as AuthAuthorAuthorProceedingProceedingProceedingIdLayoutEditImport } from './routes/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/edit'
import { Route as AuthAuthorAuthorPresentationPresentationPresentationIdLayoutEditImport } from './routes/_auth/author/_author/presentation/_presentation/$presentationId/_layout/edit'
import { Route as AuthAuthorAuthorPatentPatentPatentIdLayoutEditImport } from './routes/_auth/author/_author/patent/_patent/$patentId/_layout/edit'
import { Route as AuthAuthorAuthorMobilityMobilityMobilityIdLayoutEditImport } from './routes/_auth/author/_author/mobility/_mobility/$mobilityId/_layout/edit'
import { Route as AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutEditImport } from './routes/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout/edit'
import { Route as AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutEditImport } from './routes/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout/edit'
import { Route as AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutEditImport } from './routes/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout/edit'
import { Route as AuthAuthorAuthorCourseCourseCourseIdLayoutEditImport } from './routes/_auth/author/_author/course/_course/$courseId/_layout/edit'
import { Route as AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutEditImport } from './routes/_auth/author/_author/committee/_committee/$committeeId/_layout/edit'
import { Route as AuthAuthorAuthorChapterChapterChapterIdLayoutEditImport } from './routes/_auth/author/_author/chapter/_chapter/$chapterId/_layout/edit'
import { Route as AuthAuthorAuthorBookBookBookIdLayoutEditImport } from './routes/_auth/author/_author/book/_book/$bookId/_layout/edit'
import { Route as AuthAuthorAuthorAwardAwardAwardIdLayoutEditImport } from './routes/_auth/author/_author/award/_award/$awardId/_layout/edit'
import { Route as AuthAuthorAuthorArticleArticleArticleIdLayoutEditImport } from './routes/_auth/author/_author/article/_article/$articleId/_layout/edit'
import { Route as AuthAuthorAuthorAbstractAbstractAbstractIdLayoutEditImport } from './routes/_auth/author/_author/abstract/_abstract/$abstractId/_layout/edit'
import { Route as AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutEditImport } from './routes/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout/edit'
import { Route as AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutEditImport } from './routes/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout/edit'
import { Route as AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutEditImport } from './routes/_auth/administration/_administration/department/_department/$departmentId/_layout/edit'
import { Route as AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherIndexImport } from './routes/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/index'
import { Route as AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutIndexImport } from './routes/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode/_layout/index'
import { Route as AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherIndexImport } from './routes/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/index'
import { Route as AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsIndexImport } from './routes/_auth/author/_author/translation/_translation/$translationId/_layout/citations/index'
import { Route as AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsIndexImport } from './routes/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/index'
import { Route as AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsIndexImport } from './routes/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/index'
import { Route as AuthAuthorAuthorBookBookBookIdLayoutCitationsIndexImport } from './routes/_auth/author/_author/book/_book/$bookId/_layout/citations/index'
import { Route as AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsIndexImport } from './routes/_auth/author/_author/article/_article/$articleId/_layout/citations/index'
import { Route as AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsIndexImport } from './routes/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/index'
import { Route as AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutImport } from './routes/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout'
import { Route as AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCreateImport } from './routes/_auth/author/_author/translation/_translation/$translationId/_layout/citations/create'
import { Route as AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCreateImport } from './routes/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/create'
import { Route as AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCreateImport } from './routes/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/create'
import { Route as AuthAuthorAuthorBookBookBookIdLayoutCitationsCreateImport } from './routes/_auth/author/_author/book/_book/$bookId/_layout/citations/create'
import { Route as AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCreateImport } from './routes/_auth/author/_author/article/_article/$articleId/_layout/citations/create'
import { Route as AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCreateImport } from './routes/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/create'
import { Route as AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutIndexImport } from './routes/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout/index'
import { Route as AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutImport } from './routes/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout'
import { Route as AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutEditImport } from './routes/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout/edit'
import { Route as AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutImport } from './routes/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout'
import { Route as AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutImport } from './routes/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout'
import { Route as AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutImport } from './routes/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout'
import { Route as AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutImport } from './routes/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout'
import { Route as AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutImport } from './routes/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout'
import { Route as AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutImport } from './routes/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout'
import { Route as AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutImport } from './routes/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout'
import { Route as AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexImport } from './routes/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout/index'
import { Route as AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexImport } from './routes/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout/index'
import { Route as AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutIndexImport } from './routes/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout/index'
import { Route as AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutIndexImport } from './routes/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout/index'
import { Route as AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutIndexImport } from './routes/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout/index'
import { Route as AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutIndexImport } from './routes/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout/index'
import { Route as AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutIndexImport } from './routes/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout/index'
import { Route as AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutIndexImport } from './routes/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout/index'
import { Route as AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutEditImport } from './routes/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout/edit'
import { Route as AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutEditImport } from './routes/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout/edit'
import { Route as AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutEditImport } from './routes/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout/edit'
import { Route as AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutEditImport } from './routes/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout/edit'
import { Route as AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutEditImport } from './routes/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout/edit'
import { Route as AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutEditImport } from './routes/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout/edit'

// Create Virtual Routes

const AuthTravelImport = createFileRoute('/_auth/travel')()
const AuthResearchPerfEvalImport = createFileRoute(
  '/_auth/research-perf-eval',
)()
const AuthResearchCenterImport = createFileRoute('/_auth/research-center')()
const AuthReportImport = createFileRoute('/_auth/report')()
const AuthPublisherImport = createFileRoute('/_auth/publisher')()
const AuthMinimalStandardsImport = createFileRoute('/_auth/minimal-standards')()
const AuthJournalImport = createFileRoute('/_auth/journal')()
const AuthGovEvaluationImport = createFileRoute('/_auth/gov-evaluation')()
const AuthEvaluationImport = createFileRoute('/_auth/evaluation')()
const AuthConferenceImport = createFileRoute('/_auth/conference')()
const AuthAuthorImport = createFileRoute('/_auth/author')()
const AuthAdministrationImport = createFileRoute('/_auth/administration')()
const AuthResearchPerfEvalLayoutEvaluationIdImport = createFileRoute(
  '/_auth/research-perf-eval/_layout/$evaluationId',
)()
const AuthResearchCenterResearchCenterResearchCenterIdImport = createFileRoute(
  '/_auth/research-center/_research-center/$researchCenterId',
)()
const AuthPublisherPublisherPublisherIdImport = createFileRoute(
  '/_auth/publisher/_publisher/$publisherId',
)()
const AuthJournalJournalJournalIdImport = createFileRoute(
  '/_auth/journal/_journal/$journalId',
)()
const AuthGovEvaluationLayoutEvaluationIdImport = createFileRoute(
  '/_auth/gov-evaluation/_layout/$evaluationId',
)()
const AuthEvaluationLayoutEvaluationIdImport = createFileRoute(
  '/_auth/evaluation/_layout/$evaluationId',
)()
const AuthConferenceConferenceConferenceIdImport = createFileRoute(
  '/_auth/conference/_conference/$conferenceId',
)()
const AuthAuthorAuthorTranslationImport = createFileRoute(
  '/_auth/author/_author/translation',
)()
const AuthAuthorAuthorTechnologicalTransferImport = createFileRoute(
  '/_auth/author/_author/technological-transfer',
)()
const AuthAuthorAuthorReviewImport = createFileRoute(
  '/_auth/author/_author/review',
)()
const AuthAuthorAuthorProjectImport = createFileRoute(
  '/_auth/author/_author/project',
)()
const AuthAuthorAuthorProceedingImport = createFileRoute(
  '/_auth/author/_author/proceeding',
)()
const AuthAuthorAuthorPresentationImport = createFileRoute(
  '/_auth/author/_author/presentation',
)()
const AuthAuthorAuthorPatentImport = createFileRoute(
  '/_auth/author/_author/patent',
)()
const AuthAuthorAuthorMobilityImport = createFileRoute(
  '/_auth/author/_author/mobility',
)()
const AuthAuthorAuthorEditorialTeamImport = createFileRoute(
  '/_auth/author/_author/editorial-team',
)()
const AuthAuthorAuthorDoctoralCommitteeImport = createFileRoute(
  '/_auth/author/_author/doctoral-committee',
)()
const AuthAuthorAuthorDictionaryImport = createFileRoute(
  '/_auth/author/_author/dictionary',
)()
const AuthAuthorAuthorCourseImport = createFileRoute(
  '/_auth/author/_author/course',
)()
const AuthAuthorAuthorCommitteeImport = createFileRoute(
  '/_auth/author/_author/committee',
)()
const AuthAuthorAuthorChapterImport = createFileRoute(
  '/_auth/author/_author/chapter',
)()
const AuthAuthorAuthorBookImport = createFileRoute(
  '/_auth/author/_author/book',
)()
const AuthAuthorAuthorAwardImport = createFileRoute(
  '/_auth/author/_author/award',
)()
const AuthAuthorAuthorArticleImport = createFileRoute(
  '/_auth/author/_author/article',
)()
const AuthAuthorAuthorAbstractImport = createFileRoute(
  '/_auth/author/_author/abstract',
)()
const AuthAdministrationAdministrationUserDocumentsImport = createFileRoute(
  '/_auth/administration/_administration/user-documents',
)()
const AuthAdministrationAdministrationUniversityConfigImport = createFileRoute(
  '/_auth/administration/_administration/university-config',
)()
const AuthAdministrationAdministrationLocalAccountsImport = createFileRoute(
  '/_auth/administration/_administration/local-accounts',
)()
const AuthAdministrationAdministrationLegalHolidayImport = createFileRoute(
  '/_auth/administration/_administration/legal-holiday',
)()
const AuthAdministrationAdministrationFacultyImport = createFileRoute(
  '/_auth/administration/_administration/faculty',
)()
const AuthAdministrationAdministrationDisciplineImport = createFileRoute(
  '/_auth/administration/_administration/discipline',
)()
const AuthAdministrationAdministrationDepartmentImport = createFileRoute(
  '/_auth/administration/_administration/department',
)()
const AuthTravelTravelRequestsRequestIdImport = createFileRoute(
  '/_auth/travel/_travel/requests/$requestId',
)()
const AuthMinimalStandardsLayoutReportGatherImport = createFileRoute(
  '/_auth/minimal-standards/_layout/report/gather',
)()
const AuthResearchCenterResearchCenterResearchCenterIdLayoutLabImport =
  createFileRoute(
    '/_auth/research-center/_research-center/$researchCenterId/_layout/lab',
  )()
const AuthAuthorAuthorTranslationTranslationTranslationIdImport =
  createFileRoute(
    '/_auth/author/_author/translation/_translation/$translationId',
  )()
const AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdImport =
  createFileRoute(
    '/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId',
  )()
const AuthAuthorAuthorReviewReviewReviewIdImport = createFileRoute(
  '/_auth/author/_author/review/_review/$reviewId',
)()
const AuthAuthorAuthorProjectProjectProjectIdImport = createFileRoute(
  '/_auth/author/_author/project/_project/$projectId',
)()
const AuthAuthorAuthorProceedingProceedingProceedingIdImport = createFileRoute(
  '/_auth/author/_author/proceeding/_proceeding/$proceedingId',
)()
const AuthAuthorAuthorPresentationPresentationPresentationIdImport =
  createFileRoute(
    '/_auth/author/_author/presentation/_presentation/$presentationId',
  )()
const AuthAuthorAuthorPatentPatentPatentIdImport = createFileRoute(
  '/_auth/author/_author/patent/_patent/$patentId',
)()
const AuthAuthorAuthorMobilityMobilityMobilityIdImport = createFileRoute(
  '/_auth/author/_author/mobility/_mobility/$mobilityId',
)()
const AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdImport =
  createFileRoute(
    '/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId',
  )()
const AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdImport =
  createFileRoute(
    '/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId',
  )()
const AuthAuthorAuthorDictionaryDictionaryDictionaryIdImport = createFileRoute(
  '/_auth/author/_author/dictionary/_dictionary/$dictionaryId',
)()
const AuthAuthorAuthorCourseCourseCourseIdImport = createFileRoute(
  '/_auth/author/_author/course/_course/$courseId',
)()
const AuthAuthorAuthorCommitteeCommitteeCommitteeIdImport = createFileRoute(
  '/_auth/author/_author/committee/_committee/$committeeId',
)()
const AuthAuthorAuthorChapterChapterChapterIdImport = createFileRoute(
  '/_auth/author/_author/chapter/_chapter/$chapterId',
)()
const AuthAuthorAuthorBookBookBookIdImport = createFileRoute(
  '/_auth/author/_author/book/_book/$bookId',
)()
const AuthAuthorAuthorAwardAwardAwardIdImport = createFileRoute(
  '/_auth/author/_author/award/_award/$awardId',
)()
const AuthAuthorAuthorArticleArticleArticleIdImport = createFileRoute(
  '/_auth/author/_author/article/_article/$articleId',
)()
const AuthAuthorAuthorAbstractAbstractAbstractIdImport = createFileRoute(
  '/_auth/author/_author/abstract/_abstract/$abstractId',
)()
const AuthAdministrationAdministrationFacultyFacultyFacultyIdImport =
  createFileRoute(
    '/_auth/administration/_administration/faculty/_faculty/$facultyId',
  )()
const AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdImport =
  createFileRoute(
    '/_auth/administration/_administration/discipline/_discipline/$disciplineId',
  )()
const AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdImport =
  createFileRoute(
    '/_auth/administration/_administration/department/_department/$departmentId',
  )()
const AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherImport =
  createFileRoute(
    '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather',
  )()
const AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeImport =
  createFileRoute(
    '/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode',
  )()
const AuthEvaluationLayoutEvaluationIdLayoutReportGatherImport =
  createFileRoute(
    '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather',
  )()
const AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdImport =
  createFileRoute(
    '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId',
  )()
const AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoImport =
  createFileRoute(
    '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo',
  )()
const AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoImport =
  createFileRoute(
    '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo',
  )()
const AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdImport =
  createFileRoute(
    '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId',
  )()
const AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdImport =
  createFileRoute(
    '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId',
  )()
const AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdImport =
  createFileRoute(
    '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId',
  )()
const AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdImport =
  createFileRoute(
    '/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId',
  )()
const AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdImport =
  createFileRoute(
    '/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId',
  )()
const AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdImport =
  createFileRoute(
    '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId',
  )()

// Create/Update Routes

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const ChangePasswordRoute = ChangePasswordImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const AuthTravelRoute = AuthTravelImport.update({
  id: '/travel',
  path: '/travel',
  getParentRoute: () => AuthRoute,
} as any)

const AuthResearchPerfEvalRoute = AuthResearchPerfEvalImport.update({
  id: '/research-perf-eval',
  path: '/research-perf-eval',
  getParentRoute: () => AuthRoute,
} as any)

const AuthResearchCenterRoute = AuthResearchCenterImport.update({
  id: '/research-center',
  path: '/research-center',
  getParentRoute: () => AuthRoute,
} as any)

const AuthReportRoute = AuthReportImport.update({
  id: '/report',
  path: '/report',
  getParentRoute: () => AuthRoute,
} as any)

const AuthPublisherRoute = AuthPublisherImport.update({
  id: '/publisher',
  path: '/publisher',
  getParentRoute: () => AuthRoute,
} as any)

const AuthMinimalStandardsRoute = AuthMinimalStandardsImport.update({
  id: '/minimal-standards',
  path: '/minimal-standards',
  getParentRoute: () => AuthRoute,
} as any)

const AuthJournalRoute = AuthJournalImport.update({
  id: '/journal',
  path: '/journal',
  getParentRoute: () => AuthRoute,
} as any)

const AuthGovEvaluationRoute = AuthGovEvaluationImport.update({
  id: '/gov-evaluation',
  path: '/gov-evaluation',
  getParentRoute: () => AuthRoute,
} as any)

const AuthEvaluationRoute = AuthEvaluationImport.update({
  id: '/evaluation',
  path: '/evaluation',
  getParentRoute: () => AuthRoute,
} as any)

const AuthConferenceRoute = AuthConferenceImport.update({
  id: '/conference',
  path: '/conference',
  getParentRoute: () => AuthRoute,
} as any)

const AuthAuthorRoute = AuthAuthorImport.update({
  id: '/author',
  path: '/author',
  getParentRoute: () => AuthRoute,
} as any)

const AuthAdministrationRoute = AuthAdministrationImport.update({
  id: '/administration',
  path: '/administration',
  getParentRoute: () => AuthRoute,
} as any)

const AuthIndexRoute = AuthIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSyncScopusRoute = AuthSyncScopusImport.update({
  id: '/sync-scopus',
  path: '/sync-scopus',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSyncBibtexRoute = AuthSyncBibtexImport.update({
  id: '/sync-bibtex',
  path: '/sync-bibtex',
  getParentRoute: () => AuthRoute,
} as any)

const AuthTravelTravelRoute = AuthTravelTravelImport.update({
  id: '/_travel',
  getParentRoute: () => AuthTravelRoute,
} as any)

const AuthResearchPerfEvalLayoutRoute = AuthResearchPerfEvalLayoutImport.update(
  {
    id: '/_layout',
    getParentRoute: () => AuthResearchPerfEvalRoute,
  } as any,
)

const AuthResearchCenterResearchCenterRoute =
  AuthResearchCenterResearchCenterImport.update({
    id: '/_research-center',
    getParentRoute: () => AuthResearchCenterRoute,
  } as any)

const AuthReportReportRoute = AuthReportReportImport.update({
  id: '/_report',
  getParentRoute: () => AuthReportRoute,
} as any)

const AuthPublisherPublisherRoute = AuthPublisherPublisherImport.update({
  id: '/_publisher',
  getParentRoute: () => AuthPublisherRoute,
} as any)

const AuthMinimalStandardsLayoutRoute = AuthMinimalStandardsLayoutImport.update(
  {
    id: '/_layout',
    getParentRoute: () => AuthMinimalStandardsRoute,
  } as any,
)

const AuthJournalJournalRoute = AuthJournalJournalImport.update({
  id: '/_journal',
  getParentRoute: () => AuthJournalRoute,
} as any)

const AuthGovEvaluationLayoutRoute = AuthGovEvaluationLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AuthGovEvaluationRoute,
} as any)

const AuthEvaluationLayoutRoute = AuthEvaluationLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => AuthEvaluationRoute,
} as any)

const AuthConferenceConferenceRoute = AuthConferenceConferenceImport.update({
  id: '/_conference',
  getParentRoute: () => AuthConferenceRoute,
} as any)

const AuthAuthorAuthorRoute = AuthAuthorAuthorImport.update({
  id: '/_author',
  getParentRoute: () => AuthAuthorRoute,
} as any)

const AuthAdministrationAdministrationRoute =
  AuthAdministrationAdministrationImport.update({
    id: '/_administration',
    getParentRoute: () => AuthAdministrationRoute,
  } as any)

const AuthResearchPerfEvalLayoutEvaluationIdRoute =
  AuthResearchPerfEvalLayoutEvaluationIdImport.update({
    id: '/$evaluationId',
    path: '/$evaluationId',
    getParentRoute: () => AuthResearchPerfEvalLayoutRoute,
  } as any)

const AuthResearchCenterResearchCenterResearchCenterIdRoute =
  AuthResearchCenterResearchCenterResearchCenterIdImport.update({
    id: '/$researchCenterId',
    path: '/$researchCenterId',
    getParentRoute: () => AuthResearchCenterResearchCenterRoute,
  } as any)

const AuthPublisherPublisherPublisherIdRoute =
  AuthPublisherPublisherPublisherIdImport.update({
    id: '/$publisherId',
    path: '/$publisherId',
    getParentRoute: () => AuthPublisherPublisherRoute,
  } as any)

const AuthJournalJournalJournalIdRoute =
  AuthJournalJournalJournalIdImport.update({
    id: '/$journalId',
    path: '/$journalId',
    getParentRoute: () => AuthJournalJournalRoute,
  } as any)

const AuthGovEvaluationLayoutEvaluationIdRoute =
  AuthGovEvaluationLayoutEvaluationIdImport.update({
    id: '/$evaluationId',
    path: '/$evaluationId',
    getParentRoute: () => AuthGovEvaluationLayoutRoute,
  } as any)

const AuthEvaluationLayoutEvaluationIdRoute =
  AuthEvaluationLayoutEvaluationIdImport.update({
    id: '/$evaluationId',
    path: '/$evaluationId',
    getParentRoute: () => AuthEvaluationLayoutRoute,
  } as any)

const AuthConferenceConferenceConferenceIdRoute =
  AuthConferenceConferenceConferenceIdImport.update({
    id: '/$conferenceId',
    path: '/$conferenceId',
    getParentRoute: () => AuthConferenceConferenceRoute,
  } as any)

const AuthAuthorAuthorTranslationRoute =
  AuthAuthorAuthorTranslationImport.update({
    id: '/translation',
    path: '/translation',
    getParentRoute: () => AuthAuthorAuthorRoute,
  } as any)

const AuthAuthorAuthorTechnologicalTransferRoute =
  AuthAuthorAuthorTechnologicalTransferImport.update({
    id: '/technological-transfer',
    path: '/technological-transfer',
    getParentRoute: () => AuthAuthorAuthorRoute,
  } as any)

const AuthAuthorAuthorReviewRoute = AuthAuthorAuthorReviewImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => AuthAuthorAuthorRoute,
} as any)

const AuthAuthorAuthorProjectRoute = AuthAuthorAuthorProjectImport.update({
  id: '/project',
  path: '/project',
  getParentRoute: () => AuthAuthorAuthorRoute,
} as any)

const AuthAuthorAuthorProceedingRoute = AuthAuthorAuthorProceedingImport.update(
  {
    id: '/proceeding',
    path: '/proceeding',
    getParentRoute: () => AuthAuthorAuthorRoute,
  } as any,
)

const AuthAuthorAuthorPresentationRoute =
  AuthAuthorAuthorPresentationImport.update({
    id: '/presentation',
    path: '/presentation',
    getParentRoute: () => AuthAuthorAuthorRoute,
  } as any)

const AuthAuthorAuthorPatentRoute = AuthAuthorAuthorPatentImport.update({
  id: '/patent',
  path: '/patent',
  getParentRoute: () => AuthAuthorAuthorRoute,
} as any)

const AuthAuthorAuthorMobilityRoute = AuthAuthorAuthorMobilityImport.update({
  id: '/mobility',
  path: '/mobility',
  getParentRoute: () => AuthAuthorAuthorRoute,
} as any)

const AuthAuthorAuthorEditorialTeamRoute =
  AuthAuthorAuthorEditorialTeamImport.update({
    id: '/editorial-team',
    path: '/editorial-team',
    getParentRoute: () => AuthAuthorAuthorRoute,
  } as any)

const AuthAuthorAuthorDoctoralCommitteeRoute =
  AuthAuthorAuthorDoctoralCommitteeImport.update({
    id: '/doctoral-committee',
    path: '/doctoral-committee',
    getParentRoute: () => AuthAuthorAuthorRoute,
  } as any)

const AuthAuthorAuthorDictionaryRoute = AuthAuthorAuthorDictionaryImport.update(
  {
    id: '/dictionary',
    path: '/dictionary',
    getParentRoute: () => AuthAuthorAuthorRoute,
  } as any,
)

const AuthAuthorAuthorCourseRoute = AuthAuthorAuthorCourseImport.update({
  id: '/course',
  path: '/course',
  getParentRoute: () => AuthAuthorAuthorRoute,
} as any)

const AuthAuthorAuthorCommitteeRoute = AuthAuthorAuthorCommitteeImport.update({
  id: '/committee',
  path: '/committee',
  getParentRoute: () => AuthAuthorAuthorRoute,
} as any)

const AuthAuthorAuthorChapterRoute = AuthAuthorAuthorChapterImport.update({
  id: '/chapter',
  path: '/chapter',
  getParentRoute: () => AuthAuthorAuthorRoute,
} as any)

const AuthAuthorAuthorBookRoute = AuthAuthorAuthorBookImport.update({
  id: '/book',
  path: '/book',
  getParentRoute: () => AuthAuthorAuthorRoute,
} as any)

const AuthAuthorAuthorAwardRoute = AuthAuthorAuthorAwardImport.update({
  id: '/award',
  path: '/award',
  getParentRoute: () => AuthAuthorAuthorRoute,
} as any)

const AuthAuthorAuthorArticleRoute = AuthAuthorAuthorArticleImport.update({
  id: '/article',
  path: '/article',
  getParentRoute: () => AuthAuthorAuthorRoute,
} as any)

const AuthAuthorAuthorAbstractRoute = AuthAuthorAuthorAbstractImport.update({
  id: '/abstract',
  path: '/abstract',
  getParentRoute: () => AuthAuthorAuthorRoute,
} as any)

const AuthAdministrationAdministrationUserDocumentsRoute =
  AuthAdministrationAdministrationUserDocumentsImport.update({
    id: '/user-documents',
    path: '/user-documents',
    getParentRoute: () => AuthAdministrationAdministrationRoute,
  } as any)

const AuthAdministrationAdministrationUniversityConfigRoute =
  AuthAdministrationAdministrationUniversityConfigImport.update({
    id: '/university-config',
    path: '/university-config',
    getParentRoute: () => AuthAdministrationAdministrationRoute,
  } as any)

const AuthAdministrationAdministrationLocalAccountsRoute =
  AuthAdministrationAdministrationLocalAccountsImport.update({
    id: '/local-accounts',
    path: '/local-accounts',
    getParentRoute: () => AuthAdministrationAdministrationRoute,
  } as any)

const AuthAdministrationAdministrationLegalHolidayRoute =
  AuthAdministrationAdministrationLegalHolidayImport.update({
    id: '/legal-holiday',
    path: '/legal-holiday',
    getParentRoute: () => AuthAdministrationAdministrationRoute,
  } as any)

const AuthAdministrationAdministrationFacultyRoute =
  AuthAdministrationAdministrationFacultyImport.update({
    id: '/faculty',
    path: '/faculty',
    getParentRoute: () => AuthAdministrationAdministrationRoute,
  } as any)

const AuthAdministrationAdministrationDisciplineRoute =
  AuthAdministrationAdministrationDisciplineImport.update({
    id: '/discipline',
    path: '/discipline',
    getParentRoute: () => AuthAdministrationAdministrationRoute,
  } as any)

const AuthAdministrationAdministrationDepartmentRoute =
  AuthAdministrationAdministrationDepartmentImport.update({
    id: '/department',
    path: '/department',
    getParentRoute: () => AuthAdministrationAdministrationRoute,
  } as any)

const AuthTravelTravelIndexRoute = AuthTravelTravelIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthTravelTravelRoute,
} as any)

const AuthResearchPerfEvalLayoutIndexRoute =
  AuthResearchPerfEvalLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthResearchPerfEvalLayoutRoute,
  } as any)

const AuthResearchCenterResearchCenterIndexRoute =
  AuthResearchCenterResearchCenterIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthResearchCenterResearchCenterRoute,
  } as any)

const AuthReportReportIndexRoute = AuthReportReportIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthReportReportRoute,
} as any)

const AuthPublisherPublisherIndexRoute =
  AuthPublisherPublisherIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthPublisherPublisherRoute,
  } as any)

const AuthMinimalStandardsLayoutIndexRoute =
  AuthMinimalStandardsLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthMinimalStandardsLayoutRoute,
  } as any)

const AuthJournalJournalIndexRoute = AuthJournalJournalIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthJournalJournalRoute,
} as any)

const AuthGovEvaluationLayoutIndexRoute =
  AuthGovEvaluationLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthGovEvaluationLayoutRoute,
  } as any)

const AuthEvaluationLayoutIndexRoute = AuthEvaluationLayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthEvaluationLayoutRoute,
} as any)

const AuthConferenceConferenceIndexRoute =
  AuthConferenceConferenceIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthConferenceConferenceRoute,
  } as any)

const AuthAuthorAuthorIndexRoute = AuthAuthorAuthorIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAuthorAuthorRoute,
} as any)

const AuthAdministrationAdministrationIndexRoute =
  AuthAdministrationAdministrationIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAdministrationAdministrationRoute,
  } as any)

const AuthResearchCenterResearchCenterCreateRoute =
  AuthResearchCenterResearchCenterCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthResearchCenterResearchCenterRoute,
  } as any)

const AuthReportReportAnalyticsRoute = AuthReportReportAnalyticsImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthReportReportRoute,
} as any)

const AuthPublisherPublisherCreateRoute =
  AuthPublisherPublisherCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthPublisherPublisherRoute,
  } as any)

const AuthJournalJournalCreateRoute = AuthJournalJournalCreateImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AuthJournalJournalRoute,
} as any)

const AuthConferenceConferenceCreateRoute =
  AuthConferenceConferenceCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthConferenceConferenceRoute,
  } as any)

const AuthAuthorAuthorWosIsiReportRoute =
  AuthAuthorAuthorWosIsiReportImport.update({
    id: '/wos-isi-report',
    path: '/wos-isi-report',
    getParentRoute: () => AuthAuthorAuthorRoute,
  } as any)

const AuthTravelTravelRequestsRequestIdRoute =
  AuthTravelTravelRequestsRequestIdImport.update({
    id: '/requests/$requestId',
    path: '/requests/$requestId',
    getParentRoute: () => AuthTravelTravelRoute,
  } as any)

const AuthMinimalStandardsLayoutReportGatherRoute =
  AuthMinimalStandardsLayoutReportGatherImport.update({
    id: '/report/gather',
    path: '/report/gather',
    getParentRoute: () => AuthMinimalStandardsLayoutRoute,
  } as any)

const AuthTravelTravelSettingsIndexRoute =
  AuthTravelTravelSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthTravelTravelRoute,
  } as any)

const AuthTravelTravelRequestsIndexRoute =
  AuthTravelTravelRequestsIndexImport.update({
    id: '/requests/',
    path: '/requests/',
    getParentRoute: () => AuthTravelTravelRoute,
  } as any)

const AuthTravelTravelRegistryIndexRoute =
  AuthTravelTravelRegistryIndexImport.update({
    id: '/registry/',
    path: '/registry/',
    getParentRoute: () => AuthTravelTravelRoute,
  } as any)

const AuthTravelTravelDocumentsIndexRoute =
  AuthTravelTravelDocumentsIndexImport.update({
    id: '/documents/',
    path: '/documents/',
    getParentRoute: () => AuthTravelTravelRoute,
  } as any)

const AuthTravelTravelDaysIndexRoute = AuthTravelTravelDaysIndexImport.update({
  id: '/days/',
  path: '/days/',
  getParentRoute: () => AuthTravelTravelRoute,
} as any)

const AuthTravelTravelBoardRequestsIndexRoute =
  AuthTravelTravelBoardRequestsIndexImport.update({
    id: '/board-requests/',
    path: '/board-requests/',
    getParentRoute: () => AuthTravelTravelRoute,
  } as any)

const AuthTravelTravelApprovalsIndexRoute =
  AuthTravelTravelApprovalsIndexImport.update({
    id: '/approvals/',
    path: '/approvals/',
    getParentRoute: () => AuthTravelTravelRoute,
  } as any)

const AuthTravelTravelAnalyticsIndexRoute =
  AuthTravelTravelAnalyticsIndexImport.update({
    id: '/analytics/',
    path: '/analytics/',
    getParentRoute: () => AuthTravelTravelRoute,
  } as any)

const AuthTravelTravelRequestsCreateRoute =
  AuthTravelTravelRequestsCreateImport.update({
    id: '/requests/create',
    path: '/requests/create',
    getParentRoute: () => AuthTravelTravelRoute,
  } as any)

const AuthResearchPerfEvalLayoutEvaluationIdLayoutRoute =
  AuthResearchPerfEvalLayoutEvaluationIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthResearchPerfEvalLayoutEvaluationIdRoute,
  } as any)

const AuthResearchCenterResearchCenterResearchCenterIdLayoutRoute =
  AuthResearchCenterResearchCenterResearchCenterIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthResearchCenterResearchCenterResearchCenterIdRoute,
  } as any)

const AuthPublisherPublisherPublisherIdLayoutRoute =
  AuthPublisherPublisherPublisherIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthPublisherPublisherPublisherIdRoute,
  } as any)

const AuthJournalJournalJournalIdLayoutRoute =
  AuthJournalJournalJournalIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthJournalJournalJournalIdRoute,
  } as any)

const AuthGovEvaluationLayoutEvaluationIdLayoutRoute =
  AuthGovEvaluationLayoutEvaluationIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthGovEvaluationLayoutEvaluationIdRoute,
  } as any)

const AuthEvaluationLayoutEvaluationIdFacultySummaryResultsRoute =
  AuthEvaluationLayoutEvaluationIdFacultySummaryResultsImport.update({
    id: '/faculty-summary-results',
    path: '/faculty-summary-results',
    getParentRoute: () => AuthEvaluationLayoutEvaluationIdRoute,
  } as any)

const AuthEvaluationLayoutEvaluationIdDepartmentSummaryResultsRoute =
  AuthEvaluationLayoutEvaluationIdDepartmentSummaryResultsImport.update({
    id: '/department-summary-results',
    path: '/department-summary-results',
    getParentRoute: () => AuthEvaluationLayoutEvaluationIdRoute,
  } as any)

const AuthEvaluationLayoutEvaluationIdLayoutRoute =
  AuthEvaluationLayoutEvaluationIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthEvaluationLayoutEvaluationIdRoute,
  } as any)

const AuthConferenceConferenceConferenceIdLayoutRoute =
  AuthConferenceConferenceConferenceIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthConferenceConferenceConferenceIdRoute,
  } as any)

const AuthAuthorAuthorTranslationTranslationRoute =
  AuthAuthorAuthorTranslationTranslationImport.update({
    id: '/_translation',
    getParentRoute: () => AuthAuthorAuthorTranslationRoute,
  } as any)

const AuthAuthorAuthorTechnologicalTransferTechnologicalTransferRoute =
  AuthAuthorAuthorTechnologicalTransferTechnologicalTransferImport.update({
    id: '/_technologicalTransfer',
    getParentRoute: () => AuthAuthorAuthorTechnologicalTransferRoute,
  } as any)

const AuthAuthorAuthorReviewReviewRoute =
  AuthAuthorAuthorReviewReviewImport.update({
    id: '/_review',
    getParentRoute: () => AuthAuthorAuthorReviewRoute,
  } as any)

const AuthAuthorAuthorProjectProjectRoute =
  AuthAuthorAuthorProjectProjectImport.update({
    id: '/_project',
    getParentRoute: () => AuthAuthorAuthorProjectRoute,
  } as any)

const AuthAuthorAuthorProceedingProceedingRoute =
  AuthAuthorAuthorProceedingProceedingImport.update({
    id: '/_proceeding',
    getParentRoute: () => AuthAuthorAuthorProceedingRoute,
  } as any)

const AuthAuthorAuthorPresentationPresentationRoute =
  AuthAuthorAuthorPresentationPresentationImport.update({
    id: '/_presentation',
    getParentRoute: () => AuthAuthorAuthorPresentationRoute,
  } as any)

const AuthAuthorAuthorPatentPatentRoute =
  AuthAuthorAuthorPatentPatentImport.update({
    id: '/_patent',
    getParentRoute: () => AuthAuthorAuthorPatentRoute,
  } as any)

const AuthAuthorAuthorMobilityMobilityRoute =
  AuthAuthorAuthorMobilityMobilityImport.update({
    id: '/_mobility',
    getParentRoute: () => AuthAuthorAuthorMobilityRoute,
  } as any)

const AuthAuthorAuthorEditorialTeamEditorialTeamRoute =
  AuthAuthorAuthorEditorialTeamEditorialTeamImport.update({
    id: '/_editorialTeam',
    getParentRoute: () => AuthAuthorAuthorEditorialTeamRoute,
  } as any)

const AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeRoute =
  AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeImport.update({
    id: '/_doctoralCommittee',
    getParentRoute: () => AuthAuthorAuthorDoctoralCommitteeRoute,
  } as any)

const AuthAuthorAuthorDictionaryDictionaryRoute =
  AuthAuthorAuthorDictionaryDictionaryImport.update({
    id: '/_dictionary',
    getParentRoute: () => AuthAuthorAuthorDictionaryRoute,
  } as any)

const AuthAuthorAuthorCourseCourseRoute =
  AuthAuthorAuthorCourseCourseImport.update({
    id: '/_course',
    getParentRoute: () => AuthAuthorAuthorCourseRoute,
  } as any)

const AuthAuthorAuthorCommitteeCommitteeRoute =
  AuthAuthorAuthorCommitteeCommitteeImport.update({
    id: '/_committee',
    getParentRoute: () => AuthAuthorAuthorCommitteeRoute,
  } as any)

const AuthAuthorAuthorChapterChapterRoute =
  AuthAuthorAuthorChapterChapterImport.update({
    id: '/_chapter',
    getParentRoute: () => AuthAuthorAuthorChapterRoute,
  } as any)

const AuthAuthorAuthorBookBookRoute = AuthAuthorAuthorBookBookImport.update({
  id: '/_book',
  getParentRoute: () => AuthAuthorAuthorBookRoute,
} as any)

const AuthAuthorAuthorAwardAwardRoute = AuthAuthorAuthorAwardAwardImport.update(
  {
    id: '/_award',
    getParentRoute: () => AuthAuthorAuthorAwardRoute,
  } as any,
)

const AuthAuthorAuthorArticleArticleRoute =
  AuthAuthorAuthorArticleArticleImport.update({
    id: '/_article',
    getParentRoute: () => AuthAuthorAuthorArticleRoute,
  } as any)

const AuthAuthorAuthorAbstractAbstractRoute =
  AuthAuthorAuthorAbstractAbstractImport.update({
    id: '/_abstract',
    getParentRoute: () => AuthAuthorAuthorAbstractRoute,
  } as any)

const AuthAdministrationAdministrationUserDocumentsUserDocumentsRoute =
  AuthAdministrationAdministrationUserDocumentsUserDocumentsImport.update({
    id: '/_user-documents',
    getParentRoute: () => AuthAdministrationAdministrationUserDocumentsRoute,
  } as any)

const AuthAdministrationAdministrationUniversityConfigUniversityConfigRoute =
  AuthAdministrationAdministrationUniversityConfigUniversityConfigImport.update(
    {
      id: '/_university-config',
      getParentRoute: () =>
        AuthAdministrationAdministrationUniversityConfigRoute,
    } as any,
  )

const AuthAdministrationAdministrationLocalAccountsLocalAccountsRoute =
  AuthAdministrationAdministrationLocalAccountsLocalAccountsImport.update({
    id: '/_local-accounts',
    getParentRoute: () => AuthAdministrationAdministrationLocalAccountsRoute,
  } as any)

const AuthAdministrationAdministrationLegalHolidayLegalHolidayRoute =
  AuthAdministrationAdministrationLegalHolidayLegalHolidayImport.update({
    id: '/_legal-holiday',
    getParentRoute: () => AuthAdministrationAdministrationLegalHolidayRoute,
  } as any)

const AuthAdministrationAdministrationFacultyFacultyRoute =
  AuthAdministrationAdministrationFacultyFacultyImport.update({
    id: '/_faculty',
    getParentRoute: () => AuthAdministrationAdministrationFacultyRoute,
  } as any)

const AuthAdministrationAdministrationDisciplineDisciplineRoute =
  AuthAdministrationAdministrationDisciplineDisciplineImport.update({
    id: '/_discipline',
    getParentRoute: () => AuthAdministrationAdministrationDisciplineRoute,
  } as any)

const AuthAdministrationAdministrationDepartmentDepartmentRoute =
  AuthAdministrationAdministrationDepartmentDepartmentImport.update({
    id: '/_department',
    getParentRoute: () => AuthAdministrationAdministrationDepartmentRoute,
  } as any)

const AuthResearchCenterResearchCenterResearchCenterIdLayoutLabRoute =
  AuthResearchCenterResearchCenterResearchCenterIdLayoutLabImport.update({
    id: '/lab',
    path: '/lab',
    getParentRoute: () =>
      AuthResearchCenterResearchCenterResearchCenterIdLayoutRoute,
  } as any)

const AuthAuthorAuthorTranslationTranslationTranslationIdRoute =
  AuthAuthorAuthorTranslationTranslationTranslationIdImport.update({
    id: '/$translationId',
    path: '/$translationId',
    getParentRoute: () => AuthAuthorAuthorTranslationTranslationRoute,
  } as any)

const AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdRoute =
  AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdImport.update(
    {
      id: '/$technologicalTransferId',
      path: '/$technologicalTransferId',
      getParentRoute: () =>
        AuthAuthorAuthorTechnologicalTransferTechnologicalTransferRoute,
    } as any,
  )

const AuthAuthorAuthorReviewReviewReviewIdRoute =
  AuthAuthorAuthorReviewReviewReviewIdImport.update({
    id: '/$reviewId',
    path: '/$reviewId',
    getParentRoute: () => AuthAuthorAuthorReviewReviewRoute,
  } as any)

const AuthAuthorAuthorProjectProjectProjectIdRoute =
  AuthAuthorAuthorProjectProjectProjectIdImport.update({
    id: '/$projectId',
    path: '/$projectId',
    getParentRoute: () => AuthAuthorAuthorProjectProjectRoute,
  } as any)

const AuthAuthorAuthorProceedingProceedingProceedingIdRoute =
  AuthAuthorAuthorProceedingProceedingProceedingIdImport.update({
    id: '/$proceedingId',
    path: '/$proceedingId',
    getParentRoute: () => AuthAuthorAuthorProceedingProceedingRoute,
  } as any)

const AuthAuthorAuthorPresentationPresentationPresentationIdRoute =
  AuthAuthorAuthorPresentationPresentationPresentationIdImport.update({
    id: '/$presentationId',
    path: '/$presentationId',
    getParentRoute: () => AuthAuthorAuthorPresentationPresentationRoute,
  } as any)

const AuthAuthorAuthorPatentPatentPatentIdRoute =
  AuthAuthorAuthorPatentPatentPatentIdImport.update({
    id: '/$patentId',
    path: '/$patentId',
    getParentRoute: () => AuthAuthorAuthorPatentPatentRoute,
  } as any)

const AuthAuthorAuthorMobilityMobilityMobilityIdRoute =
  AuthAuthorAuthorMobilityMobilityMobilityIdImport.update({
    id: '/$mobilityId',
    path: '/$mobilityId',
    getParentRoute: () => AuthAuthorAuthorMobilityMobilityRoute,
  } as any)

const AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdRoute =
  AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdImport.update({
    id: '/$editorialTeamId',
    path: '/$editorialTeamId',
    getParentRoute: () => AuthAuthorAuthorEditorialTeamEditorialTeamRoute,
  } as any)

const AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdRoute =
  AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdImport.update(
    {
      id: '/$doctoralCommitteeId',
      path: '/$doctoralCommitteeId',
      getParentRoute: () =>
        AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeRoute,
    } as any,
  )

const AuthAuthorAuthorDictionaryDictionaryDictionaryIdRoute =
  AuthAuthorAuthorDictionaryDictionaryDictionaryIdImport.update({
    id: '/$dictionaryId',
    path: '/$dictionaryId',
    getParentRoute: () => AuthAuthorAuthorDictionaryDictionaryRoute,
  } as any)

const AuthAuthorAuthorCourseCourseCourseIdRoute =
  AuthAuthorAuthorCourseCourseCourseIdImport.update({
    id: '/$courseId',
    path: '/$courseId',
    getParentRoute: () => AuthAuthorAuthorCourseCourseRoute,
  } as any)

const AuthAuthorAuthorCommitteeCommitteeCommitteeIdRoute =
  AuthAuthorAuthorCommitteeCommitteeCommitteeIdImport.update({
    id: '/$committeeId',
    path: '/$committeeId',
    getParentRoute: () => AuthAuthorAuthorCommitteeCommitteeRoute,
  } as any)

const AuthAuthorAuthorChapterChapterChapterIdRoute =
  AuthAuthorAuthorChapterChapterChapterIdImport.update({
    id: '/$chapterId',
    path: '/$chapterId',
    getParentRoute: () => AuthAuthorAuthorChapterChapterRoute,
  } as any)

const AuthAuthorAuthorBookBookBookIdRoute =
  AuthAuthorAuthorBookBookBookIdImport.update({
    id: '/$bookId',
    path: '/$bookId',
    getParentRoute: () => AuthAuthorAuthorBookBookRoute,
  } as any)

const AuthAuthorAuthorAwardAwardAwardIdRoute =
  AuthAuthorAuthorAwardAwardAwardIdImport.update({
    id: '/$awardId',
    path: '/$awardId',
    getParentRoute: () => AuthAuthorAuthorAwardAwardRoute,
  } as any)

const AuthAuthorAuthorArticleArticleArticleIdRoute =
  AuthAuthorAuthorArticleArticleArticleIdImport.update({
    id: '/$articleId',
    path: '/$articleId',
    getParentRoute: () => AuthAuthorAuthorArticleArticleRoute,
  } as any)

const AuthAuthorAuthorAbstractAbstractAbstractIdRoute =
  AuthAuthorAuthorAbstractAbstractAbstractIdImport.update({
    id: '/$abstractId',
    path: '/$abstractId',
    getParentRoute: () => AuthAuthorAuthorAbstractAbstractRoute,
  } as any)

const AuthAdministrationAdministrationFacultyFacultyFacultyIdRoute =
  AuthAdministrationAdministrationFacultyFacultyFacultyIdImport.update({
    id: '/$facultyId',
    path: '/$facultyId',
    getParentRoute: () => AuthAdministrationAdministrationFacultyFacultyRoute,
  } as any)

const AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdRoute =
  AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdImport.update(
    {
      id: '/$disciplineId',
      path: '/$disciplineId',
      getParentRoute: () =>
        AuthAdministrationAdministrationDisciplineDisciplineRoute,
    } as any,
  )

const AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdRoute =
  AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdImport.update(
    {
      id: '/$departmentId',
      path: '/$departmentId',
      getParentRoute: () =>
        AuthAdministrationAdministrationDepartmentDepartmentRoute,
    } as any,
  )

const AuthResearchPerfEvalLayoutEvaluationIdLayoutIndexRoute =
  AuthResearchPerfEvalLayoutEvaluationIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthResearchPerfEvalLayoutEvaluationIdLayoutRoute,
  } as any)

const AuthResearchCenterResearchCenterResearchCenterIdLayoutIndexRoute =
  AuthResearchCenterResearchCenterResearchCenterIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthResearchCenterResearchCenterResearchCenterIdLayoutRoute,
  } as any)

const AuthPublisherPublisherPublisherIdLayoutIndexRoute =
  AuthPublisherPublisherPublisherIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthPublisherPublisherPublisherIdLayoutRoute,
  } as any)

const AuthJournalJournalJournalIdLayoutIndexRoute =
  AuthJournalJournalJournalIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthJournalJournalJournalIdLayoutRoute,
  } as any)

const AuthGovEvaluationLayoutEvaluationIdLayoutIndexRoute =
  AuthGovEvaluationLayoutEvaluationIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthGovEvaluationLayoutEvaluationIdLayoutRoute,
  } as any)

const AuthEvaluationLayoutEvaluationIdLayoutIndexRoute =
  AuthEvaluationLayoutEvaluationIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthEvaluationLayoutEvaluationIdLayoutRoute,
  } as any)

const AuthConferenceConferenceConferenceIdLayoutIndexRoute =
  AuthConferenceConferenceConferenceIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthConferenceConferenceConferenceIdLayoutRoute,
  } as any)

const AuthAuthorAuthorTranslationTranslationIndexRoute =
  AuthAuthorAuthorTranslationTranslationIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorTranslationTranslationRoute,
  } as any)

const AuthAuthorAuthorTechnologicalTransferTechnologicalTransferIndexRoute =
  AuthAuthorAuthorTechnologicalTransferTechnologicalTransferIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthAuthorAuthorTechnologicalTransferTechnologicalTransferRoute,
  } as any)

const AuthAuthorAuthorReviewReviewIndexRoute =
  AuthAuthorAuthorReviewReviewIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorReviewReviewRoute,
  } as any)

const AuthAuthorAuthorProjectProjectIndexRoute =
  AuthAuthorAuthorProjectProjectIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorProjectProjectRoute,
  } as any)

const AuthAuthorAuthorProceedingProceedingIndexRoute =
  AuthAuthorAuthorProceedingProceedingIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorProceedingProceedingRoute,
  } as any)

const AuthAuthorAuthorPresentationPresentationIndexRoute =
  AuthAuthorAuthorPresentationPresentationIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorPresentationPresentationRoute,
  } as any)

const AuthAuthorAuthorPatentPatentIndexRoute =
  AuthAuthorAuthorPatentPatentIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorPatentPatentRoute,
  } as any)

const AuthAuthorAuthorMobilityMobilityIndexRoute =
  AuthAuthorAuthorMobilityMobilityIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorMobilityMobilityRoute,
  } as any)

const AuthAuthorAuthorEditorialTeamEditorialTeamIndexRoute =
  AuthAuthorAuthorEditorialTeamEditorialTeamIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorEditorialTeamEditorialTeamRoute,
  } as any)

const AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeIndexRoute =
  AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeRoute,
  } as any)

const AuthAuthorAuthorDictionaryDictionaryIndexRoute =
  AuthAuthorAuthorDictionaryDictionaryIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorDictionaryDictionaryRoute,
  } as any)

const AuthAuthorAuthorCourseCourseIndexRoute =
  AuthAuthorAuthorCourseCourseIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorCourseCourseRoute,
  } as any)

const AuthAuthorAuthorCommitteeCommitteeIndexRoute =
  AuthAuthorAuthorCommitteeCommitteeIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorCommitteeCommitteeRoute,
  } as any)

const AuthAuthorAuthorChapterChapterIndexRoute =
  AuthAuthorAuthorChapterChapterIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorChapterChapterRoute,
  } as any)

const AuthAuthorAuthorBookBookIndexRoute =
  AuthAuthorAuthorBookBookIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorBookBookRoute,
  } as any)

const AuthAuthorAuthorAwardAwardIndexRoute =
  AuthAuthorAuthorAwardAwardIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorAwardAwardRoute,
  } as any)

const AuthAuthorAuthorArticleArticleIndexRoute =
  AuthAuthorAuthorArticleArticleIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorArticleArticleRoute,
  } as any)

const AuthAuthorAuthorAbstractAbstractIndexRoute =
  AuthAuthorAuthorAbstractAbstractIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorAbstractAbstractRoute,
  } as any)

const AuthAdministrationAdministrationUserDocumentsUserDocumentsIndexRoute =
  AuthAdministrationAdministrationUserDocumentsUserDocumentsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthAdministrationAdministrationUserDocumentsUserDocumentsRoute,
  } as any)

const AuthAdministrationAdministrationUniversityConfigUniversityConfigIndexRoute =
  AuthAdministrationAdministrationUniversityConfigUniversityConfigIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthAdministrationAdministrationUniversityConfigUniversityConfigRoute,
    } as any,
  )

const AuthAdministrationAdministrationLocalAccountsLocalAccountsIndexRoute =
  AuthAdministrationAdministrationLocalAccountsLocalAccountsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthAdministrationAdministrationLocalAccountsLocalAccountsRoute,
  } as any)

const AuthAdministrationAdministrationLegalHolidayLegalHolidayIndexRoute =
  AuthAdministrationAdministrationLegalHolidayLegalHolidayIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthAdministrationAdministrationLegalHolidayLegalHolidayRoute,
  } as any)

const AuthAdministrationAdministrationFacultyFacultyIndexRoute =
  AuthAdministrationAdministrationFacultyFacultyIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAdministrationAdministrationFacultyFacultyRoute,
  } as any)

const AuthAdministrationAdministrationDisciplineDisciplineIndexRoute =
  AuthAdministrationAdministrationDisciplineDisciplineIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthAdministrationAdministrationDisciplineDisciplineRoute,
  } as any)

const AuthAdministrationAdministrationDepartmentDepartmentIndexRoute =
  AuthAdministrationAdministrationDepartmentDepartmentIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthAdministrationAdministrationDepartmentDepartmentRoute,
  } as any)

const AuthTravelTravelRequestsRequestIdLayoutRoute =
  AuthTravelTravelRequestsRequestIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthTravelTravelRequestsRequestIdRoute,
  } as any)

const AuthResearchCenterResearchCenterResearchCenterIdLayoutEditRoute =
  AuthResearchCenterResearchCenterResearchCenterIdLayoutEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () =>
      AuthResearchCenterResearchCenterResearchCenterIdLayoutRoute,
  } as any)

const AuthResearchCenterResearchCenterResearchCenterIdLayoutCreateRoute =
  AuthResearchCenterResearchCenterResearchCenterIdLayoutCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      AuthResearchCenterResearchCenterResearchCenterIdLayoutRoute,
  } as any)

const AuthPublisherPublisherPublisherIdLayoutEditRoute =
  AuthPublisherPublisherPublisherIdLayoutEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthPublisherPublisherPublisherIdLayoutRoute,
  } as any)

const AuthMinimalStandardsLayoutReportGatherGatherRoute =
  AuthMinimalStandardsLayoutReportGatherGatherImport.update({
    id: '/_gather',
    getParentRoute: () => AuthMinimalStandardsLayoutReportGatherRoute,
  } as any)

const AuthJournalJournalJournalIdLayoutImpactFactorRoute =
  AuthJournalJournalJournalIdLayoutImpactFactorImport.update({
    id: '/impact-factor',
    path: '/impact-factor',
    getParentRoute: () => AuthJournalJournalJournalIdLayoutRoute,
  } as any)

const AuthJournalJournalJournalIdLayoutEditRoute =
  AuthJournalJournalJournalIdLayoutEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthJournalJournalJournalIdLayoutRoute,
  } as any)

const AuthJournalJournalJournalIdLayoutArticleInfluenceScoreRoute =
  AuthJournalJournalJournalIdLayoutArticleInfluenceScoreImport.update({
    id: '/article-influence-score',
    path: '/article-influence-score',
    getParentRoute: () => AuthJournalJournalJournalIdLayoutRoute,
  } as any)

const AuthConferenceConferenceConferenceIdLayoutEditRoute =
  AuthConferenceConferenceConferenceIdLayoutEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthConferenceConferenceConferenceIdLayoutRoute,
  } as any)

const AuthAuthorAuthorTranslationTranslationSearchClaimableRoute =
  AuthAuthorAuthorTranslationTranslationSearchClaimableImport.update({
    id: '/search-claimable',
    path: '/search-claimable',
    getParentRoute: () => AuthAuthorAuthorTranslationTranslationRoute,
  } as any)

const AuthAuthorAuthorTranslationTranslationCreateRoute =
  AuthAuthorAuthorTranslationTranslationCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAuthorAuthorTranslationTranslationRoute,
  } as any)

const AuthAuthorAuthorTechnologicalTransferTechnologicalTransferSearchClaimableRoute =
  AuthAuthorAuthorTechnologicalTransferTechnologicalTransferSearchClaimableImport.update(
    {
      id: '/search-claimable',
      path: '/search-claimable',
      getParentRoute: () =>
        AuthAuthorAuthorTechnologicalTransferTechnologicalTransferRoute,
    } as any,
  )

const AuthAuthorAuthorTechnologicalTransferTechnologicalTransferCreateRoute =
  AuthAuthorAuthorTechnologicalTransferTechnologicalTransferCreateImport.update(
    {
      id: '/create',
      path: '/create',
      getParentRoute: () =>
        AuthAuthorAuthorTechnologicalTransferTechnologicalTransferRoute,
    } as any,
  )

const AuthAuthorAuthorReviewReviewSearchClaimableRoute =
  AuthAuthorAuthorReviewReviewSearchClaimableImport.update({
    id: '/search-claimable',
    path: '/search-claimable',
    getParentRoute: () => AuthAuthorAuthorReviewReviewRoute,
  } as any)

const AuthAuthorAuthorReviewReviewCreateRoute =
  AuthAuthorAuthorReviewReviewCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAuthorAuthorReviewReviewRoute,
  } as any)

const AuthAuthorAuthorProjectProjectSearchClaimableRoute =
  AuthAuthorAuthorProjectProjectSearchClaimableImport.update({
    id: '/search-claimable',
    path: '/search-claimable',
    getParentRoute: () => AuthAuthorAuthorProjectProjectRoute,
  } as any)

const AuthAuthorAuthorProjectProjectCreateRoute =
  AuthAuthorAuthorProjectProjectCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAuthorAuthorProjectProjectRoute,
  } as any)

const AuthAuthorAuthorProceedingProceedingSearchClaimableRoute =
  AuthAuthorAuthorProceedingProceedingSearchClaimableImport.update({
    id: '/search-claimable',
    path: '/search-claimable',
    getParentRoute: () => AuthAuthorAuthorProceedingProceedingRoute,
  } as any)

const AuthAuthorAuthorProceedingProceedingCreateRoute =
  AuthAuthorAuthorProceedingProceedingCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAuthorAuthorProceedingProceedingRoute,
  } as any)

const AuthAuthorAuthorPresentationPresentationCreateRoute =
  AuthAuthorAuthorPresentationPresentationCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAuthorAuthorPresentationPresentationRoute,
  } as any)

const AuthAuthorAuthorPatentPatentSearchClaimableRoute =
  AuthAuthorAuthorPatentPatentSearchClaimableImport.update({
    id: '/search-claimable',
    path: '/search-claimable',
    getParentRoute: () => AuthAuthorAuthorPatentPatentRoute,
  } as any)

const AuthAuthorAuthorPatentPatentCreateRoute =
  AuthAuthorAuthorPatentPatentCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAuthorAuthorPatentPatentRoute,
  } as any)

const AuthAuthorAuthorMobilityMobilityCreateRoute =
  AuthAuthorAuthorMobilityMobilityCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAuthorAuthorMobilityMobilityRoute,
  } as any)

const AuthAuthorAuthorEditorialTeamEditorialTeamCreateRoute =
  AuthAuthorAuthorEditorialTeamEditorialTeamCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAuthorAuthorEditorialTeamEditorialTeamRoute,
  } as any)

const AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeCreateRoute =
  AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeRoute,
  } as any)

const AuthAuthorAuthorDictionaryDictionaryCreateRoute =
  AuthAuthorAuthorDictionaryDictionaryCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAuthorAuthorDictionaryDictionaryRoute,
  } as any)

const AuthAuthorAuthorCourseCourseCreateRoute =
  AuthAuthorAuthorCourseCourseCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAuthorAuthorCourseCourseRoute,
  } as any)

const AuthAuthorAuthorCommitteeCommitteeCreateRoute =
  AuthAuthorAuthorCommitteeCommitteeCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAuthorAuthorCommitteeCommitteeRoute,
  } as any)

const AuthAuthorAuthorChapterChapterSearchClaimableRoute =
  AuthAuthorAuthorChapterChapterSearchClaimableImport.update({
    id: '/search-claimable',
    path: '/search-claimable',
    getParentRoute: () => AuthAuthorAuthorChapterChapterRoute,
  } as any)

const AuthAuthorAuthorChapterChapterCreateRoute =
  AuthAuthorAuthorChapterChapterCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAuthorAuthorChapterChapterRoute,
  } as any)

const AuthAuthorAuthorBookBookSearchClaimableRoute =
  AuthAuthorAuthorBookBookSearchClaimableImport.update({
    id: '/search-claimable',
    path: '/search-claimable',
    getParentRoute: () => AuthAuthorAuthorBookBookRoute,
  } as any)

const AuthAuthorAuthorBookBookCreateRoute =
  AuthAuthorAuthorBookBookCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAuthorAuthorBookBookRoute,
  } as any)

const AuthAuthorAuthorAwardAwardCreateRoute =
  AuthAuthorAuthorAwardAwardCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAuthorAuthorAwardAwardRoute,
  } as any)

const AuthAuthorAuthorArticleArticleSearchClaimableRoute =
  AuthAuthorAuthorArticleArticleSearchClaimableImport.update({
    id: '/search-claimable',
    path: '/search-claimable',
    getParentRoute: () => AuthAuthorAuthorArticleArticleRoute,
  } as any)

const AuthAuthorAuthorArticleArticleCreateRoute =
  AuthAuthorAuthorArticleArticleCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAuthorAuthorArticleArticleRoute,
  } as any)

const AuthAuthorAuthorAbstractAbstractSearchClaimableRoute =
  AuthAuthorAuthorAbstractAbstractSearchClaimableImport.update({
    id: '/search-claimable',
    path: '/search-claimable',
    getParentRoute: () => AuthAuthorAuthorAbstractAbstractRoute,
  } as any)

const AuthAuthorAuthorAbstractAbstractCreateRoute =
  AuthAuthorAuthorAbstractAbstractCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAuthorAuthorAbstractAbstractRoute,
  } as any)

const AuthAdministrationAdministrationFacultyFacultyCreateRoute =
  AuthAdministrationAdministrationFacultyFacultyCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthAdministrationAdministrationFacultyFacultyRoute,
  } as any)

const AuthAdministrationAdministrationDisciplineDisciplineCreateRoute =
  AuthAdministrationAdministrationDisciplineDisciplineCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      AuthAdministrationAdministrationDisciplineDisciplineRoute,
  } as any)

const AuthAdministrationAdministrationDepartmentDepartmentCreateRoute =
  AuthAdministrationAdministrationDepartmentDepartmentCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () =>
      AuthAdministrationAdministrationDepartmentDepartmentRoute,
  } as any)

const AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherRoute =
  AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherImport.update({
    id: '/report/gather',
    path: '/report/gather',
    getParentRoute: () => AuthResearchPerfEvalLayoutEvaluationIdLayoutRoute,
  } as any)

const AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeRoute =
  AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeImport.update({
    id: '/$indicatorCode',
    path: '/$indicatorCode',
    getParentRoute: () => AuthMinimalStandardsLayoutReportGatherGatherRoute,
  } as any)

const AuthEvaluationLayoutEvaluationIdLayoutReportGatherRoute =
  AuthEvaluationLayoutEvaluationIdLayoutReportGatherImport.update({
    id: '/report/gather',
    path: '/report/gather',
    getParentRoute: () => AuthEvaluationLayoutEvaluationIdLayoutRoute,
  } as any)

const AuthTravelTravelRequestsRequestIdLayoutIndexRoute =
  AuthTravelTravelRequestsRequestIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthTravelTravelRequestsRequestIdLayoutRoute,
  } as any)

const AuthMinimalStandardsLayoutReportGatherGatherIndexRoute =
  AuthMinimalStandardsLayoutReportGatherGatherIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthMinimalStandardsLayoutReportGatherGatherRoute,
  } as any)

const AuthTravelTravelRequestsRequestIdLayoutEditRoute =
  AuthTravelTravelRequestsRequestIdLayoutEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthTravelTravelRequestsRequestIdLayoutRoute,
  } as any)

const AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutRoute =
  AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      AuthResearchCenterResearchCenterResearchCenterIdLayoutLabRoute,
  } as any)

const AuthAuthorAuthorTranslationTranslationTranslationIdLayoutRoute =
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      AuthAuthorAuthorTranslationTranslationTranslationIdRoute,
  } as any)

const AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutRoute =
  AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdRoute,
    } as any,
  )

const AuthAuthorAuthorReviewReviewReviewIdLayoutRoute =
  AuthAuthorAuthorReviewReviewReviewIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthAuthorAuthorReviewReviewReviewIdRoute,
  } as any)

const AuthAuthorAuthorProjectProjectProjectIdLayoutRoute =
  AuthAuthorAuthorProjectProjectProjectIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthAuthorAuthorProjectProjectProjectIdRoute,
  } as any)

const AuthAuthorAuthorProceedingProceedingProceedingIdLayoutRoute =
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthAuthorAuthorProceedingProceedingProceedingIdRoute,
  } as any)

const AuthAuthorAuthorPresentationPresentationPresentationIdLayoutRoute =
  AuthAuthorAuthorPresentationPresentationPresentationIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      AuthAuthorAuthorPresentationPresentationPresentationIdRoute,
  } as any)

const AuthAuthorAuthorPatentPatentPatentIdLayoutRoute =
  AuthAuthorAuthorPatentPatentPatentIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthAuthorAuthorPatentPatentPatentIdRoute,
  } as any)

const AuthAuthorAuthorMobilityMobilityMobilityIdLayoutRoute =
  AuthAuthorAuthorMobilityMobilityMobilityIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthAuthorAuthorMobilityMobilityMobilityIdRoute,
  } as any)

const AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutRoute =
  AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdRoute,
  } as any)

const AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutRoute =
  AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdRoute,
    } as any,
  )

const AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutRoute =
  AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthAuthorAuthorDictionaryDictionaryDictionaryIdRoute,
  } as any)

const AuthAuthorAuthorCourseCourseCourseIdLayoutRoute =
  AuthAuthorAuthorCourseCourseCourseIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthAuthorAuthorCourseCourseCourseIdRoute,
  } as any)

const AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutRoute =
  AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthAuthorAuthorCommitteeCommitteeCommitteeIdRoute,
  } as any)

const AuthAuthorAuthorChapterChapterChapterIdLayoutRoute =
  AuthAuthorAuthorChapterChapterChapterIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthAuthorAuthorChapterChapterChapterIdRoute,
  } as any)

const AuthAuthorAuthorBookBookBookIdLayoutRoute =
  AuthAuthorAuthorBookBookBookIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthAuthorAuthorBookBookBookIdRoute,
  } as any)

const AuthAuthorAuthorAwardAwardAwardIdLayoutRoute =
  AuthAuthorAuthorAwardAwardAwardIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthAuthorAuthorAwardAwardAwardIdRoute,
  } as any)

const AuthAuthorAuthorArticleArticleArticleIdLayoutRoute =
  AuthAuthorAuthorArticleArticleArticleIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthAuthorAuthorArticleArticleArticleIdRoute,
  } as any)

const AuthAuthorAuthorAbstractAbstractAbstractIdLayoutRoute =
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthAuthorAuthorAbstractAbstractAbstractIdRoute,
  } as any)

const AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutRoute =
  AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      AuthAdministrationAdministrationFacultyFacultyFacultyIdRoute,
  } as any)

const AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutRoute =
  AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdRoute,
    } as any,
  )

const AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutRoute =
  AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdRoute,
    } as any,
  )

const AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdRoute =
  AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdImport.update(
    {
      id: '/$labId',
      path: '/$labId',
      getParentRoute: () =>
        AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutRoute,
    } as any,
  )

const AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutIndexRoute =
  AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorTranslationTranslationTranslationIdLayoutIndexRoute =
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthAuthorAuthorTranslationTranslationTranslationIdLayoutRoute,
  } as any)

const AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutIndexRoute =
  AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorReviewReviewReviewIdLayoutIndexRoute =
  AuthAuthorAuthorReviewReviewReviewIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorReviewReviewReviewIdLayoutRoute,
  } as any)

const AuthAuthorAuthorProjectProjectProjectIdLayoutIndexRoute =
  AuthAuthorAuthorProjectProjectProjectIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorProjectProjectProjectIdLayoutRoute,
  } as any)

const AuthAuthorAuthorProceedingProceedingProceedingIdLayoutIndexRoute =
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthAuthorAuthorProceedingProceedingProceedingIdLayoutRoute,
  } as any)

const AuthAuthorAuthorPresentationPresentationPresentationIdLayoutIndexRoute =
  AuthAuthorAuthorPresentationPresentationPresentationIdLayoutIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthAuthorAuthorPresentationPresentationPresentationIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorPatentPatentPatentIdLayoutIndexRoute =
  AuthAuthorAuthorPatentPatentPatentIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorPatentPatentPatentIdLayoutRoute,
  } as any)

const AuthAuthorAuthorMobilityMobilityMobilityIdLayoutIndexRoute =
  AuthAuthorAuthorMobilityMobilityMobilityIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorMobilityMobilityMobilityIdLayoutRoute,
  } as any)

const AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutIndexRoute =
  AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutIndexRoute =
  AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutIndexRoute =
  AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutRoute,
  } as any)

const AuthAuthorAuthorCourseCourseCourseIdLayoutIndexRoute =
  AuthAuthorAuthorCourseCourseCourseIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorCourseCourseCourseIdLayoutRoute,
  } as any)

const AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutIndexRoute =
  AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutRoute,
  } as any)

const AuthAuthorAuthorChapterChapterChapterIdLayoutIndexRoute =
  AuthAuthorAuthorChapterChapterChapterIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorChapterChapterChapterIdLayoutRoute,
  } as any)

const AuthAuthorAuthorBookBookBookIdLayoutIndexRoute =
  AuthAuthorAuthorBookBookBookIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorBookBookBookIdLayoutRoute,
  } as any)

const AuthAuthorAuthorAwardAwardAwardIdLayoutIndexRoute =
  AuthAuthorAuthorAwardAwardAwardIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorAwardAwardAwardIdLayoutRoute,
  } as any)

const AuthAuthorAuthorArticleArticleArticleIdLayoutIndexRoute =
  AuthAuthorAuthorArticleArticleArticleIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorArticleArticleArticleIdLayoutRoute,
  } as any)

const AuthAuthorAuthorAbstractAbstractAbstractIdLayoutIndexRoute =
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAuthorAuthorAbstractAbstractAbstractIdLayoutRoute,
  } as any)

const AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutIndexRoute =
  AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutRoute,
    } as any,
  )

const AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutIndexRoute =
  AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutRoute,
    } as any,
  )

const AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutIndexRoute =
  AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutRoute,
    } as any,
  )

const AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherRoute =
  AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherImport.update({
    id: '/_gather',
    getParentRoute: () =>
      AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherRoute,
  } as any)

const AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutRoute =
  AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeRoute,
  } as any)

const AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherRoute =
  AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherImport.update({
    id: '/_gather',
    getParentRoute: () =>
      AuthEvaluationLayoutEvaluationIdLayoutReportGatherRoute,
  } as any)

const AuthAuthorAuthorTranslationTranslationTranslationIdLayoutEditRoute =
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () =>
      AuthAuthorAuthorTranslationTranslationTranslationIdLayoutRoute,
  } as any)

const AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutEditRoute =
  AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutEditImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorReviewReviewReviewIdLayoutEditRoute =
  AuthAuthorAuthorReviewReviewReviewIdLayoutEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthAuthorAuthorReviewReviewReviewIdLayoutRoute,
  } as any)

const AuthAuthorAuthorProjectProjectProjectIdLayoutEditRoute =
  AuthAuthorAuthorProjectProjectProjectIdLayoutEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthAuthorAuthorProjectProjectProjectIdLayoutRoute,
  } as any)

const AuthAuthorAuthorProceedingProceedingProceedingIdLayoutEditRoute =
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () =>
      AuthAuthorAuthorProceedingProceedingProceedingIdLayoutRoute,
  } as any)

const AuthAuthorAuthorPresentationPresentationPresentationIdLayoutEditRoute =
  AuthAuthorAuthorPresentationPresentationPresentationIdLayoutEditImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        AuthAuthorAuthorPresentationPresentationPresentationIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorPatentPatentPatentIdLayoutEditRoute =
  AuthAuthorAuthorPatentPatentPatentIdLayoutEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthAuthorAuthorPatentPatentPatentIdLayoutRoute,
  } as any)

const AuthAuthorAuthorMobilityMobilityMobilityIdLayoutEditRoute =
  AuthAuthorAuthorMobilityMobilityMobilityIdLayoutEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthAuthorAuthorMobilityMobilityMobilityIdLayoutRoute,
  } as any)

const AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutEditRoute =
  AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutEditImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutEditRoute =
  AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutEditImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutEditRoute =
  AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () =>
      AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutRoute,
  } as any)

const AuthAuthorAuthorCourseCourseCourseIdLayoutEditRoute =
  AuthAuthorAuthorCourseCourseCourseIdLayoutEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthAuthorAuthorCourseCourseCourseIdLayoutRoute,
  } as any)

const AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutEditRoute =
  AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () =>
      AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutRoute,
  } as any)

const AuthAuthorAuthorChapterChapterChapterIdLayoutEditRoute =
  AuthAuthorAuthorChapterChapterChapterIdLayoutEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthAuthorAuthorChapterChapterChapterIdLayoutRoute,
  } as any)

const AuthAuthorAuthorBookBookBookIdLayoutEditRoute =
  AuthAuthorAuthorBookBookBookIdLayoutEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthAuthorAuthorBookBookBookIdLayoutRoute,
  } as any)

const AuthAuthorAuthorAwardAwardAwardIdLayoutEditRoute =
  AuthAuthorAuthorAwardAwardAwardIdLayoutEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthAuthorAuthorAwardAwardAwardIdLayoutRoute,
  } as any)

const AuthAuthorAuthorArticleArticleArticleIdLayoutEditRoute =
  AuthAuthorAuthorArticleArticleArticleIdLayoutEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthAuthorAuthorArticleArticleArticleIdLayoutRoute,
  } as any)

const AuthAuthorAuthorAbstractAbstractAbstractIdLayoutEditRoute =
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthAuthorAuthorAbstractAbstractAbstractIdLayoutRoute,
  } as any)

const AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutEditRoute =
  AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutEditImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutRoute,
    } as any,
  )

const AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutEditRoute =
  AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutEditImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutRoute,
    } as any,
  )

const AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutEditRoute =
  AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutEditImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutRoute,
    } as any,
  )

const AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoRoute =
  AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoImport.update(
    {
      id: '/$orderNo',
      path: '/$orderNo',
      getParentRoute: () =>
        AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherRoute,
    } as any,
  )

const AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoRoute =
  AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoImport.update({
    id: '/$orderNo',
    path: '/$orderNo',
    getParentRoute: () =>
      AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherRoute,
  } as any)

const AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdRoute =
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdImport.update(
    {
      id: '/citations/$citationId',
      path: '/citations/$citationId',
      getParentRoute: () =>
        AuthAuthorAuthorTranslationTranslationTranslationIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdRoute =
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdImport.update(
    {
      id: '/citations/$citationId',
      path: '/citations/$citationId',
      getParentRoute: () =>
        AuthAuthorAuthorProceedingProceedingProceedingIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdRoute =
  AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdImport.update(
    {
      id: '/citations/$citationId',
      path: '/citations/$citationId',
      getParentRoute: () => AuthAuthorAuthorChapterChapterChapterIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdRoute =
  AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdImport.update({
    id: '/citations/$citationId',
    path: '/citations/$citationId',
    getParentRoute: () => AuthAuthorAuthorBookBookBookIdLayoutRoute,
  } as any)

const AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdRoute =
  AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdImport.update(
    {
      id: '/citations/$citationId',
      path: '/citations/$citationId',
      getParentRoute: () => AuthAuthorAuthorArticleArticleArticleIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdRoute =
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdImport.update(
    {
      id: '/citations/$citationId',
      path: '/citations/$citationId',
      getParentRoute: () =>
        AuthAuthorAuthorAbstractAbstractAbstractIdLayoutRoute,
    } as any,
  )

const AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherIndexRoute =
  AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherRoute,
    } as any,
  )

const AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutIndexRoute =
  AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutRoute,
    } as any,
  )

const AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherIndexRoute =
  AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherRoute,
  } as any)

const AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsIndexRoute =
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsIndexImport.update(
    {
      id: '/citations/',
      path: '/citations/',
      getParentRoute: () =>
        AuthAuthorAuthorTranslationTranslationTranslationIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsIndexRoute =
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsIndexImport.update(
    {
      id: '/citations/',
      path: '/citations/',
      getParentRoute: () =>
        AuthAuthorAuthorProceedingProceedingProceedingIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsIndexRoute =
  AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsIndexImport.update({
    id: '/citations/',
    path: '/citations/',
    getParentRoute: () => AuthAuthorAuthorChapterChapterChapterIdLayoutRoute,
  } as any)

const AuthAuthorAuthorBookBookBookIdLayoutCitationsIndexRoute =
  AuthAuthorAuthorBookBookBookIdLayoutCitationsIndexImport.update({
    id: '/citations/',
    path: '/citations/',
    getParentRoute: () => AuthAuthorAuthorBookBookBookIdLayoutRoute,
  } as any)

const AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsIndexRoute =
  AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsIndexImport.update({
    id: '/citations/',
    path: '/citations/',
    getParentRoute: () => AuthAuthorAuthorArticleArticleArticleIdLayoutRoute,
  } as any)

const AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsIndexRoute =
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsIndexImport.update({
    id: '/citations/',
    path: '/citations/',
    getParentRoute: () => AuthAuthorAuthorAbstractAbstractAbstractIdLayoutRoute,
  } as any)

const AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutRoute =
  AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdRoute,
    } as any,
  )

const AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCreateRoute =
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCreateImport.update(
    {
      id: '/citations/create',
      path: '/citations/create',
      getParentRoute: () =>
        AuthAuthorAuthorTranslationTranslationTranslationIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCreateRoute =
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCreateImport.update(
    {
      id: '/citations/create',
      path: '/citations/create',
      getParentRoute: () =>
        AuthAuthorAuthorProceedingProceedingProceedingIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCreateRoute =
  AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCreateImport.update({
    id: '/citations/create',
    path: '/citations/create',
    getParentRoute: () => AuthAuthorAuthorChapterChapterChapterIdLayoutRoute,
  } as any)

const AuthAuthorAuthorBookBookBookIdLayoutCitationsCreateRoute =
  AuthAuthorAuthorBookBookBookIdLayoutCitationsCreateImport.update({
    id: '/citations/create',
    path: '/citations/create',
    getParentRoute: () => AuthAuthorAuthorBookBookBookIdLayoutRoute,
  } as any)

const AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCreateRoute =
  AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCreateImport.update({
    id: '/citations/create',
    path: '/citations/create',
    getParentRoute: () => AuthAuthorAuthorArticleArticleArticleIdLayoutRoute,
  } as any)

const AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCreateRoute =
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCreateImport.update({
    id: '/citations/create',
    path: '/citations/create',
    getParentRoute: () => AuthAuthorAuthorAbstractAbstractAbstractIdLayoutRoute,
  } as any)

const AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutIndexRoute =
  AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutRoute,
    } as any,
  )

const AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRoute =
  AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoRoute,
    } as any,
  )

const AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutEditRoute =
  AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutEditImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutRoute,
    } as any,
  )

const AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRoute =
  AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoRoute,
    } as any,
  )

const AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutRoute =
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdRoute,
    } as any,
  )

const AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutRoute =
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdRoute,
    } as any,
  )

const AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutRoute =
  AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdRoute,
    } as any,
  )

const AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutRoute =
  AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () =>
      AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdRoute,
  } as any)

const AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutRoute =
  AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdRoute,
    } as any,
  )

const AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutRoute =
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutImport.update(
    {
      id: '/_layout',
      getParentRoute: () =>
        AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdRoute,
    } as any,
  )

const AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexRoute =
  AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRoute,
    } as any,
  )

const AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexRoute =
  AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutIndexRoute =
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutIndexRoute =
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutIndexRoute =
  AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutIndexRoute =
  AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutIndexRoute =
  AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutIndexRoute =
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutIndexImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutEditRoute =
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutEditImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutEditRoute =
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutEditImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutEditRoute =
  AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutEditImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutEditRoute =
  AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutEditImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutEditRoute =
  AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutEditImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutRoute,
    } as any,
  )

const AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutEditRoute =
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutEditImport.update(
    {
      id: '/edit',
      path: '/edit',
      getParentRoute: () =>
        AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/_auth/sync-bibtex': {
      id: '/_auth/sync-bibtex'
      path: '/sync-bibtex'
      fullPath: '/sync-bibtex'
      preLoaderRoute: typeof AuthSyncBibtexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sync-scopus': {
      id: '/_auth/sync-scopus'
      path: '/sync-scopus'
      fullPath: '/sync-scopus'
      preLoaderRoute: typeof AuthSyncScopusImport
      parentRoute: typeof AuthImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/administration': {
      id: '/_auth/administration'
      path: '/administration'
      fullPath: '/administration'
      preLoaderRoute: typeof AuthAdministrationImport
      parentRoute: typeof AuthImport
    }
    '/_auth/administration/_administration': {
      id: '/_auth/administration/_administration'
      path: '/administration'
      fullPath: '/administration'
      preLoaderRoute: typeof AuthAdministrationAdministrationImport
      parentRoute: typeof AuthAdministrationRoute
    }
    '/_auth/author': {
      id: '/_auth/author'
      path: '/author'
      fullPath: '/author'
      preLoaderRoute: typeof AuthAuthorImport
      parentRoute: typeof AuthImport
    }
    '/_auth/author/_author': {
      id: '/_auth/author/_author'
      path: '/author'
      fullPath: '/author'
      preLoaderRoute: typeof AuthAuthorAuthorImport
      parentRoute: typeof AuthAuthorRoute
    }
    '/_auth/conference': {
      id: '/_auth/conference'
      path: '/conference'
      fullPath: '/conference'
      preLoaderRoute: typeof AuthConferenceImport
      parentRoute: typeof AuthImport
    }
    '/_auth/conference/_conference': {
      id: '/_auth/conference/_conference'
      path: '/conference'
      fullPath: '/conference'
      preLoaderRoute: typeof AuthConferenceConferenceImport
      parentRoute: typeof AuthConferenceRoute
    }
    '/_auth/evaluation': {
      id: '/_auth/evaluation'
      path: '/evaluation'
      fullPath: '/evaluation'
      preLoaderRoute: typeof AuthEvaluationImport
      parentRoute: typeof AuthImport
    }
    '/_auth/evaluation/_layout': {
      id: '/_auth/evaluation/_layout'
      path: '/evaluation'
      fullPath: '/evaluation'
      preLoaderRoute: typeof AuthEvaluationLayoutImport
      parentRoute: typeof AuthEvaluationRoute
    }
    '/_auth/gov-evaluation': {
      id: '/_auth/gov-evaluation'
      path: '/gov-evaluation'
      fullPath: '/gov-evaluation'
      preLoaderRoute: typeof AuthGovEvaluationImport
      parentRoute: typeof AuthImport
    }
    '/_auth/gov-evaluation/_layout': {
      id: '/_auth/gov-evaluation/_layout'
      path: '/gov-evaluation'
      fullPath: '/gov-evaluation'
      preLoaderRoute: typeof AuthGovEvaluationLayoutImport
      parentRoute: typeof AuthGovEvaluationRoute
    }
    '/_auth/journal': {
      id: '/_auth/journal'
      path: '/journal'
      fullPath: '/journal'
      preLoaderRoute: typeof AuthJournalImport
      parentRoute: typeof AuthImport
    }
    '/_auth/journal/_journal': {
      id: '/_auth/journal/_journal'
      path: '/journal'
      fullPath: '/journal'
      preLoaderRoute: typeof AuthJournalJournalImport
      parentRoute: typeof AuthJournalRoute
    }
    '/_auth/minimal-standards': {
      id: '/_auth/minimal-standards'
      path: '/minimal-standards'
      fullPath: '/minimal-standards'
      preLoaderRoute: typeof AuthMinimalStandardsImport
      parentRoute: typeof AuthImport
    }
    '/_auth/minimal-standards/_layout': {
      id: '/_auth/minimal-standards/_layout'
      path: '/minimal-standards'
      fullPath: '/minimal-standards'
      preLoaderRoute: typeof AuthMinimalStandardsLayoutImport
      parentRoute: typeof AuthMinimalStandardsRoute
    }
    '/_auth/publisher': {
      id: '/_auth/publisher'
      path: '/publisher'
      fullPath: '/publisher'
      preLoaderRoute: typeof AuthPublisherImport
      parentRoute: typeof AuthImport
    }
    '/_auth/publisher/_publisher': {
      id: '/_auth/publisher/_publisher'
      path: '/publisher'
      fullPath: '/publisher'
      preLoaderRoute: typeof AuthPublisherPublisherImport
      parentRoute: typeof AuthPublisherRoute
    }
    '/_auth/report': {
      id: '/_auth/report'
      path: '/report'
      fullPath: '/report'
      preLoaderRoute: typeof AuthReportImport
      parentRoute: typeof AuthImport
    }
    '/_auth/report/_report': {
      id: '/_auth/report/_report'
      path: '/report'
      fullPath: '/report'
      preLoaderRoute: typeof AuthReportReportImport
      parentRoute: typeof AuthReportRoute
    }
    '/_auth/research-center': {
      id: '/_auth/research-center'
      path: '/research-center'
      fullPath: '/research-center'
      preLoaderRoute: typeof AuthResearchCenterImport
      parentRoute: typeof AuthImport
    }
    '/_auth/research-center/_research-center': {
      id: '/_auth/research-center/_research-center'
      path: '/research-center'
      fullPath: '/research-center'
      preLoaderRoute: typeof AuthResearchCenterResearchCenterImport
      parentRoute: typeof AuthResearchCenterRoute
    }
    '/_auth/research-perf-eval': {
      id: '/_auth/research-perf-eval'
      path: '/research-perf-eval'
      fullPath: '/research-perf-eval'
      preLoaderRoute: typeof AuthResearchPerfEvalImport
      parentRoute: typeof AuthImport
    }
    '/_auth/research-perf-eval/_layout': {
      id: '/_auth/research-perf-eval/_layout'
      path: '/research-perf-eval'
      fullPath: '/research-perf-eval'
      preLoaderRoute: typeof AuthResearchPerfEvalLayoutImport
      parentRoute: typeof AuthResearchPerfEvalRoute
    }
    '/_auth/travel': {
      id: '/_auth/travel'
      path: '/travel'
      fullPath: '/travel'
      preLoaderRoute: typeof AuthTravelImport
      parentRoute: typeof AuthImport
    }
    '/_auth/travel/_travel': {
      id: '/_auth/travel/_travel'
      path: '/travel'
      fullPath: '/travel'
      preLoaderRoute: typeof AuthTravelTravelImport
      parentRoute: typeof AuthTravelRoute
    }
    '/_auth/author/_author/wos-isi-report': {
      id: '/_auth/author/_author/wos-isi-report'
      path: '/wos-isi-report'
      fullPath: '/author/wos-isi-report'
      preLoaderRoute: typeof AuthAuthorAuthorWosIsiReportImport
      parentRoute: typeof AuthAuthorAuthorImport
    }
    '/_auth/conference/_conference/create': {
      id: '/_auth/conference/_conference/create'
      path: '/create'
      fullPath: '/conference/create'
      preLoaderRoute: typeof AuthConferenceConferenceCreateImport
      parentRoute: typeof AuthConferenceConferenceImport
    }
    '/_auth/journal/_journal/create': {
      id: '/_auth/journal/_journal/create'
      path: '/create'
      fullPath: '/journal/create'
      preLoaderRoute: typeof AuthJournalJournalCreateImport
      parentRoute: typeof AuthJournalJournalImport
    }
    '/_auth/publisher/_publisher/create': {
      id: '/_auth/publisher/_publisher/create'
      path: '/create'
      fullPath: '/publisher/create'
      preLoaderRoute: typeof AuthPublisherPublisherCreateImport
      parentRoute: typeof AuthPublisherPublisherImport
    }
    '/_auth/report/_report/analytics': {
      id: '/_auth/report/_report/analytics'
      path: '/analytics'
      fullPath: '/report/analytics'
      preLoaderRoute: typeof AuthReportReportAnalyticsImport
      parentRoute: typeof AuthReportReportImport
    }
    '/_auth/research-center/_research-center/create': {
      id: '/_auth/research-center/_research-center/create'
      path: '/create'
      fullPath: '/research-center/create'
      preLoaderRoute: typeof AuthResearchCenterResearchCenterCreateImport
      parentRoute: typeof AuthResearchCenterResearchCenterImport
    }
    '/_auth/administration/_administration/': {
      id: '/_auth/administration/_administration/'
      path: '/'
      fullPath: '/administration/'
      preLoaderRoute: typeof AuthAdministrationAdministrationIndexImport
      parentRoute: typeof AuthAdministrationAdministrationImport
    }
    '/_auth/author/_author/': {
      id: '/_auth/author/_author/'
      path: '/'
      fullPath: '/author/'
      preLoaderRoute: typeof AuthAuthorAuthorIndexImport
      parentRoute: typeof AuthAuthorAuthorImport
    }
    '/_auth/conference/_conference/': {
      id: '/_auth/conference/_conference/'
      path: '/'
      fullPath: '/conference/'
      preLoaderRoute: typeof AuthConferenceConferenceIndexImport
      parentRoute: typeof AuthConferenceConferenceImport
    }
    '/_auth/evaluation/_layout/': {
      id: '/_auth/evaluation/_layout/'
      path: '/'
      fullPath: '/evaluation/'
      preLoaderRoute: typeof AuthEvaluationLayoutIndexImport
      parentRoute: typeof AuthEvaluationLayoutImport
    }
    '/_auth/gov-evaluation/_layout/': {
      id: '/_auth/gov-evaluation/_layout/'
      path: '/'
      fullPath: '/gov-evaluation/'
      preLoaderRoute: typeof AuthGovEvaluationLayoutIndexImport
      parentRoute: typeof AuthGovEvaluationLayoutImport
    }
    '/_auth/journal/_journal/': {
      id: '/_auth/journal/_journal/'
      path: '/'
      fullPath: '/journal/'
      preLoaderRoute: typeof AuthJournalJournalIndexImport
      parentRoute: typeof AuthJournalJournalImport
    }
    '/_auth/minimal-standards/_layout/': {
      id: '/_auth/minimal-standards/_layout/'
      path: '/'
      fullPath: '/minimal-standards/'
      preLoaderRoute: typeof AuthMinimalStandardsLayoutIndexImport
      parentRoute: typeof AuthMinimalStandardsLayoutImport
    }
    '/_auth/publisher/_publisher/': {
      id: '/_auth/publisher/_publisher/'
      path: '/'
      fullPath: '/publisher/'
      preLoaderRoute: typeof AuthPublisherPublisherIndexImport
      parentRoute: typeof AuthPublisherPublisherImport
    }
    '/_auth/report/_report/': {
      id: '/_auth/report/_report/'
      path: '/'
      fullPath: '/report/'
      preLoaderRoute: typeof AuthReportReportIndexImport
      parentRoute: typeof AuthReportReportImport
    }
    '/_auth/research-center/_research-center/': {
      id: '/_auth/research-center/_research-center/'
      path: '/'
      fullPath: '/research-center/'
      preLoaderRoute: typeof AuthResearchCenterResearchCenterIndexImport
      parentRoute: typeof AuthResearchCenterResearchCenterImport
    }
    '/_auth/research-perf-eval/_layout/': {
      id: '/_auth/research-perf-eval/_layout/'
      path: '/'
      fullPath: '/research-perf-eval/'
      preLoaderRoute: typeof AuthResearchPerfEvalLayoutIndexImport
      parentRoute: typeof AuthResearchPerfEvalLayoutImport
    }
    '/_auth/travel/_travel/': {
      id: '/_auth/travel/_travel/'
      path: '/'
      fullPath: '/travel/'
      preLoaderRoute: typeof AuthTravelTravelIndexImport
      parentRoute: typeof AuthTravelTravelImport
    }
    '/_auth/administration/_administration/department': {
      id: '/_auth/administration/_administration/department'
      path: '/department'
      fullPath: '/administration/department'
      preLoaderRoute: typeof AuthAdministrationAdministrationDepartmentImport
      parentRoute: typeof AuthAdministrationAdministrationImport
    }
    '/_auth/administration/_administration/department/_department': {
      id: '/_auth/administration/_administration/department/_department'
      path: '/department'
      fullPath: '/administration/department'
      preLoaderRoute: typeof AuthAdministrationAdministrationDepartmentDepartmentImport
      parentRoute: typeof AuthAdministrationAdministrationDepartmentRoute
    }
    '/_auth/administration/_administration/discipline': {
      id: '/_auth/administration/_administration/discipline'
      path: '/discipline'
      fullPath: '/administration/discipline'
      preLoaderRoute: typeof AuthAdministrationAdministrationDisciplineImport
      parentRoute: typeof AuthAdministrationAdministrationImport
    }
    '/_auth/administration/_administration/discipline/_discipline': {
      id: '/_auth/administration/_administration/discipline/_discipline'
      path: '/discipline'
      fullPath: '/administration/discipline'
      preLoaderRoute: typeof AuthAdministrationAdministrationDisciplineDisciplineImport
      parentRoute: typeof AuthAdministrationAdministrationDisciplineRoute
    }
    '/_auth/administration/_administration/faculty': {
      id: '/_auth/administration/_administration/faculty'
      path: '/faculty'
      fullPath: '/administration/faculty'
      preLoaderRoute: typeof AuthAdministrationAdministrationFacultyImport
      parentRoute: typeof AuthAdministrationAdministrationImport
    }
    '/_auth/administration/_administration/faculty/_faculty': {
      id: '/_auth/administration/_administration/faculty/_faculty'
      path: '/faculty'
      fullPath: '/administration/faculty'
      preLoaderRoute: typeof AuthAdministrationAdministrationFacultyFacultyImport
      parentRoute: typeof AuthAdministrationAdministrationFacultyRoute
    }
    '/_auth/administration/_administration/legal-holiday': {
      id: '/_auth/administration/_administration/legal-holiday'
      path: '/legal-holiday'
      fullPath: '/administration/legal-holiday'
      preLoaderRoute: typeof AuthAdministrationAdministrationLegalHolidayImport
      parentRoute: typeof AuthAdministrationAdministrationImport
    }
    '/_auth/administration/_administration/legal-holiday/_legal-holiday': {
      id: '/_auth/administration/_administration/legal-holiday/_legal-holiday'
      path: '/legal-holiday'
      fullPath: '/administration/legal-holiday'
      preLoaderRoute: typeof AuthAdministrationAdministrationLegalHolidayLegalHolidayImport
      parentRoute: typeof AuthAdministrationAdministrationLegalHolidayRoute
    }
    '/_auth/administration/_administration/local-accounts': {
      id: '/_auth/administration/_administration/local-accounts'
      path: '/local-accounts'
      fullPath: '/administration/local-accounts'
      preLoaderRoute: typeof AuthAdministrationAdministrationLocalAccountsImport
      parentRoute: typeof AuthAdministrationAdministrationImport
    }
    '/_auth/administration/_administration/local-accounts/_local-accounts': {
      id: '/_auth/administration/_administration/local-accounts/_local-accounts'
      path: '/local-accounts'
      fullPath: '/administration/local-accounts'
      preLoaderRoute: typeof AuthAdministrationAdministrationLocalAccountsLocalAccountsImport
      parentRoute: typeof AuthAdministrationAdministrationLocalAccountsRoute
    }
    '/_auth/administration/_administration/university-config': {
      id: '/_auth/administration/_administration/university-config'
      path: '/university-config'
      fullPath: '/administration/university-config'
      preLoaderRoute: typeof AuthAdministrationAdministrationUniversityConfigImport
      parentRoute: typeof AuthAdministrationAdministrationImport
    }
    '/_auth/administration/_administration/university-config/_university-config': {
      id: '/_auth/administration/_administration/university-config/_university-config'
      path: '/university-config'
      fullPath: '/administration/university-config'
      preLoaderRoute: typeof AuthAdministrationAdministrationUniversityConfigUniversityConfigImport
      parentRoute: typeof AuthAdministrationAdministrationUniversityConfigRoute
    }
    '/_auth/administration/_administration/user-documents': {
      id: '/_auth/administration/_administration/user-documents'
      path: '/user-documents'
      fullPath: '/administration/user-documents'
      preLoaderRoute: typeof AuthAdministrationAdministrationUserDocumentsImport
      parentRoute: typeof AuthAdministrationAdministrationImport
    }
    '/_auth/administration/_administration/user-documents/_user-documents': {
      id: '/_auth/administration/_administration/user-documents/_user-documents'
      path: '/user-documents'
      fullPath: '/administration/user-documents'
      preLoaderRoute: typeof AuthAdministrationAdministrationUserDocumentsUserDocumentsImport
      parentRoute: typeof AuthAdministrationAdministrationUserDocumentsRoute
    }
    '/_auth/author/_author/abstract': {
      id: '/_auth/author/_author/abstract'
      path: '/abstract'
      fullPath: '/author/abstract'
      preLoaderRoute: typeof AuthAuthorAuthorAbstractImport
      parentRoute: typeof AuthAuthorAuthorImport
    }
    '/_auth/author/_author/abstract/_abstract': {
      id: '/_auth/author/_author/abstract/_abstract'
      path: '/abstract'
      fullPath: '/author/abstract'
      preLoaderRoute: typeof AuthAuthorAuthorAbstractAbstractImport
      parentRoute: typeof AuthAuthorAuthorAbstractRoute
    }
    '/_auth/author/_author/article': {
      id: '/_auth/author/_author/article'
      path: '/article'
      fullPath: '/author/article'
      preLoaderRoute: typeof AuthAuthorAuthorArticleImport
      parentRoute: typeof AuthAuthorAuthorImport
    }
    '/_auth/author/_author/article/_article': {
      id: '/_auth/author/_author/article/_article'
      path: '/article'
      fullPath: '/author/article'
      preLoaderRoute: typeof AuthAuthorAuthorArticleArticleImport
      parentRoute: typeof AuthAuthorAuthorArticleRoute
    }
    '/_auth/author/_author/award': {
      id: '/_auth/author/_author/award'
      path: '/award'
      fullPath: '/author/award'
      preLoaderRoute: typeof AuthAuthorAuthorAwardImport
      parentRoute: typeof AuthAuthorAuthorImport
    }
    '/_auth/author/_author/award/_award': {
      id: '/_auth/author/_author/award/_award'
      path: '/award'
      fullPath: '/author/award'
      preLoaderRoute: typeof AuthAuthorAuthorAwardAwardImport
      parentRoute: typeof AuthAuthorAuthorAwardRoute
    }
    '/_auth/author/_author/book': {
      id: '/_auth/author/_author/book'
      path: '/book'
      fullPath: '/author/book'
      preLoaderRoute: typeof AuthAuthorAuthorBookImport
      parentRoute: typeof AuthAuthorAuthorImport
    }
    '/_auth/author/_author/book/_book': {
      id: '/_auth/author/_author/book/_book'
      path: '/book'
      fullPath: '/author/book'
      preLoaderRoute: typeof AuthAuthorAuthorBookBookImport
      parentRoute: typeof AuthAuthorAuthorBookRoute
    }
    '/_auth/author/_author/chapter': {
      id: '/_auth/author/_author/chapter'
      path: '/chapter'
      fullPath: '/author/chapter'
      preLoaderRoute: typeof AuthAuthorAuthorChapterImport
      parentRoute: typeof AuthAuthorAuthorImport
    }
    '/_auth/author/_author/chapter/_chapter': {
      id: '/_auth/author/_author/chapter/_chapter'
      path: '/chapter'
      fullPath: '/author/chapter'
      preLoaderRoute: typeof AuthAuthorAuthorChapterChapterImport
      parentRoute: typeof AuthAuthorAuthorChapterRoute
    }
    '/_auth/author/_author/committee': {
      id: '/_auth/author/_author/committee'
      path: '/committee'
      fullPath: '/author/committee'
      preLoaderRoute: typeof AuthAuthorAuthorCommitteeImport
      parentRoute: typeof AuthAuthorAuthorImport
    }
    '/_auth/author/_author/committee/_committee': {
      id: '/_auth/author/_author/committee/_committee'
      path: '/committee'
      fullPath: '/author/committee'
      preLoaderRoute: typeof AuthAuthorAuthorCommitteeCommitteeImport
      parentRoute: typeof AuthAuthorAuthorCommitteeRoute
    }
    '/_auth/author/_author/course': {
      id: '/_auth/author/_author/course'
      path: '/course'
      fullPath: '/author/course'
      preLoaderRoute: typeof AuthAuthorAuthorCourseImport
      parentRoute: typeof AuthAuthorAuthorImport
    }
    '/_auth/author/_author/course/_course': {
      id: '/_auth/author/_author/course/_course'
      path: '/course'
      fullPath: '/author/course'
      preLoaderRoute: typeof AuthAuthorAuthorCourseCourseImport
      parentRoute: typeof AuthAuthorAuthorCourseRoute
    }
    '/_auth/author/_author/dictionary': {
      id: '/_auth/author/_author/dictionary'
      path: '/dictionary'
      fullPath: '/author/dictionary'
      preLoaderRoute: typeof AuthAuthorAuthorDictionaryImport
      parentRoute: typeof AuthAuthorAuthorImport
    }
    '/_auth/author/_author/dictionary/_dictionary': {
      id: '/_auth/author/_author/dictionary/_dictionary'
      path: '/dictionary'
      fullPath: '/author/dictionary'
      preLoaderRoute: typeof AuthAuthorAuthorDictionaryDictionaryImport
      parentRoute: typeof AuthAuthorAuthorDictionaryRoute
    }
    '/_auth/author/_author/doctoral-committee': {
      id: '/_auth/author/_author/doctoral-committee'
      path: '/doctoral-committee'
      fullPath: '/author/doctoral-committee'
      preLoaderRoute: typeof AuthAuthorAuthorDoctoralCommitteeImport
      parentRoute: typeof AuthAuthorAuthorImport
    }
    '/_auth/author/_author/doctoral-committee/_doctoralCommittee': {
      id: '/_auth/author/_author/doctoral-committee/_doctoralCommittee'
      path: '/doctoral-committee'
      fullPath: '/author/doctoral-committee'
      preLoaderRoute: typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeImport
      parentRoute: typeof AuthAuthorAuthorDoctoralCommitteeRoute
    }
    '/_auth/author/_author/editorial-team': {
      id: '/_auth/author/_author/editorial-team'
      path: '/editorial-team'
      fullPath: '/author/editorial-team'
      preLoaderRoute: typeof AuthAuthorAuthorEditorialTeamImport
      parentRoute: typeof AuthAuthorAuthorImport
    }
    '/_auth/author/_author/editorial-team/_editorialTeam': {
      id: '/_auth/author/_author/editorial-team/_editorialTeam'
      path: '/editorial-team'
      fullPath: '/author/editorial-team'
      preLoaderRoute: typeof AuthAuthorAuthorEditorialTeamEditorialTeamImport
      parentRoute: typeof AuthAuthorAuthorEditorialTeamRoute
    }
    '/_auth/author/_author/mobility': {
      id: '/_auth/author/_author/mobility'
      path: '/mobility'
      fullPath: '/author/mobility'
      preLoaderRoute: typeof AuthAuthorAuthorMobilityImport
      parentRoute: typeof AuthAuthorAuthorImport
    }
    '/_auth/author/_author/mobility/_mobility': {
      id: '/_auth/author/_author/mobility/_mobility'
      path: '/mobility'
      fullPath: '/author/mobility'
      preLoaderRoute: typeof AuthAuthorAuthorMobilityMobilityImport
      parentRoute: typeof AuthAuthorAuthorMobilityRoute
    }
    '/_auth/author/_author/patent': {
      id: '/_auth/author/_author/patent'
      path: '/patent'
      fullPath: '/author/patent'
      preLoaderRoute: typeof AuthAuthorAuthorPatentImport
      parentRoute: typeof AuthAuthorAuthorImport
    }
    '/_auth/author/_author/patent/_patent': {
      id: '/_auth/author/_author/patent/_patent'
      path: '/patent'
      fullPath: '/author/patent'
      preLoaderRoute: typeof AuthAuthorAuthorPatentPatentImport
      parentRoute: typeof AuthAuthorAuthorPatentRoute
    }
    '/_auth/author/_author/presentation': {
      id: '/_auth/author/_author/presentation'
      path: '/presentation'
      fullPath: '/author/presentation'
      preLoaderRoute: typeof AuthAuthorAuthorPresentationImport
      parentRoute: typeof AuthAuthorAuthorImport
    }
    '/_auth/author/_author/presentation/_presentation': {
      id: '/_auth/author/_author/presentation/_presentation'
      path: '/presentation'
      fullPath: '/author/presentation'
      preLoaderRoute: typeof AuthAuthorAuthorPresentationPresentationImport
      parentRoute: typeof AuthAuthorAuthorPresentationRoute
    }
    '/_auth/author/_author/proceeding': {
      id: '/_auth/author/_author/proceeding'
      path: '/proceeding'
      fullPath: '/author/proceeding'
      preLoaderRoute: typeof AuthAuthorAuthorProceedingImport
      parentRoute: typeof AuthAuthorAuthorImport
    }
    '/_auth/author/_author/proceeding/_proceeding': {
      id: '/_auth/author/_author/proceeding/_proceeding'
      path: '/proceeding'
      fullPath: '/author/proceeding'
      preLoaderRoute: typeof AuthAuthorAuthorProceedingProceedingImport
      parentRoute: typeof AuthAuthorAuthorProceedingRoute
    }
    '/_auth/author/_author/project': {
      id: '/_auth/author/_author/project'
      path: '/project'
      fullPath: '/author/project'
      preLoaderRoute: typeof AuthAuthorAuthorProjectImport
      parentRoute: typeof AuthAuthorAuthorImport
    }
    '/_auth/author/_author/project/_project': {
      id: '/_auth/author/_author/project/_project'
      path: '/project'
      fullPath: '/author/project'
      preLoaderRoute: typeof AuthAuthorAuthorProjectProjectImport
      parentRoute: typeof AuthAuthorAuthorProjectRoute
    }
    '/_auth/author/_author/review': {
      id: '/_auth/author/_author/review'
      path: '/review'
      fullPath: '/author/review'
      preLoaderRoute: typeof AuthAuthorAuthorReviewImport
      parentRoute: typeof AuthAuthorAuthorImport
    }
    '/_auth/author/_author/review/_review': {
      id: '/_auth/author/_author/review/_review'
      path: '/review'
      fullPath: '/author/review'
      preLoaderRoute: typeof AuthAuthorAuthorReviewReviewImport
      parentRoute: typeof AuthAuthorAuthorReviewRoute
    }
    '/_auth/author/_author/technological-transfer': {
      id: '/_auth/author/_author/technological-transfer'
      path: '/technological-transfer'
      fullPath: '/author/technological-transfer'
      preLoaderRoute: typeof AuthAuthorAuthorTechnologicalTransferImport
      parentRoute: typeof AuthAuthorAuthorImport
    }
    '/_auth/author/_author/technological-transfer/_technologicalTransfer': {
      id: '/_auth/author/_author/technological-transfer/_technologicalTransfer'
      path: '/technological-transfer'
      fullPath: '/author/technological-transfer'
      preLoaderRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferImport
      parentRoute: typeof AuthAuthorAuthorTechnologicalTransferRoute
    }
    '/_auth/author/_author/translation': {
      id: '/_auth/author/_author/translation'
      path: '/translation'
      fullPath: '/author/translation'
      preLoaderRoute: typeof AuthAuthorAuthorTranslationImport
      parentRoute: typeof AuthAuthorAuthorImport
    }
    '/_auth/author/_author/translation/_translation': {
      id: '/_auth/author/_author/translation/_translation'
      path: '/translation'
      fullPath: '/author/translation'
      preLoaderRoute: typeof AuthAuthorAuthorTranslationTranslationImport
      parentRoute: typeof AuthAuthorAuthorTranslationRoute
    }
    '/_auth/conference/_conference/$conferenceId': {
      id: '/_auth/conference/_conference/$conferenceId'
      path: '/$conferenceId'
      fullPath: '/conference/$conferenceId'
      preLoaderRoute: typeof AuthConferenceConferenceConferenceIdImport
      parentRoute: typeof AuthConferenceConferenceImport
    }
    '/_auth/conference/_conference/$conferenceId/_layout': {
      id: '/_auth/conference/_conference/$conferenceId/_layout'
      path: '/$conferenceId'
      fullPath: '/conference/$conferenceId'
      preLoaderRoute: typeof AuthConferenceConferenceConferenceIdLayoutImport
      parentRoute: typeof AuthConferenceConferenceConferenceIdRoute
    }
    '/_auth/evaluation/_layout/$evaluationId': {
      id: '/_auth/evaluation/_layout/$evaluationId'
      path: '/$evaluationId'
      fullPath: '/evaluation/$evaluationId'
      preLoaderRoute: typeof AuthEvaluationLayoutEvaluationIdImport
      parentRoute: typeof AuthEvaluationLayoutImport
    }
    '/_auth/evaluation/_layout/$evaluationId/_layout': {
      id: '/_auth/evaluation/_layout/$evaluationId/_layout'
      path: '/$evaluationId'
      fullPath: '/evaluation/$evaluationId'
      preLoaderRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutImport
      parentRoute: typeof AuthEvaluationLayoutEvaluationIdRoute
    }
    '/_auth/evaluation/_layout/$evaluationId/department-summary-results': {
      id: '/_auth/evaluation/_layout/$evaluationId/department-summary-results'
      path: '/department-summary-results'
      fullPath: '/evaluation/$evaluationId/department-summary-results'
      preLoaderRoute: typeof AuthEvaluationLayoutEvaluationIdDepartmentSummaryResultsImport
      parentRoute: typeof AuthEvaluationLayoutEvaluationIdImport
    }
    '/_auth/evaluation/_layout/$evaluationId/faculty-summary-results': {
      id: '/_auth/evaluation/_layout/$evaluationId/faculty-summary-results'
      path: '/faculty-summary-results'
      fullPath: '/evaluation/$evaluationId/faculty-summary-results'
      preLoaderRoute: typeof AuthEvaluationLayoutEvaluationIdFacultySummaryResultsImport
      parentRoute: typeof AuthEvaluationLayoutEvaluationIdImport
    }
    '/_auth/gov-evaluation/_layout/$evaluationId': {
      id: '/_auth/gov-evaluation/_layout/$evaluationId'
      path: '/$evaluationId'
      fullPath: '/gov-evaluation/$evaluationId'
      preLoaderRoute: typeof AuthGovEvaluationLayoutEvaluationIdImport
      parentRoute: typeof AuthGovEvaluationLayoutImport
    }
    '/_auth/gov-evaluation/_layout/$evaluationId/_layout': {
      id: '/_auth/gov-evaluation/_layout/$evaluationId/_layout'
      path: '/$evaluationId'
      fullPath: '/gov-evaluation/$evaluationId'
      preLoaderRoute: typeof AuthGovEvaluationLayoutEvaluationIdLayoutImport
      parentRoute: typeof AuthGovEvaluationLayoutEvaluationIdRoute
    }
    '/_auth/journal/_journal/$journalId': {
      id: '/_auth/journal/_journal/$journalId'
      path: '/$journalId'
      fullPath: '/journal/$journalId'
      preLoaderRoute: typeof AuthJournalJournalJournalIdImport
      parentRoute: typeof AuthJournalJournalImport
    }
    '/_auth/journal/_journal/$journalId/_layout': {
      id: '/_auth/journal/_journal/$journalId/_layout'
      path: '/$journalId'
      fullPath: '/journal/$journalId'
      preLoaderRoute: typeof AuthJournalJournalJournalIdLayoutImport
      parentRoute: typeof AuthJournalJournalJournalIdRoute
    }
    '/_auth/publisher/_publisher/$publisherId': {
      id: '/_auth/publisher/_publisher/$publisherId'
      path: '/$publisherId'
      fullPath: '/publisher/$publisherId'
      preLoaderRoute: typeof AuthPublisherPublisherPublisherIdImport
      parentRoute: typeof AuthPublisherPublisherImport
    }
    '/_auth/publisher/_publisher/$publisherId/_layout': {
      id: '/_auth/publisher/_publisher/$publisherId/_layout'
      path: '/$publisherId'
      fullPath: '/publisher/$publisherId'
      preLoaderRoute: typeof AuthPublisherPublisherPublisherIdLayoutImport
      parentRoute: typeof AuthPublisherPublisherPublisherIdRoute
    }
    '/_auth/research-center/_research-center/$researchCenterId': {
      id: '/_auth/research-center/_research-center/$researchCenterId'
      path: '/$researchCenterId'
      fullPath: '/research-center/$researchCenterId'
      preLoaderRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdImport
      parentRoute: typeof AuthResearchCenterResearchCenterImport
    }
    '/_auth/research-center/_research-center/$researchCenterId/_layout': {
      id: '/_auth/research-center/_research-center/$researchCenterId/_layout'
      path: '/$researchCenterId'
      fullPath: '/research-center/$researchCenterId'
      preLoaderRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutImport
      parentRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdRoute
    }
    '/_auth/research-perf-eval/_layout/$evaluationId': {
      id: '/_auth/research-perf-eval/_layout/$evaluationId'
      path: '/$evaluationId'
      fullPath: '/research-perf-eval/$evaluationId'
      preLoaderRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdImport
      parentRoute: typeof AuthResearchPerfEvalLayoutImport
    }
    '/_auth/research-perf-eval/_layout/$evaluationId/_layout': {
      id: '/_auth/research-perf-eval/_layout/$evaluationId/_layout'
      path: '/$evaluationId'
      fullPath: '/research-perf-eval/$evaluationId'
      preLoaderRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutImport
      parentRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdRoute
    }
    '/_auth/travel/_travel/requests/create': {
      id: '/_auth/travel/_travel/requests/create'
      path: '/requests/create'
      fullPath: '/travel/requests/create'
      preLoaderRoute: typeof AuthTravelTravelRequestsCreateImport
      parentRoute: typeof AuthTravelTravelImport
    }
    '/_auth/travel/_travel/analytics/': {
      id: '/_auth/travel/_travel/analytics/'
      path: '/analytics'
      fullPath: '/travel/analytics'
      preLoaderRoute: typeof AuthTravelTravelAnalyticsIndexImport
      parentRoute: typeof AuthTravelTravelImport
    }
    '/_auth/travel/_travel/approvals/': {
      id: '/_auth/travel/_travel/approvals/'
      path: '/approvals'
      fullPath: '/travel/approvals'
      preLoaderRoute: typeof AuthTravelTravelApprovalsIndexImport
      parentRoute: typeof AuthTravelTravelImport
    }
    '/_auth/travel/_travel/board-requests/': {
      id: '/_auth/travel/_travel/board-requests/'
      path: '/board-requests'
      fullPath: '/travel/board-requests'
      preLoaderRoute: typeof AuthTravelTravelBoardRequestsIndexImport
      parentRoute: typeof AuthTravelTravelImport
    }
    '/_auth/travel/_travel/days/': {
      id: '/_auth/travel/_travel/days/'
      path: '/days'
      fullPath: '/travel/days'
      preLoaderRoute: typeof AuthTravelTravelDaysIndexImport
      parentRoute: typeof AuthTravelTravelImport
    }
    '/_auth/travel/_travel/documents/': {
      id: '/_auth/travel/_travel/documents/'
      path: '/documents'
      fullPath: '/travel/documents'
      preLoaderRoute: typeof AuthTravelTravelDocumentsIndexImport
      parentRoute: typeof AuthTravelTravelImport
    }
    '/_auth/travel/_travel/registry/': {
      id: '/_auth/travel/_travel/registry/'
      path: '/registry'
      fullPath: '/travel/registry'
      preLoaderRoute: typeof AuthTravelTravelRegistryIndexImport
      parentRoute: typeof AuthTravelTravelImport
    }
    '/_auth/travel/_travel/requests/': {
      id: '/_auth/travel/_travel/requests/'
      path: '/requests'
      fullPath: '/travel/requests'
      preLoaderRoute: typeof AuthTravelTravelRequestsIndexImport
      parentRoute: typeof AuthTravelTravelImport
    }
    '/_auth/travel/_travel/settings/': {
      id: '/_auth/travel/_travel/settings/'
      path: '/settings'
      fullPath: '/travel/settings'
      preLoaderRoute: typeof AuthTravelTravelSettingsIndexImport
      parentRoute: typeof AuthTravelTravelImport
    }
    '/_auth/administration/_administration/department/_department/create': {
      id: '/_auth/administration/_administration/department/_department/create'
      path: '/create'
      fullPath: '/administration/department/create'
      preLoaderRoute: typeof AuthAdministrationAdministrationDepartmentDepartmentCreateImport
      parentRoute: typeof AuthAdministrationAdministrationDepartmentDepartmentImport
    }
    '/_auth/administration/_administration/discipline/_discipline/create': {
      id: '/_auth/administration/_administration/discipline/_discipline/create'
      path: '/create'
      fullPath: '/administration/discipline/create'
      preLoaderRoute: typeof AuthAdministrationAdministrationDisciplineDisciplineCreateImport
      parentRoute: typeof AuthAdministrationAdministrationDisciplineDisciplineImport
    }
    '/_auth/administration/_administration/faculty/_faculty/create': {
      id: '/_auth/administration/_administration/faculty/_faculty/create'
      path: '/create'
      fullPath: '/administration/faculty/create'
      preLoaderRoute: typeof AuthAdministrationAdministrationFacultyFacultyCreateImport
      parentRoute: typeof AuthAdministrationAdministrationFacultyFacultyImport
    }
    '/_auth/author/_author/abstract/_abstract/create': {
      id: '/_auth/author/_author/abstract/_abstract/create'
      path: '/create'
      fullPath: '/author/abstract/create'
      preLoaderRoute: typeof AuthAuthorAuthorAbstractAbstractCreateImport
      parentRoute: typeof AuthAuthorAuthorAbstractAbstractImport
    }
    '/_auth/author/_author/abstract/_abstract/search-claimable': {
      id: '/_auth/author/_author/abstract/_abstract/search-claimable'
      path: '/search-claimable'
      fullPath: '/author/abstract/search-claimable'
      preLoaderRoute: typeof AuthAuthorAuthorAbstractAbstractSearchClaimableImport
      parentRoute: typeof AuthAuthorAuthorAbstractAbstractImport
    }
    '/_auth/author/_author/article/_article/create': {
      id: '/_auth/author/_author/article/_article/create'
      path: '/create'
      fullPath: '/author/article/create'
      preLoaderRoute: typeof AuthAuthorAuthorArticleArticleCreateImport
      parentRoute: typeof AuthAuthorAuthorArticleArticleImport
    }
    '/_auth/author/_author/article/_article/search-claimable': {
      id: '/_auth/author/_author/article/_article/search-claimable'
      path: '/search-claimable'
      fullPath: '/author/article/search-claimable'
      preLoaderRoute: typeof AuthAuthorAuthorArticleArticleSearchClaimableImport
      parentRoute: typeof AuthAuthorAuthorArticleArticleImport
    }
    '/_auth/author/_author/award/_award/create': {
      id: '/_auth/author/_author/award/_award/create'
      path: '/create'
      fullPath: '/author/award/create'
      preLoaderRoute: typeof AuthAuthorAuthorAwardAwardCreateImport
      parentRoute: typeof AuthAuthorAuthorAwardAwardImport
    }
    '/_auth/author/_author/book/_book/create': {
      id: '/_auth/author/_author/book/_book/create'
      path: '/create'
      fullPath: '/author/book/create'
      preLoaderRoute: typeof AuthAuthorAuthorBookBookCreateImport
      parentRoute: typeof AuthAuthorAuthorBookBookImport
    }
    '/_auth/author/_author/book/_book/search-claimable': {
      id: '/_auth/author/_author/book/_book/search-claimable'
      path: '/search-claimable'
      fullPath: '/author/book/search-claimable'
      preLoaderRoute: typeof AuthAuthorAuthorBookBookSearchClaimableImport
      parentRoute: typeof AuthAuthorAuthorBookBookImport
    }
    '/_auth/author/_author/chapter/_chapter/create': {
      id: '/_auth/author/_author/chapter/_chapter/create'
      path: '/create'
      fullPath: '/author/chapter/create'
      preLoaderRoute: typeof AuthAuthorAuthorChapterChapterCreateImport
      parentRoute: typeof AuthAuthorAuthorChapterChapterImport
    }
    '/_auth/author/_author/chapter/_chapter/search-claimable': {
      id: '/_auth/author/_author/chapter/_chapter/search-claimable'
      path: '/search-claimable'
      fullPath: '/author/chapter/search-claimable'
      preLoaderRoute: typeof AuthAuthorAuthorChapterChapterSearchClaimableImport
      parentRoute: typeof AuthAuthorAuthorChapterChapterImport
    }
    '/_auth/author/_author/committee/_committee/create': {
      id: '/_auth/author/_author/committee/_committee/create'
      path: '/create'
      fullPath: '/author/committee/create'
      preLoaderRoute: typeof AuthAuthorAuthorCommitteeCommitteeCreateImport
      parentRoute: typeof AuthAuthorAuthorCommitteeCommitteeImport
    }
    '/_auth/author/_author/course/_course/create': {
      id: '/_auth/author/_author/course/_course/create'
      path: '/create'
      fullPath: '/author/course/create'
      preLoaderRoute: typeof AuthAuthorAuthorCourseCourseCreateImport
      parentRoute: typeof AuthAuthorAuthorCourseCourseImport
    }
    '/_auth/author/_author/dictionary/_dictionary/create': {
      id: '/_auth/author/_author/dictionary/_dictionary/create'
      path: '/create'
      fullPath: '/author/dictionary/create'
      preLoaderRoute: typeof AuthAuthorAuthorDictionaryDictionaryCreateImport
      parentRoute: typeof AuthAuthorAuthorDictionaryDictionaryImport
    }
    '/_auth/author/_author/doctoral-committee/_doctoralCommittee/create': {
      id: '/_auth/author/_author/doctoral-committee/_doctoralCommittee/create'
      path: '/create'
      fullPath: '/author/doctoral-committee/create'
      preLoaderRoute: typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeCreateImport
      parentRoute: typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeImport
    }
    '/_auth/author/_author/editorial-team/_editorialTeam/create': {
      id: '/_auth/author/_author/editorial-team/_editorialTeam/create'
      path: '/create'
      fullPath: '/author/editorial-team/create'
      preLoaderRoute: typeof AuthAuthorAuthorEditorialTeamEditorialTeamCreateImport
      parentRoute: typeof AuthAuthorAuthorEditorialTeamEditorialTeamImport
    }
    '/_auth/author/_author/mobility/_mobility/create': {
      id: '/_auth/author/_author/mobility/_mobility/create'
      path: '/create'
      fullPath: '/author/mobility/create'
      preLoaderRoute: typeof AuthAuthorAuthorMobilityMobilityCreateImport
      parentRoute: typeof AuthAuthorAuthorMobilityMobilityImport
    }
    '/_auth/author/_author/patent/_patent/create': {
      id: '/_auth/author/_author/patent/_patent/create'
      path: '/create'
      fullPath: '/author/patent/create'
      preLoaderRoute: typeof AuthAuthorAuthorPatentPatentCreateImport
      parentRoute: typeof AuthAuthorAuthorPatentPatentImport
    }
    '/_auth/author/_author/patent/_patent/search-claimable': {
      id: '/_auth/author/_author/patent/_patent/search-claimable'
      path: '/search-claimable'
      fullPath: '/author/patent/search-claimable'
      preLoaderRoute: typeof AuthAuthorAuthorPatentPatentSearchClaimableImport
      parentRoute: typeof AuthAuthorAuthorPatentPatentImport
    }
    '/_auth/author/_author/presentation/_presentation/create': {
      id: '/_auth/author/_author/presentation/_presentation/create'
      path: '/create'
      fullPath: '/author/presentation/create'
      preLoaderRoute: typeof AuthAuthorAuthorPresentationPresentationCreateImport
      parentRoute: typeof AuthAuthorAuthorPresentationPresentationImport
    }
    '/_auth/author/_author/proceeding/_proceeding/create': {
      id: '/_auth/author/_author/proceeding/_proceeding/create'
      path: '/create'
      fullPath: '/author/proceeding/create'
      preLoaderRoute: typeof AuthAuthorAuthorProceedingProceedingCreateImport
      parentRoute: typeof AuthAuthorAuthorProceedingProceedingImport
    }
    '/_auth/author/_author/proceeding/_proceeding/search-claimable': {
      id: '/_auth/author/_author/proceeding/_proceeding/search-claimable'
      path: '/search-claimable'
      fullPath: '/author/proceeding/search-claimable'
      preLoaderRoute: typeof AuthAuthorAuthorProceedingProceedingSearchClaimableImport
      parentRoute: typeof AuthAuthorAuthorProceedingProceedingImport
    }
    '/_auth/author/_author/project/_project/create': {
      id: '/_auth/author/_author/project/_project/create'
      path: '/create'
      fullPath: '/author/project/create'
      preLoaderRoute: typeof AuthAuthorAuthorProjectProjectCreateImport
      parentRoute: typeof AuthAuthorAuthorProjectProjectImport
    }
    '/_auth/author/_author/project/_project/search-claimable': {
      id: '/_auth/author/_author/project/_project/search-claimable'
      path: '/search-claimable'
      fullPath: '/author/project/search-claimable'
      preLoaderRoute: typeof AuthAuthorAuthorProjectProjectSearchClaimableImport
      parentRoute: typeof AuthAuthorAuthorProjectProjectImport
    }
    '/_auth/author/_author/review/_review/create': {
      id: '/_auth/author/_author/review/_review/create'
      path: '/create'
      fullPath: '/author/review/create'
      preLoaderRoute: typeof AuthAuthorAuthorReviewReviewCreateImport
      parentRoute: typeof AuthAuthorAuthorReviewReviewImport
    }
    '/_auth/author/_author/review/_review/search-claimable': {
      id: '/_auth/author/_author/review/_review/search-claimable'
      path: '/search-claimable'
      fullPath: '/author/review/search-claimable'
      preLoaderRoute: typeof AuthAuthorAuthorReviewReviewSearchClaimableImport
      parentRoute: typeof AuthAuthorAuthorReviewReviewImport
    }
    '/_auth/author/_author/technological-transfer/_technologicalTransfer/create': {
      id: '/_auth/author/_author/technological-transfer/_technologicalTransfer/create'
      path: '/create'
      fullPath: '/author/technological-transfer/create'
      preLoaderRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferCreateImport
      parentRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferImport
    }
    '/_auth/author/_author/technological-transfer/_technologicalTransfer/search-claimable': {
      id: '/_auth/author/_author/technological-transfer/_technologicalTransfer/search-claimable'
      path: '/search-claimable'
      fullPath: '/author/technological-transfer/search-claimable'
      preLoaderRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferSearchClaimableImport
      parentRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferImport
    }
    '/_auth/author/_author/translation/_translation/create': {
      id: '/_auth/author/_author/translation/_translation/create'
      path: '/create'
      fullPath: '/author/translation/create'
      preLoaderRoute: typeof AuthAuthorAuthorTranslationTranslationCreateImport
      parentRoute: typeof AuthAuthorAuthorTranslationTranslationImport
    }
    '/_auth/author/_author/translation/_translation/search-claimable': {
      id: '/_auth/author/_author/translation/_translation/search-claimable'
      path: '/search-claimable'
      fullPath: '/author/translation/search-claimable'
      preLoaderRoute: typeof AuthAuthorAuthorTranslationTranslationSearchClaimableImport
      parentRoute: typeof AuthAuthorAuthorTranslationTranslationImport
    }
    '/_auth/conference/_conference/$conferenceId/_layout/edit': {
      id: '/_auth/conference/_conference/$conferenceId/_layout/edit'
      path: '/edit'
      fullPath: '/conference/$conferenceId/edit'
      preLoaderRoute: typeof AuthConferenceConferenceConferenceIdLayoutEditImport
      parentRoute: typeof AuthConferenceConferenceConferenceIdLayoutImport
    }
    '/_auth/journal/_journal/$journalId/_layout/article-influence-score': {
      id: '/_auth/journal/_journal/$journalId/_layout/article-influence-score'
      path: '/article-influence-score'
      fullPath: '/journal/$journalId/article-influence-score'
      preLoaderRoute: typeof AuthJournalJournalJournalIdLayoutArticleInfluenceScoreImport
      parentRoute: typeof AuthJournalJournalJournalIdLayoutImport
    }
    '/_auth/journal/_journal/$journalId/_layout/edit': {
      id: '/_auth/journal/_journal/$journalId/_layout/edit'
      path: '/edit'
      fullPath: '/journal/$journalId/edit'
      preLoaderRoute: typeof AuthJournalJournalJournalIdLayoutEditImport
      parentRoute: typeof AuthJournalJournalJournalIdLayoutImport
    }
    '/_auth/journal/_journal/$journalId/_layout/impact-factor': {
      id: '/_auth/journal/_journal/$journalId/_layout/impact-factor'
      path: '/impact-factor'
      fullPath: '/journal/$journalId/impact-factor'
      preLoaderRoute: typeof AuthJournalJournalJournalIdLayoutImpactFactorImport
      parentRoute: typeof AuthJournalJournalJournalIdLayoutImport
    }
    '/_auth/minimal-standards/_layout/report/gather': {
      id: '/_auth/minimal-standards/_layout/report/gather'
      path: '/report/gather'
      fullPath: '/minimal-standards/report/gather'
      preLoaderRoute: typeof AuthMinimalStandardsLayoutReportGatherImport
      parentRoute: typeof AuthMinimalStandardsLayoutImport
    }
    '/_auth/minimal-standards/_layout/report/gather/_gather': {
      id: '/_auth/minimal-standards/_layout/report/gather/_gather'
      path: '/report/gather'
      fullPath: '/minimal-standards/report/gather'
      preLoaderRoute: typeof AuthMinimalStandardsLayoutReportGatherGatherImport
      parentRoute: typeof AuthMinimalStandardsLayoutReportGatherRoute
    }
    '/_auth/publisher/_publisher/$publisherId/_layout/edit': {
      id: '/_auth/publisher/_publisher/$publisherId/_layout/edit'
      path: '/edit'
      fullPath: '/publisher/$publisherId/edit'
      preLoaderRoute: typeof AuthPublisherPublisherPublisherIdLayoutEditImport
      parentRoute: typeof AuthPublisherPublisherPublisherIdLayoutImport
    }
    '/_auth/research-center/_research-center/$researchCenterId/_layout/create': {
      id: '/_auth/research-center/_research-center/$researchCenterId/_layout/create'
      path: '/create'
      fullPath: '/research-center/$researchCenterId/create'
      preLoaderRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutCreateImport
      parentRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutImport
    }
    '/_auth/research-center/_research-center/$researchCenterId/_layout/edit': {
      id: '/_auth/research-center/_research-center/$researchCenterId/_layout/edit'
      path: '/edit'
      fullPath: '/research-center/$researchCenterId/edit'
      preLoaderRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutEditImport
      parentRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutImport
    }
    '/_auth/travel/_travel/requests/$requestId': {
      id: '/_auth/travel/_travel/requests/$requestId'
      path: '/requests/$requestId'
      fullPath: '/travel/requests/$requestId'
      preLoaderRoute: typeof AuthTravelTravelRequestsRequestIdImport
      parentRoute: typeof AuthTravelTravelImport
    }
    '/_auth/travel/_travel/requests/$requestId/_layout': {
      id: '/_auth/travel/_travel/requests/$requestId/_layout'
      path: '/requests/$requestId'
      fullPath: '/travel/requests/$requestId'
      preLoaderRoute: typeof AuthTravelTravelRequestsRequestIdLayoutImport
      parentRoute: typeof AuthTravelTravelRequestsRequestIdRoute
    }
    '/_auth/administration/_administration/department/_department/': {
      id: '/_auth/administration/_administration/department/_department/'
      path: '/'
      fullPath: '/administration/department/'
      preLoaderRoute: typeof AuthAdministrationAdministrationDepartmentDepartmentIndexImport
      parentRoute: typeof AuthAdministrationAdministrationDepartmentDepartmentImport
    }
    '/_auth/administration/_administration/discipline/_discipline/': {
      id: '/_auth/administration/_administration/discipline/_discipline/'
      path: '/'
      fullPath: '/administration/discipline/'
      preLoaderRoute: typeof AuthAdministrationAdministrationDisciplineDisciplineIndexImport
      parentRoute: typeof AuthAdministrationAdministrationDisciplineDisciplineImport
    }
    '/_auth/administration/_administration/faculty/_faculty/': {
      id: '/_auth/administration/_administration/faculty/_faculty/'
      path: '/'
      fullPath: '/administration/faculty/'
      preLoaderRoute: typeof AuthAdministrationAdministrationFacultyFacultyIndexImport
      parentRoute: typeof AuthAdministrationAdministrationFacultyFacultyImport
    }
    '/_auth/administration/_administration/legal-holiday/_legal-holiday/': {
      id: '/_auth/administration/_administration/legal-holiday/_legal-holiday/'
      path: '/'
      fullPath: '/administration/legal-holiday/'
      preLoaderRoute: typeof AuthAdministrationAdministrationLegalHolidayLegalHolidayIndexImport
      parentRoute: typeof AuthAdministrationAdministrationLegalHolidayLegalHolidayImport
    }
    '/_auth/administration/_administration/local-accounts/_local-accounts/': {
      id: '/_auth/administration/_administration/local-accounts/_local-accounts/'
      path: '/'
      fullPath: '/administration/local-accounts/'
      preLoaderRoute: typeof AuthAdministrationAdministrationLocalAccountsLocalAccountsIndexImport
      parentRoute: typeof AuthAdministrationAdministrationLocalAccountsLocalAccountsImport
    }
    '/_auth/administration/_administration/university-config/_university-config/': {
      id: '/_auth/administration/_administration/university-config/_university-config/'
      path: '/'
      fullPath: '/administration/university-config/'
      preLoaderRoute: typeof AuthAdministrationAdministrationUniversityConfigUniversityConfigIndexImport
      parentRoute: typeof AuthAdministrationAdministrationUniversityConfigUniversityConfigImport
    }
    '/_auth/administration/_administration/user-documents/_user-documents/': {
      id: '/_auth/administration/_administration/user-documents/_user-documents/'
      path: '/'
      fullPath: '/administration/user-documents/'
      preLoaderRoute: typeof AuthAdministrationAdministrationUserDocumentsUserDocumentsIndexImport
      parentRoute: typeof AuthAdministrationAdministrationUserDocumentsUserDocumentsImport
    }
    '/_auth/author/_author/abstract/_abstract/': {
      id: '/_auth/author/_author/abstract/_abstract/'
      path: '/'
      fullPath: '/author/abstract/'
      preLoaderRoute: typeof AuthAuthorAuthorAbstractAbstractIndexImport
      parentRoute: typeof AuthAuthorAuthorAbstractAbstractImport
    }
    '/_auth/author/_author/article/_article/': {
      id: '/_auth/author/_author/article/_article/'
      path: '/'
      fullPath: '/author/article/'
      preLoaderRoute: typeof AuthAuthorAuthorArticleArticleIndexImport
      parentRoute: typeof AuthAuthorAuthorArticleArticleImport
    }
    '/_auth/author/_author/award/_award/': {
      id: '/_auth/author/_author/award/_award/'
      path: '/'
      fullPath: '/author/award/'
      preLoaderRoute: typeof AuthAuthorAuthorAwardAwardIndexImport
      parentRoute: typeof AuthAuthorAuthorAwardAwardImport
    }
    '/_auth/author/_author/book/_book/': {
      id: '/_auth/author/_author/book/_book/'
      path: '/'
      fullPath: '/author/book/'
      preLoaderRoute: typeof AuthAuthorAuthorBookBookIndexImport
      parentRoute: typeof AuthAuthorAuthorBookBookImport
    }
    '/_auth/author/_author/chapter/_chapter/': {
      id: '/_auth/author/_author/chapter/_chapter/'
      path: '/'
      fullPath: '/author/chapter/'
      preLoaderRoute: typeof AuthAuthorAuthorChapterChapterIndexImport
      parentRoute: typeof AuthAuthorAuthorChapterChapterImport
    }
    '/_auth/author/_author/committee/_committee/': {
      id: '/_auth/author/_author/committee/_committee/'
      path: '/'
      fullPath: '/author/committee/'
      preLoaderRoute: typeof AuthAuthorAuthorCommitteeCommitteeIndexImport
      parentRoute: typeof AuthAuthorAuthorCommitteeCommitteeImport
    }
    '/_auth/author/_author/course/_course/': {
      id: '/_auth/author/_author/course/_course/'
      path: '/'
      fullPath: '/author/course/'
      preLoaderRoute: typeof AuthAuthorAuthorCourseCourseIndexImport
      parentRoute: typeof AuthAuthorAuthorCourseCourseImport
    }
    '/_auth/author/_author/dictionary/_dictionary/': {
      id: '/_auth/author/_author/dictionary/_dictionary/'
      path: '/'
      fullPath: '/author/dictionary/'
      preLoaderRoute: typeof AuthAuthorAuthorDictionaryDictionaryIndexImport
      parentRoute: typeof AuthAuthorAuthorDictionaryDictionaryImport
    }
    '/_auth/author/_author/doctoral-committee/_doctoralCommittee/': {
      id: '/_auth/author/_author/doctoral-committee/_doctoralCommittee/'
      path: '/'
      fullPath: '/author/doctoral-committee/'
      preLoaderRoute: typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeIndexImport
      parentRoute: typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeImport
    }
    '/_auth/author/_author/editorial-team/_editorialTeam/': {
      id: '/_auth/author/_author/editorial-team/_editorialTeam/'
      path: '/'
      fullPath: '/author/editorial-team/'
      preLoaderRoute: typeof AuthAuthorAuthorEditorialTeamEditorialTeamIndexImport
      parentRoute: typeof AuthAuthorAuthorEditorialTeamEditorialTeamImport
    }
    '/_auth/author/_author/mobility/_mobility/': {
      id: '/_auth/author/_author/mobility/_mobility/'
      path: '/'
      fullPath: '/author/mobility/'
      preLoaderRoute: typeof AuthAuthorAuthorMobilityMobilityIndexImport
      parentRoute: typeof AuthAuthorAuthorMobilityMobilityImport
    }
    '/_auth/author/_author/patent/_patent/': {
      id: '/_auth/author/_author/patent/_patent/'
      path: '/'
      fullPath: '/author/patent/'
      preLoaderRoute: typeof AuthAuthorAuthorPatentPatentIndexImport
      parentRoute: typeof AuthAuthorAuthorPatentPatentImport
    }
    '/_auth/author/_author/presentation/_presentation/': {
      id: '/_auth/author/_author/presentation/_presentation/'
      path: '/'
      fullPath: '/author/presentation/'
      preLoaderRoute: typeof AuthAuthorAuthorPresentationPresentationIndexImport
      parentRoute: typeof AuthAuthorAuthorPresentationPresentationImport
    }
    '/_auth/author/_author/proceeding/_proceeding/': {
      id: '/_auth/author/_author/proceeding/_proceeding/'
      path: '/'
      fullPath: '/author/proceeding/'
      preLoaderRoute: typeof AuthAuthorAuthorProceedingProceedingIndexImport
      parentRoute: typeof AuthAuthorAuthorProceedingProceedingImport
    }
    '/_auth/author/_author/project/_project/': {
      id: '/_auth/author/_author/project/_project/'
      path: '/'
      fullPath: '/author/project/'
      preLoaderRoute: typeof AuthAuthorAuthorProjectProjectIndexImport
      parentRoute: typeof AuthAuthorAuthorProjectProjectImport
    }
    '/_auth/author/_author/review/_review/': {
      id: '/_auth/author/_author/review/_review/'
      path: '/'
      fullPath: '/author/review/'
      preLoaderRoute: typeof AuthAuthorAuthorReviewReviewIndexImport
      parentRoute: typeof AuthAuthorAuthorReviewReviewImport
    }
    '/_auth/author/_author/technological-transfer/_technologicalTransfer/': {
      id: '/_auth/author/_author/technological-transfer/_technologicalTransfer/'
      path: '/'
      fullPath: '/author/technological-transfer/'
      preLoaderRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferIndexImport
      parentRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferImport
    }
    '/_auth/author/_author/translation/_translation/': {
      id: '/_auth/author/_author/translation/_translation/'
      path: '/'
      fullPath: '/author/translation/'
      preLoaderRoute: typeof AuthAuthorAuthorTranslationTranslationIndexImport
      parentRoute: typeof AuthAuthorAuthorTranslationTranslationImport
    }
    '/_auth/conference/_conference/$conferenceId/_layout/': {
      id: '/_auth/conference/_conference/$conferenceId/_layout/'
      path: '/'
      fullPath: '/conference/$conferenceId/'
      preLoaderRoute: typeof AuthConferenceConferenceConferenceIdLayoutIndexImport
      parentRoute: typeof AuthConferenceConferenceConferenceIdLayoutImport
    }
    '/_auth/evaluation/_layout/$evaluationId/_layout/': {
      id: '/_auth/evaluation/_layout/$evaluationId/_layout/'
      path: '/'
      fullPath: '/evaluation/$evaluationId/'
      preLoaderRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutIndexImport
      parentRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutImport
    }
    '/_auth/gov-evaluation/_layout/$evaluationId/_layout/': {
      id: '/_auth/gov-evaluation/_layout/$evaluationId/_layout/'
      path: '/'
      fullPath: '/gov-evaluation/$evaluationId/'
      preLoaderRoute: typeof AuthGovEvaluationLayoutEvaluationIdLayoutIndexImport
      parentRoute: typeof AuthGovEvaluationLayoutEvaluationIdLayoutImport
    }
    '/_auth/journal/_journal/$journalId/_layout/': {
      id: '/_auth/journal/_journal/$journalId/_layout/'
      path: '/'
      fullPath: '/journal/$journalId/'
      preLoaderRoute: typeof AuthJournalJournalJournalIdLayoutIndexImport
      parentRoute: typeof AuthJournalJournalJournalIdLayoutImport
    }
    '/_auth/publisher/_publisher/$publisherId/_layout/': {
      id: '/_auth/publisher/_publisher/$publisherId/_layout/'
      path: '/'
      fullPath: '/publisher/$publisherId/'
      preLoaderRoute: typeof AuthPublisherPublisherPublisherIdLayoutIndexImport
      parentRoute: typeof AuthPublisherPublisherPublisherIdLayoutImport
    }
    '/_auth/research-center/_research-center/$researchCenterId/_layout/': {
      id: '/_auth/research-center/_research-center/$researchCenterId/_layout/'
      path: '/'
      fullPath: '/research-center/$researchCenterId/'
      preLoaderRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutIndexImport
      parentRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutImport
    }
    '/_auth/research-perf-eval/_layout/$evaluationId/_layout/': {
      id: '/_auth/research-perf-eval/_layout/$evaluationId/_layout/'
      path: '/'
      fullPath: '/research-perf-eval/$evaluationId/'
      preLoaderRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutIndexImport
      parentRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutImport
    }
    '/_auth/administration/_administration/department/_department/$departmentId': {
      id: '/_auth/administration/_administration/department/_department/$departmentId'
      path: '/$departmentId'
      fullPath: '/administration/department/$departmentId'
      preLoaderRoute: typeof AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdImport
      parentRoute: typeof AuthAdministrationAdministrationDepartmentDepartmentImport
    }
    '/_auth/administration/_administration/department/_department/$departmentId/_layout': {
      id: '/_auth/administration/_administration/department/_department/$departmentId/_layout'
      path: '/$departmentId'
      fullPath: '/administration/department/$departmentId'
      preLoaderRoute: typeof AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutImport
      parentRoute: typeof AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdRoute
    }
    '/_auth/administration/_administration/discipline/_discipline/$disciplineId': {
      id: '/_auth/administration/_administration/discipline/_discipline/$disciplineId'
      path: '/$disciplineId'
      fullPath: '/administration/discipline/$disciplineId'
      preLoaderRoute: typeof AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdImport
      parentRoute: typeof AuthAdministrationAdministrationDisciplineDisciplineImport
    }
    '/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout': {
      id: '/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout'
      path: '/$disciplineId'
      fullPath: '/administration/discipline/$disciplineId'
      preLoaderRoute: typeof AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutImport
      parentRoute: typeof AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdRoute
    }
    '/_auth/administration/_administration/faculty/_faculty/$facultyId': {
      id: '/_auth/administration/_administration/faculty/_faculty/$facultyId'
      path: '/$facultyId'
      fullPath: '/administration/faculty/$facultyId'
      preLoaderRoute: typeof AuthAdministrationAdministrationFacultyFacultyFacultyIdImport
      parentRoute: typeof AuthAdministrationAdministrationFacultyFacultyImport
    }
    '/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout': {
      id: '/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout'
      path: '/$facultyId'
      fullPath: '/administration/faculty/$facultyId'
      preLoaderRoute: typeof AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutImport
      parentRoute: typeof AuthAdministrationAdministrationFacultyFacultyFacultyIdRoute
    }
    '/_auth/author/_author/abstract/_abstract/$abstractId': {
      id: '/_auth/author/_author/abstract/_abstract/$abstractId'
      path: '/$abstractId'
      fullPath: '/author/abstract/$abstractId'
      preLoaderRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdImport
      parentRoute: typeof AuthAuthorAuthorAbstractAbstractImport
    }
    '/_auth/author/_author/abstract/_abstract/$abstractId/_layout': {
      id: '/_auth/author/_author/abstract/_abstract/$abstractId/_layout'
      path: '/$abstractId'
      fullPath: '/author/abstract/$abstractId'
      preLoaderRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdRoute
    }
    '/_auth/author/_author/article/_article/$articleId': {
      id: '/_auth/author/_author/article/_article/$articleId'
      path: '/$articleId'
      fullPath: '/author/article/$articleId'
      preLoaderRoute: typeof AuthAuthorAuthorArticleArticleArticleIdImport
      parentRoute: typeof AuthAuthorAuthorArticleArticleImport
    }
    '/_auth/author/_author/article/_article/$articleId/_layout': {
      id: '/_auth/author/_author/article/_article/$articleId/_layout'
      path: '/$articleId'
      fullPath: '/author/article/$articleId'
      preLoaderRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorArticleArticleArticleIdRoute
    }
    '/_auth/author/_author/award/_award/$awardId': {
      id: '/_auth/author/_author/award/_award/$awardId'
      path: '/$awardId'
      fullPath: '/author/award/$awardId'
      preLoaderRoute: typeof AuthAuthorAuthorAwardAwardAwardIdImport
      parentRoute: typeof AuthAuthorAuthorAwardAwardImport
    }
    '/_auth/author/_author/award/_award/$awardId/_layout': {
      id: '/_auth/author/_author/award/_award/$awardId/_layout'
      path: '/$awardId'
      fullPath: '/author/award/$awardId'
      preLoaderRoute: typeof AuthAuthorAuthorAwardAwardAwardIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorAwardAwardAwardIdRoute
    }
    '/_auth/author/_author/book/_book/$bookId': {
      id: '/_auth/author/_author/book/_book/$bookId'
      path: '/$bookId'
      fullPath: '/author/book/$bookId'
      preLoaderRoute: typeof AuthAuthorAuthorBookBookBookIdImport
      parentRoute: typeof AuthAuthorAuthorBookBookImport
    }
    '/_auth/author/_author/book/_book/$bookId/_layout': {
      id: '/_auth/author/_author/book/_book/$bookId/_layout'
      path: '/$bookId'
      fullPath: '/author/book/$bookId'
      preLoaderRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorBookBookBookIdRoute
    }
    '/_auth/author/_author/chapter/_chapter/$chapterId': {
      id: '/_auth/author/_author/chapter/_chapter/$chapterId'
      path: '/$chapterId'
      fullPath: '/author/chapter/$chapterId'
      preLoaderRoute: typeof AuthAuthorAuthorChapterChapterChapterIdImport
      parentRoute: typeof AuthAuthorAuthorChapterChapterImport
    }
    '/_auth/author/_author/chapter/_chapter/$chapterId/_layout': {
      id: '/_auth/author/_author/chapter/_chapter/$chapterId/_layout'
      path: '/$chapterId'
      fullPath: '/author/chapter/$chapterId'
      preLoaderRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorChapterChapterChapterIdRoute
    }
    '/_auth/author/_author/committee/_committee/$committeeId': {
      id: '/_auth/author/_author/committee/_committee/$committeeId'
      path: '/$committeeId'
      fullPath: '/author/committee/$committeeId'
      preLoaderRoute: typeof AuthAuthorAuthorCommitteeCommitteeCommitteeIdImport
      parentRoute: typeof AuthAuthorAuthorCommitteeCommitteeImport
    }
    '/_auth/author/_author/committee/_committee/$committeeId/_layout': {
      id: '/_auth/author/_author/committee/_committee/$committeeId/_layout'
      path: '/$committeeId'
      fullPath: '/author/committee/$committeeId'
      preLoaderRoute: typeof AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorCommitteeCommitteeCommitteeIdRoute
    }
    '/_auth/author/_author/course/_course/$courseId': {
      id: '/_auth/author/_author/course/_course/$courseId'
      path: '/$courseId'
      fullPath: '/author/course/$courseId'
      preLoaderRoute: typeof AuthAuthorAuthorCourseCourseCourseIdImport
      parentRoute: typeof AuthAuthorAuthorCourseCourseImport
    }
    '/_auth/author/_author/course/_course/$courseId/_layout': {
      id: '/_auth/author/_author/course/_course/$courseId/_layout'
      path: '/$courseId'
      fullPath: '/author/course/$courseId'
      preLoaderRoute: typeof AuthAuthorAuthorCourseCourseCourseIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorCourseCourseCourseIdRoute
    }
    '/_auth/author/_author/dictionary/_dictionary/$dictionaryId': {
      id: '/_auth/author/_author/dictionary/_dictionary/$dictionaryId'
      path: '/$dictionaryId'
      fullPath: '/author/dictionary/$dictionaryId'
      preLoaderRoute: typeof AuthAuthorAuthorDictionaryDictionaryDictionaryIdImport
      parentRoute: typeof AuthAuthorAuthorDictionaryDictionaryImport
    }
    '/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout': {
      id: '/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout'
      path: '/$dictionaryId'
      fullPath: '/author/dictionary/$dictionaryId'
      preLoaderRoute: typeof AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorDictionaryDictionaryDictionaryIdRoute
    }
    '/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId': {
      id: '/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId'
      path: '/$doctoralCommitteeId'
      fullPath: '/author/doctoral-committee/$doctoralCommitteeId'
      preLoaderRoute: typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdImport
      parentRoute: typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeImport
    }
    '/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout': {
      id: '/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout'
      path: '/$doctoralCommitteeId'
      fullPath: '/author/doctoral-committee/$doctoralCommitteeId'
      preLoaderRoute: typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdRoute
    }
    '/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId': {
      id: '/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId'
      path: '/$editorialTeamId'
      fullPath: '/author/editorial-team/$editorialTeamId'
      preLoaderRoute: typeof AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdImport
      parentRoute: typeof AuthAuthorAuthorEditorialTeamEditorialTeamImport
    }
    '/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout': {
      id: '/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout'
      path: '/$editorialTeamId'
      fullPath: '/author/editorial-team/$editorialTeamId'
      preLoaderRoute: typeof AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdRoute
    }
    '/_auth/author/_author/mobility/_mobility/$mobilityId': {
      id: '/_auth/author/_author/mobility/_mobility/$mobilityId'
      path: '/$mobilityId'
      fullPath: '/author/mobility/$mobilityId'
      preLoaderRoute: typeof AuthAuthorAuthorMobilityMobilityMobilityIdImport
      parentRoute: typeof AuthAuthorAuthorMobilityMobilityImport
    }
    '/_auth/author/_author/mobility/_mobility/$mobilityId/_layout': {
      id: '/_auth/author/_author/mobility/_mobility/$mobilityId/_layout'
      path: '/$mobilityId'
      fullPath: '/author/mobility/$mobilityId'
      preLoaderRoute: typeof AuthAuthorAuthorMobilityMobilityMobilityIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorMobilityMobilityMobilityIdRoute
    }
    '/_auth/author/_author/patent/_patent/$patentId': {
      id: '/_auth/author/_author/patent/_patent/$patentId'
      path: '/$patentId'
      fullPath: '/author/patent/$patentId'
      preLoaderRoute: typeof AuthAuthorAuthorPatentPatentPatentIdImport
      parentRoute: typeof AuthAuthorAuthorPatentPatentImport
    }
    '/_auth/author/_author/patent/_patent/$patentId/_layout': {
      id: '/_auth/author/_author/patent/_patent/$patentId/_layout'
      path: '/$patentId'
      fullPath: '/author/patent/$patentId'
      preLoaderRoute: typeof AuthAuthorAuthorPatentPatentPatentIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorPatentPatentPatentIdRoute
    }
    '/_auth/author/_author/presentation/_presentation/$presentationId': {
      id: '/_auth/author/_author/presentation/_presentation/$presentationId'
      path: '/$presentationId'
      fullPath: '/author/presentation/$presentationId'
      preLoaderRoute: typeof AuthAuthorAuthorPresentationPresentationPresentationIdImport
      parentRoute: typeof AuthAuthorAuthorPresentationPresentationImport
    }
    '/_auth/author/_author/presentation/_presentation/$presentationId/_layout': {
      id: '/_auth/author/_author/presentation/_presentation/$presentationId/_layout'
      path: '/$presentationId'
      fullPath: '/author/presentation/$presentationId'
      preLoaderRoute: typeof AuthAuthorAuthorPresentationPresentationPresentationIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorPresentationPresentationPresentationIdRoute
    }
    '/_auth/author/_author/proceeding/_proceeding/$proceedingId': {
      id: '/_auth/author/_author/proceeding/_proceeding/$proceedingId'
      path: '/$proceedingId'
      fullPath: '/author/proceeding/$proceedingId'
      preLoaderRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdImport
      parentRoute: typeof AuthAuthorAuthorProceedingProceedingImport
    }
    '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout': {
      id: '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout'
      path: '/$proceedingId'
      fullPath: '/author/proceeding/$proceedingId'
      preLoaderRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdRoute
    }
    '/_auth/author/_author/project/_project/$projectId': {
      id: '/_auth/author/_author/project/_project/$projectId'
      path: '/$projectId'
      fullPath: '/author/project/$projectId'
      preLoaderRoute: typeof AuthAuthorAuthorProjectProjectProjectIdImport
      parentRoute: typeof AuthAuthorAuthorProjectProjectImport
    }
    '/_auth/author/_author/project/_project/$projectId/_layout': {
      id: '/_auth/author/_author/project/_project/$projectId/_layout'
      path: '/$projectId'
      fullPath: '/author/project/$projectId'
      preLoaderRoute: typeof AuthAuthorAuthorProjectProjectProjectIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorProjectProjectProjectIdRoute
    }
    '/_auth/author/_author/review/_review/$reviewId': {
      id: '/_auth/author/_author/review/_review/$reviewId'
      path: '/$reviewId'
      fullPath: '/author/review/$reviewId'
      preLoaderRoute: typeof AuthAuthorAuthorReviewReviewReviewIdImport
      parentRoute: typeof AuthAuthorAuthorReviewReviewImport
    }
    '/_auth/author/_author/review/_review/$reviewId/_layout': {
      id: '/_auth/author/_author/review/_review/$reviewId/_layout'
      path: '/$reviewId'
      fullPath: '/author/review/$reviewId'
      preLoaderRoute: typeof AuthAuthorAuthorReviewReviewReviewIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorReviewReviewReviewIdRoute
    }
    '/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId': {
      id: '/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId'
      path: '/$technologicalTransferId'
      fullPath: '/author/technological-transfer/$technologicalTransferId'
      preLoaderRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdImport
      parentRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferImport
    }
    '/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout': {
      id: '/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout'
      path: '/$technologicalTransferId'
      fullPath: '/author/technological-transfer/$technologicalTransferId'
      preLoaderRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdRoute
    }
    '/_auth/author/_author/translation/_translation/$translationId': {
      id: '/_auth/author/_author/translation/_translation/$translationId'
      path: '/$translationId'
      fullPath: '/author/translation/$translationId'
      preLoaderRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdImport
      parentRoute: typeof AuthAuthorAuthorTranslationTranslationImport
    }
    '/_auth/author/_author/translation/_translation/$translationId/_layout': {
      id: '/_auth/author/_author/translation/_translation/$translationId/_layout'
      path: '/$translationId'
      fullPath: '/author/translation/$translationId'
      preLoaderRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdRoute
    }
    '/_auth/research-center/_research-center/$researchCenterId/_layout/lab': {
      id: '/_auth/research-center/_research-center/$researchCenterId/_layout/lab'
      path: '/lab'
      fullPath: '/research-center/$researchCenterId/lab'
      preLoaderRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabImport
      parentRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutImport
    }
    '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout': {
      id: '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout'
      path: '/lab'
      fullPath: '/research-center/$researchCenterId/lab'
      preLoaderRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutImport
      parentRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabRoute
    }
    '/_auth/travel/_travel/requests/$requestId/_layout/edit': {
      id: '/_auth/travel/_travel/requests/$requestId/_layout/edit'
      path: '/edit'
      fullPath: '/travel/requests/$requestId/edit'
      preLoaderRoute: typeof AuthTravelTravelRequestsRequestIdLayoutEditImport
      parentRoute: typeof AuthTravelTravelRequestsRequestIdLayoutImport
    }
    '/_auth/minimal-standards/_layout/report/gather/_gather/': {
      id: '/_auth/minimal-standards/_layout/report/gather/_gather/'
      path: '/'
      fullPath: '/minimal-standards/report/gather/'
      preLoaderRoute: typeof AuthMinimalStandardsLayoutReportGatherGatherIndexImport
      parentRoute: typeof AuthMinimalStandardsLayoutReportGatherGatherImport
    }
    '/_auth/travel/_travel/requests/$requestId/_layout/': {
      id: '/_auth/travel/_travel/requests/$requestId/_layout/'
      path: '/'
      fullPath: '/travel/requests/$requestId/'
      preLoaderRoute: typeof AuthTravelTravelRequestsRequestIdLayoutIndexImport
      parentRoute: typeof AuthTravelTravelRequestsRequestIdLayoutImport
    }
    '/_auth/administration/_administration/department/_department/$departmentId/_layout/edit': {
      id: '/_auth/administration/_administration/department/_department/$departmentId/_layout/edit'
      path: '/edit'
      fullPath: '/administration/department/$departmentId/edit'
      preLoaderRoute: typeof AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutEditImport
      parentRoute: typeof AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutImport
    }
    '/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout/edit': {
      id: '/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout/edit'
      path: '/edit'
      fullPath: '/administration/discipline/$disciplineId/edit'
      preLoaderRoute: typeof AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutEditImport
      parentRoute: typeof AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutImport
    }
    '/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout/edit': {
      id: '/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout/edit'
      path: '/edit'
      fullPath: '/administration/faculty/$facultyId/edit'
      preLoaderRoute: typeof AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutEditImport
      parentRoute: typeof AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutImport
    }
    '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/edit': {
      id: '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/edit'
      path: '/edit'
      fullPath: '/author/abstract/$abstractId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutImport
    }
    '/_auth/author/_author/article/_article/$articleId/_layout/edit': {
      id: '/_auth/author/_author/article/_article/$articleId/_layout/edit'
      path: '/edit'
      fullPath: '/author/article/$articleId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutImport
    }
    '/_auth/author/_author/award/_award/$awardId/_layout/edit': {
      id: '/_auth/author/_author/award/_award/$awardId/_layout/edit'
      path: '/edit'
      fullPath: '/author/award/$awardId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorAwardAwardAwardIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorAwardAwardAwardIdLayoutImport
    }
    '/_auth/author/_author/book/_book/$bookId/_layout/edit': {
      id: '/_auth/author/_author/book/_book/$bookId/_layout/edit'
      path: '/edit'
      fullPath: '/author/book/$bookId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutImport
    }
    '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/edit': {
      id: '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/edit'
      path: '/edit'
      fullPath: '/author/chapter/$chapterId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutImport
    }
    '/_auth/author/_author/committee/_committee/$committeeId/_layout/edit': {
      id: '/_auth/author/_author/committee/_committee/$committeeId/_layout/edit'
      path: '/edit'
      fullPath: '/author/committee/$committeeId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutImport
    }
    '/_auth/author/_author/course/_course/$courseId/_layout/edit': {
      id: '/_auth/author/_author/course/_course/$courseId/_layout/edit'
      path: '/edit'
      fullPath: '/author/course/$courseId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorCourseCourseCourseIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorCourseCourseCourseIdLayoutImport
    }
    '/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout/edit': {
      id: '/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout/edit'
      path: '/edit'
      fullPath: '/author/dictionary/$dictionaryId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutImport
    }
    '/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout/edit': {
      id: '/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout/edit'
      path: '/edit'
      fullPath: '/author/doctoral-committee/$doctoralCommitteeId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutImport
    }
    '/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout/edit': {
      id: '/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout/edit'
      path: '/edit'
      fullPath: '/author/editorial-team/$editorialTeamId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutImport
    }
    '/_auth/author/_author/mobility/_mobility/$mobilityId/_layout/edit': {
      id: '/_auth/author/_author/mobility/_mobility/$mobilityId/_layout/edit'
      path: '/edit'
      fullPath: '/author/mobility/$mobilityId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorMobilityMobilityMobilityIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorMobilityMobilityMobilityIdLayoutImport
    }
    '/_auth/author/_author/patent/_patent/$patentId/_layout/edit': {
      id: '/_auth/author/_author/patent/_patent/$patentId/_layout/edit'
      path: '/edit'
      fullPath: '/author/patent/$patentId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorPatentPatentPatentIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorPatentPatentPatentIdLayoutImport
    }
    '/_auth/author/_author/presentation/_presentation/$presentationId/_layout/edit': {
      id: '/_auth/author/_author/presentation/_presentation/$presentationId/_layout/edit'
      path: '/edit'
      fullPath: '/author/presentation/$presentationId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorPresentationPresentationPresentationIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorPresentationPresentationPresentationIdLayoutImport
    }
    '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/edit': {
      id: '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/edit'
      path: '/edit'
      fullPath: '/author/proceeding/$proceedingId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutImport
    }
    '/_auth/author/_author/project/_project/$projectId/_layout/edit': {
      id: '/_auth/author/_author/project/_project/$projectId/_layout/edit'
      path: '/edit'
      fullPath: '/author/project/$projectId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorProjectProjectProjectIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorProjectProjectProjectIdLayoutImport
    }
    '/_auth/author/_author/review/_review/$reviewId/_layout/edit': {
      id: '/_auth/author/_author/review/_review/$reviewId/_layout/edit'
      path: '/edit'
      fullPath: '/author/review/$reviewId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorReviewReviewReviewIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorReviewReviewReviewIdLayoutImport
    }
    '/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout/edit': {
      id: '/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout/edit'
      path: '/edit'
      fullPath: '/author/technological-transfer/$technologicalTransferId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutImport
    }
    '/_auth/author/_author/translation/_translation/$translationId/_layout/edit': {
      id: '/_auth/author/_author/translation/_translation/$translationId/_layout/edit'
      path: '/edit'
      fullPath: '/author/translation/$translationId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutImport
    }
    '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather': {
      id: '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather'
      path: '/report/gather'
      fullPath: '/evaluation/$evaluationId/report/gather'
      preLoaderRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherImport
      parentRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutImport
    }
    '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather': {
      id: '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather'
      path: '/report/gather'
      fullPath: '/evaluation/$evaluationId/report/gather'
      preLoaderRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherImport
      parentRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherRoute
    }
    '/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode': {
      id: '/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode'
      path: '/$indicatorCode'
      fullPath: '/minimal-standards/report/gather/$indicatorCode'
      preLoaderRoute: typeof AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeImport
      parentRoute: typeof AuthMinimalStandardsLayoutReportGatherGatherImport
    }
    '/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode/_layout': {
      id: '/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode/_layout'
      path: '/$indicatorCode'
      fullPath: '/minimal-standards/report/gather/$indicatorCode'
      preLoaderRoute: typeof AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutImport
      parentRoute: typeof AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeRoute
    }
    '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather': {
      id: '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather'
      path: '/report/gather'
      fullPath: '/research-perf-eval/$evaluationId/report/gather'
      preLoaderRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherImport
      parentRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutImport
    }
    '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather': {
      id: '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather'
      path: '/report/gather'
      fullPath: '/research-perf-eval/$evaluationId/report/gather'
      preLoaderRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherImport
      parentRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherRoute
    }
    '/_auth/administration/_administration/department/_department/$departmentId/_layout/': {
      id: '/_auth/administration/_administration/department/_department/$departmentId/_layout/'
      path: '/'
      fullPath: '/administration/department/$departmentId/'
      preLoaderRoute: typeof AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutIndexImport
      parentRoute: typeof AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutImport
    }
    '/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout/': {
      id: '/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout/'
      path: '/'
      fullPath: '/administration/discipline/$disciplineId/'
      preLoaderRoute: typeof AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutIndexImport
      parentRoute: typeof AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutImport
    }
    '/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout/': {
      id: '/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout/'
      path: '/'
      fullPath: '/administration/faculty/$facultyId/'
      preLoaderRoute: typeof AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutIndexImport
      parentRoute: typeof AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutImport
    }
    '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/': {
      id: '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/'
      path: '/'
      fullPath: '/author/abstract/$abstractId/'
      preLoaderRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutImport
    }
    '/_auth/author/_author/article/_article/$articleId/_layout/': {
      id: '/_auth/author/_author/article/_article/$articleId/_layout/'
      path: '/'
      fullPath: '/author/article/$articleId/'
      preLoaderRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutImport
    }
    '/_auth/author/_author/award/_award/$awardId/_layout/': {
      id: '/_auth/author/_author/award/_award/$awardId/_layout/'
      path: '/'
      fullPath: '/author/award/$awardId/'
      preLoaderRoute: typeof AuthAuthorAuthorAwardAwardAwardIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorAwardAwardAwardIdLayoutImport
    }
    '/_auth/author/_author/book/_book/$bookId/_layout/': {
      id: '/_auth/author/_author/book/_book/$bookId/_layout/'
      path: '/'
      fullPath: '/author/book/$bookId/'
      preLoaderRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutImport
    }
    '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/': {
      id: '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/'
      path: '/'
      fullPath: '/author/chapter/$chapterId/'
      preLoaderRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutImport
    }
    '/_auth/author/_author/committee/_committee/$committeeId/_layout/': {
      id: '/_auth/author/_author/committee/_committee/$committeeId/_layout/'
      path: '/'
      fullPath: '/author/committee/$committeeId/'
      preLoaderRoute: typeof AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutImport
    }
    '/_auth/author/_author/course/_course/$courseId/_layout/': {
      id: '/_auth/author/_author/course/_course/$courseId/_layout/'
      path: '/'
      fullPath: '/author/course/$courseId/'
      preLoaderRoute: typeof AuthAuthorAuthorCourseCourseCourseIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorCourseCourseCourseIdLayoutImport
    }
    '/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout/': {
      id: '/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout/'
      path: '/'
      fullPath: '/author/dictionary/$dictionaryId/'
      preLoaderRoute: typeof AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutImport
    }
    '/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout/': {
      id: '/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout/'
      path: '/'
      fullPath: '/author/doctoral-committee/$doctoralCommitteeId/'
      preLoaderRoute: typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutImport
    }
    '/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout/': {
      id: '/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout/'
      path: '/'
      fullPath: '/author/editorial-team/$editorialTeamId/'
      preLoaderRoute: typeof AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutImport
    }
    '/_auth/author/_author/mobility/_mobility/$mobilityId/_layout/': {
      id: '/_auth/author/_author/mobility/_mobility/$mobilityId/_layout/'
      path: '/'
      fullPath: '/author/mobility/$mobilityId/'
      preLoaderRoute: typeof AuthAuthorAuthorMobilityMobilityMobilityIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorMobilityMobilityMobilityIdLayoutImport
    }
    '/_auth/author/_author/patent/_patent/$patentId/_layout/': {
      id: '/_auth/author/_author/patent/_patent/$patentId/_layout/'
      path: '/'
      fullPath: '/author/patent/$patentId/'
      preLoaderRoute: typeof AuthAuthorAuthorPatentPatentPatentIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorPatentPatentPatentIdLayoutImport
    }
    '/_auth/author/_author/presentation/_presentation/$presentationId/_layout/': {
      id: '/_auth/author/_author/presentation/_presentation/$presentationId/_layout/'
      path: '/'
      fullPath: '/author/presentation/$presentationId/'
      preLoaderRoute: typeof AuthAuthorAuthorPresentationPresentationPresentationIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorPresentationPresentationPresentationIdLayoutImport
    }
    '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/': {
      id: '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/'
      path: '/'
      fullPath: '/author/proceeding/$proceedingId/'
      preLoaderRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutImport
    }
    '/_auth/author/_author/project/_project/$projectId/_layout/': {
      id: '/_auth/author/_author/project/_project/$projectId/_layout/'
      path: '/'
      fullPath: '/author/project/$projectId/'
      preLoaderRoute: typeof AuthAuthorAuthorProjectProjectProjectIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorProjectProjectProjectIdLayoutImport
    }
    '/_auth/author/_author/review/_review/$reviewId/_layout/': {
      id: '/_auth/author/_author/review/_review/$reviewId/_layout/'
      path: '/'
      fullPath: '/author/review/$reviewId/'
      preLoaderRoute: typeof AuthAuthorAuthorReviewReviewReviewIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorReviewReviewReviewIdLayoutImport
    }
    '/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout/': {
      id: '/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout/'
      path: '/'
      fullPath: '/author/technological-transfer/$technologicalTransferId/'
      preLoaderRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutImport
    }
    '/_auth/author/_author/translation/_translation/$translationId/_layout/': {
      id: '/_auth/author/_author/translation/_translation/$translationId/_layout/'
      path: '/'
      fullPath: '/author/translation/$translationId/'
      preLoaderRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutImport
    }
    '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/': {
      id: '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/'
      path: '/'
      fullPath: '/research-center/$researchCenterId/lab/'
      preLoaderRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutIndexImport
      parentRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutImport
    }
    '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/create': {
      id: '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/create'
      path: '/citations/create'
      fullPath: '/author/abstract/$abstractId/citations/create'
      preLoaderRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCreateImport
      parentRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutImport
    }
    '/_auth/author/_author/article/_article/$articleId/_layout/citations/create': {
      id: '/_auth/author/_author/article/_article/$articleId/_layout/citations/create'
      path: '/citations/create'
      fullPath: '/author/article/$articleId/citations/create'
      preLoaderRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCreateImport
      parentRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutImport
    }
    '/_auth/author/_author/book/_book/$bookId/_layout/citations/create': {
      id: '/_auth/author/_author/book/_book/$bookId/_layout/citations/create'
      path: '/citations/create'
      fullPath: '/author/book/$bookId/citations/create'
      preLoaderRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCreateImport
      parentRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutImport
    }
    '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/create': {
      id: '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/create'
      path: '/citations/create'
      fullPath: '/author/chapter/$chapterId/citations/create'
      preLoaderRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCreateImport
      parentRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutImport
    }
    '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/create': {
      id: '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/create'
      path: '/citations/create'
      fullPath: '/author/proceeding/$proceedingId/citations/create'
      preLoaderRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCreateImport
      parentRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutImport
    }
    '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/create': {
      id: '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/create'
      path: '/citations/create'
      fullPath: '/author/translation/$translationId/citations/create'
      preLoaderRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCreateImport
      parentRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutImport
    }
    '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId': {
      id: '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId'
      path: '/$labId'
      fullPath: '/research-center/$researchCenterId/lab/$labId'
      preLoaderRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdImport
      parentRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutImport
    }
    '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout': {
      id: '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout'
      path: '/$labId'
      fullPath: '/research-center/$researchCenterId/lab/$labId'
      preLoaderRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutImport
      parentRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdRoute
    }
    '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/': {
      id: '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/'
      path: '/citations'
      fullPath: '/author/abstract/$abstractId/citations'
      preLoaderRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsIndexImport
      parentRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutImport
    }
    '/_auth/author/_author/article/_article/$articleId/_layout/citations/': {
      id: '/_auth/author/_author/article/_article/$articleId/_layout/citations/'
      path: '/citations'
      fullPath: '/author/article/$articleId/citations'
      preLoaderRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsIndexImport
      parentRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutImport
    }
    '/_auth/author/_author/book/_book/$bookId/_layout/citations/': {
      id: '/_auth/author/_author/book/_book/$bookId/_layout/citations/'
      path: '/citations'
      fullPath: '/author/book/$bookId/citations'
      preLoaderRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsIndexImport
      parentRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutImport
    }
    '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/': {
      id: '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/'
      path: '/citations'
      fullPath: '/author/chapter/$chapterId/citations'
      preLoaderRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsIndexImport
      parentRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutImport
    }
    '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/': {
      id: '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/'
      path: '/citations'
      fullPath: '/author/proceeding/$proceedingId/citations'
      preLoaderRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsIndexImport
      parentRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutImport
    }
    '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/': {
      id: '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/'
      path: '/citations'
      fullPath: '/author/translation/$translationId/citations'
      preLoaderRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsIndexImport
      parentRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutImport
    }
    '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/': {
      id: '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/'
      path: '/'
      fullPath: '/evaluation/$evaluationId/report/gather/'
      preLoaderRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherIndexImport
      parentRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherImport
    }
    '/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode/_layout/': {
      id: '/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode/_layout/'
      path: '/'
      fullPath: '/minimal-standards/report/gather/$indicatorCode/'
      preLoaderRoute: typeof AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutIndexImport
      parentRoute: typeof AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutImport
    }
    '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/': {
      id: '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/'
      path: '/'
      fullPath: '/research-perf-eval/$evaluationId/report/gather/'
      preLoaderRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherIndexImport
      parentRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherImport
    }
    '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId': {
      id: '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId'
      path: '/citations/$citationId'
      fullPath: '/author/abstract/$abstractId/citations/$citationId'
      preLoaderRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdImport
      parentRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutImport
    }
    '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout': {
      id: '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout'
      path: '/citations/$citationId'
      fullPath: '/author/abstract/$abstractId/citations/$citationId'
      preLoaderRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdRoute
    }
    '/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId': {
      id: '/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId'
      path: '/citations/$citationId'
      fullPath: '/author/article/$articleId/citations/$citationId'
      preLoaderRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdImport
      parentRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutImport
    }
    '/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout': {
      id: '/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout'
      path: '/citations/$citationId'
      fullPath: '/author/article/$articleId/citations/$citationId'
      preLoaderRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdRoute
    }
    '/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId': {
      id: '/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId'
      path: '/citations/$citationId'
      fullPath: '/author/book/$bookId/citations/$citationId'
      preLoaderRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdImport
      parentRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutImport
    }
    '/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout': {
      id: '/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout'
      path: '/citations/$citationId'
      fullPath: '/author/book/$bookId/citations/$citationId'
      preLoaderRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdRoute
    }
    '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId': {
      id: '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId'
      path: '/citations/$citationId'
      fullPath: '/author/chapter/$chapterId/citations/$citationId'
      preLoaderRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdImport
      parentRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutImport
    }
    '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout': {
      id: '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout'
      path: '/citations/$citationId'
      fullPath: '/author/chapter/$chapterId/citations/$citationId'
      preLoaderRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdRoute
    }
    '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId': {
      id: '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId'
      path: '/citations/$citationId'
      fullPath: '/author/proceeding/$proceedingId/citations/$citationId'
      preLoaderRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdImport
      parentRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutImport
    }
    '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout': {
      id: '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout'
      path: '/citations/$citationId'
      fullPath: '/author/proceeding/$proceedingId/citations/$citationId'
      preLoaderRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdRoute
    }
    '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId': {
      id: '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId'
      path: '/citations/$citationId'
      fullPath: '/author/translation/$translationId/citations/$citationId'
      preLoaderRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdImport
      parentRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutImport
    }
    '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout': {
      id: '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout'
      path: '/citations/$citationId'
      fullPath: '/author/translation/$translationId/citations/$citationId'
      preLoaderRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutImport
      parentRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdRoute
    }
    '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo': {
      id: '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo'
      path: '/$orderNo'
      fullPath: '/evaluation/$evaluationId/report/gather/$orderNo'
      preLoaderRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoImport
      parentRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherImport
    }
    '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout': {
      id: '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout'
      path: '/$orderNo'
      fullPath: '/evaluation/$evaluationId/report/gather/$orderNo'
      preLoaderRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutImport
      parentRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoRoute
    }
    '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout/edit': {
      id: '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout/edit'
      path: '/edit'
      fullPath: '/research-center/$researchCenterId/lab/$labId/edit'
      preLoaderRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutEditImport
      parentRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutImport
    }
    '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo': {
      id: '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo'
      path: '/$orderNo'
      fullPath: '/research-perf-eval/$evaluationId/report/gather/$orderNo'
      preLoaderRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoImport
      parentRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherImport
    }
    '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout': {
      id: '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout'
      path: '/$orderNo'
      fullPath: '/research-perf-eval/$evaluationId/report/gather/$orderNo'
      preLoaderRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutImport
      parentRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoRoute
    }
    '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout/': {
      id: '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout/'
      path: '/'
      fullPath: '/research-center/$researchCenterId/lab/$labId/'
      preLoaderRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutIndexImport
      parentRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutImport
    }
    '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout/edit': {
      id: '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout/edit'
      path: '/edit'
      fullPath: '/author/abstract/$abstractId/citations/$citationId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutImport
    }
    '/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout/edit': {
      id: '/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout/edit'
      path: '/edit'
      fullPath: '/author/article/$articleId/citations/$citationId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutImport
    }
    '/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout/edit': {
      id: '/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout/edit'
      path: '/edit'
      fullPath: '/author/book/$bookId/citations/$citationId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutImport
    }
    '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout/edit': {
      id: '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout/edit'
      path: '/edit'
      fullPath: '/author/chapter/$chapterId/citations/$citationId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutImport
    }
    '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout/edit': {
      id: '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout/edit'
      path: '/edit'
      fullPath: '/author/proceeding/$proceedingId/citations/$citationId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutImport
    }
    '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout/edit': {
      id: '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout/edit'
      path: '/edit'
      fullPath: '/author/translation/$translationId/citations/$citationId/edit'
      preLoaderRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutEditImport
      parentRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutImport
    }
    '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout/': {
      id: '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout/'
      path: '/'
      fullPath: '/author/abstract/$abstractId/citations/$citationId/'
      preLoaderRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutImport
    }
    '/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout/': {
      id: '/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout/'
      path: '/'
      fullPath: '/author/article/$articleId/citations/$citationId/'
      preLoaderRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutImport
    }
    '/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout/': {
      id: '/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout/'
      path: '/'
      fullPath: '/author/book/$bookId/citations/$citationId/'
      preLoaderRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutImport
    }
    '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout/': {
      id: '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout/'
      path: '/'
      fullPath: '/author/chapter/$chapterId/citations/$citationId/'
      preLoaderRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutImport
    }
    '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout/': {
      id: '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout/'
      path: '/'
      fullPath: '/author/proceeding/$proceedingId/citations/$citationId/'
      preLoaderRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutImport
    }
    '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout/': {
      id: '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout/'
      path: '/'
      fullPath: '/author/translation/$translationId/citations/$citationId/'
      preLoaderRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutIndexImport
      parentRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutImport
    }
    '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout/': {
      id: '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout/'
      path: '/'
      fullPath: '/evaluation/$evaluationId/report/gather/$orderNo/'
      preLoaderRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexImport
      parentRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutImport
    }
    '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout/': {
      id: '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout/'
      path: '/'
      fullPath: '/research-perf-eval/$evaluationId/report/gather/$orderNo/'
      preLoaderRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexImport
      parentRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutImport
    }
  }
}

// Create and export the route tree

interface AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutRouteChildren {
  AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutEditRoute: typeof AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutEditRoute
  AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutIndexRoute: typeof AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutIndexRoute
}

const AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutRouteChildren: AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutRouteChildren =
  {
    AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutEditRoute:
      AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutEditRoute,
    AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutIndexRoute:
      AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutIndexRoute,
  }

const AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutRouteWithChildren =
  AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutRoute._addFileChildren(
    AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutRouteChildren,
  )

interface AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdRouteChildren {
  AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutRoute: typeof AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutRouteWithChildren
}

const AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdRouteChildren: AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdRouteChildren =
  {
    AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutRoute:
      AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutRouteWithChildren,
  }

const AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdRouteWithChildren =
  AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdRoute._addFileChildren(
    AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdRouteChildren,
  )

interface AuthAdministrationAdministrationDepartmentDepartmentRouteChildren {
  AuthAdministrationAdministrationDepartmentDepartmentCreateRoute: typeof AuthAdministrationAdministrationDepartmentDepartmentCreateRoute
  AuthAdministrationAdministrationDepartmentDepartmentIndexRoute: typeof AuthAdministrationAdministrationDepartmentDepartmentIndexRoute
  AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdRoute: typeof AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdRouteWithChildren
}

const AuthAdministrationAdministrationDepartmentDepartmentRouteChildren: AuthAdministrationAdministrationDepartmentDepartmentRouteChildren =
  {
    AuthAdministrationAdministrationDepartmentDepartmentCreateRoute:
      AuthAdministrationAdministrationDepartmentDepartmentCreateRoute,
    AuthAdministrationAdministrationDepartmentDepartmentIndexRoute:
      AuthAdministrationAdministrationDepartmentDepartmentIndexRoute,
    AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdRoute:
      AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdRouteWithChildren,
  }

const AuthAdministrationAdministrationDepartmentDepartmentRouteWithChildren =
  AuthAdministrationAdministrationDepartmentDepartmentRoute._addFileChildren(
    AuthAdministrationAdministrationDepartmentDepartmentRouteChildren,
  )

interface AuthAdministrationAdministrationDepartmentRouteChildren {
  AuthAdministrationAdministrationDepartmentDepartmentRoute: typeof AuthAdministrationAdministrationDepartmentDepartmentRouteWithChildren
}

const AuthAdministrationAdministrationDepartmentRouteChildren: AuthAdministrationAdministrationDepartmentRouteChildren =
  {
    AuthAdministrationAdministrationDepartmentDepartmentRoute:
      AuthAdministrationAdministrationDepartmentDepartmentRouteWithChildren,
  }

const AuthAdministrationAdministrationDepartmentRouteWithChildren =
  AuthAdministrationAdministrationDepartmentRoute._addFileChildren(
    AuthAdministrationAdministrationDepartmentRouteChildren,
  )

interface AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutRouteChildren {
  AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutEditRoute: typeof AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutEditRoute
  AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutIndexRoute: typeof AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutIndexRoute
}

const AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutRouteChildren: AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutRouteChildren =
  {
    AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutEditRoute:
      AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutEditRoute,
    AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutIndexRoute:
      AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutIndexRoute,
  }

const AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutRouteWithChildren =
  AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutRoute._addFileChildren(
    AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutRouteChildren,
  )

interface AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdRouteChildren {
  AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutRoute: typeof AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutRouteWithChildren
}

const AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdRouteChildren: AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdRouteChildren =
  {
    AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutRoute:
      AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutRouteWithChildren,
  }

const AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdRouteWithChildren =
  AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdRoute._addFileChildren(
    AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdRouteChildren,
  )

interface AuthAdministrationAdministrationDisciplineDisciplineRouteChildren {
  AuthAdministrationAdministrationDisciplineDisciplineCreateRoute: typeof AuthAdministrationAdministrationDisciplineDisciplineCreateRoute
  AuthAdministrationAdministrationDisciplineDisciplineIndexRoute: typeof AuthAdministrationAdministrationDisciplineDisciplineIndexRoute
  AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdRoute: typeof AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdRouteWithChildren
}

const AuthAdministrationAdministrationDisciplineDisciplineRouteChildren: AuthAdministrationAdministrationDisciplineDisciplineRouteChildren =
  {
    AuthAdministrationAdministrationDisciplineDisciplineCreateRoute:
      AuthAdministrationAdministrationDisciplineDisciplineCreateRoute,
    AuthAdministrationAdministrationDisciplineDisciplineIndexRoute:
      AuthAdministrationAdministrationDisciplineDisciplineIndexRoute,
    AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdRoute:
      AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdRouteWithChildren,
  }

const AuthAdministrationAdministrationDisciplineDisciplineRouteWithChildren =
  AuthAdministrationAdministrationDisciplineDisciplineRoute._addFileChildren(
    AuthAdministrationAdministrationDisciplineDisciplineRouteChildren,
  )

interface AuthAdministrationAdministrationDisciplineRouteChildren {
  AuthAdministrationAdministrationDisciplineDisciplineRoute: typeof AuthAdministrationAdministrationDisciplineDisciplineRouteWithChildren
}

const AuthAdministrationAdministrationDisciplineRouteChildren: AuthAdministrationAdministrationDisciplineRouteChildren =
  {
    AuthAdministrationAdministrationDisciplineDisciplineRoute:
      AuthAdministrationAdministrationDisciplineDisciplineRouteWithChildren,
  }

const AuthAdministrationAdministrationDisciplineRouteWithChildren =
  AuthAdministrationAdministrationDisciplineRoute._addFileChildren(
    AuthAdministrationAdministrationDisciplineRouteChildren,
  )

interface AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutRouteChildren {
  AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutEditRoute: typeof AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutEditRoute
  AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutIndexRoute: typeof AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutIndexRoute
}

const AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutRouteChildren: AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutRouteChildren =
  {
    AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutEditRoute:
      AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutEditRoute,
    AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutIndexRoute:
      AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutIndexRoute,
  }

const AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutRouteWithChildren =
  AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutRoute._addFileChildren(
    AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutRouteChildren,
  )

interface AuthAdministrationAdministrationFacultyFacultyFacultyIdRouteChildren {
  AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutRoute: typeof AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutRouteWithChildren
}

const AuthAdministrationAdministrationFacultyFacultyFacultyIdRouteChildren: AuthAdministrationAdministrationFacultyFacultyFacultyIdRouteChildren =
  {
    AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutRoute:
      AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutRouteWithChildren,
  }

const AuthAdministrationAdministrationFacultyFacultyFacultyIdRouteWithChildren =
  AuthAdministrationAdministrationFacultyFacultyFacultyIdRoute._addFileChildren(
    AuthAdministrationAdministrationFacultyFacultyFacultyIdRouteChildren,
  )

interface AuthAdministrationAdministrationFacultyFacultyRouteChildren {
  AuthAdministrationAdministrationFacultyFacultyCreateRoute: typeof AuthAdministrationAdministrationFacultyFacultyCreateRoute
  AuthAdministrationAdministrationFacultyFacultyIndexRoute: typeof AuthAdministrationAdministrationFacultyFacultyIndexRoute
  AuthAdministrationAdministrationFacultyFacultyFacultyIdRoute: typeof AuthAdministrationAdministrationFacultyFacultyFacultyIdRouteWithChildren
}

const AuthAdministrationAdministrationFacultyFacultyRouteChildren: AuthAdministrationAdministrationFacultyFacultyRouteChildren =
  {
    AuthAdministrationAdministrationFacultyFacultyCreateRoute:
      AuthAdministrationAdministrationFacultyFacultyCreateRoute,
    AuthAdministrationAdministrationFacultyFacultyIndexRoute:
      AuthAdministrationAdministrationFacultyFacultyIndexRoute,
    AuthAdministrationAdministrationFacultyFacultyFacultyIdRoute:
      AuthAdministrationAdministrationFacultyFacultyFacultyIdRouteWithChildren,
  }

const AuthAdministrationAdministrationFacultyFacultyRouteWithChildren =
  AuthAdministrationAdministrationFacultyFacultyRoute._addFileChildren(
    AuthAdministrationAdministrationFacultyFacultyRouteChildren,
  )

interface AuthAdministrationAdministrationFacultyRouteChildren {
  AuthAdministrationAdministrationFacultyFacultyRoute: typeof AuthAdministrationAdministrationFacultyFacultyRouteWithChildren
}

const AuthAdministrationAdministrationFacultyRouteChildren: AuthAdministrationAdministrationFacultyRouteChildren =
  {
    AuthAdministrationAdministrationFacultyFacultyRoute:
      AuthAdministrationAdministrationFacultyFacultyRouteWithChildren,
  }

const AuthAdministrationAdministrationFacultyRouteWithChildren =
  AuthAdministrationAdministrationFacultyRoute._addFileChildren(
    AuthAdministrationAdministrationFacultyRouteChildren,
  )

interface AuthAdministrationAdministrationLegalHolidayLegalHolidayRouteChildren {
  AuthAdministrationAdministrationLegalHolidayLegalHolidayIndexRoute: typeof AuthAdministrationAdministrationLegalHolidayLegalHolidayIndexRoute
}

const AuthAdministrationAdministrationLegalHolidayLegalHolidayRouteChildren: AuthAdministrationAdministrationLegalHolidayLegalHolidayRouteChildren =
  {
    AuthAdministrationAdministrationLegalHolidayLegalHolidayIndexRoute:
      AuthAdministrationAdministrationLegalHolidayLegalHolidayIndexRoute,
  }

const AuthAdministrationAdministrationLegalHolidayLegalHolidayRouteWithChildren =
  AuthAdministrationAdministrationLegalHolidayLegalHolidayRoute._addFileChildren(
    AuthAdministrationAdministrationLegalHolidayLegalHolidayRouteChildren,
  )

interface AuthAdministrationAdministrationLegalHolidayRouteChildren {
  AuthAdministrationAdministrationLegalHolidayLegalHolidayRoute: typeof AuthAdministrationAdministrationLegalHolidayLegalHolidayRouteWithChildren
}

const AuthAdministrationAdministrationLegalHolidayRouteChildren: AuthAdministrationAdministrationLegalHolidayRouteChildren =
  {
    AuthAdministrationAdministrationLegalHolidayLegalHolidayRoute:
      AuthAdministrationAdministrationLegalHolidayLegalHolidayRouteWithChildren,
  }

const AuthAdministrationAdministrationLegalHolidayRouteWithChildren =
  AuthAdministrationAdministrationLegalHolidayRoute._addFileChildren(
    AuthAdministrationAdministrationLegalHolidayRouteChildren,
  )

interface AuthAdministrationAdministrationLocalAccountsLocalAccountsRouteChildren {
  AuthAdministrationAdministrationLocalAccountsLocalAccountsIndexRoute: typeof AuthAdministrationAdministrationLocalAccountsLocalAccountsIndexRoute
}

const AuthAdministrationAdministrationLocalAccountsLocalAccountsRouteChildren: AuthAdministrationAdministrationLocalAccountsLocalAccountsRouteChildren =
  {
    AuthAdministrationAdministrationLocalAccountsLocalAccountsIndexRoute:
      AuthAdministrationAdministrationLocalAccountsLocalAccountsIndexRoute,
  }

const AuthAdministrationAdministrationLocalAccountsLocalAccountsRouteWithChildren =
  AuthAdministrationAdministrationLocalAccountsLocalAccountsRoute._addFileChildren(
    AuthAdministrationAdministrationLocalAccountsLocalAccountsRouteChildren,
  )

interface AuthAdministrationAdministrationLocalAccountsRouteChildren {
  AuthAdministrationAdministrationLocalAccountsLocalAccountsRoute: typeof AuthAdministrationAdministrationLocalAccountsLocalAccountsRouteWithChildren
}

const AuthAdministrationAdministrationLocalAccountsRouteChildren: AuthAdministrationAdministrationLocalAccountsRouteChildren =
  {
    AuthAdministrationAdministrationLocalAccountsLocalAccountsRoute:
      AuthAdministrationAdministrationLocalAccountsLocalAccountsRouteWithChildren,
  }

const AuthAdministrationAdministrationLocalAccountsRouteWithChildren =
  AuthAdministrationAdministrationLocalAccountsRoute._addFileChildren(
    AuthAdministrationAdministrationLocalAccountsRouteChildren,
  )

interface AuthAdministrationAdministrationUniversityConfigUniversityConfigRouteChildren {
  AuthAdministrationAdministrationUniversityConfigUniversityConfigIndexRoute: typeof AuthAdministrationAdministrationUniversityConfigUniversityConfigIndexRoute
}

const AuthAdministrationAdministrationUniversityConfigUniversityConfigRouteChildren: AuthAdministrationAdministrationUniversityConfigUniversityConfigRouteChildren =
  {
    AuthAdministrationAdministrationUniversityConfigUniversityConfigIndexRoute:
      AuthAdministrationAdministrationUniversityConfigUniversityConfigIndexRoute,
  }

const AuthAdministrationAdministrationUniversityConfigUniversityConfigRouteWithChildren =
  AuthAdministrationAdministrationUniversityConfigUniversityConfigRoute._addFileChildren(
    AuthAdministrationAdministrationUniversityConfigUniversityConfigRouteChildren,
  )

interface AuthAdministrationAdministrationUniversityConfigRouteChildren {
  AuthAdministrationAdministrationUniversityConfigUniversityConfigRoute: typeof AuthAdministrationAdministrationUniversityConfigUniversityConfigRouteWithChildren
}

const AuthAdministrationAdministrationUniversityConfigRouteChildren: AuthAdministrationAdministrationUniversityConfigRouteChildren =
  {
    AuthAdministrationAdministrationUniversityConfigUniversityConfigRoute:
      AuthAdministrationAdministrationUniversityConfigUniversityConfigRouteWithChildren,
  }

const AuthAdministrationAdministrationUniversityConfigRouteWithChildren =
  AuthAdministrationAdministrationUniversityConfigRoute._addFileChildren(
    AuthAdministrationAdministrationUniversityConfigRouteChildren,
  )

interface AuthAdministrationAdministrationUserDocumentsUserDocumentsRouteChildren {
  AuthAdministrationAdministrationUserDocumentsUserDocumentsIndexRoute: typeof AuthAdministrationAdministrationUserDocumentsUserDocumentsIndexRoute
}

const AuthAdministrationAdministrationUserDocumentsUserDocumentsRouteChildren: AuthAdministrationAdministrationUserDocumentsUserDocumentsRouteChildren =
  {
    AuthAdministrationAdministrationUserDocumentsUserDocumentsIndexRoute:
      AuthAdministrationAdministrationUserDocumentsUserDocumentsIndexRoute,
  }

const AuthAdministrationAdministrationUserDocumentsUserDocumentsRouteWithChildren =
  AuthAdministrationAdministrationUserDocumentsUserDocumentsRoute._addFileChildren(
    AuthAdministrationAdministrationUserDocumentsUserDocumentsRouteChildren,
  )

interface AuthAdministrationAdministrationUserDocumentsRouteChildren {
  AuthAdministrationAdministrationUserDocumentsUserDocumentsRoute: typeof AuthAdministrationAdministrationUserDocumentsUserDocumentsRouteWithChildren
}

const AuthAdministrationAdministrationUserDocumentsRouteChildren: AuthAdministrationAdministrationUserDocumentsRouteChildren =
  {
    AuthAdministrationAdministrationUserDocumentsUserDocumentsRoute:
      AuthAdministrationAdministrationUserDocumentsUserDocumentsRouteWithChildren,
  }

const AuthAdministrationAdministrationUserDocumentsRouteWithChildren =
  AuthAdministrationAdministrationUserDocumentsRoute._addFileChildren(
    AuthAdministrationAdministrationUserDocumentsRouteChildren,
  )

interface AuthAdministrationAdministrationRouteChildren {
  AuthAdministrationAdministrationIndexRoute: typeof AuthAdministrationAdministrationIndexRoute
  AuthAdministrationAdministrationDepartmentRoute: typeof AuthAdministrationAdministrationDepartmentRouteWithChildren
  AuthAdministrationAdministrationDisciplineRoute: typeof AuthAdministrationAdministrationDisciplineRouteWithChildren
  AuthAdministrationAdministrationFacultyRoute: typeof AuthAdministrationAdministrationFacultyRouteWithChildren
  AuthAdministrationAdministrationLegalHolidayRoute: typeof AuthAdministrationAdministrationLegalHolidayRouteWithChildren
  AuthAdministrationAdministrationLocalAccountsRoute: typeof AuthAdministrationAdministrationLocalAccountsRouteWithChildren
  AuthAdministrationAdministrationUniversityConfigRoute: typeof AuthAdministrationAdministrationUniversityConfigRouteWithChildren
  AuthAdministrationAdministrationUserDocumentsRoute: typeof AuthAdministrationAdministrationUserDocumentsRouteWithChildren
}

const AuthAdministrationAdministrationRouteChildren: AuthAdministrationAdministrationRouteChildren =
  {
    AuthAdministrationAdministrationIndexRoute:
      AuthAdministrationAdministrationIndexRoute,
    AuthAdministrationAdministrationDepartmentRoute:
      AuthAdministrationAdministrationDepartmentRouteWithChildren,
    AuthAdministrationAdministrationDisciplineRoute:
      AuthAdministrationAdministrationDisciplineRouteWithChildren,
    AuthAdministrationAdministrationFacultyRoute:
      AuthAdministrationAdministrationFacultyRouteWithChildren,
    AuthAdministrationAdministrationLegalHolidayRoute:
      AuthAdministrationAdministrationLegalHolidayRouteWithChildren,
    AuthAdministrationAdministrationLocalAccountsRoute:
      AuthAdministrationAdministrationLocalAccountsRouteWithChildren,
    AuthAdministrationAdministrationUniversityConfigRoute:
      AuthAdministrationAdministrationUniversityConfigRouteWithChildren,
    AuthAdministrationAdministrationUserDocumentsRoute:
      AuthAdministrationAdministrationUserDocumentsRouteWithChildren,
  }

const AuthAdministrationAdministrationRouteWithChildren =
  AuthAdministrationAdministrationRoute._addFileChildren(
    AuthAdministrationAdministrationRouteChildren,
  )

interface AuthAdministrationRouteChildren {
  AuthAdministrationAdministrationRoute: typeof AuthAdministrationAdministrationRouteWithChildren
}

const AuthAdministrationRouteChildren: AuthAdministrationRouteChildren = {
  AuthAdministrationAdministrationRoute:
    AuthAdministrationAdministrationRouteWithChildren,
}

const AuthAdministrationRouteWithChildren =
  AuthAdministrationRoute._addFileChildren(AuthAdministrationRouteChildren)

interface AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutRouteChildren {
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutEditRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutEditRoute
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutIndexRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutIndexRoute
}

const AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutRouteChildren: AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutRouteChildren =
  {
    AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutEditRoute:
      AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutEditRoute,
    AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutIndexRoute:
      AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutIndexRoute,
  }

const AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutRouteWithChildren =
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdRouteChildren {
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutRouteWithChildren
}

const AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdRouteChildren: AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdRouteChildren =
  {
    AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutRoute:
      AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdRouteWithChildren =
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdRoute._addFileChildren(
    AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdRouteChildren,
  )

interface AuthAuthorAuthorAbstractAbstractAbstractIdLayoutRouteChildren {
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutEditRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutEditRoute
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutIndexRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutIndexRoute
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCreateRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCreateRoute
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsIndexRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsIndexRoute
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdRouteWithChildren
}

const AuthAuthorAuthorAbstractAbstractAbstractIdLayoutRouteChildren: AuthAuthorAuthorAbstractAbstractAbstractIdLayoutRouteChildren =
  {
    AuthAuthorAuthorAbstractAbstractAbstractIdLayoutEditRoute:
      AuthAuthorAuthorAbstractAbstractAbstractIdLayoutEditRoute,
    AuthAuthorAuthorAbstractAbstractAbstractIdLayoutIndexRoute:
      AuthAuthorAuthorAbstractAbstractAbstractIdLayoutIndexRoute,
    AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCreateRoute:
      AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCreateRoute,
    AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsIndexRoute:
      AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsIndexRoute,
    AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdRoute:
      AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdRouteWithChildren,
  }

const AuthAuthorAuthorAbstractAbstractAbstractIdLayoutRouteWithChildren =
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorAbstractAbstractAbstractIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorAbstractAbstractAbstractIdRouteChildren {
  AuthAuthorAuthorAbstractAbstractAbstractIdLayoutRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutRouteWithChildren
}

const AuthAuthorAuthorAbstractAbstractAbstractIdRouteChildren: AuthAuthorAuthorAbstractAbstractAbstractIdRouteChildren =
  {
    AuthAuthorAuthorAbstractAbstractAbstractIdLayoutRoute:
      AuthAuthorAuthorAbstractAbstractAbstractIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorAbstractAbstractAbstractIdRouteWithChildren =
  AuthAuthorAuthorAbstractAbstractAbstractIdRoute._addFileChildren(
    AuthAuthorAuthorAbstractAbstractAbstractIdRouteChildren,
  )

interface AuthAuthorAuthorAbstractAbstractRouteChildren {
  AuthAuthorAuthorAbstractAbstractCreateRoute: typeof AuthAuthorAuthorAbstractAbstractCreateRoute
  AuthAuthorAuthorAbstractAbstractSearchClaimableRoute: typeof AuthAuthorAuthorAbstractAbstractSearchClaimableRoute
  AuthAuthorAuthorAbstractAbstractIndexRoute: typeof AuthAuthorAuthorAbstractAbstractIndexRoute
  AuthAuthorAuthorAbstractAbstractAbstractIdRoute: typeof AuthAuthorAuthorAbstractAbstractAbstractIdRouteWithChildren
}

const AuthAuthorAuthorAbstractAbstractRouteChildren: AuthAuthorAuthorAbstractAbstractRouteChildren =
  {
    AuthAuthorAuthorAbstractAbstractCreateRoute:
      AuthAuthorAuthorAbstractAbstractCreateRoute,
    AuthAuthorAuthorAbstractAbstractSearchClaimableRoute:
      AuthAuthorAuthorAbstractAbstractSearchClaimableRoute,
    AuthAuthorAuthorAbstractAbstractIndexRoute:
      AuthAuthorAuthorAbstractAbstractIndexRoute,
    AuthAuthorAuthorAbstractAbstractAbstractIdRoute:
      AuthAuthorAuthorAbstractAbstractAbstractIdRouteWithChildren,
  }

const AuthAuthorAuthorAbstractAbstractRouteWithChildren =
  AuthAuthorAuthorAbstractAbstractRoute._addFileChildren(
    AuthAuthorAuthorAbstractAbstractRouteChildren,
  )

interface AuthAuthorAuthorAbstractRouteChildren {
  AuthAuthorAuthorAbstractAbstractRoute: typeof AuthAuthorAuthorAbstractAbstractRouteWithChildren
}

const AuthAuthorAuthorAbstractRouteChildren: AuthAuthorAuthorAbstractRouteChildren =
  {
    AuthAuthorAuthorAbstractAbstractRoute:
      AuthAuthorAuthorAbstractAbstractRouteWithChildren,
  }

const AuthAuthorAuthorAbstractRouteWithChildren =
  AuthAuthorAuthorAbstractRoute._addFileChildren(
    AuthAuthorAuthorAbstractRouteChildren,
  )

interface AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutRouteChildren {
  AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutEditRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutEditRoute
  AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutIndexRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutIndexRoute
}

const AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutRouteChildren: AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutRouteChildren =
  {
    AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutEditRoute:
      AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutEditRoute,
    AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutIndexRoute:
      AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutIndexRoute,
  }

const AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutRouteWithChildren =
  AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdRouteChildren {
  AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutRouteWithChildren
}

const AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdRouteChildren: AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdRouteChildren =
  {
    AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutRoute:
      AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdRouteWithChildren =
  AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdRoute._addFileChildren(
    AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdRouteChildren,
  )

interface AuthAuthorAuthorArticleArticleArticleIdLayoutRouteChildren {
  AuthAuthorAuthorArticleArticleArticleIdLayoutEditRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutEditRoute
  AuthAuthorAuthorArticleArticleArticleIdLayoutIndexRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutIndexRoute
  AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCreateRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCreateRoute
  AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsIndexRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsIndexRoute
  AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdRouteWithChildren
}

const AuthAuthorAuthorArticleArticleArticleIdLayoutRouteChildren: AuthAuthorAuthorArticleArticleArticleIdLayoutRouteChildren =
  {
    AuthAuthorAuthorArticleArticleArticleIdLayoutEditRoute:
      AuthAuthorAuthorArticleArticleArticleIdLayoutEditRoute,
    AuthAuthorAuthorArticleArticleArticleIdLayoutIndexRoute:
      AuthAuthorAuthorArticleArticleArticleIdLayoutIndexRoute,
    AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCreateRoute:
      AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCreateRoute,
    AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsIndexRoute:
      AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsIndexRoute,
    AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdRoute:
      AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdRouteWithChildren,
  }

const AuthAuthorAuthorArticleArticleArticleIdLayoutRouteWithChildren =
  AuthAuthorAuthorArticleArticleArticleIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorArticleArticleArticleIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorArticleArticleArticleIdRouteChildren {
  AuthAuthorAuthorArticleArticleArticleIdLayoutRoute: typeof AuthAuthorAuthorArticleArticleArticleIdLayoutRouteWithChildren
}

const AuthAuthorAuthorArticleArticleArticleIdRouteChildren: AuthAuthorAuthorArticleArticleArticleIdRouteChildren =
  {
    AuthAuthorAuthorArticleArticleArticleIdLayoutRoute:
      AuthAuthorAuthorArticleArticleArticleIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorArticleArticleArticleIdRouteWithChildren =
  AuthAuthorAuthorArticleArticleArticleIdRoute._addFileChildren(
    AuthAuthorAuthorArticleArticleArticleIdRouteChildren,
  )

interface AuthAuthorAuthorArticleArticleRouteChildren {
  AuthAuthorAuthorArticleArticleCreateRoute: typeof AuthAuthorAuthorArticleArticleCreateRoute
  AuthAuthorAuthorArticleArticleSearchClaimableRoute: typeof AuthAuthorAuthorArticleArticleSearchClaimableRoute
  AuthAuthorAuthorArticleArticleIndexRoute: typeof AuthAuthorAuthorArticleArticleIndexRoute
  AuthAuthorAuthorArticleArticleArticleIdRoute: typeof AuthAuthorAuthorArticleArticleArticleIdRouteWithChildren
}

const AuthAuthorAuthorArticleArticleRouteChildren: AuthAuthorAuthorArticleArticleRouteChildren =
  {
    AuthAuthorAuthorArticleArticleCreateRoute:
      AuthAuthorAuthorArticleArticleCreateRoute,
    AuthAuthorAuthorArticleArticleSearchClaimableRoute:
      AuthAuthorAuthorArticleArticleSearchClaimableRoute,
    AuthAuthorAuthorArticleArticleIndexRoute:
      AuthAuthorAuthorArticleArticleIndexRoute,
    AuthAuthorAuthorArticleArticleArticleIdRoute:
      AuthAuthorAuthorArticleArticleArticleIdRouteWithChildren,
  }

const AuthAuthorAuthorArticleArticleRouteWithChildren =
  AuthAuthorAuthorArticleArticleRoute._addFileChildren(
    AuthAuthorAuthorArticleArticleRouteChildren,
  )

interface AuthAuthorAuthorArticleRouteChildren {
  AuthAuthorAuthorArticleArticleRoute: typeof AuthAuthorAuthorArticleArticleRouteWithChildren
}

const AuthAuthorAuthorArticleRouteChildren: AuthAuthorAuthorArticleRouteChildren =
  {
    AuthAuthorAuthorArticleArticleRoute:
      AuthAuthorAuthorArticleArticleRouteWithChildren,
  }

const AuthAuthorAuthorArticleRouteWithChildren =
  AuthAuthorAuthorArticleRoute._addFileChildren(
    AuthAuthorAuthorArticleRouteChildren,
  )

interface AuthAuthorAuthorAwardAwardAwardIdLayoutRouteChildren {
  AuthAuthorAuthorAwardAwardAwardIdLayoutEditRoute: typeof AuthAuthorAuthorAwardAwardAwardIdLayoutEditRoute
  AuthAuthorAuthorAwardAwardAwardIdLayoutIndexRoute: typeof AuthAuthorAuthorAwardAwardAwardIdLayoutIndexRoute
}

const AuthAuthorAuthorAwardAwardAwardIdLayoutRouteChildren: AuthAuthorAuthorAwardAwardAwardIdLayoutRouteChildren =
  {
    AuthAuthorAuthorAwardAwardAwardIdLayoutEditRoute:
      AuthAuthorAuthorAwardAwardAwardIdLayoutEditRoute,
    AuthAuthorAuthorAwardAwardAwardIdLayoutIndexRoute:
      AuthAuthorAuthorAwardAwardAwardIdLayoutIndexRoute,
  }

const AuthAuthorAuthorAwardAwardAwardIdLayoutRouteWithChildren =
  AuthAuthorAuthorAwardAwardAwardIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorAwardAwardAwardIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorAwardAwardAwardIdRouteChildren {
  AuthAuthorAuthorAwardAwardAwardIdLayoutRoute: typeof AuthAuthorAuthorAwardAwardAwardIdLayoutRouteWithChildren
}

const AuthAuthorAuthorAwardAwardAwardIdRouteChildren: AuthAuthorAuthorAwardAwardAwardIdRouteChildren =
  {
    AuthAuthorAuthorAwardAwardAwardIdLayoutRoute:
      AuthAuthorAuthorAwardAwardAwardIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorAwardAwardAwardIdRouteWithChildren =
  AuthAuthorAuthorAwardAwardAwardIdRoute._addFileChildren(
    AuthAuthorAuthorAwardAwardAwardIdRouteChildren,
  )

interface AuthAuthorAuthorAwardAwardRouteChildren {
  AuthAuthorAuthorAwardAwardCreateRoute: typeof AuthAuthorAuthorAwardAwardCreateRoute
  AuthAuthorAuthorAwardAwardIndexRoute: typeof AuthAuthorAuthorAwardAwardIndexRoute
  AuthAuthorAuthorAwardAwardAwardIdRoute: typeof AuthAuthorAuthorAwardAwardAwardIdRouteWithChildren
}

const AuthAuthorAuthorAwardAwardRouteChildren: AuthAuthorAuthorAwardAwardRouteChildren =
  {
    AuthAuthorAuthorAwardAwardCreateRoute:
      AuthAuthorAuthorAwardAwardCreateRoute,
    AuthAuthorAuthorAwardAwardIndexRoute: AuthAuthorAuthorAwardAwardIndexRoute,
    AuthAuthorAuthorAwardAwardAwardIdRoute:
      AuthAuthorAuthorAwardAwardAwardIdRouteWithChildren,
  }

const AuthAuthorAuthorAwardAwardRouteWithChildren =
  AuthAuthorAuthorAwardAwardRoute._addFileChildren(
    AuthAuthorAuthorAwardAwardRouteChildren,
  )

interface AuthAuthorAuthorAwardRouteChildren {
  AuthAuthorAuthorAwardAwardRoute: typeof AuthAuthorAuthorAwardAwardRouteWithChildren
}

const AuthAuthorAuthorAwardRouteChildren: AuthAuthorAuthorAwardRouteChildren = {
  AuthAuthorAuthorAwardAwardRoute: AuthAuthorAuthorAwardAwardRouteWithChildren,
}

const AuthAuthorAuthorAwardRouteWithChildren =
  AuthAuthorAuthorAwardRoute._addFileChildren(
    AuthAuthorAuthorAwardRouteChildren,
  )

interface AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutRouteChildren {
  AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutEditRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutEditRoute
  AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutIndexRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutIndexRoute
}

const AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutRouteChildren: AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutRouteChildren =
  {
    AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutEditRoute:
      AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutEditRoute,
    AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutIndexRoute:
      AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutIndexRoute,
  }

const AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutRouteWithChildren =
  AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdRouteChildren {
  AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutRouteWithChildren
}

const AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdRouteChildren: AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdRouteChildren =
  {
    AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutRoute:
      AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdRouteWithChildren =
  AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdRoute._addFileChildren(
    AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdRouteChildren,
  )

interface AuthAuthorAuthorBookBookBookIdLayoutRouteChildren {
  AuthAuthorAuthorBookBookBookIdLayoutEditRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutEditRoute
  AuthAuthorAuthorBookBookBookIdLayoutIndexRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutIndexRoute
  AuthAuthorAuthorBookBookBookIdLayoutCitationsCreateRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCreateRoute
  AuthAuthorAuthorBookBookBookIdLayoutCitationsIndexRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsIndexRoute
  AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdRouteWithChildren
}

const AuthAuthorAuthorBookBookBookIdLayoutRouteChildren: AuthAuthorAuthorBookBookBookIdLayoutRouteChildren =
  {
    AuthAuthorAuthorBookBookBookIdLayoutEditRoute:
      AuthAuthorAuthorBookBookBookIdLayoutEditRoute,
    AuthAuthorAuthorBookBookBookIdLayoutIndexRoute:
      AuthAuthorAuthorBookBookBookIdLayoutIndexRoute,
    AuthAuthorAuthorBookBookBookIdLayoutCitationsCreateRoute:
      AuthAuthorAuthorBookBookBookIdLayoutCitationsCreateRoute,
    AuthAuthorAuthorBookBookBookIdLayoutCitationsIndexRoute:
      AuthAuthorAuthorBookBookBookIdLayoutCitationsIndexRoute,
    AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdRoute:
      AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdRouteWithChildren,
  }

const AuthAuthorAuthorBookBookBookIdLayoutRouteWithChildren =
  AuthAuthorAuthorBookBookBookIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorBookBookBookIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorBookBookBookIdRouteChildren {
  AuthAuthorAuthorBookBookBookIdLayoutRoute: typeof AuthAuthorAuthorBookBookBookIdLayoutRouteWithChildren
}

const AuthAuthorAuthorBookBookBookIdRouteChildren: AuthAuthorAuthorBookBookBookIdRouteChildren =
  {
    AuthAuthorAuthorBookBookBookIdLayoutRoute:
      AuthAuthorAuthorBookBookBookIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorBookBookBookIdRouteWithChildren =
  AuthAuthorAuthorBookBookBookIdRoute._addFileChildren(
    AuthAuthorAuthorBookBookBookIdRouteChildren,
  )

interface AuthAuthorAuthorBookBookRouteChildren {
  AuthAuthorAuthorBookBookCreateRoute: typeof AuthAuthorAuthorBookBookCreateRoute
  AuthAuthorAuthorBookBookSearchClaimableRoute: typeof AuthAuthorAuthorBookBookSearchClaimableRoute
  AuthAuthorAuthorBookBookIndexRoute: typeof AuthAuthorAuthorBookBookIndexRoute
  AuthAuthorAuthorBookBookBookIdRoute: typeof AuthAuthorAuthorBookBookBookIdRouteWithChildren
}

const AuthAuthorAuthorBookBookRouteChildren: AuthAuthorAuthorBookBookRouteChildren =
  {
    AuthAuthorAuthorBookBookCreateRoute: AuthAuthorAuthorBookBookCreateRoute,
    AuthAuthorAuthorBookBookSearchClaimableRoute:
      AuthAuthorAuthorBookBookSearchClaimableRoute,
    AuthAuthorAuthorBookBookIndexRoute: AuthAuthorAuthorBookBookIndexRoute,
    AuthAuthorAuthorBookBookBookIdRoute:
      AuthAuthorAuthorBookBookBookIdRouteWithChildren,
  }

const AuthAuthorAuthorBookBookRouteWithChildren =
  AuthAuthorAuthorBookBookRoute._addFileChildren(
    AuthAuthorAuthorBookBookRouteChildren,
  )

interface AuthAuthorAuthorBookRouteChildren {
  AuthAuthorAuthorBookBookRoute: typeof AuthAuthorAuthorBookBookRouteWithChildren
}

const AuthAuthorAuthorBookRouteChildren: AuthAuthorAuthorBookRouteChildren = {
  AuthAuthorAuthorBookBookRoute: AuthAuthorAuthorBookBookRouteWithChildren,
}

const AuthAuthorAuthorBookRouteWithChildren =
  AuthAuthorAuthorBookRoute._addFileChildren(AuthAuthorAuthorBookRouteChildren)

interface AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutRouteChildren {
  AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutEditRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutEditRoute
  AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutIndexRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutIndexRoute
}

const AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutRouteChildren: AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutRouteChildren =
  {
    AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutEditRoute:
      AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutEditRoute,
    AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutIndexRoute:
      AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutIndexRoute,
  }

const AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutRouteWithChildren =
  AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdRouteChildren {
  AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutRouteWithChildren
}

const AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdRouteChildren: AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdRouteChildren =
  {
    AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutRoute:
      AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdRouteWithChildren =
  AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdRoute._addFileChildren(
    AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdRouteChildren,
  )

interface AuthAuthorAuthorChapterChapterChapterIdLayoutRouteChildren {
  AuthAuthorAuthorChapterChapterChapterIdLayoutEditRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutEditRoute
  AuthAuthorAuthorChapterChapterChapterIdLayoutIndexRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutIndexRoute
  AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCreateRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCreateRoute
  AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsIndexRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsIndexRoute
  AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdRouteWithChildren
}

const AuthAuthorAuthorChapterChapterChapterIdLayoutRouteChildren: AuthAuthorAuthorChapterChapterChapterIdLayoutRouteChildren =
  {
    AuthAuthorAuthorChapterChapterChapterIdLayoutEditRoute:
      AuthAuthorAuthorChapterChapterChapterIdLayoutEditRoute,
    AuthAuthorAuthorChapterChapterChapterIdLayoutIndexRoute:
      AuthAuthorAuthorChapterChapterChapterIdLayoutIndexRoute,
    AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCreateRoute:
      AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCreateRoute,
    AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsIndexRoute:
      AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsIndexRoute,
    AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdRoute:
      AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdRouteWithChildren,
  }

const AuthAuthorAuthorChapterChapterChapterIdLayoutRouteWithChildren =
  AuthAuthorAuthorChapterChapterChapterIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorChapterChapterChapterIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorChapterChapterChapterIdRouteChildren {
  AuthAuthorAuthorChapterChapterChapterIdLayoutRoute: typeof AuthAuthorAuthorChapterChapterChapterIdLayoutRouteWithChildren
}

const AuthAuthorAuthorChapterChapterChapterIdRouteChildren: AuthAuthorAuthorChapterChapterChapterIdRouteChildren =
  {
    AuthAuthorAuthorChapterChapterChapterIdLayoutRoute:
      AuthAuthorAuthorChapterChapterChapterIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorChapterChapterChapterIdRouteWithChildren =
  AuthAuthorAuthorChapterChapterChapterIdRoute._addFileChildren(
    AuthAuthorAuthorChapterChapterChapterIdRouteChildren,
  )

interface AuthAuthorAuthorChapterChapterRouteChildren {
  AuthAuthorAuthorChapterChapterCreateRoute: typeof AuthAuthorAuthorChapterChapterCreateRoute
  AuthAuthorAuthorChapterChapterSearchClaimableRoute: typeof AuthAuthorAuthorChapterChapterSearchClaimableRoute
  AuthAuthorAuthorChapterChapterIndexRoute: typeof AuthAuthorAuthorChapterChapterIndexRoute
  AuthAuthorAuthorChapterChapterChapterIdRoute: typeof AuthAuthorAuthorChapterChapterChapterIdRouteWithChildren
}

const AuthAuthorAuthorChapterChapterRouteChildren: AuthAuthorAuthorChapterChapterRouteChildren =
  {
    AuthAuthorAuthorChapterChapterCreateRoute:
      AuthAuthorAuthorChapterChapterCreateRoute,
    AuthAuthorAuthorChapterChapterSearchClaimableRoute:
      AuthAuthorAuthorChapterChapterSearchClaimableRoute,
    AuthAuthorAuthorChapterChapterIndexRoute:
      AuthAuthorAuthorChapterChapterIndexRoute,
    AuthAuthorAuthorChapterChapterChapterIdRoute:
      AuthAuthorAuthorChapterChapterChapterIdRouteWithChildren,
  }

const AuthAuthorAuthorChapterChapterRouteWithChildren =
  AuthAuthorAuthorChapterChapterRoute._addFileChildren(
    AuthAuthorAuthorChapterChapterRouteChildren,
  )

interface AuthAuthorAuthorChapterRouteChildren {
  AuthAuthorAuthorChapterChapterRoute: typeof AuthAuthorAuthorChapterChapterRouteWithChildren
}

const AuthAuthorAuthorChapterRouteChildren: AuthAuthorAuthorChapterRouteChildren =
  {
    AuthAuthorAuthorChapterChapterRoute:
      AuthAuthorAuthorChapterChapterRouteWithChildren,
  }

const AuthAuthorAuthorChapterRouteWithChildren =
  AuthAuthorAuthorChapterRoute._addFileChildren(
    AuthAuthorAuthorChapterRouteChildren,
  )

interface AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutRouteChildren {
  AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutEditRoute: typeof AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutEditRoute
  AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutIndexRoute: typeof AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutIndexRoute
}

const AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutRouteChildren: AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutRouteChildren =
  {
    AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutEditRoute:
      AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutEditRoute,
    AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutIndexRoute:
      AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutIndexRoute,
  }

const AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutRouteWithChildren =
  AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorCommitteeCommitteeCommitteeIdRouteChildren {
  AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutRoute: typeof AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutRouteWithChildren
}

const AuthAuthorAuthorCommitteeCommitteeCommitteeIdRouteChildren: AuthAuthorAuthorCommitteeCommitteeCommitteeIdRouteChildren =
  {
    AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutRoute:
      AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorCommitteeCommitteeCommitteeIdRouteWithChildren =
  AuthAuthorAuthorCommitteeCommitteeCommitteeIdRoute._addFileChildren(
    AuthAuthorAuthorCommitteeCommitteeCommitteeIdRouteChildren,
  )

interface AuthAuthorAuthorCommitteeCommitteeRouteChildren {
  AuthAuthorAuthorCommitteeCommitteeCreateRoute: typeof AuthAuthorAuthorCommitteeCommitteeCreateRoute
  AuthAuthorAuthorCommitteeCommitteeIndexRoute: typeof AuthAuthorAuthorCommitteeCommitteeIndexRoute
  AuthAuthorAuthorCommitteeCommitteeCommitteeIdRoute: typeof AuthAuthorAuthorCommitteeCommitteeCommitteeIdRouteWithChildren
}

const AuthAuthorAuthorCommitteeCommitteeRouteChildren: AuthAuthorAuthorCommitteeCommitteeRouteChildren =
  {
    AuthAuthorAuthorCommitteeCommitteeCreateRoute:
      AuthAuthorAuthorCommitteeCommitteeCreateRoute,
    AuthAuthorAuthorCommitteeCommitteeIndexRoute:
      AuthAuthorAuthorCommitteeCommitteeIndexRoute,
    AuthAuthorAuthorCommitteeCommitteeCommitteeIdRoute:
      AuthAuthorAuthorCommitteeCommitteeCommitteeIdRouteWithChildren,
  }

const AuthAuthorAuthorCommitteeCommitteeRouteWithChildren =
  AuthAuthorAuthorCommitteeCommitteeRoute._addFileChildren(
    AuthAuthorAuthorCommitteeCommitteeRouteChildren,
  )

interface AuthAuthorAuthorCommitteeRouteChildren {
  AuthAuthorAuthorCommitteeCommitteeRoute: typeof AuthAuthorAuthorCommitteeCommitteeRouteWithChildren
}

const AuthAuthorAuthorCommitteeRouteChildren: AuthAuthorAuthorCommitteeRouteChildren =
  {
    AuthAuthorAuthorCommitteeCommitteeRoute:
      AuthAuthorAuthorCommitteeCommitteeRouteWithChildren,
  }

const AuthAuthorAuthorCommitteeRouteWithChildren =
  AuthAuthorAuthorCommitteeRoute._addFileChildren(
    AuthAuthorAuthorCommitteeRouteChildren,
  )

interface AuthAuthorAuthorCourseCourseCourseIdLayoutRouteChildren {
  AuthAuthorAuthorCourseCourseCourseIdLayoutEditRoute: typeof AuthAuthorAuthorCourseCourseCourseIdLayoutEditRoute
  AuthAuthorAuthorCourseCourseCourseIdLayoutIndexRoute: typeof AuthAuthorAuthorCourseCourseCourseIdLayoutIndexRoute
}

const AuthAuthorAuthorCourseCourseCourseIdLayoutRouteChildren: AuthAuthorAuthorCourseCourseCourseIdLayoutRouteChildren =
  {
    AuthAuthorAuthorCourseCourseCourseIdLayoutEditRoute:
      AuthAuthorAuthorCourseCourseCourseIdLayoutEditRoute,
    AuthAuthorAuthorCourseCourseCourseIdLayoutIndexRoute:
      AuthAuthorAuthorCourseCourseCourseIdLayoutIndexRoute,
  }

const AuthAuthorAuthorCourseCourseCourseIdLayoutRouteWithChildren =
  AuthAuthorAuthorCourseCourseCourseIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorCourseCourseCourseIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorCourseCourseCourseIdRouteChildren {
  AuthAuthorAuthorCourseCourseCourseIdLayoutRoute: typeof AuthAuthorAuthorCourseCourseCourseIdLayoutRouteWithChildren
}

const AuthAuthorAuthorCourseCourseCourseIdRouteChildren: AuthAuthorAuthorCourseCourseCourseIdRouteChildren =
  {
    AuthAuthorAuthorCourseCourseCourseIdLayoutRoute:
      AuthAuthorAuthorCourseCourseCourseIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorCourseCourseCourseIdRouteWithChildren =
  AuthAuthorAuthorCourseCourseCourseIdRoute._addFileChildren(
    AuthAuthorAuthorCourseCourseCourseIdRouteChildren,
  )

interface AuthAuthorAuthorCourseCourseRouteChildren {
  AuthAuthorAuthorCourseCourseCreateRoute: typeof AuthAuthorAuthorCourseCourseCreateRoute
  AuthAuthorAuthorCourseCourseIndexRoute: typeof AuthAuthorAuthorCourseCourseIndexRoute
  AuthAuthorAuthorCourseCourseCourseIdRoute: typeof AuthAuthorAuthorCourseCourseCourseIdRouteWithChildren
}

const AuthAuthorAuthorCourseCourseRouteChildren: AuthAuthorAuthorCourseCourseRouteChildren =
  {
    AuthAuthorAuthorCourseCourseCreateRoute:
      AuthAuthorAuthorCourseCourseCreateRoute,
    AuthAuthorAuthorCourseCourseIndexRoute:
      AuthAuthorAuthorCourseCourseIndexRoute,
    AuthAuthorAuthorCourseCourseCourseIdRoute:
      AuthAuthorAuthorCourseCourseCourseIdRouteWithChildren,
  }

const AuthAuthorAuthorCourseCourseRouteWithChildren =
  AuthAuthorAuthorCourseCourseRoute._addFileChildren(
    AuthAuthorAuthorCourseCourseRouteChildren,
  )

interface AuthAuthorAuthorCourseRouteChildren {
  AuthAuthorAuthorCourseCourseRoute: typeof AuthAuthorAuthorCourseCourseRouteWithChildren
}

const AuthAuthorAuthorCourseRouteChildren: AuthAuthorAuthorCourseRouteChildren =
  {
    AuthAuthorAuthorCourseCourseRoute:
      AuthAuthorAuthorCourseCourseRouteWithChildren,
  }

const AuthAuthorAuthorCourseRouteWithChildren =
  AuthAuthorAuthorCourseRoute._addFileChildren(
    AuthAuthorAuthorCourseRouteChildren,
  )

interface AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutRouteChildren {
  AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutEditRoute: typeof AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutEditRoute
  AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutIndexRoute: typeof AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutIndexRoute
}

const AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutRouteChildren: AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutRouteChildren =
  {
    AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutEditRoute:
      AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutEditRoute,
    AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutIndexRoute:
      AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutIndexRoute,
  }

const AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutRouteWithChildren =
  AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorDictionaryDictionaryDictionaryIdRouteChildren {
  AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutRoute: typeof AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutRouteWithChildren
}

const AuthAuthorAuthorDictionaryDictionaryDictionaryIdRouteChildren: AuthAuthorAuthorDictionaryDictionaryDictionaryIdRouteChildren =
  {
    AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutRoute:
      AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorDictionaryDictionaryDictionaryIdRouteWithChildren =
  AuthAuthorAuthorDictionaryDictionaryDictionaryIdRoute._addFileChildren(
    AuthAuthorAuthorDictionaryDictionaryDictionaryIdRouteChildren,
  )

interface AuthAuthorAuthorDictionaryDictionaryRouteChildren {
  AuthAuthorAuthorDictionaryDictionaryCreateRoute: typeof AuthAuthorAuthorDictionaryDictionaryCreateRoute
  AuthAuthorAuthorDictionaryDictionaryIndexRoute: typeof AuthAuthorAuthorDictionaryDictionaryIndexRoute
  AuthAuthorAuthorDictionaryDictionaryDictionaryIdRoute: typeof AuthAuthorAuthorDictionaryDictionaryDictionaryIdRouteWithChildren
}

const AuthAuthorAuthorDictionaryDictionaryRouteChildren: AuthAuthorAuthorDictionaryDictionaryRouteChildren =
  {
    AuthAuthorAuthorDictionaryDictionaryCreateRoute:
      AuthAuthorAuthorDictionaryDictionaryCreateRoute,
    AuthAuthorAuthorDictionaryDictionaryIndexRoute:
      AuthAuthorAuthorDictionaryDictionaryIndexRoute,
    AuthAuthorAuthorDictionaryDictionaryDictionaryIdRoute:
      AuthAuthorAuthorDictionaryDictionaryDictionaryIdRouteWithChildren,
  }

const AuthAuthorAuthorDictionaryDictionaryRouteWithChildren =
  AuthAuthorAuthorDictionaryDictionaryRoute._addFileChildren(
    AuthAuthorAuthorDictionaryDictionaryRouteChildren,
  )

interface AuthAuthorAuthorDictionaryRouteChildren {
  AuthAuthorAuthorDictionaryDictionaryRoute: typeof AuthAuthorAuthorDictionaryDictionaryRouteWithChildren
}

const AuthAuthorAuthorDictionaryRouteChildren: AuthAuthorAuthorDictionaryRouteChildren =
  {
    AuthAuthorAuthorDictionaryDictionaryRoute:
      AuthAuthorAuthorDictionaryDictionaryRouteWithChildren,
  }

const AuthAuthorAuthorDictionaryRouteWithChildren =
  AuthAuthorAuthorDictionaryRoute._addFileChildren(
    AuthAuthorAuthorDictionaryRouteChildren,
  )

interface AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutRouteChildren {
  AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutEditRoute: typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutEditRoute
  AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutIndexRoute: typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutIndexRoute
}

const AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutRouteChildren: AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutRouteChildren =
  {
    AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutEditRoute:
      AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutEditRoute,
    AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutIndexRoute:
      AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutIndexRoute,
  }

const AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutRouteWithChildren =
  AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdRouteChildren {
  AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutRoute: typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutRouteWithChildren
}

const AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdRouteChildren: AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdRouteChildren =
  {
    AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutRoute:
      AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdRouteWithChildren =
  AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdRoute._addFileChildren(
    AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdRouteChildren,
  )

interface AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeRouteChildren {
  AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeCreateRoute: typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeCreateRoute
  AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeIndexRoute: typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeIndexRoute
  AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdRoute: typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdRouteWithChildren
}

const AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeRouteChildren: AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeRouteChildren =
  {
    AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeCreateRoute:
      AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeCreateRoute,
    AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeIndexRoute:
      AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeIndexRoute,
    AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdRoute:
      AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdRouteWithChildren,
  }

const AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeRouteWithChildren =
  AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeRoute._addFileChildren(
    AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeRouteChildren,
  )

interface AuthAuthorAuthorDoctoralCommitteeRouteChildren {
  AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeRoute: typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeRouteWithChildren
}

const AuthAuthorAuthorDoctoralCommitteeRouteChildren: AuthAuthorAuthorDoctoralCommitteeRouteChildren =
  {
    AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeRoute:
      AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeRouteWithChildren,
  }

const AuthAuthorAuthorDoctoralCommitteeRouteWithChildren =
  AuthAuthorAuthorDoctoralCommitteeRoute._addFileChildren(
    AuthAuthorAuthorDoctoralCommitteeRouteChildren,
  )

interface AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutRouteChildren {
  AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutEditRoute: typeof AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutEditRoute
  AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutIndexRoute: typeof AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutIndexRoute
}

const AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutRouteChildren: AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutRouteChildren =
  {
    AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutEditRoute:
      AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutEditRoute,
    AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutIndexRoute:
      AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutIndexRoute,
  }

const AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutRouteWithChildren =
  AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdRouteChildren {
  AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutRoute: typeof AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutRouteWithChildren
}

const AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdRouteChildren: AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdRouteChildren =
  {
    AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutRoute:
      AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdRouteWithChildren =
  AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdRoute._addFileChildren(
    AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdRouteChildren,
  )

interface AuthAuthorAuthorEditorialTeamEditorialTeamRouteChildren {
  AuthAuthorAuthorEditorialTeamEditorialTeamCreateRoute: typeof AuthAuthorAuthorEditorialTeamEditorialTeamCreateRoute
  AuthAuthorAuthorEditorialTeamEditorialTeamIndexRoute: typeof AuthAuthorAuthorEditorialTeamEditorialTeamIndexRoute
  AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdRoute: typeof AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdRouteWithChildren
}

const AuthAuthorAuthorEditorialTeamEditorialTeamRouteChildren: AuthAuthorAuthorEditorialTeamEditorialTeamRouteChildren =
  {
    AuthAuthorAuthorEditorialTeamEditorialTeamCreateRoute:
      AuthAuthorAuthorEditorialTeamEditorialTeamCreateRoute,
    AuthAuthorAuthorEditorialTeamEditorialTeamIndexRoute:
      AuthAuthorAuthorEditorialTeamEditorialTeamIndexRoute,
    AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdRoute:
      AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdRouteWithChildren,
  }

const AuthAuthorAuthorEditorialTeamEditorialTeamRouteWithChildren =
  AuthAuthorAuthorEditorialTeamEditorialTeamRoute._addFileChildren(
    AuthAuthorAuthorEditorialTeamEditorialTeamRouteChildren,
  )

interface AuthAuthorAuthorEditorialTeamRouteChildren {
  AuthAuthorAuthorEditorialTeamEditorialTeamRoute: typeof AuthAuthorAuthorEditorialTeamEditorialTeamRouteWithChildren
}

const AuthAuthorAuthorEditorialTeamRouteChildren: AuthAuthorAuthorEditorialTeamRouteChildren =
  {
    AuthAuthorAuthorEditorialTeamEditorialTeamRoute:
      AuthAuthorAuthorEditorialTeamEditorialTeamRouteWithChildren,
  }

const AuthAuthorAuthorEditorialTeamRouteWithChildren =
  AuthAuthorAuthorEditorialTeamRoute._addFileChildren(
    AuthAuthorAuthorEditorialTeamRouteChildren,
  )

interface AuthAuthorAuthorMobilityMobilityMobilityIdLayoutRouteChildren {
  AuthAuthorAuthorMobilityMobilityMobilityIdLayoutEditRoute: typeof AuthAuthorAuthorMobilityMobilityMobilityIdLayoutEditRoute
  AuthAuthorAuthorMobilityMobilityMobilityIdLayoutIndexRoute: typeof AuthAuthorAuthorMobilityMobilityMobilityIdLayoutIndexRoute
}

const AuthAuthorAuthorMobilityMobilityMobilityIdLayoutRouteChildren: AuthAuthorAuthorMobilityMobilityMobilityIdLayoutRouteChildren =
  {
    AuthAuthorAuthorMobilityMobilityMobilityIdLayoutEditRoute:
      AuthAuthorAuthorMobilityMobilityMobilityIdLayoutEditRoute,
    AuthAuthorAuthorMobilityMobilityMobilityIdLayoutIndexRoute:
      AuthAuthorAuthorMobilityMobilityMobilityIdLayoutIndexRoute,
  }

const AuthAuthorAuthorMobilityMobilityMobilityIdLayoutRouteWithChildren =
  AuthAuthorAuthorMobilityMobilityMobilityIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorMobilityMobilityMobilityIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorMobilityMobilityMobilityIdRouteChildren {
  AuthAuthorAuthorMobilityMobilityMobilityIdLayoutRoute: typeof AuthAuthorAuthorMobilityMobilityMobilityIdLayoutRouteWithChildren
}

const AuthAuthorAuthorMobilityMobilityMobilityIdRouteChildren: AuthAuthorAuthorMobilityMobilityMobilityIdRouteChildren =
  {
    AuthAuthorAuthorMobilityMobilityMobilityIdLayoutRoute:
      AuthAuthorAuthorMobilityMobilityMobilityIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorMobilityMobilityMobilityIdRouteWithChildren =
  AuthAuthorAuthorMobilityMobilityMobilityIdRoute._addFileChildren(
    AuthAuthorAuthorMobilityMobilityMobilityIdRouteChildren,
  )

interface AuthAuthorAuthorMobilityMobilityRouteChildren {
  AuthAuthorAuthorMobilityMobilityCreateRoute: typeof AuthAuthorAuthorMobilityMobilityCreateRoute
  AuthAuthorAuthorMobilityMobilityIndexRoute: typeof AuthAuthorAuthorMobilityMobilityIndexRoute
  AuthAuthorAuthorMobilityMobilityMobilityIdRoute: typeof AuthAuthorAuthorMobilityMobilityMobilityIdRouteWithChildren
}

const AuthAuthorAuthorMobilityMobilityRouteChildren: AuthAuthorAuthorMobilityMobilityRouteChildren =
  {
    AuthAuthorAuthorMobilityMobilityCreateRoute:
      AuthAuthorAuthorMobilityMobilityCreateRoute,
    AuthAuthorAuthorMobilityMobilityIndexRoute:
      AuthAuthorAuthorMobilityMobilityIndexRoute,
    AuthAuthorAuthorMobilityMobilityMobilityIdRoute:
      AuthAuthorAuthorMobilityMobilityMobilityIdRouteWithChildren,
  }

const AuthAuthorAuthorMobilityMobilityRouteWithChildren =
  AuthAuthorAuthorMobilityMobilityRoute._addFileChildren(
    AuthAuthorAuthorMobilityMobilityRouteChildren,
  )

interface AuthAuthorAuthorMobilityRouteChildren {
  AuthAuthorAuthorMobilityMobilityRoute: typeof AuthAuthorAuthorMobilityMobilityRouteWithChildren
}

const AuthAuthorAuthorMobilityRouteChildren: AuthAuthorAuthorMobilityRouteChildren =
  {
    AuthAuthorAuthorMobilityMobilityRoute:
      AuthAuthorAuthorMobilityMobilityRouteWithChildren,
  }

const AuthAuthorAuthorMobilityRouteWithChildren =
  AuthAuthorAuthorMobilityRoute._addFileChildren(
    AuthAuthorAuthorMobilityRouteChildren,
  )

interface AuthAuthorAuthorPatentPatentPatentIdLayoutRouteChildren {
  AuthAuthorAuthorPatentPatentPatentIdLayoutEditRoute: typeof AuthAuthorAuthorPatentPatentPatentIdLayoutEditRoute
  AuthAuthorAuthorPatentPatentPatentIdLayoutIndexRoute: typeof AuthAuthorAuthorPatentPatentPatentIdLayoutIndexRoute
}

const AuthAuthorAuthorPatentPatentPatentIdLayoutRouteChildren: AuthAuthorAuthorPatentPatentPatentIdLayoutRouteChildren =
  {
    AuthAuthorAuthorPatentPatentPatentIdLayoutEditRoute:
      AuthAuthorAuthorPatentPatentPatentIdLayoutEditRoute,
    AuthAuthorAuthorPatentPatentPatentIdLayoutIndexRoute:
      AuthAuthorAuthorPatentPatentPatentIdLayoutIndexRoute,
  }

const AuthAuthorAuthorPatentPatentPatentIdLayoutRouteWithChildren =
  AuthAuthorAuthorPatentPatentPatentIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorPatentPatentPatentIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorPatentPatentPatentIdRouteChildren {
  AuthAuthorAuthorPatentPatentPatentIdLayoutRoute: typeof AuthAuthorAuthorPatentPatentPatentIdLayoutRouteWithChildren
}

const AuthAuthorAuthorPatentPatentPatentIdRouteChildren: AuthAuthorAuthorPatentPatentPatentIdRouteChildren =
  {
    AuthAuthorAuthorPatentPatentPatentIdLayoutRoute:
      AuthAuthorAuthorPatentPatentPatentIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorPatentPatentPatentIdRouteWithChildren =
  AuthAuthorAuthorPatentPatentPatentIdRoute._addFileChildren(
    AuthAuthorAuthorPatentPatentPatentIdRouteChildren,
  )

interface AuthAuthorAuthorPatentPatentRouteChildren {
  AuthAuthorAuthorPatentPatentCreateRoute: typeof AuthAuthorAuthorPatentPatentCreateRoute
  AuthAuthorAuthorPatentPatentSearchClaimableRoute: typeof AuthAuthorAuthorPatentPatentSearchClaimableRoute
  AuthAuthorAuthorPatentPatentIndexRoute: typeof AuthAuthorAuthorPatentPatentIndexRoute
  AuthAuthorAuthorPatentPatentPatentIdRoute: typeof AuthAuthorAuthorPatentPatentPatentIdRouteWithChildren
}

const AuthAuthorAuthorPatentPatentRouteChildren: AuthAuthorAuthorPatentPatentRouteChildren =
  {
    AuthAuthorAuthorPatentPatentCreateRoute:
      AuthAuthorAuthorPatentPatentCreateRoute,
    AuthAuthorAuthorPatentPatentSearchClaimableRoute:
      AuthAuthorAuthorPatentPatentSearchClaimableRoute,
    AuthAuthorAuthorPatentPatentIndexRoute:
      AuthAuthorAuthorPatentPatentIndexRoute,
    AuthAuthorAuthorPatentPatentPatentIdRoute:
      AuthAuthorAuthorPatentPatentPatentIdRouteWithChildren,
  }

const AuthAuthorAuthorPatentPatentRouteWithChildren =
  AuthAuthorAuthorPatentPatentRoute._addFileChildren(
    AuthAuthorAuthorPatentPatentRouteChildren,
  )

interface AuthAuthorAuthorPatentRouteChildren {
  AuthAuthorAuthorPatentPatentRoute: typeof AuthAuthorAuthorPatentPatentRouteWithChildren
}

const AuthAuthorAuthorPatentRouteChildren: AuthAuthorAuthorPatentRouteChildren =
  {
    AuthAuthorAuthorPatentPatentRoute:
      AuthAuthorAuthorPatentPatentRouteWithChildren,
  }

const AuthAuthorAuthorPatentRouteWithChildren =
  AuthAuthorAuthorPatentRoute._addFileChildren(
    AuthAuthorAuthorPatentRouteChildren,
  )

interface AuthAuthorAuthorPresentationPresentationPresentationIdLayoutRouteChildren {
  AuthAuthorAuthorPresentationPresentationPresentationIdLayoutEditRoute: typeof AuthAuthorAuthorPresentationPresentationPresentationIdLayoutEditRoute
  AuthAuthorAuthorPresentationPresentationPresentationIdLayoutIndexRoute: typeof AuthAuthorAuthorPresentationPresentationPresentationIdLayoutIndexRoute
}

const AuthAuthorAuthorPresentationPresentationPresentationIdLayoutRouteChildren: AuthAuthorAuthorPresentationPresentationPresentationIdLayoutRouteChildren =
  {
    AuthAuthorAuthorPresentationPresentationPresentationIdLayoutEditRoute:
      AuthAuthorAuthorPresentationPresentationPresentationIdLayoutEditRoute,
    AuthAuthorAuthorPresentationPresentationPresentationIdLayoutIndexRoute:
      AuthAuthorAuthorPresentationPresentationPresentationIdLayoutIndexRoute,
  }

const AuthAuthorAuthorPresentationPresentationPresentationIdLayoutRouteWithChildren =
  AuthAuthorAuthorPresentationPresentationPresentationIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorPresentationPresentationPresentationIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorPresentationPresentationPresentationIdRouteChildren {
  AuthAuthorAuthorPresentationPresentationPresentationIdLayoutRoute: typeof AuthAuthorAuthorPresentationPresentationPresentationIdLayoutRouteWithChildren
}

const AuthAuthorAuthorPresentationPresentationPresentationIdRouteChildren: AuthAuthorAuthorPresentationPresentationPresentationIdRouteChildren =
  {
    AuthAuthorAuthorPresentationPresentationPresentationIdLayoutRoute:
      AuthAuthorAuthorPresentationPresentationPresentationIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorPresentationPresentationPresentationIdRouteWithChildren =
  AuthAuthorAuthorPresentationPresentationPresentationIdRoute._addFileChildren(
    AuthAuthorAuthorPresentationPresentationPresentationIdRouteChildren,
  )

interface AuthAuthorAuthorPresentationPresentationRouteChildren {
  AuthAuthorAuthorPresentationPresentationCreateRoute: typeof AuthAuthorAuthorPresentationPresentationCreateRoute
  AuthAuthorAuthorPresentationPresentationIndexRoute: typeof AuthAuthorAuthorPresentationPresentationIndexRoute
  AuthAuthorAuthorPresentationPresentationPresentationIdRoute: typeof AuthAuthorAuthorPresentationPresentationPresentationIdRouteWithChildren
}

const AuthAuthorAuthorPresentationPresentationRouteChildren: AuthAuthorAuthorPresentationPresentationRouteChildren =
  {
    AuthAuthorAuthorPresentationPresentationCreateRoute:
      AuthAuthorAuthorPresentationPresentationCreateRoute,
    AuthAuthorAuthorPresentationPresentationIndexRoute:
      AuthAuthorAuthorPresentationPresentationIndexRoute,
    AuthAuthorAuthorPresentationPresentationPresentationIdRoute:
      AuthAuthorAuthorPresentationPresentationPresentationIdRouteWithChildren,
  }

const AuthAuthorAuthorPresentationPresentationRouteWithChildren =
  AuthAuthorAuthorPresentationPresentationRoute._addFileChildren(
    AuthAuthorAuthorPresentationPresentationRouteChildren,
  )

interface AuthAuthorAuthorPresentationRouteChildren {
  AuthAuthorAuthorPresentationPresentationRoute: typeof AuthAuthorAuthorPresentationPresentationRouteWithChildren
}

const AuthAuthorAuthorPresentationRouteChildren: AuthAuthorAuthorPresentationRouteChildren =
  {
    AuthAuthorAuthorPresentationPresentationRoute:
      AuthAuthorAuthorPresentationPresentationRouteWithChildren,
  }

const AuthAuthorAuthorPresentationRouteWithChildren =
  AuthAuthorAuthorPresentationRoute._addFileChildren(
    AuthAuthorAuthorPresentationRouteChildren,
  )

interface AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutRouteChildren {
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutEditRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutEditRoute
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutIndexRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutIndexRoute
}

const AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutRouteChildren: AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutRouteChildren =
  {
    AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutEditRoute:
      AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutEditRoute,
    AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutIndexRoute:
      AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutIndexRoute,
  }

const AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutRouteWithChildren =
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdRouteChildren {
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutRouteWithChildren
}

const AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdRouteChildren: AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdRouteChildren =
  {
    AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutRoute:
      AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdRouteWithChildren =
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdRoute._addFileChildren(
    AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdRouteChildren,
  )

interface AuthAuthorAuthorProceedingProceedingProceedingIdLayoutRouteChildren {
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutEditRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutEditRoute
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutIndexRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutIndexRoute
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCreateRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCreateRoute
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsIndexRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsIndexRoute
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdRouteWithChildren
}

const AuthAuthorAuthorProceedingProceedingProceedingIdLayoutRouteChildren: AuthAuthorAuthorProceedingProceedingProceedingIdLayoutRouteChildren =
  {
    AuthAuthorAuthorProceedingProceedingProceedingIdLayoutEditRoute:
      AuthAuthorAuthorProceedingProceedingProceedingIdLayoutEditRoute,
    AuthAuthorAuthorProceedingProceedingProceedingIdLayoutIndexRoute:
      AuthAuthorAuthorProceedingProceedingProceedingIdLayoutIndexRoute,
    AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCreateRoute:
      AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCreateRoute,
    AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsIndexRoute:
      AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsIndexRoute,
    AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdRoute:
      AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdRouteWithChildren,
  }

const AuthAuthorAuthorProceedingProceedingProceedingIdLayoutRouteWithChildren =
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorProceedingProceedingProceedingIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorProceedingProceedingProceedingIdRouteChildren {
  AuthAuthorAuthorProceedingProceedingProceedingIdLayoutRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutRouteWithChildren
}

const AuthAuthorAuthorProceedingProceedingProceedingIdRouteChildren: AuthAuthorAuthorProceedingProceedingProceedingIdRouteChildren =
  {
    AuthAuthorAuthorProceedingProceedingProceedingIdLayoutRoute:
      AuthAuthorAuthorProceedingProceedingProceedingIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorProceedingProceedingProceedingIdRouteWithChildren =
  AuthAuthorAuthorProceedingProceedingProceedingIdRoute._addFileChildren(
    AuthAuthorAuthorProceedingProceedingProceedingIdRouteChildren,
  )

interface AuthAuthorAuthorProceedingProceedingRouteChildren {
  AuthAuthorAuthorProceedingProceedingCreateRoute: typeof AuthAuthorAuthorProceedingProceedingCreateRoute
  AuthAuthorAuthorProceedingProceedingSearchClaimableRoute: typeof AuthAuthorAuthorProceedingProceedingSearchClaimableRoute
  AuthAuthorAuthorProceedingProceedingIndexRoute: typeof AuthAuthorAuthorProceedingProceedingIndexRoute
  AuthAuthorAuthorProceedingProceedingProceedingIdRoute: typeof AuthAuthorAuthorProceedingProceedingProceedingIdRouteWithChildren
}

const AuthAuthorAuthorProceedingProceedingRouteChildren: AuthAuthorAuthorProceedingProceedingRouteChildren =
  {
    AuthAuthorAuthorProceedingProceedingCreateRoute:
      AuthAuthorAuthorProceedingProceedingCreateRoute,
    AuthAuthorAuthorProceedingProceedingSearchClaimableRoute:
      AuthAuthorAuthorProceedingProceedingSearchClaimableRoute,
    AuthAuthorAuthorProceedingProceedingIndexRoute:
      AuthAuthorAuthorProceedingProceedingIndexRoute,
    AuthAuthorAuthorProceedingProceedingProceedingIdRoute:
      AuthAuthorAuthorProceedingProceedingProceedingIdRouteWithChildren,
  }

const AuthAuthorAuthorProceedingProceedingRouteWithChildren =
  AuthAuthorAuthorProceedingProceedingRoute._addFileChildren(
    AuthAuthorAuthorProceedingProceedingRouteChildren,
  )

interface AuthAuthorAuthorProceedingRouteChildren {
  AuthAuthorAuthorProceedingProceedingRoute: typeof AuthAuthorAuthorProceedingProceedingRouteWithChildren
}

const AuthAuthorAuthorProceedingRouteChildren: AuthAuthorAuthorProceedingRouteChildren =
  {
    AuthAuthorAuthorProceedingProceedingRoute:
      AuthAuthorAuthorProceedingProceedingRouteWithChildren,
  }

const AuthAuthorAuthorProceedingRouteWithChildren =
  AuthAuthorAuthorProceedingRoute._addFileChildren(
    AuthAuthorAuthorProceedingRouteChildren,
  )

interface AuthAuthorAuthorProjectProjectProjectIdLayoutRouteChildren {
  AuthAuthorAuthorProjectProjectProjectIdLayoutEditRoute: typeof AuthAuthorAuthorProjectProjectProjectIdLayoutEditRoute
  AuthAuthorAuthorProjectProjectProjectIdLayoutIndexRoute: typeof AuthAuthorAuthorProjectProjectProjectIdLayoutIndexRoute
}

const AuthAuthorAuthorProjectProjectProjectIdLayoutRouteChildren: AuthAuthorAuthorProjectProjectProjectIdLayoutRouteChildren =
  {
    AuthAuthorAuthorProjectProjectProjectIdLayoutEditRoute:
      AuthAuthorAuthorProjectProjectProjectIdLayoutEditRoute,
    AuthAuthorAuthorProjectProjectProjectIdLayoutIndexRoute:
      AuthAuthorAuthorProjectProjectProjectIdLayoutIndexRoute,
  }

const AuthAuthorAuthorProjectProjectProjectIdLayoutRouteWithChildren =
  AuthAuthorAuthorProjectProjectProjectIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorProjectProjectProjectIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorProjectProjectProjectIdRouteChildren {
  AuthAuthorAuthorProjectProjectProjectIdLayoutRoute: typeof AuthAuthorAuthorProjectProjectProjectIdLayoutRouteWithChildren
}

const AuthAuthorAuthorProjectProjectProjectIdRouteChildren: AuthAuthorAuthorProjectProjectProjectIdRouteChildren =
  {
    AuthAuthorAuthorProjectProjectProjectIdLayoutRoute:
      AuthAuthorAuthorProjectProjectProjectIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorProjectProjectProjectIdRouteWithChildren =
  AuthAuthorAuthorProjectProjectProjectIdRoute._addFileChildren(
    AuthAuthorAuthorProjectProjectProjectIdRouteChildren,
  )

interface AuthAuthorAuthorProjectProjectRouteChildren {
  AuthAuthorAuthorProjectProjectCreateRoute: typeof AuthAuthorAuthorProjectProjectCreateRoute
  AuthAuthorAuthorProjectProjectSearchClaimableRoute: typeof AuthAuthorAuthorProjectProjectSearchClaimableRoute
  AuthAuthorAuthorProjectProjectIndexRoute: typeof AuthAuthorAuthorProjectProjectIndexRoute
  AuthAuthorAuthorProjectProjectProjectIdRoute: typeof AuthAuthorAuthorProjectProjectProjectIdRouteWithChildren
}

const AuthAuthorAuthorProjectProjectRouteChildren: AuthAuthorAuthorProjectProjectRouteChildren =
  {
    AuthAuthorAuthorProjectProjectCreateRoute:
      AuthAuthorAuthorProjectProjectCreateRoute,
    AuthAuthorAuthorProjectProjectSearchClaimableRoute:
      AuthAuthorAuthorProjectProjectSearchClaimableRoute,
    AuthAuthorAuthorProjectProjectIndexRoute:
      AuthAuthorAuthorProjectProjectIndexRoute,
    AuthAuthorAuthorProjectProjectProjectIdRoute:
      AuthAuthorAuthorProjectProjectProjectIdRouteWithChildren,
  }

const AuthAuthorAuthorProjectProjectRouteWithChildren =
  AuthAuthorAuthorProjectProjectRoute._addFileChildren(
    AuthAuthorAuthorProjectProjectRouteChildren,
  )

interface AuthAuthorAuthorProjectRouteChildren {
  AuthAuthorAuthorProjectProjectRoute: typeof AuthAuthorAuthorProjectProjectRouteWithChildren
}

const AuthAuthorAuthorProjectRouteChildren: AuthAuthorAuthorProjectRouteChildren =
  {
    AuthAuthorAuthorProjectProjectRoute:
      AuthAuthorAuthorProjectProjectRouteWithChildren,
  }

const AuthAuthorAuthorProjectRouteWithChildren =
  AuthAuthorAuthorProjectRoute._addFileChildren(
    AuthAuthorAuthorProjectRouteChildren,
  )

interface AuthAuthorAuthorReviewReviewReviewIdLayoutRouteChildren {
  AuthAuthorAuthorReviewReviewReviewIdLayoutEditRoute: typeof AuthAuthorAuthorReviewReviewReviewIdLayoutEditRoute
  AuthAuthorAuthorReviewReviewReviewIdLayoutIndexRoute: typeof AuthAuthorAuthorReviewReviewReviewIdLayoutIndexRoute
}

const AuthAuthorAuthorReviewReviewReviewIdLayoutRouteChildren: AuthAuthorAuthorReviewReviewReviewIdLayoutRouteChildren =
  {
    AuthAuthorAuthorReviewReviewReviewIdLayoutEditRoute:
      AuthAuthorAuthorReviewReviewReviewIdLayoutEditRoute,
    AuthAuthorAuthorReviewReviewReviewIdLayoutIndexRoute:
      AuthAuthorAuthorReviewReviewReviewIdLayoutIndexRoute,
  }

const AuthAuthorAuthorReviewReviewReviewIdLayoutRouteWithChildren =
  AuthAuthorAuthorReviewReviewReviewIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorReviewReviewReviewIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorReviewReviewReviewIdRouteChildren {
  AuthAuthorAuthorReviewReviewReviewIdLayoutRoute: typeof AuthAuthorAuthorReviewReviewReviewIdLayoutRouteWithChildren
}

const AuthAuthorAuthorReviewReviewReviewIdRouteChildren: AuthAuthorAuthorReviewReviewReviewIdRouteChildren =
  {
    AuthAuthorAuthorReviewReviewReviewIdLayoutRoute:
      AuthAuthorAuthorReviewReviewReviewIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorReviewReviewReviewIdRouteWithChildren =
  AuthAuthorAuthorReviewReviewReviewIdRoute._addFileChildren(
    AuthAuthorAuthorReviewReviewReviewIdRouteChildren,
  )

interface AuthAuthorAuthorReviewReviewRouteChildren {
  AuthAuthorAuthorReviewReviewCreateRoute: typeof AuthAuthorAuthorReviewReviewCreateRoute
  AuthAuthorAuthorReviewReviewSearchClaimableRoute: typeof AuthAuthorAuthorReviewReviewSearchClaimableRoute
  AuthAuthorAuthorReviewReviewIndexRoute: typeof AuthAuthorAuthorReviewReviewIndexRoute
  AuthAuthorAuthorReviewReviewReviewIdRoute: typeof AuthAuthorAuthorReviewReviewReviewIdRouteWithChildren
}

const AuthAuthorAuthorReviewReviewRouteChildren: AuthAuthorAuthorReviewReviewRouteChildren =
  {
    AuthAuthorAuthorReviewReviewCreateRoute:
      AuthAuthorAuthorReviewReviewCreateRoute,
    AuthAuthorAuthorReviewReviewSearchClaimableRoute:
      AuthAuthorAuthorReviewReviewSearchClaimableRoute,
    AuthAuthorAuthorReviewReviewIndexRoute:
      AuthAuthorAuthorReviewReviewIndexRoute,
    AuthAuthorAuthorReviewReviewReviewIdRoute:
      AuthAuthorAuthorReviewReviewReviewIdRouteWithChildren,
  }

const AuthAuthorAuthorReviewReviewRouteWithChildren =
  AuthAuthorAuthorReviewReviewRoute._addFileChildren(
    AuthAuthorAuthorReviewReviewRouteChildren,
  )

interface AuthAuthorAuthorReviewRouteChildren {
  AuthAuthorAuthorReviewReviewRoute: typeof AuthAuthorAuthorReviewReviewRouteWithChildren
}

const AuthAuthorAuthorReviewRouteChildren: AuthAuthorAuthorReviewRouteChildren =
  {
    AuthAuthorAuthorReviewReviewRoute:
      AuthAuthorAuthorReviewReviewRouteWithChildren,
  }

const AuthAuthorAuthorReviewRouteWithChildren =
  AuthAuthorAuthorReviewRoute._addFileChildren(
    AuthAuthorAuthorReviewRouteChildren,
  )

interface AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutRouteChildren {
  AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutEditRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutEditRoute
  AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutIndexRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutIndexRoute
}

const AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutRouteChildren: AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutRouteChildren =
  {
    AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutEditRoute:
      AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutEditRoute,
    AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutIndexRoute:
      AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutIndexRoute,
  }

const AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutRouteWithChildren =
  AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdRouteChildren {
  AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutRouteWithChildren
}

const AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdRouteChildren: AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdRouteChildren =
  {
    AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutRoute:
      AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdRouteWithChildren =
  AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdRoute._addFileChildren(
    AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdRouteChildren,
  )

interface AuthAuthorAuthorTechnologicalTransferTechnologicalTransferRouteChildren {
  AuthAuthorAuthorTechnologicalTransferTechnologicalTransferCreateRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferCreateRoute
  AuthAuthorAuthorTechnologicalTransferTechnologicalTransferSearchClaimableRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferSearchClaimableRoute
  AuthAuthorAuthorTechnologicalTransferTechnologicalTransferIndexRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferIndexRoute
  AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdRouteWithChildren
}

const AuthAuthorAuthorTechnologicalTransferTechnologicalTransferRouteChildren: AuthAuthorAuthorTechnologicalTransferTechnologicalTransferRouteChildren =
  {
    AuthAuthorAuthorTechnologicalTransferTechnologicalTransferCreateRoute:
      AuthAuthorAuthorTechnologicalTransferTechnologicalTransferCreateRoute,
    AuthAuthorAuthorTechnologicalTransferTechnologicalTransferSearchClaimableRoute:
      AuthAuthorAuthorTechnologicalTransferTechnologicalTransferSearchClaimableRoute,
    AuthAuthorAuthorTechnologicalTransferTechnologicalTransferIndexRoute:
      AuthAuthorAuthorTechnologicalTransferTechnologicalTransferIndexRoute,
    AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdRoute:
      AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdRouteWithChildren,
  }

const AuthAuthorAuthorTechnologicalTransferTechnologicalTransferRouteWithChildren =
  AuthAuthorAuthorTechnologicalTransferTechnologicalTransferRoute._addFileChildren(
    AuthAuthorAuthorTechnologicalTransferTechnologicalTransferRouteChildren,
  )

interface AuthAuthorAuthorTechnologicalTransferRouteChildren {
  AuthAuthorAuthorTechnologicalTransferTechnologicalTransferRoute: typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferRouteWithChildren
}

const AuthAuthorAuthorTechnologicalTransferRouteChildren: AuthAuthorAuthorTechnologicalTransferRouteChildren =
  {
    AuthAuthorAuthorTechnologicalTransferTechnologicalTransferRoute:
      AuthAuthorAuthorTechnologicalTransferTechnologicalTransferRouteWithChildren,
  }

const AuthAuthorAuthorTechnologicalTransferRouteWithChildren =
  AuthAuthorAuthorTechnologicalTransferRoute._addFileChildren(
    AuthAuthorAuthorTechnologicalTransferRouteChildren,
  )

interface AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutRouteChildren {
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutEditRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutEditRoute
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutIndexRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutIndexRoute
}

const AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutRouteChildren: AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutRouteChildren =
  {
    AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutEditRoute:
      AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutEditRoute,
    AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutIndexRoute:
      AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutIndexRoute,
  }

const AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutRouteWithChildren =
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdRouteChildren {
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutRouteWithChildren
}

const AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdRouteChildren: AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdRouteChildren =
  {
    AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutRoute:
      AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdRouteWithChildren =
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdRoute._addFileChildren(
    AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdRouteChildren,
  )

interface AuthAuthorAuthorTranslationTranslationTranslationIdLayoutRouteChildren {
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutEditRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutEditRoute
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutIndexRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutIndexRoute
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCreateRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCreateRoute
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsIndexRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsIndexRoute
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdRouteWithChildren
}

const AuthAuthorAuthorTranslationTranslationTranslationIdLayoutRouteChildren: AuthAuthorAuthorTranslationTranslationTranslationIdLayoutRouteChildren =
  {
    AuthAuthorAuthorTranslationTranslationTranslationIdLayoutEditRoute:
      AuthAuthorAuthorTranslationTranslationTranslationIdLayoutEditRoute,
    AuthAuthorAuthorTranslationTranslationTranslationIdLayoutIndexRoute:
      AuthAuthorAuthorTranslationTranslationTranslationIdLayoutIndexRoute,
    AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCreateRoute:
      AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCreateRoute,
    AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsIndexRoute:
      AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsIndexRoute,
    AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdRoute:
      AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdRouteWithChildren,
  }

const AuthAuthorAuthorTranslationTranslationTranslationIdLayoutRouteWithChildren =
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutRoute._addFileChildren(
    AuthAuthorAuthorTranslationTranslationTranslationIdLayoutRouteChildren,
  )

interface AuthAuthorAuthorTranslationTranslationTranslationIdRouteChildren {
  AuthAuthorAuthorTranslationTranslationTranslationIdLayoutRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutRouteWithChildren
}

const AuthAuthorAuthorTranslationTranslationTranslationIdRouteChildren: AuthAuthorAuthorTranslationTranslationTranslationIdRouteChildren =
  {
    AuthAuthorAuthorTranslationTranslationTranslationIdLayoutRoute:
      AuthAuthorAuthorTranslationTranslationTranslationIdLayoutRouteWithChildren,
  }

const AuthAuthorAuthorTranslationTranslationTranslationIdRouteWithChildren =
  AuthAuthorAuthorTranslationTranslationTranslationIdRoute._addFileChildren(
    AuthAuthorAuthorTranslationTranslationTranslationIdRouteChildren,
  )

interface AuthAuthorAuthorTranslationTranslationRouteChildren {
  AuthAuthorAuthorTranslationTranslationCreateRoute: typeof AuthAuthorAuthorTranslationTranslationCreateRoute
  AuthAuthorAuthorTranslationTranslationSearchClaimableRoute: typeof AuthAuthorAuthorTranslationTranslationSearchClaimableRoute
  AuthAuthorAuthorTranslationTranslationIndexRoute: typeof AuthAuthorAuthorTranslationTranslationIndexRoute
  AuthAuthorAuthorTranslationTranslationTranslationIdRoute: typeof AuthAuthorAuthorTranslationTranslationTranslationIdRouteWithChildren
}

const AuthAuthorAuthorTranslationTranslationRouteChildren: AuthAuthorAuthorTranslationTranslationRouteChildren =
  {
    AuthAuthorAuthorTranslationTranslationCreateRoute:
      AuthAuthorAuthorTranslationTranslationCreateRoute,
    AuthAuthorAuthorTranslationTranslationSearchClaimableRoute:
      AuthAuthorAuthorTranslationTranslationSearchClaimableRoute,
    AuthAuthorAuthorTranslationTranslationIndexRoute:
      AuthAuthorAuthorTranslationTranslationIndexRoute,
    AuthAuthorAuthorTranslationTranslationTranslationIdRoute:
      AuthAuthorAuthorTranslationTranslationTranslationIdRouteWithChildren,
  }

const AuthAuthorAuthorTranslationTranslationRouteWithChildren =
  AuthAuthorAuthorTranslationTranslationRoute._addFileChildren(
    AuthAuthorAuthorTranslationTranslationRouteChildren,
  )

interface AuthAuthorAuthorTranslationRouteChildren {
  AuthAuthorAuthorTranslationTranslationRoute: typeof AuthAuthorAuthorTranslationTranslationRouteWithChildren
}

const AuthAuthorAuthorTranslationRouteChildren: AuthAuthorAuthorTranslationRouteChildren =
  {
    AuthAuthorAuthorTranslationTranslationRoute:
      AuthAuthorAuthorTranslationTranslationRouteWithChildren,
  }

const AuthAuthorAuthorTranslationRouteWithChildren =
  AuthAuthorAuthorTranslationRoute._addFileChildren(
    AuthAuthorAuthorTranslationRouteChildren,
  )

interface AuthAuthorAuthorRouteChildren {
  AuthAuthorAuthorWosIsiReportRoute: typeof AuthAuthorAuthorWosIsiReportRoute
  AuthAuthorAuthorIndexRoute: typeof AuthAuthorAuthorIndexRoute
  AuthAuthorAuthorAbstractRoute: typeof AuthAuthorAuthorAbstractRouteWithChildren
  AuthAuthorAuthorArticleRoute: typeof AuthAuthorAuthorArticleRouteWithChildren
  AuthAuthorAuthorAwardRoute: typeof AuthAuthorAuthorAwardRouteWithChildren
  AuthAuthorAuthorBookRoute: typeof AuthAuthorAuthorBookRouteWithChildren
  AuthAuthorAuthorChapterRoute: typeof AuthAuthorAuthorChapterRouteWithChildren
  AuthAuthorAuthorCommitteeRoute: typeof AuthAuthorAuthorCommitteeRouteWithChildren
  AuthAuthorAuthorCourseRoute: typeof AuthAuthorAuthorCourseRouteWithChildren
  AuthAuthorAuthorDictionaryRoute: typeof AuthAuthorAuthorDictionaryRouteWithChildren
  AuthAuthorAuthorDoctoralCommitteeRoute: typeof AuthAuthorAuthorDoctoralCommitteeRouteWithChildren
  AuthAuthorAuthorEditorialTeamRoute: typeof AuthAuthorAuthorEditorialTeamRouteWithChildren
  AuthAuthorAuthorMobilityRoute: typeof AuthAuthorAuthorMobilityRouteWithChildren
  AuthAuthorAuthorPatentRoute: typeof AuthAuthorAuthorPatentRouteWithChildren
  AuthAuthorAuthorPresentationRoute: typeof AuthAuthorAuthorPresentationRouteWithChildren
  AuthAuthorAuthorProceedingRoute: typeof AuthAuthorAuthorProceedingRouteWithChildren
  AuthAuthorAuthorProjectRoute: typeof AuthAuthorAuthorProjectRouteWithChildren
  AuthAuthorAuthorReviewRoute: typeof AuthAuthorAuthorReviewRouteWithChildren
  AuthAuthorAuthorTechnologicalTransferRoute: typeof AuthAuthorAuthorTechnologicalTransferRouteWithChildren
  AuthAuthorAuthorTranslationRoute: typeof AuthAuthorAuthorTranslationRouteWithChildren
}

const AuthAuthorAuthorRouteChildren: AuthAuthorAuthorRouteChildren = {
  AuthAuthorAuthorWosIsiReportRoute: AuthAuthorAuthorWosIsiReportRoute,
  AuthAuthorAuthorIndexRoute: AuthAuthorAuthorIndexRoute,
  AuthAuthorAuthorAbstractRoute: AuthAuthorAuthorAbstractRouteWithChildren,
  AuthAuthorAuthorArticleRoute: AuthAuthorAuthorArticleRouteWithChildren,
  AuthAuthorAuthorAwardRoute: AuthAuthorAuthorAwardRouteWithChildren,
  AuthAuthorAuthorBookRoute: AuthAuthorAuthorBookRouteWithChildren,
  AuthAuthorAuthorChapterRoute: AuthAuthorAuthorChapterRouteWithChildren,
  AuthAuthorAuthorCommitteeRoute: AuthAuthorAuthorCommitteeRouteWithChildren,
  AuthAuthorAuthorCourseRoute: AuthAuthorAuthorCourseRouteWithChildren,
  AuthAuthorAuthorDictionaryRoute: AuthAuthorAuthorDictionaryRouteWithChildren,
  AuthAuthorAuthorDoctoralCommitteeRoute:
    AuthAuthorAuthorDoctoralCommitteeRouteWithChildren,
  AuthAuthorAuthorEditorialTeamRoute:
    AuthAuthorAuthorEditorialTeamRouteWithChildren,
  AuthAuthorAuthorMobilityRoute: AuthAuthorAuthorMobilityRouteWithChildren,
  AuthAuthorAuthorPatentRoute: AuthAuthorAuthorPatentRouteWithChildren,
  AuthAuthorAuthorPresentationRoute:
    AuthAuthorAuthorPresentationRouteWithChildren,
  AuthAuthorAuthorProceedingRoute: AuthAuthorAuthorProceedingRouteWithChildren,
  AuthAuthorAuthorProjectRoute: AuthAuthorAuthorProjectRouteWithChildren,
  AuthAuthorAuthorReviewRoute: AuthAuthorAuthorReviewRouteWithChildren,
  AuthAuthorAuthorTechnologicalTransferRoute:
    AuthAuthorAuthorTechnologicalTransferRouteWithChildren,
  AuthAuthorAuthorTranslationRoute:
    AuthAuthorAuthorTranslationRouteWithChildren,
}

const AuthAuthorAuthorRouteWithChildren =
  AuthAuthorAuthorRoute._addFileChildren(AuthAuthorAuthorRouteChildren)

interface AuthAuthorRouteChildren {
  AuthAuthorAuthorRoute: typeof AuthAuthorAuthorRouteWithChildren
}

const AuthAuthorRouteChildren: AuthAuthorRouteChildren = {
  AuthAuthorAuthorRoute: AuthAuthorAuthorRouteWithChildren,
}

const AuthAuthorRouteWithChildren = AuthAuthorRoute._addFileChildren(
  AuthAuthorRouteChildren,
)

interface AuthConferenceConferenceConferenceIdLayoutRouteChildren {
  AuthConferenceConferenceConferenceIdLayoutEditRoute: typeof AuthConferenceConferenceConferenceIdLayoutEditRoute
  AuthConferenceConferenceConferenceIdLayoutIndexRoute: typeof AuthConferenceConferenceConferenceIdLayoutIndexRoute
}

const AuthConferenceConferenceConferenceIdLayoutRouteChildren: AuthConferenceConferenceConferenceIdLayoutRouteChildren =
  {
    AuthConferenceConferenceConferenceIdLayoutEditRoute:
      AuthConferenceConferenceConferenceIdLayoutEditRoute,
    AuthConferenceConferenceConferenceIdLayoutIndexRoute:
      AuthConferenceConferenceConferenceIdLayoutIndexRoute,
  }

const AuthConferenceConferenceConferenceIdLayoutRouteWithChildren =
  AuthConferenceConferenceConferenceIdLayoutRoute._addFileChildren(
    AuthConferenceConferenceConferenceIdLayoutRouteChildren,
  )

interface AuthConferenceConferenceConferenceIdRouteChildren {
  AuthConferenceConferenceConferenceIdLayoutRoute: typeof AuthConferenceConferenceConferenceIdLayoutRouteWithChildren
}

const AuthConferenceConferenceConferenceIdRouteChildren: AuthConferenceConferenceConferenceIdRouteChildren =
  {
    AuthConferenceConferenceConferenceIdLayoutRoute:
      AuthConferenceConferenceConferenceIdLayoutRouteWithChildren,
  }

const AuthConferenceConferenceConferenceIdRouteWithChildren =
  AuthConferenceConferenceConferenceIdRoute._addFileChildren(
    AuthConferenceConferenceConferenceIdRouteChildren,
  )

interface AuthConferenceConferenceRouteChildren {
  AuthConferenceConferenceCreateRoute: typeof AuthConferenceConferenceCreateRoute
  AuthConferenceConferenceIndexRoute: typeof AuthConferenceConferenceIndexRoute
  AuthConferenceConferenceConferenceIdRoute: typeof AuthConferenceConferenceConferenceIdRouteWithChildren
}

const AuthConferenceConferenceRouteChildren: AuthConferenceConferenceRouteChildren =
  {
    AuthConferenceConferenceCreateRoute: AuthConferenceConferenceCreateRoute,
    AuthConferenceConferenceIndexRoute: AuthConferenceConferenceIndexRoute,
    AuthConferenceConferenceConferenceIdRoute:
      AuthConferenceConferenceConferenceIdRouteWithChildren,
  }

const AuthConferenceConferenceRouteWithChildren =
  AuthConferenceConferenceRoute._addFileChildren(
    AuthConferenceConferenceRouteChildren,
  )

interface AuthConferenceRouteChildren {
  AuthConferenceConferenceRoute: typeof AuthConferenceConferenceRouteWithChildren
}

const AuthConferenceRouteChildren: AuthConferenceRouteChildren = {
  AuthConferenceConferenceRoute: AuthConferenceConferenceRouteWithChildren,
}

const AuthConferenceRouteWithChildren = AuthConferenceRoute._addFileChildren(
  AuthConferenceRouteChildren,
)

interface AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRouteChildren {
  AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexRoute
}

const AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRouteChildren: AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRouteChildren =
  {
    AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexRoute:
      AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexRoute,
  }

const AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRouteWithChildren =
  AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRoute._addFileChildren(
    AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRouteChildren,
  )

interface AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoRouteChildren {
  AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRouteWithChildren
}

const AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoRouteChildren: AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoRouteChildren =
  {
    AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRoute:
      AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRouteWithChildren,
  }

const AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoRouteWithChildren =
  AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoRoute._addFileChildren(
    AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoRouteChildren,
  )

interface AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherRouteChildren {
  AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherIndexRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherIndexRoute
  AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoRouteWithChildren
}

const AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherRouteChildren: AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherRouteChildren =
  {
    AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherIndexRoute:
      AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherIndexRoute,
    AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoRoute:
      AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoRouteWithChildren,
  }

const AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherRouteWithChildren =
  AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherRoute._addFileChildren(
    AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherRouteChildren,
  )

interface AuthEvaluationLayoutEvaluationIdLayoutReportGatherRouteChildren {
  AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherRouteWithChildren
}

const AuthEvaluationLayoutEvaluationIdLayoutReportGatherRouteChildren: AuthEvaluationLayoutEvaluationIdLayoutReportGatherRouteChildren =
  {
    AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherRoute:
      AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherRouteWithChildren,
  }

const AuthEvaluationLayoutEvaluationIdLayoutReportGatherRouteWithChildren =
  AuthEvaluationLayoutEvaluationIdLayoutReportGatherRoute._addFileChildren(
    AuthEvaluationLayoutEvaluationIdLayoutReportGatherRouteChildren,
  )

interface AuthEvaluationLayoutEvaluationIdLayoutRouteChildren {
  AuthEvaluationLayoutEvaluationIdLayoutIndexRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutIndexRoute
  AuthEvaluationLayoutEvaluationIdLayoutReportGatherRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherRouteWithChildren
}

const AuthEvaluationLayoutEvaluationIdLayoutRouteChildren: AuthEvaluationLayoutEvaluationIdLayoutRouteChildren =
  {
    AuthEvaluationLayoutEvaluationIdLayoutIndexRoute:
      AuthEvaluationLayoutEvaluationIdLayoutIndexRoute,
    AuthEvaluationLayoutEvaluationIdLayoutReportGatherRoute:
      AuthEvaluationLayoutEvaluationIdLayoutReportGatherRouteWithChildren,
  }

const AuthEvaluationLayoutEvaluationIdLayoutRouteWithChildren =
  AuthEvaluationLayoutEvaluationIdLayoutRoute._addFileChildren(
    AuthEvaluationLayoutEvaluationIdLayoutRouteChildren,
  )

interface AuthEvaluationLayoutEvaluationIdRouteChildren {
  AuthEvaluationLayoutEvaluationIdLayoutRoute: typeof AuthEvaluationLayoutEvaluationIdLayoutRouteWithChildren
  AuthEvaluationLayoutEvaluationIdDepartmentSummaryResultsRoute: typeof AuthEvaluationLayoutEvaluationIdDepartmentSummaryResultsRoute
  AuthEvaluationLayoutEvaluationIdFacultySummaryResultsRoute: typeof AuthEvaluationLayoutEvaluationIdFacultySummaryResultsRoute
}

const AuthEvaluationLayoutEvaluationIdRouteChildren: AuthEvaluationLayoutEvaluationIdRouteChildren =
  {
    AuthEvaluationLayoutEvaluationIdLayoutRoute:
      AuthEvaluationLayoutEvaluationIdLayoutRouteWithChildren,
    AuthEvaluationLayoutEvaluationIdDepartmentSummaryResultsRoute:
      AuthEvaluationLayoutEvaluationIdDepartmentSummaryResultsRoute,
    AuthEvaluationLayoutEvaluationIdFacultySummaryResultsRoute:
      AuthEvaluationLayoutEvaluationIdFacultySummaryResultsRoute,
  }

const AuthEvaluationLayoutEvaluationIdRouteWithChildren =
  AuthEvaluationLayoutEvaluationIdRoute._addFileChildren(
    AuthEvaluationLayoutEvaluationIdRouteChildren,
  )

interface AuthEvaluationLayoutRouteChildren {
  AuthEvaluationLayoutIndexRoute: typeof AuthEvaluationLayoutIndexRoute
  AuthEvaluationLayoutEvaluationIdRoute: typeof AuthEvaluationLayoutEvaluationIdRouteWithChildren
}

const AuthEvaluationLayoutRouteChildren: AuthEvaluationLayoutRouteChildren = {
  AuthEvaluationLayoutIndexRoute: AuthEvaluationLayoutIndexRoute,
  AuthEvaluationLayoutEvaluationIdRoute:
    AuthEvaluationLayoutEvaluationIdRouteWithChildren,
}

const AuthEvaluationLayoutRouteWithChildren =
  AuthEvaluationLayoutRoute._addFileChildren(AuthEvaluationLayoutRouteChildren)

interface AuthEvaluationRouteChildren {
  AuthEvaluationLayoutRoute: typeof AuthEvaluationLayoutRouteWithChildren
}

const AuthEvaluationRouteChildren: AuthEvaluationRouteChildren = {
  AuthEvaluationLayoutRoute: AuthEvaluationLayoutRouteWithChildren,
}

const AuthEvaluationRouteWithChildren = AuthEvaluationRoute._addFileChildren(
  AuthEvaluationRouteChildren,
)

interface AuthGovEvaluationLayoutEvaluationIdLayoutRouteChildren {
  AuthGovEvaluationLayoutEvaluationIdLayoutIndexRoute: typeof AuthGovEvaluationLayoutEvaluationIdLayoutIndexRoute
}

const AuthGovEvaluationLayoutEvaluationIdLayoutRouteChildren: AuthGovEvaluationLayoutEvaluationIdLayoutRouteChildren =
  {
    AuthGovEvaluationLayoutEvaluationIdLayoutIndexRoute:
      AuthGovEvaluationLayoutEvaluationIdLayoutIndexRoute,
  }

const AuthGovEvaluationLayoutEvaluationIdLayoutRouteWithChildren =
  AuthGovEvaluationLayoutEvaluationIdLayoutRoute._addFileChildren(
    AuthGovEvaluationLayoutEvaluationIdLayoutRouteChildren,
  )

interface AuthGovEvaluationLayoutEvaluationIdRouteChildren {
  AuthGovEvaluationLayoutEvaluationIdLayoutRoute: typeof AuthGovEvaluationLayoutEvaluationIdLayoutRouteWithChildren
}

const AuthGovEvaluationLayoutEvaluationIdRouteChildren: AuthGovEvaluationLayoutEvaluationIdRouteChildren =
  {
    AuthGovEvaluationLayoutEvaluationIdLayoutRoute:
      AuthGovEvaluationLayoutEvaluationIdLayoutRouteWithChildren,
  }

const AuthGovEvaluationLayoutEvaluationIdRouteWithChildren =
  AuthGovEvaluationLayoutEvaluationIdRoute._addFileChildren(
    AuthGovEvaluationLayoutEvaluationIdRouteChildren,
  )

interface AuthGovEvaluationLayoutRouteChildren {
  AuthGovEvaluationLayoutIndexRoute: typeof AuthGovEvaluationLayoutIndexRoute
  AuthGovEvaluationLayoutEvaluationIdRoute: typeof AuthGovEvaluationLayoutEvaluationIdRouteWithChildren
}

const AuthGovEvaluationLayoutRouteChildren: AuthGovEvaluationLayoutRouteChildren =
  {
    AuthGovEvaluationLayoutIndexRoute: AuthGovEvaluationLayoutIndexRoute,
    AuthGovEvaluationLayoutEvaluationIdRoute:
      AuthGovEvaluationLayoutEvaluationIdRouteWithChildren,
  }

const AuthGovEvaluationLayoutRouteWithChildren =
  AuthGovEvaluationLayoutRoute._addFileChildren(
    AuthGovEvaluationLayoutRouteChildren,
  )

interface AuthGovEvaluationRouteChildren {
  AuthGovEvaluationLayoutRoute: typeof AuthGovEvaluationLayoutRouteWithChildren
}

const AuthGovEvaluationRouteChildren: AuthGovEvaluationRouteChildren = {
  AuthGovEvaluationLayoutRoute: AuthGovEvaluationLayoutRouteWithChildren,
}

const AuthGovEvaluationRouteWithChildren =
  AuthGovEvaluationRoute._addFileChildren(AuthGovEvaluationRouteChildren)

interface AuthJournalJournalJournalIdLayoutRouteChildren {
  AuthJournalJournalJournalIdLayoutArticleInfluenceScoreRoute: typeof AuthJournalJournalJournalIdLayoutArticleInfluenceScoreRoute
  AuthJournalJournalJournalIdLayoutEditRoute: typeof AuthJournalJournalJournalIdLayoutEditRoute
  AuthJournalJournalJournalIdLayoutImpactFactorRoute: typeof AuthJournalJournalJournalIdLayoutImpactFactorRoute
  AuthJournalJournalJournalIdLayoutIndexRoute: typeof AuthJournalJournalJournalIdLayoutIndexRoute
}

const AuthJournalJournalJournalIdLayoutRouteChildren: AuthJournalJournalJournalIdLayoutRouteChildren =
  {
    AuthJournalJournalJournalIdLayoutArticleInfluenceScoreRoute:
      AuthJournalJournalJournalIdLayoutArticleInfluenceScoreRoute,
    AuthJournalJournalJournalIdLayoutEditRoute:
      AuthJournalJournalJournalIdLayoutEditRoute,
    AuthJournalJournalJournalIdLayoutImpactFactorRoute:
      AuthJournalJournalJournalIdLayoutImpactFactorRoute,
    AuthJournalJournalJournalIdLayoutIndexRoute:
      AuthJournalJournalJournalIdLayoutIndexRoute,
  }

const AuthJournalJournalJournalIdLayoutRouteWithChildren =
  AuthJournalJournalJournalIdLayoutRoute._addFileChildren(
    AuthJournalJournalJournalIdLayoutRouteChildren,
  )

interface AuthJournalJournalJournalIdRouteChildren {
  AuthJournalJournalJournalIdLayoutRoute: typeof AuthJournalJournalJournalIdLayoutRouteWithChildren
}

const AuthJournalJournalJournalIdRouteChildren: AuthJournalJournalJournalIdRouteChildren =
  {
    AuthJournalJournalJournalIdLayoutRoute:
      AuthJournalJournalJournalIdLayoutRouteWithChildren,
  }

const AuthJournalJournalJournalIdRouteWithChildren =
  AuthJournalJournalJournalIdRoute._addFileChildren(
    AuthJournalJournalJournalIdRouteChildren,
  )

interface AuthJournalJournalRouteChildren {
  AuthJournalJournalCreateRoute: typeof AuthJournalJournalCreateRoute
  AuthJournalJournalIndexRoute: typeof AuthJournalJournalIndexRoute
  AuthJournalJournalJournalIdRoute: typeof AuthJournalJournalJournalIdRouteWithChildren
}

const AuthJournalJournalRouteChildren: AuthJournalJournalRouteChildren = {
  AuthJournalJournalCreateRoute: AuthJournalJournalCreateRoute,
  AuthJournalJournalIndexRoute: AuthJournalJournalIndexRoute,
  AuthJournalJournalJournalIdRoute:
    AuthJournalJournalJournalIdRouteWithChildren,
}

const AuthJournalJournalRouteWithChildren =
  AuthJournalJournalRoute._addFileChildren(AuthJournalJournalRouteChildren)

interface AuthJournalRouteChildren {
  AuthJournalJournalRoute: typeof AuthJournalJournalRouteWithChildren
}

const AuthJournalRouteChildren: AuthJournalRouteChildren = {
  AuthJournalJournalRoute: AuthJournalJournalRouteWithChildren,
}

const AuthJournalRouteWithChildren = AuthJournalRoute._addFileChildren(
  AuthJournalRouteChildren,
)

interface AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutRouteChildren {
  AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutIndexRoute: typeof AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutIndexRoute
}

const AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutRouteChildren: AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutRouteChildren =
  {
    AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutIndexRoute:
      AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutIndexRoute,
  }

const AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutRouteWithChildren =
  AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutRoute._addFileChildren(
    AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutRouteChildren,
  )

interface AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeRouteChildren {
  AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutRoute: typeof AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutRouteWithChildren
}

const AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeRouteChildren: AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeRouteChildren =
  {
    AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutRoute:
      AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutRouteWithChildren,
  }

const AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeRouteWithChildren =
  AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeRoute._addFileChildren(
    AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeRouteChildren,
  )

interface AuthMinimalStandardsLayoutReportGatherGatherRouteChildren {
  AuthMinimalStandardsLayoutReportGatherGatherIndexRoute: typeof AuthMinimalStandardsLayoutReportGatherGatherIndexRoute
  AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeRoute: typeof AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeRouteWithChildren
}

const AuthMinimalStandardsLayoutReportGatherGatherRouteChildren: AuthMinimalStandardsLayoutReportGatherGatherRouteChildren =
  {
    AuthMinimalStandardsLayoutReportGatherGatherIndexRoute:
      AuthMinimalStandardsLayoutReportGatherGatherIndexRoute,
    AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeRoute:
      AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeRouteWithChildren,
  }

const AuthMinimalStandardsLayoutReportGatherGatherRouteWithChildren =
  AuthMinimalStandardsLayoutReportGatherGatherRoute._addFileChildren(
    AuthMinimalStandardsLayoutReportGatherGatherRouteChildren,
  )

interface AuthMinimalStandardsLayoutReportGatherRouteChildren {
  AuthMinimalStandardsLayoutReportGatherGatherRoute: typeof AuthMinimalStandardsLayoutReportGatherGatherRouteWithChildren
}

const AuthMinimalStandardsLayoutReportGatherRouteChildren: AuthMinimalStandardsLayoutReportGatherRouteChildren =
  {
    AuthMinimalStandardsLayoutReportGatherGatherRoute:
      AuthMinimalStandardsLayoutReportGatherGatherRouteWithChildren,
  }

const AuthMinimalStandardsLayoutReportGatherRouteWithChildren =
  AuthMinimalStandardsLayoutReportGatherRoute._addFileChildren(
    AuthMinimalStandardsLayoutReportGatherRouteChildren,
  )

interface AuthMinimalStandardsLayoutRouteChildren {
  AuthMinimalStandardsLayoutIndexRoute: typeof AuthMinimalStandardsLayoutIndexRoute
  AuthMinimalStandardsLayoutReportGatherRoute: typeof AuthMinimalStandardsLayoutReportGatherRouteWithChildren
}

const AuthMinimalStandardsLayoutRouteChildren: AuthMinimalStandardsLayoutRouteChildren =
  {
    AuthMinimalStandardsLayoutIndexRoute: AuthMinimalStandardsLayoutIndexRoute,
    AuthMinimalStandardsLayoutReportGatherRoute:
      AuthMinimalStandardsLayoutReportGatherRouteWithChildren,
  }

const AuthMinimalStandardsLayoutRouteWithChildren =
  AuthMinimalStandardsLayoutRoute._addFileChildren(
    AuthMinimalStandardsLayoutRouteChildren,
  )

interface AuthMinimalStandardsRouteChildren {
  AuthMinimalStandardsLayoutRoute: typeof AuthMinimalStandardsLayoutRouteWithChildren
}

const AuthMinimalStandardsRouteChildren: AuthMinimalStandardsRouteChildren = {
  AuthMinimalStandardsLayoutRoute: AuthMinimalStandardsLayoutRouteWithChildren,
}

const AuthMinimalStandardsRouteWithChildren =
  AuthMinimalStandardsRoute._addFileChildren(AuthMinimalStandardsRouteChildren)

interface AuthPublisherPublisherPublisherIdLayoutRouteChildren {
  AuthPublisherPublisherPublisherIdLayoutEditRoute: typeof AuthPublisherPublisherPublisherIdLayoutEditRoute
  AuthPublisherPublisherPublisherIdLayoutIndexRoute: typeof AuthPublisherPublisherPublisherIdLayoutIndexRoute
}

const AuthPublisherPublisherPublisherIdLayoutRouteChildren: AuthPublisherPublisherPublisherIdLayoutRouteChildren =
  {
    AuthPublisherPublisherPublisherIdLayoutEditRoute:
      AuthPublisherPublisherPublisherIdLayoutEditRoute,
    AuthPublisherPublisherPublisherIdLayoutIndexRoute:
      AuthPublisherPublisherPublisherIdLayoutIndexRoute,
  }

const AuthPublisherPublisherPublisherIdLayoutRouteWithChildren =
  AuthPublisherPublisherPublisherIdLayoutRoute._addFileChildren(
    AuthPublisherPublisherPublisherIdLayoutRouteChildren,
  )

interface AuthPublisherPublisherPublisherIdRouteChildren {
  AuthPublisherPublisherPublisherIdLayoutRoute: typeof AuthPublisherPublisherPublisherIdLayoutRouteWithChildren
}

const AuthPublisherPublisherPublisherIdRouteChildren: AuthPublisherPublisherPublisherIdRouteChildren =
  {
    AuthPublisherPublisherPublisherIdLayoutRoute:
      AuthPublisherPublisherPublisherIdLayoutRouteWithChildren,
  }

const AuthPublisherPublisherPublisherIdRouteWithChildren =
  AuthPublisherPublisherPublisherIdRoute._addFileChildren(
    AuthPublisherPublisherPublisherIdRouteChildren,
  )

interface AuthPublisherPublisherRouteChildren {
  AuthPublisherPublisherCreateRoute: typeof AuthPublisherPublisherCreateRoute
  AuthPublisherPublisherIndexRoute: typeof AuthPublisherPublisherIndexRoute
  AuthPublisherPublisherPublisherIdRoute: typeof AuthPublisherPublisherPublisherIdRouteWithChildren
}

const AuthPublisherPublisherRouteChildren: AuthPublisherPublisherRouteChildren =
  {
    AuthPublisherPublisherCreateRoute: AuthPublisherPublisherCreateRoute,
    AuthPublisherPublisherIndexRoute: AuthPublisherPublisherIndexRoute,
    AuthPublisherPublisherPublisherIdRoute:
      AuthPublisherPublisherPublisherIdRouteWithChildren,
  }

const AuthPublisherPublisherRouteWithChildren =
  AuthPublisherPublisherRoute._addFileChildren(
    AuthPublisherPublisherRouteChildren,
  )

interface AuthPublisherRouteChildren {
  AuthPublisherPublisherRoute: typeof AuthPublisherPublisherRouteWithChildren
}

const AuthPublisherRouteChildren: AuthPublisherRouteChildren = {
  AuthPublisherPublisherRoute: AuthPublisherPublisherRouteWithChildren,
}

const AuthPublisherRouteWithChildren = AuthPublisherRoute._addFileChildren(
  AuthPublisherRouteChildren,
)

interface AuthReportReportRouteChildren {
  AuthReportReportAnalyticsRoute: typeof AuthReportReportAnalyticsRoute
  AuthReportReportIndexRoute: typeof AuthReportReportIndexRoute
}

const AuthReportReportRouteChildren: AuthReportReportRouteChildren = {
  AuthReportReportAnalyticsRoute: AuthReportReportAnalyticsRoute,
  AuthReportReportIndexRoute: AuthReportReportIndexRoute,
}

const AuthReportReportRouteWithChildren =
  AuthReportReportRoute._addFileChildren(AuthReportReportRouteChildren)

interface AuthReportRouteChildren {
  AuthReportReportRoute: typeof AuthReportReportRouteWithChildren
}

const AuthReportRouteChildren: AuthReportRouteChildren = {
  AuthReportReportRoute: AuthReportReportRouteWithChildren,
}

const AuthReportRouteWithChildren = AuthReportRoute._addFileChildren(
  AuthReportRouteChildren,
)

interface AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutRouteChildren {
  AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutEditRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutEditRoute
  AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutIndexRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutIndexRoute
}

const AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutRouteChildren: AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutRouteChildren =
  {
    AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutEditRoute:
      AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutEditRoute,
    AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutIndexRoute:
      AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutIndexRoute,
  }

const AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutRouteWithChildren =
  AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutRoute._addFileChildren(
    AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutRouteChildren,
  )

interface AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdRouteChildren {
  AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutRouteWithChildren
}

const AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdRouteChildren: AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdRouteChildren =
  {
    AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutRoute:
      AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutRouteWithChildren,
  }

const AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdRouteWithChildren =
  AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdRoute._addFileChildren(
    AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdRouteChildren,
  )

interface AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutRouteChildren {
  AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutIndexRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutIndexRoute
  AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdRouteWithChildren
}

const AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutRouteChildren: AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutRouteChildren =
  {
    AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutIndexRoute:
      AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutIndexRoute,
    AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdRoute:
      AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdRouteWithChildren,
  }

const AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutRouteWithChildren =
  AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutRoute._addFileChildren(
    AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutRouteChildren,
  )

interface AuthResearchCenterResearchCenterResearchCenterIdLayoutLabRouteChildren {
  AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutRouteWithChildren
}

const AuthResearchCenterResearchCenterResearchCenterIdLayoutLabRouteChildren: AuthResearchCenterResearchCenterResearchCenterIdLayoutLabRouteChildren =
  {
    AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutRoute:
      AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutRouteWithChildren,
  }

const AuthResearchCenterResearchCenterResearchCenterIdLayoutLabRouteWithChildren =
  AuthResearchCenterResearchCenterResearchCenterIdLayoutLabRoute._addFileChildren(
    AuthResearchCenterResearchCenterResearchCenterIdLayoutLabRouteChildren,
  )

interface AuthResearchCenterResearchCenterResearchCenterIdLayoutRouteChildren {
  AuthResearchCenterResearchCenterResearchCenterIdLayoutCreateRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutCreateRoute
  AuthResearchCenterResearchCenterResearchCenterIdLayoutEditRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutEditRoute
  AuthResearchCenterResearchCenterResearchCenterIdLayoutIndexRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutIndexRoute
  AuthResearchCenterResearchCenterResearchCenterIdLayoutLabRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabRouteWithChildren
}

const AuthResearchCenterResearchCenterResearchCenterIdLayoutRouteChildren: AuthResearchCenterResearchCenterResearchCenterIdLayoutRouteChildren =
  {
    AuthResearchCenterResearchCenterResearchCenterIdLayoutCreateRoute:
      AuthResearchCenterResearchCenterResearchCenterIdLayoutCreateRoute,
    AuthResearchCenterResearchCenterResearchCenterIdLayoutEditRoute:
      AuthResearchCenterResearchCenterResearchCenterIdLayoutEditRoute,
    AuthResearchCenterResearchCenterResearchCenterIdLayoutIndexRoute:
      AuthResearchCenterResearchCenterResearchCenterIdLayoutIndexRoute,
    AuthResearchCenterResearchCenterResearchCenterIdLayoutLabRoute:
      AuthResearchCenterResearchCenterResearchCenterIdLayoutLabRouteWithChildren,
  }

const AuthResearchCenterResearchCenterResearchCenterIdLayoutRouteWithChildren =
  AuthResearchCenterResearchCenterResearchCenterIdLayoutRoute._addFileChildren(
    AuthResearchCenterResearchCenterResearchCenterIdLayoutRouteChildren,
  )

interface AuthResearchCenterResearchCenterResearchCenterIdRouteChildren {
  AuthResearchCenterResearchCenterResearchCenterIdLayoutRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutRouteWithChildren
}

const AuthResearchCenterResearchCenterResearchCenterIdRouteChildren: AuthResearchCenterResearchCenterResearchCenterIdRouteChildren =
  {
    AuthResearchCenterResearchCenterResearchCenterIdLayoutRoute:
      AuthResearchCenterResearchCenterResearchCenterIdLayoutRouteWithChildren,
  }

const AuthResearchCenterResearchCenterResearchCenterIdRouteWithChildren =
  AuthResearchCenterResearchCenterResearchCenterIdRoute._addFileChildren(
    AuthResearchCenterResearchCenterResearchCenterIdRouteChildren,
  )

interface AuthResearchCenterResearchCenterRouteChildren {
  AuthResearchCenterResearchCenterCreateRoute: typeof AuthResearchCenterResearchCenterCreateRoute
  AuthResearchCenterResearchCenterIndexRoute: typeof AuthResearchCenterResearchCenterIndexRoute
  AuthResearchCenterResearchCenterResearchCenterIdRoute: typeof AuthResearchCenterResearchCenterResearchCenterIdRouteWithChildren
}

const AuthResearchCenterResearchCenterRouteChildren: AuthResearchCenterResearchCenterRouteChildren =
  {
    AuthResearchCenterResearchCenterCreateRoute:
      AuthResearchCenterResearchCenterCreateRoute,
    AuthResearchCenterResearchCenterIndexRoute:
      AuthResearchCenterResearchCenterIndexRoute,
    AuthResearchCenterResearchCenterResearchCenterIdRoute:
      AuthResearchCenterResearchCenterResearchCenterIdRouteWithChildren,
  }

const AuthResearchCenterResearchCenterRouteWithChildren =
  AuthResearchCenterResearchCenterRoute._addFileChildren(
    AuthResearchCenterResearchCenterRouteChildren,
  )

interface AuthResearchCenterRouteChildren {
  AuthResearchCenterResearchCenterRoute: typeof AuthResearchCenterResearchCenterRouteWithChildren
}

const AuthResearchCenterRouteChildren: AuthResearchCenterRouteChildren = {
  AuthResearchCenterResearchCenterRoute:
    AuthResearchCenterResearchCenterRouteWithChildren,
}

const AuthResearchCenterRouteWithChildren =
  AuthResearchCenterRoute._addFileChildren(AuthResearchCenterRouteChildren)

interface AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRouteChildren {
  AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexRoute
}

const AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRouteChildren: AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRouteChildren =
  {
    AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexRoute:
      AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexRoute,
  }

const AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRouteWithChildren =
  AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRoute._addFileChildren(
    AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRouteChildren,
  )

interface AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoRouteChildren {
  AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRouteWithChildren
}

const AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoRouteChildren: AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoRouteChildren =
  {
    AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRoute:
      AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRouteWithChildren,
  }

const AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoRouteWithChildren =
  AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoRoute._addFileChildren(
    AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoRouteChildren,
  )

interface AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherRouteChildren {
  AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherIndexRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherIndexRoute
  AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoRouteWithChildren
}

const AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherRouteChildren: AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherRouteChildren =
  {
    AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherIndexRoute:
      AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherIndexRoute,
    AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoRoute:
      AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoRouteWithChildren,
  }

const AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherRouteWithChildren =
  AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherRoute._addFileChildren(
    AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherRouteChildren,
  )

interface AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherRouteChildren {
  AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherRouteWithChildren
}

const AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherRouteChildren: AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherRouteChildren =
  {
    AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherRoute:
      AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherRouteWithChildren,
  }

const AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherRouteWithChildren =
  AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherRoute._addFileChildren(
    AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherRouteChildren,
  )

interface AuthResearchPerfEvalLayoutEvaluationIdLayoutRouteChildren {
  AuthResearchPerfEvalLayoutEvaluationIdLayoutIndexRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutIndexRoute
  AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherRouteWithChildren
}

const AuthResearchPerfEvalLayoutEvaluationIdLayoutRouteChildren: AuthResearchPerfEvalLayoutEvaluationIdLayoutRouteChildren =
  {
    AuthResearchPerfEvalLayoutEvaluationIdLayoutIndexRoute:
      AuthResearchPerfEvalLayoutEvaluationIdLayoutIndexRoute,
    AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherRoute:
      AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherRouteWithChildren,
  }

const AuthResearchPerfEvalLayoutEvaluationIdLayoutRouteWithChildren =
  AuthResearchPerfEvalLayoutEvaluationIdLayoutRoute._addFileChildren(
    AuthResearchPerfEvalLayoutEvaluationIdLayoutRouteChildren,
  )

interface AuthResearchPerfEvalLayoutEvaluationIdRouteChildren {
  AuthResearchPerfEvalLayoutEvaluationIdLayoutRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutRouteWithChildren
}

const AuthResearchPerfEvalLayoutEvaluationIdRouteChildren: AuthResearchPerfEvalLayoutEvaluationIdRouteChildren =
  {
    AuthResearchPerfEvalLayoutEvaluationIdLayoutRoute:
      AuthResearchPerfEvalLayoutEvaluationIdLayoutRouteWithChildren,
  }

const AuthResearchPerfEvalLayoutEvaluationIdRouteWithChildren =
  AuthResearchPerfEvalLayoutEvaluationIdRoute._addFileChildren(
    AuthResearchPerfEvalLayoutEvaluationIdRouteChildren,
  )

interface AuthResearchPerfEvalLayoutRouteChildren {
  AuthResearchPerfEvalLayoutIndexRoute: typeof AuthResearchPerfEvalLayoutIndexRoute
  AuthResearchPerfEvalLayoutEvaluationIdRoute: typeof AuthResearchPerfEvalLayoutEvaluationIdRouteWithChildren
}

const AuthResearchPerfEvalLayoutRouteChildren: AuthResearchPerfEvalLayoutRouteChildren =
  {
    AuthResearchPerfEvalLayoutIndexRoute: AuthResearchPerfEvalLayoutIndexRoute,
    AuthResearchPerfEvalLayoutEvaluationIdRoute:
      AuthResearchPerfEvalLayoutEvaluationIdRouteWithChildren,
  }

const AuthResearchPerfEvalLayoutRouteWithChildren =
  AuthResearchPerfEvalLayoutRoute._addFileChildren(
    AuthResearchPerfEvalLayoutRouteChildren,
  )

interface AuthResearchPerfEvalRouteChildren {
  AuthResearchPerfEvalLayoutRoute: typeof AuthResearchPerfEvalLayoutRouteWithChildren
}

const AuthResearchPerfEvalRouteChildren: AuthResearchPerfEvalRouteChildren = {
  AuthResearchPerfEvalLayoutRoute: AuthResearchPerfEvalLayoutRouteWithChildren,
}

const AuthResearchPerfEvalRouteWithChildren =
  AuthResearchPerfEvalRoute._addFileChildren(AuthResearchPerfEvalRouteChildren)

interface AuthTravelTravelRequestsRequestIdLayoutRouteChildren {
  AuthTravelTravelRequestsRequestIdLayoutEditRoute: typeof AuthTravelTravelRequestsRequestIdLayoutEditRoute
  AuthTravelTravelRequestsRequestIdLayoutIndexRoute: typeof AuthTravelTravelRequestsRequestIdLayoutIndexRoute
}

const AuthTravelTravelRequestsRequestIdLayoutRouteChildren: AuthTravelTravelRequestsRequestIdLayoutRouteChildren =
  {
    AuthTravelTravelRequestsRequestIdLayoutEditRoute:
      AuthTravelTravelRequestsRequestIdLayoutEditRoute,
    AuthTravelTravelRequestsRequestIdLayoutIndexRoute:
      AuthTravelTravelRequestsRequestIdLayoutIndexRoute,
  }

const AuthTravelTravelRequestsRequestIdLayoutRouteWithChildren =
  AuthTravelTravelRequestsRequestIdLayoutRoute._addFileChildren(
    AuthTravelTravelRequestsRequestIdLayoutRouteChildren,
  )

interface AuthTravelTravelRequestsRequestIdRouteChildren {
  AuthTravelTravelRequestsRequestIdLayoutRoute: typeof AuthTravelTravelRequestsRequestIdLayoutRouteWithChildren
}

const AuthTravelTravelRequestsRequestIdRouteChildren: AuthTravelTravelRequestsRequestIdRouteChildren =
  {
    AuthTravelTravelRequestsRequestIdLayoutRoute:
      AuthTravelTravelRequestsRequestIdLayoutRouteWithChildren,
  }

const AuthTravelTravelRequestsRequestIdRouteWithChildren =
  AuthTravelTravelRequestsRequestIdRoute._addFileChildren(
    AuthTravelTravelRequestsRequestIdRouteChildren,
  )

interface AuthTravelTravelRouteChildren {
  AuthTravelTravelIndexRoute: typeof AuthTravelTravelIndexRoute
  AuthTravelTravelRequestsCreateRoute: typeof AuthTravelTravelRequestsCreateRoute
  AuthTravelTravelAnalyticsIndexRoute: typeof AuthTravelTravelAnalyticsIndexRoute
  AuthTravelTravelApprovalsIndexRoute: typeof AuthTravelTravelApprovalsIndexRoute
  AuthTravelTravelBoardRequestsIndexRoute: typeof AuthTravelTravelBoardRequestsIndexRoute
  AuthTravelTravelDaysIndexRoute: typeof AuthTravelTravelDaysIndexRoute
  AuthTravelTravelDocumentsIndexRoute: typeof AuthTravelTravelDocumentsIndexRoute
  AuthTravelTravelRegistryIndexRoute: typeof AuthTravelTravelRegistryIndexRoute
  AuthTravelTravelRequestsIndexRoute: typeof AuthTravelTravelRequestsIndexRoute
  AuthTravelTravelSettingsIndexRoute: typeof AuthTravelTravelSettingsIndexRoute
  AuthTravelTravelRequestsRequestIdRoute: typeof AuthTravelTravelRequestsRequestIdRouteWithChildren
}

const AuthTravelTravelRouteChildren: AuthTravelTravelRouteChildren = {
  AuthTravelTravelIndexRoute: AuthTravelTravelIndexRoute,
  AuthTravelTravelRequestsCreateRoute: AuthTravelTravelRequestsCreateRoute,
  AuthTravelTravelAnalyticsIndexRoute: AuthTravelTravelAnalyticsIndexRoute,
  AuthTravelTravelApprovalsIndexRoute: AuthTravelTravelApprovalsIndexRoute,
  AuthTravelTravelBoardRequestsIndexRoute:
    AuthTravelTravelBoardRequestsIndexRoute,
  AuthTravelTravelDaysIndexRoute: AuthTravelTravelDaysIndexRoute,
  AuthTravelTravelDocumentsIndexRoute: AuthTravelTravelDocumentsIndexRoute,
  AuthTravelTravelRegistryIndexRoute: AuthTravelTravelRegistryIndexRoute,
  AuthTravelTravelRequestsIndexRoute: AuthTravelTravelRequestsIndexRoute,
  AuthTravelTravelSettingsIndexRoute: AuthTravelTravelSettingsIndexRoute,
  AuthTravelTravelRequestsRequestIdRoute:
    AuthTravelTravelRequestsRequestIdRouteWithChildren,
}

const AuthTravelTravelRouteWithChildren =
  AuthTravelTravelRoute._addFileChildren(AuthTravelTravelRouteChildren)

interface AuthTravelRouteChildren {
  AuthTravelTravelRoute: typeof AuthTravelTravelRouteWithChildren
}

const AuthTravelRouteChildren: AuthTravelRouteChildren = {
  AuthTravelTravelRoute: AuthTravelTravelRouteWithChildren,
}

const AuthTravelRouteWithChildren = AuthTravelRoute._addFileChildren(
  AuthTravelRouteChildren,
)

interface AuthRouteChildren {
  AuthSyncBibtexRoute: typeof AuthSyncBibtexRoute
  AuthSyncScopusRoute: typeof AuthSyncScopusRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthAdministrationRoute: typeof AuthAdministrationRouteWithChildren
  AuthAuthorRoute: typeof AuthAuthorRouteWithChildren
  AuthConferenceRoute: typeof AuthConferenceRouteWithChildren
  AuthEvaluationRoute: typeof AuthEvaluationRouteWithChildren
  AuthGovEvaluationRoute: typeof AuthGovEvaluationRouteWithChildren
  AuthJournalRoute: typeof AuthJournalRouteWithChildren
  AuthMinimalStandardsRoute: typeof AuthMinimalStandardsRouteWithChildren
  AuthPublisherRoute: typeof AuthPublisherRouteWithChildren
  AuthReportRoute: typeof AuthReportRouteWithChildren
  AuthResearchCenterRoute: typeof AuthResearchCenterRouteWithChildren
  AuthResearchPerfEvalRoute: typeof AuthResearchPerfEvalRouteWithChildren
  AuthTravelRoute: typeof AuthTravelRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthSyncBibtexRoute: AuthSyncBibtexRoute,
  AuthSyncScopusRoute: AuthSyncScopusRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthAdministrationRoute: AuthAdministrationRouteWithChildren,
  AuthAuthorRoute: AuthAuthorRouteWithChildren,
  AuthConferenceRoute: AuthConferenceRouteWithChildren,
  AuthEvaluationRoute: AuthEvaluationRouteWithChildren,
  AuthGovEvaluationRoute: AuthGovEvaluationRouteWithChildren,
  AuthJournalRoute: AuthJournalRouteWithChildren,
  AuthMinimalStandardsRoute: AuthMinimalStandardsRouteWithChildren,
  AuthPublisherRoute: AuthPublisherRouteWithChildren,
  AuthReportRoute: AuthReportRouteWithChildren,
  AuthResearchCenterRoute: AuthResearchCenterRouteWithChildren,
  AuthResearchPerfEvalRoute: AuthResearchPerfEvalRouteWithChildren,
  AuthTravelRoute: AuthTravelRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof AuthRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/sync-bibtex': typeof AuthSyncBibtexRoute
  '/sync-scopus': typeof AuthSyncScopusRoute
  '/': typeof AuthIndexRoute
  '/administration': typeof AuthAdministrationAdministrationRouteWithChildren
  '/author': typeof AuthAuthorAuthorRouteWithChildren
  '/conference': typeof AuthConferenceConferenceRouteWithChildren
  '/evaluation': typeof AuthEvaluationLayoutRouteWithChildren
  '/gov-evaluation': typeof AuthGovEvaluationLayoutRouteWithChildren
  '/journal': typeof AuthJournalJournalRouteWithChildren
  '/minimal-standards': typeof AuthMinimalStandardsLayoutRouteWithChildren
  '/publisher': typeof AuthPublisherPublisherRouteWithChildren
  '/report': typeof AuthReportReportRouteWithChildren
  '/research-center': typeof AuthResearchCenterResearchCenterRouteWithChildren
  '/research-perf-eval': typeof AuthResearchPerfEvalLayoutRouteWithChildren
  '/travel': typeof AuthTravelTravelRouteWithChildren
  '/author/wos-isi-report': typeof AuthAuthorAuthorWosIsiReportRoute
  '/conference/create': typeof AuthConferenceConferenceCreateRoute
  '/journal/create': typeof AuthJournalJournalCreateRoute
  '/publisher/create': typeof AuthPublisherPublisherCreateRoute
  '/report/analytics': typeof AuthReportReportAnalyticsRoute
  '/research-center/create': typeof AuthResearchCenterResearchCenterCreateRoute
  '/administration/': typeof AuthAdministrationAdministrationIndexRoute
  '/author/': typeof AuthAuthorAuthorIndexRoute
  '/conference/': typeof AuthConferenceConferenceIndexRoute
  '/evaluation/': typeof AuthEvaluationLayoutIndexRoute
  '/gov-evaluation/': typeof AuthGovEvaluationLayoutIndexRoute
  '/journal/': typeof AuthJournalJournalIndexRoute
  '/minimal-standards/': typeof AuthMinimalStandardsLayoutIndexRoute
  '/publisher/': typeof AuthPublisherPublisherIndexRoute
  '/report/': typeof AuthReportReportIndexRoute
  '/research-center/': typeof AuthResearchCenterResearchCenterIndexRoute
  '/research-perf-eval/': typeof AuthResearchPerfEvalLayoutIndexRoute
  '/travel/': typeof AuthTravelTravelIndexRoute
  '/administration/department': typeof AuthAdministrationAdministrationDepartmentDepartmentRouteWithChildren
  '/administration/discipline': typeof AuthAdministrationAdministrationDisciplineDisciplineRouteWithChildren
  '/administration/faculty': typeof AuthAdministrationAdministrationFacultyFacultyRouteWithChildren
  '/administration/legal-holiday': typeof AuthAdministrationAdministrationLegalHolidayLegalHolidayRouteWithChildren
  '/administration/local-accounts': typeof AuthAdministrationAdministrationLocalAccountsLocalAccountsRouteWithChildren
  '/administration/university-config': typeof AuthAdministrationAdministrationUniversityConfigUniversityConfigRouteWithChildren
  '/administration/user-documents': typeof AuthAdministrationAdministrationUserDocumentsUserDocumentsRouteWithChildren
  '/author/abstract': typeof AuthAuthorAuthorAbstractAbstractRouteWithChildren
  '/author/article': typeof AuthAuthorAuthorArticleArticleRouteWithChildren
  '/author/award': typeof AuthAuthorAuthorAwardAwardRouteWithChildren
  '/author/book': typeof AuthAuthorAuthorBookBookRouteWithChildren
  '/author/chapter': typeof AuthAuthorAuthorChapterChapterRouteWithChildren
  '/author/committee': typeof AuthAuthorAuthorCommitteeCommitteeRouteWithChildren
  '/author/course': typeof AuthAuthorAuthorCourseCourseRouteWithChildren
  '/author/dictionary': typeof AuthAuthorAuthorDictionaryDictionaryRouteWithChildren
  '/author/doctoral-committee': typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeRouteWithChildren
  '/author/editorial-team': typeof AuthAuthorAuthorEditorialTeamEditorialTeamRouteWithChildren
  '/author/mobility': typeof AuthAuthorAuthorMobilityMobilityRouteWithChildren
  '/author/patent': typeof AuthAuthorAuthorPatentPatentRouteWithChildren
  '/author/presentation': typeof AuthAuthorAuthorPresentationPresentationRouteWithChildren
  '/author/proceeding': typeof AuthAuthorAuthorProceedingProceedingRouteWithChildren
  '/author/project': typeof AuthAuthorAuthorProjectProjectRouteWithChildren
  '/author/review': typeof AuthAuthorAuthorReviewReviewRouteWithChildren
  '/author/technological-transfer': typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferRouteWithChildren
  '/author/translation': typeof AuthAuthorAuthorTranslationTranslationRouteWithChildren
  '/conference/$conferenceId': typeof AuthConferenceConferenceConferenceIdLayoutRouteWithChildren
  '/evaluation/$evaluationId': typeof AuthEvaluationLayoutEvaluationIdLayoutRouteWithChildren
  '/evaluation/$evaluationId/department-summary-results': typeof AuthEvaluationLayoutEvaluationIdDepartmentSummaryResultsRoute
  '/evaluation/$evaluationId/faculty-summary-results': typeof AuthEvaluationLayoutEvaluationIdFacultySummaryResultsRoute
  '/gov-evaluation/$evaluationId': typeof AuthGovEvaluationLayoutEvaluationIdLayoutRouteWithChildren
  '/journal/$journalId': typeof AuthJournalJournalJournalIdLayoutRouteWithChildren
  '/publisher/$publisherId': typeof AuthPublisherPublisherPublisherIdLayoutRouteWithChildren
  '/research-center/$researchCenterId': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutRouteWithChildren
  '/research-perf-eval/$evaluationId': typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutRouteWithChildren
  '/travel/requests/create': typeof AuthTravelTravelRequestsCreateRoute
  '/travel/analytics': typeof AuthTravelTravelAnalyticsIndexRoute
  '/travel/approvals': typeof AuthTravelTravelApprovalsIndexRoute
  '/travel/board-requests': typeof AuthTravelTravelBoardRequestsIndexRoute
  '/travel/days': typeof AuthTravelTravelDaysIndexRoute
  '/travel/documents': typeof AuthTravelTravelDocumentsIndexRoute
  '/travel/registry': typeof AuthTravelTravelRegistryIndexRoute
  '/travel/requests': typeof AuthTravelTravelRequestsIndexRoute
  '/travel/settings': typeof AuthTravelTravelSettingsIndexRoute
  '/administration/department/create': typeof AuthAdministrationAdministrationDepartmentDepartmentCreateRoute
  '/administration/discipline/create': typeof AuthAdministrationAdministrationDisciplineDisciplineCreateRoute
  '/administration/faculty/create': typeof AuthAdministrationAdministrationFacultyFacultyCreateRoute
  '/author/abstract/create': typeof AuthAuthorAuthorAbstractAbstractCreateRoute
  '/author/abstract/search-claimable': typeof AuthAuthorAuthorAbstractAbstractSearchClaimableRoute
  '/author/article/create': typeof AuthAuthorAuthorArticleArticleCreateRoute
  '/author/article/search-claimable': typeof AuthAuthorAuthorArticleArticleSearchClaimableRoute
  '/author/award/create': typeof AuthAuthorAuthorAwardAwardCreateRoute
  '/author/book/create': typeof AuthAuthorAuthorBookBookCreateRoute
  '/author/book/search-claimable': typeof AuthAuthorAuthorBookBookSearchClaimableRoute
  '/author/chapter/create': typeof AuthAuthorAuthorChapterChapterCreateRoute
  '/author/chapter/search-claimable': typeof AuthAuthorAuthorChapterChapterSearchClaimableRoute
  '/author/committee/create': typeof AuthAuthorAuthorCommitteeCommitteeCreateRoute
  '/author/course/create': typeof AuthAuthorAuthorCourseCourseCreateRoute
  '/author/dictionary/create': typeof AuthAuthorAuthorDictionaryDictionaryCreateRoute
  '/author/doctoral-committee/create': typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeCreateRoute
  '/author/editorial-team/create': typeof AuthAuthorAuthorEditorialTeamEditorialTeamCreateRoute
  '/author/mobility/create': typeof AuthAuthorAuthorMobilityMobilityCreateRoute
  '/author/patent/create': typeof AuthAuthorAuthorPatentPatentCreateRoute
  '/author/patent/search-claimable': typeof AuthAuthorAuthorPatentPatentSearchClaimableRoute
  '/author/presentation/create': typeof AuthAuthorAuthorPresentationPresentationCreateRoute
  '/author/proceeding/create': typeof AuthAuthorAuthorProceedingProceedingCreateRoute
  '/author/proceeding/search-claimable': typeof AuthAuthorAuthorProceedingProceedingSearchClaimableRoute
  '/author/project/create': typeof AuthAuthorAuthorProjectProjectCreateRoute
  '/author/project/search-claimable': typeof AuthAuthorAuthorProjectProjectSearchClaimableRoute
  '/author/review/create': typeof AuthAuthorAuthorReviewReviewCreateRoute
  '/author/review/search-claimable': typeof AuthAuthorAuthorReviewReviewSearchClaimableRoute
  '/author/technological-transfer/create': typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferCreateRoute
  '/author/technological-transfer/search-claimable': typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferSearchClaimableRoute
  '/author/translation/create': typeof AuthAuthorAuthorTranslationTranslationCreateRoute
  '/author/translation/search-claimable': typeof AuthAuthorAuthorTranslationTranslationSearchClaimableRoute
  '/conference/$conferenceId/edit': typeof AuthConferenceConferenceConferenceIdLayoutEditRoute
  '/journal/$journalId/article-influence-score': typeof AuthJournalJournalJournalIdLayoutArticleInfluenceScoreRoute
  '/journal/$journalId/edit': typeof AuthJournalJournalJournalIdLayoutEditRoute
  '/journal/$journalId/impact-factor': typeof AuthJournalJournalJournalIdLayoutImpactFactorRoute
  '/minimal-standards/report/gather': typeof AuthMinimalStandardsLayoutReportGatherGatherRouteWithChildren
  '/publisher/$publisherId/edit': typeof AuthPublisherPublisherPublisherIdLayoutEditRoute
  '/research-center/$researchCenterId/create': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutCreateRoute
  '/research-center/$researchCenterId/edit': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutEditRoute
  '/travel/requests/$requestId': typeof AuthTravelTravelRequestsRequestIdLayoutRouteWithChildren
  '/administration/department/': typeof AuthAdministrationAdministrationDepartmentDepartmentIndexRoute
  '/administration/discipline/': typeof AuthAdministrationAdministrationDisciplineDisciplineIndexRoute
  '/administration/faculty/': typeof AuthAdministrationAdministrationFacultyFacultyIndexRoute
  '/administration/legal-holiday/': typeof AuthAdministrationAdministrationLegalHolidayLegalHolidayIndexRoute
  '/administration/local-accounts/': typeof AuthAdministrationAdministrationLocalAccountsLocalAccountsIndexRoute
  '/administration/university-config/': typeof AuthAdministrationAdministrationUniversityConfigUniversityConfigIndexRoute
  '/administration/user-documents/': typeof AuthAdministrationAdministrationUserDocumentsUserDocumentsIndexRoute
  '/author/abstract/': typeof AuthAuthorAuthorAbstractAbstractIndexRoute
  '/author/article/': typeof AuthAuthorAuthorArticleArticleIndexRoute
  '/author/award/': typeof AuthAuthorAuthorAwardAwardIndexRoute
  '/author/book/': typeof AuthAuthorAuthorBookBookIndexRoute
  '/author/chapter/': typeof AuthAuthorAuthorChapterChapterIndexRoute
  '/author/committee/': typeof AuthAuthorAuthorCommitteeCommitteeIndexRoute
  '/author/course/': typeof AuthAuthorAuthorCourseCourseIndexRoute
  '/author/dictionary/': typeof AuthAuthorAuthorDictionaryDictionaryIndexRoute
  '/author/doctoral-committee/': typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeIndexRoute
  '/author/editorial-team/': typeof AuthAuthorAuthorEditorialTeamEditorialTeamIndexRoute
  '/author/mobility/': typeof AuthAuthorAuthorMobilityMobilityIndexRoute
  '/author/patent/': typeof AuthAuthorAuthorPatentPatentIndexRoute
  '/author/presentation/': typeof AuthAuthorAuthorPresentationPresentationIndexRoute
  '/author/proceeding/': typeof AuthAuthorAuthorProceedingProceedingIndexRoute
  '/author/project/': typeof AuthAuthorAuthorProjectProjectIndexRoute
  '/author/review/': typeof AuthAuthorAuthorReviewReviewIndexRoute
  '/author/technological-transfer/': typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferIndexRoute
  '/author/translation/': typeof AuthAuthorAuthorTranslationTranslationIndexRoute
  '/conference/$conferenceId/': typeof AuthConferenceConferenceConferenceIdLayoutIndexRoute
  '/evaluation/$evaluationId/': typeof AuthEvaluationLayoutEvaluationIdLayoutIndexRoute
  '/gov-evaluation/$evaluationId/': typeof AuthGovEvaluationLayoutEvaluationIdLayoutIndexRoute
  '/journal/$journalId/': typeof AuthJournalJournalJournalIdLayoutIndexRoute
  '/publisher/$publisherId/': typeof AuthPublisherPublisherPublisherIdLayoutIndexRoute
  '/research-center/$researchCenterId/': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutIndexRoute
  '/research-perf-eval/$evaluationId/': typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutIndexRoute
  '/administration/department/$departmentId': typeof AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutRouteWithChildren
  '/administration/discipline/$disciplineId': typeof AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutRouteWithChildren
  '/administration/faculty/$facultyId': typeof AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutRouteWithChildren
  '/author/abstract/$abstractId': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutRouteWithChildren
  '/author/article/$articleId': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutRouteWithChildren
  '/author/award/$awardId': typeof AuthAuthorAuthorAwardAwardAwardIdLayoutRouteWithChildren
  '/author/book/$bookId': typeof AuthAuthorAuthorBookBookBookIdLayoutRouteWithChildren
  '/author/chapter/$chapterId': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutRouteWithChildren
  '/author/committee/$committeeId': typeof AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutRouteWithChildren
  '/author/course/$courseId': typeof AuthAuthorAuthorCourseCourseCourseIdLayoutRouteWithChildren
  '/author/dictionary/$dictionaryId': typeof AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutRouteWithChildren
  '/author/doctoral-committee/$doctoralCommitteeId': typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutRouteWithChildren
  '/author/editorial-team/$editorialTeamId': typeof AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutRouteWithChildren
  '/author/mobility/$mobilityId': typeof AuthAuthorAuthorMobilityMobilityMobilityIdLayoutRouteWithChildren
  '/author/patent/$patentId': typeof AuthAuthorAuthorPatentPatentPatentIdLayoutRouteWithChildren
  '/author/presentation/$presentationId': typeof AuthAuthorAuthorPresentationPresentationPresentationIdLayoutRouteWithChildren
  '/author/proceeding/$proceedingId': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutRouteWithChildren
  '/author/project/$projectId': typeof AuthAuthorAuthorProjectProjectProjectIdLayoutRouteWithChildren
  '/author/review/$reviewId': typeof AuthAuthorAuthorReviewReviewReviewIdLayoutRouteWithChildren
  '/author/technological-transfer/$technologicalTransferId': typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutRouteWithChildren
  '/author/translation/$translationId': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutRouteWithChildren
  '/research-center/$researchCenterId/lab': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutRouteWithChildren
  '/travel/requests/$requestId/edit': typeof AuthTravelTravelRequestsRequestIdLayoutEditRoute
  '/minimal-standards/report/gather/': typeof AuthMinimalStandardsLayoutReportGatherGatherIndexRoute
  '/travel/requests/$requestId/': typeof AuthTravelTravelRequestsRequestIdLayoutIndexRoute
  '/administration/department/$departmentId/edit': typeof AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutEditRoute
  '/administration/discipline/$disciplineId/edit': typeof AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutEditRoute
  '/administration/faculty/$facultyId/edit': typeof AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutEditRoute
  '/author/abstract/$abstractId/edit': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutEditRoute
  '/author/article/$articleId/edit': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutEditRoute
  '/author/award/$awardId/edit': typeof AuthAuthorAuthorAwardAwardAwardIdLayoutEditRoute
  '/author/book/$bookId/edit': typeof AuthAuthorAuthorBookBookBookIdLayoutEditRoute
  '/author/chapter/$chapterId/edit': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutEditRoute
  '/author/committee/$committeeId/edit': typeof AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutEditRoute
  '/author/course/$courseId/edit': typeof AuthAuthorAuthorCourseCourseCourseIdLayoutEditRoute
  '/author/dictionary/$dictionaryId/edit': typeof AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutEditRoute
  '/author/doctoral-committee/$doctoralCommitteeId/edit': typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutEditRoute
  '/author/editorial-team/$editorialTeamId/edit': typeof AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutEditRoute
  '/author/mobility/$mobilityId/edit': typeof AuthAuthorAuthorMobilityMobilityMobilityIdLayoutEditRoute
  '/author/patent/$patentId/edit': typeof AuthAuthorAuthorPatentPatentPatentIdLayoutEditRoute
  '/author/presentation/$presentationId/edit': typeof AuthAuthorAuthorPresentationPresentationPresentationIdLayoutEditRoute
  '/author/proceeding/$proceedingId/edit': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutEditRoute
  '/author/project/$projectId/edit': typeof AuthAuthorAuthorProjectProjectProjectIdLayoutEditRoute
  '/author/review/$reviewId/edit': typeof AuthAuthorAuthorReviewReviewReviewIdLayoutEditRoute
  '/author/technological-transfer/$technologicalTransferId/edit': typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutEditRoute
  '/author/translation/$translationId/edit': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutEditRoute
  '/evaluation/$evaluationId/report/gather': typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherRouteWithChildren
  '/minimal-standards/report/gather/$indicatorCode': typeof AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutRouteWithChildren
  '/research-perf-eval/$evaluationId/report/gather': typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherRouteWithChildren
  '/administration/department/$departmentId/': typeof AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutIndexRoute
  '/administration/discipline/$disciplineId/': typeof AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutIndexRoute
  '/administration/faculty/$facultyId/': typeof AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutIndexRoute
  '/author/abstract/$abstractId/': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutIndexRoute
  '/author/article/$articleId/': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutIndexRoute
  '/author/award/$awardId/': typeof AuthAuthorAuthorAwardAwardAwardIdLayoutIndexRoute
  '/author/book/$bookId/': typeof AuthAuthorAuthorBookBookBookIdLayoutIndexRoute
  '/author/chapter/$chapterId/': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutIndexRoute
  '/author/committee/$committeeId/': typeof AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutIndexRoute
  '/author/course/$courseId/': typeof AuthAuthorAuthorCourseCourseCourseIdLayoutIndexRoute
  '/author/dictionary/$dictionaryId/': typeof AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutIndexRoute
  '/author/doctoral-committee/$doctoralCommitteeId/': typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutIndexRoute
  '/author/editorial-team/$editorialTeamId/': typeof AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutIndexRoute
  '/author/mobility/$mobilityId/': typeof AuthAuthorAuthorMobilityMobilityMobilityIdLayoutIndexRoute
  '/author/patent/$patentId/': typeof AuthAuthorAuthorPatentPatentPatentIdLayoutIndexRoute
  '/author/presentation/$presentationId/': typeof AuthAuthorAuthorPresentationPresentationPresentationIdLayoutIndexRoute
  '/author/proceeding/$proceedingId/': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutIndexRoute
  '/author/project/$projectId/': typeof AuthAuthorAuthorProjectProjectProjectIdLayoutIndexRoute
  '/author/review/$reviewId/': typeof AuthAuthorAuthorReviewReviewReviewIdLayoutIndexRoute
  '/author/technological-transfer/$technologicalTransferId/': typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutIndexRoute
  '/author/translation/$translationId/': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutIndexRoute
  '/research-center/$researchCenterId/lab/': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutIndexRoute
  '/author/abstract/$abstractId/citations/create': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCreateRoute
  '/author/article/$articleId/citations/create': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCreateRoute
  '/author/book/$bookId/citations/create': typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCreateRoute
  '/author/chapter/$chapterId/citations/create': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCreateRoute
  '/author/proceeding/$proceedingId/citations/create': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCreateRoute
  '/author/translation/$translationId/citations/create': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCreateRoute
  '/research-center/$researchCenterId/lab/$labId': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutRouteWithChildren
  '/author/abstract/$abstractId/citations': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsIndexRoute
  '/author/article/$articleId/citations': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsIndexRoute
  '/author/book/$bookId/citations': typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsIndexRoute
  '/author/chapter/$chapterId/citations': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsIndexRoute
  '/author/proceeding/$proceedingId/citations': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsIndexRoute
  '/author/translation/$translationId/citations': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsIndexRoute
  '/evaluation/$evaluationId/report/gather/': typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherIndexRoute
  '/minimal-standards/report/gather/$indicatorCode/': typeof AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutIndexRoute
  '/research-perf-eval/$evaluationId/report/gather/': typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherIndexRoute
  '/author/abstract/$abstractId/citations/$citationId': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutRouteWithChildren
  '/author/article/$articleId/citations/$citationId': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutRouteWithChildren
  '/author/book/$bookId/citations/$citationId': typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutRouteWithChildren
  '/author/chapter/$chapterId/citations/$citationId': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutRouteWithChildren
  '/author/proceeding/$proceedingId/citations/$citationId': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutRouteWithChildren
  '/author/translation/$translationId/citations/$citationId': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutRouteWithChildren
  '/evaluation/$evaluationId/report/gather/$orderNo': typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRouteWithChildren
  '/research-center/$researchCenterId/lab/$labId/edit': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutEditRoute
  '/research-perf-eval/$evaluationId/report/gather/$orderNo': typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRouteWithChildren
  '/research-center/$researchCenterId/lab/$labId/': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutIndexRoute
  '/author/abstract/$abstractId/citations/$citationId/edit': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutEditRoute
  '/author/article/$articleId/citations/$citationId/edit': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutEditRoute
  '/author/book/$bookId/citations/$citationId/edit': typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutEditRoute
  '/author/chapter/$chapterId/citations/$citationId/edit': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutEditRoute
  '/author/proceeding/$proceedingId/citations/$citationId/edit': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutEditRoute
  '/author/translation/$translationId/citations/$citationId/edit': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutEditRoute
  '/author/abstract/$abstractId/citations/$citationId/': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutIndexRoute
  '/author/article/$articleId/citations/$citationId/': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutIndexRoute
  '/author/book/$bookId/citations/$citationId/': typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutIndexRoute
  '/author/chapter/$chapterId/citations/$citationId/': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutIndexRoute
  '/author/proceeding/$proceedingId/citations/$citationId/': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutIndexRoute
  '/author/translation/$translationId/citations/$citationId/': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutIndexRoute
  '/evaluation/$evaluationId/report/gather/$orderNo/': typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexRoute
  '/research-perf-eval/$evaluationId/report/gather/$orderNo/': typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexRoute
}

export interface FileRoutesByTo {
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/sync-bibtex': typeof AuthSyncBibtexRoute
  '/sync-scopus': typeof AuthSyncScopusRoute
  '/': typeof AuthIndexRoute
  '/administration': typeof AuthAdministrationAdministrationIndexRoute
  '/author': typeof AuthAuthorAuthorIndexRoute
  '/conference': typeof AuthConferenceConferenceIndexRoute
  '/evaluation': typeof AuthEvaluationLayoutIndexRoute
  '/gov-evaluation': typeof AuthGovEvaluationLayoutIndexRoute
  '/journal': typeof AuthJournalJournalIndexRoute
  '/minimal-standards': typeof AuthMinimalStandardsLayoutIndexRoute
  '/publisher': typeof AuthPublisherPublisherIndexRoute
  '/report': typeof AuthReportReportIndexRoute
  '/research-center': typeof AuthResearchCenterResearchCenterIndexRoute
  '/research-perf-eval': typeof AuthResearchPerfEvalLayoutIndexRoute
  '/travel': typeof AuthTravelTravelIndexRoute
  '/author/wos-isi-report': typeof AuthAuthorAuthorWosIsiReportRoute
  '/conference/create': typeof AuthConferenceConferenceCreateRoute
  '/journal/create': typeof AuthJournalJournalCreateRoute
  '/publisher/create': typeof AuthPublisherPublisherCreateRoute
  '/report/analytics': typeof AuthReportReportAnalyticsRoute
  '/research-center/create': typeof AuthResearchCenterResearchCenterCreateRoute
  '/administration/department': typeof AuthAdministrationAdministrationDepartmentDepartmentIndexRoute
  '/administration/discipline': typeof AuthAdministrationAdministrationDisciplineDisciplineIndexRoute
  '/administration/faculty': typeof AuthAdministrationAdministrationFacultyFacultyIndexRoute
  '/administration/legal-holiday': typeof AuthAdministrationAdministrationLegalHolidayLegalHolidayIndexRoute
  '/administration/local-accounts': typeof AuthAdministrationAdministrationLocalAccountsLocalAccountsIndexRoute
  '/administration/university-config': typeof AuthAdministrationAdministrationUniversityConfigUniversityConfigIndexRoute
  '/administration/user-documents': typeof AuthAdministrationAdministrationUserDocumentsUserDocumentsIndexRoute
  '/author/abstract': typeof AuthAuthorAuthorAbstractAbstractIndexRoute
  '/author/article': typeof AuthAuthorAuthorArticleArticleIndexRoute
  '/author/award': typeof AuthAuthorAuthorAwardAwardIndexRoute
  '/author/book': typeof AuthAuthorAuthorBookBookIndexRoute
  '/author/chapter': typeof AuthAuthorAuthorChapterChapterIndexRoute
  '/author/committee': typeof AuthAuthorAuthorCommitteeCommitteeIndexRoute
  '/author/course': typeof AuthAuthorAuthorCourseCourseIndexRoute
  '/author/dictionary': typeof AuthAuthorAuthorDictionaryDictionaryIndexRoute
  '/author/doctoral-committee': typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeIndexRoute
  '/author/editorial-team': typeof AuthAuthorAuthorEditorialTeamEditorialTeamIndexRoute
  '/author/mobility': typeof AuthAuthorAuthorMobilityMobilityIndexRoute
  '/author/patent': typeof AuthAuthorAuthorPatentPatentIndexRoute
  '/author/presentation': typeof AuthAuthorAuthorPresentationPresentationIndexRoute
  '/author/proceeding': typeof AuthAuthorAuthorProceedingProceedingIndexRoute
  '/author/project': typeof AuthAuthorAuthorProjectProjectIndexRoute
  '/author/review': typeof AuthAuthorAuthorReviewReviewIndexRoute
  '/author/technological-transfer': typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferIndexRoute
  '/author/translation': typeof AuthAuthorAuthorTranslationTranslationIndexRoute
  '/conference/$conferenceId': typeof AuthConferenceConferenceConferenceIdLayoutIndexRoute
  '/evaluation/$evaluationId': typeof AuthEvaluationLayoutEvaluationIdLayoutIndexRoute
  '/evaluation/$evaluationId/department-summary-results': typeof AuthEvaluationLayoutEvaluationIdDepartmentSummaryResultsRoute
  '/evaluation/$evaluationId/faculty-summary-results': typeof AuthEvaluationLayoutEvaluationIdFacultySummaryResultsRoute
  '/gov-evaluation/$evaluationId': typeof AuthGovEvaluationLayoutEvaluationIdLayoutIndexRoute
  '/journal/$journalId': typeof AuthJournalJournalJournalIdLayoutIndexRoute
  '/publisher/$publisherId': typeof AuthPublisherPublisherPublisherIdLayoutIndexRoute
  '/research-center/$researchCenterId': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutIndexRoute
  '/research-perf-eval/$evaluationId': typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutIndexRoute
  '/travel/requests/create': typeof AuthTravelTravelRequestsCreateRoute
  '/travel/analytics': typeof AuthTravelTravelAnalyticsIndexRoute
  '/travel/approvals': typeof AuthTravelTravelApprovalsIndexRoute
  '/travel/board-requests': typeof AuthTravelTravelBoardRequestsIndexRoute
  '/travel/days': typeof AuthTravelTravelDaysIndexRoute
  '/travel/documents': typeof AuthTravelTravelDocumentsIndexRoute
  '/travel/registry': typeof AuthTravelTravelRegistryIndexRoute
  '/travel/requests': typeof AuthTravelTravelRequestsIndexRoute
  '/travel/settings': typeof AuthTravelTravelSettingsIndexRoute
  '/administration/department/create': typeof AuthAdministrationAdministrationDepartmentDepartmentCreateRoute
  '/administration/discipline/create': typeof AuthAdministrationAdministrationDisciplineDisciplineCreateRoute
  '/administration/faculty/create': typeof AuthAdministrationAdministrationFacultyFacultyCreateRoute
  '/author/abstract/create': typeof AuthAuthorAuthorAbstractAbstractCreateRoute
  '/author/abstract/search-claimable': typeof AuthAuthorAuthorAbstractAbstractSearchClaimableRoute
  '/author/article/create': typeof AuthAuthorAuthorArticleArticleCreateRoute
  '/author/article/search-claimable': typeof AuthAuthorAuthorArticleArticleSearchClaimableRoute
  '/author/award/create': typeof AuthAuthorAuthorAwardAwardCreateRoute
  '/author/book/create': typeof AuthAuthorAuthorBookBookCreateRoute
  '/author/book/search-claimable': typeof AuthAuthorAuthorBookBookSearchClaimableRoute
  '/author/chapter/create': typeof AuthAuthorAuthorChapterChapterCreateRoute
  '/author/chapter/search-claimable': typeof AuthAuthorAuthorChapterChapterSearchClaimableRoute
  '/author/committee/create': typeof AuthAuthorAuthorCommitteeCommitteeCreateRoute
  '/author/course/create': typeof AuthAuthorAuthorCourseCourseCreateRoute
  '/author/dictionary/create': typeof AuthAuthorAuthorDictionaryDictionaryCreateRoute
  '/author/doctoral-committee/create': typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeCreateRoute
  '/author/editorial-team/create': typeof AuthAuthorAuthorEditorialTeamEditorialTeamCreateRoute
  '/author/mobility/create': typeof AuthAuthorAuthorMobilityMobilityCreateRoute
  '/author/patent/create': typeof AuthAuthorAuthorPatentPatentCreateRoute
  '/author/patent/search-claimable': typeof AuthAuthorAuthorPatentPatentSearchClaimableRoute
  '/author/presentation/create': typeof AuthAuthorAuthorPresentationPresentationCreateRoute
  '/author/proceeding/create': typeof AuthAuthorAuthorProceedingProceedingCreateRoute
  '/author/proceeding/search-claimable': typeof AuthAuthorAuthorProceedingProceedingSearchClaimableRoute
  '/author/project/create': typeof AuthAuthorAuthorProjectProjectCreateRoute
  '/author/project/search-claimable': typeof AuthAuthorAuthorProjectProjectSearchClaimableRoute
  '/author/review/create': typeof AuthAuthorAuthorReviewReviewCreateRoute
  '/author/review/search-claimable': typeof AuthAuthorAuthorReviewReviewSearchClaimableRoute
  '/author/technological-transfer/create': typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferCreateRoute
  '/author/technological-transfer/search-claimable': typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferSearchClaimableRoute
  '/author/translation/create': typeof AuthAuthorAuthorTranslationTranslationCreateRoute
  '/author/translation/search-claimable': typeof AuthAuthorAuthorTranslationTranslationSearchClaimableRoute
  '/conference/$conferenceId/edit': typeof AuthConferenceConferenceConferenceIdLayoutEditRoute
  '/journal/$journalId/article-influence-score': typeof AuthJournalJournalJournalIdLayoutArticleInfluenceScoreRoute
  '/journal/$journalId/edit': typeof AuthJournalJournalJournalIdLayoutEditRoute
  '/journal/$journalId/impact-factor': typeof AuthJournalJournalJournalIdLayoutImpactFactorRoute
  '/minimal-standards/report/gather': typeof AuthMinimalStandardsLayoutReportGatherGatherIndexRoute
  '/publisher/$publisherId/edit': typeof AuthPublisherPublisherPublisherIdLayoutEditRoute
  '/research-center/$researchCenterId/create': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutCreateRoute
  '/research-center/$researchCenterId/edit': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutEditRoute
  '/travel/requests/$requestId': typeof AuthTravelTravelRequestsRequestIdLayoutIndexRoute
  '/administration/department/$departmentId': typeof AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutIndexRoute
  '/administration/discipline/$disciplineId': typeof AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutIndexRoute
  '/administration/faculty/$facultyId': typeof AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutIndexRoute
  '/author/abstract/$abstractId': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutIndexRoute
  '/author/article/$articleId': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutIndexRoute
  '/author/award/$awardId': typeof AuthAuthorAuthorAwardAwardAwardIdLayoutIndexRoute
  '/author/book/$bookId': typeof AuthAuthorAuthorBookBookBookIdLayoutIndexRoute
  '/author/chapter/$chapterId': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutIndexRoute
  '/author/committee/$committeeId': typeof AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutIndexRoute
  '/author/course/$courseId': typeof AuthAuthorAuthorCourseCourseCourseIdLayoutIndexRoute
  '/author/dictionary/$dictionaryId': typeof AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutIndexRoute
  '/author/doctoral-committee/$doctoralCommitteeId': typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutIndexRoute
  '/author/editorial-team/$editorialTeamId': typeof AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutIndexRoute
  '/author/mobility/$mobilityId': typeof AuthAuthorAuthorMobilityMobilityMobilityIdLayoutIndexRoute
  '/author/patent/$patentId': typeof AuthAuthorAuthorPatentPatentPatentIdLayoutIndexRoute
  '/author/presentation/$presentationId': typeof AuthAuthorAuthorPresentationPresentationPresentationIdLayoutIndexRoute
  '/author/proceeding/$proceedingId': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutIndexRoute
  '/author/project/$projectId': typeof AuthAuthorAuthorProjectProjectProjectIdLayoutIndexRoute
  '/author/review/$reviewId': typeof AuthAuthorAuthorReviewReviewReviewIdLayoutIndexRoute
  '/author/technological-transfer/$technologicalTransferId': typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutIndexRoute
  '/author/translation/$translationId': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutIndexRoute
  '/research-center/$researchCenterId/lab': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutIndexRoute
  '/travel/requests/$requestId/edit': typeof AuthTravelTravelRequestsRequestIdLayoutEditRoute
  '/administration/department/$departmentId/edit': typeof AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutEditRoute
  '/administration/discipline/$disciplineId/edit': typeof AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutEditRoute
  '/administration/faculty/$facultyId/edit': typeof AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutEditRoute
  '/author/abstract/$abstractId/edit': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutEditRoute
  '/author/article/$articleId/edit': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutEditRoute
  '/author/award/$awardId/edit': typeof AuthAuthorAuthorAwardAwardAwardIdLayoutEditRoute
  '/author/book/$bookId/edit': typeof AuthAuthorAuthorBookBookBookIdLayoutEditRoute
  '/author/chapter/$chapterId/edit': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutEditRoute
  '/author/committee/$committeeId/edit': typeof AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutEditRoute
  '/author/course/$courseId/edit': typeof AuthAuthorAuthorCourseCourseCourseIdLayoutEditRoute
  '/author/dictionary/$dictionaryId/edit': typeof AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutEditRoute
  '/author/doctoral-committee/$doctoralCommitteeId/edit': typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutEditRoute
  '/author/editorial-team/$editorialTeamId/edit': typeof AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutEditRoute
  '/author/mobility/$mobilityId/edit': typeof AuthAuthorAuthorMobilityMobilityMobilityIdLayoutEditRoute
  '/author/patent/$patentId/edit': typeof AuthAuthorAuthorPatentPatentPatentIdLayoutEditRoute
  '/author/presentation/$presentationId/edit': typeof AuthAuthorAuthorPresentationPresentationPresentationIdLayoutEditRoute
  '/author/proceeding/$proceedingId/edit': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutEditRoute
  '/author/project/$projectId/edit': typeof AuthAuthorAuthorProjectProjectProjectIdLayoutEditRoute
  '/author/review/$reviewId/edit': typeof AuthAuthorAuthorReviewReviewReviewIdLayoutEditRoute
  '/author/technological-transfer/$technologicalTransferId/edit': typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutEditRoute
  '/author/translation/$translationId/edit': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutEditRoute
  '/evaluation/$evaluationId/report/gather': typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherIndexRoute
  '/minimal-standards/report/gather/$indicatorCode': typeof AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutIndexRoute
  '/research-perf-eval/$evaluationId/report/gather': typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherIndexRoute
  '/author/abstract/$abstractId/citations/create': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCreateRoute
  '/author/article/$articleId/citations/create': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCreateRoute
  '/author/book/$bookId/citations/create': typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCreateRoute
  '/author/chapter/$chapterId/citations/create': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCreateRoute
  '/author/proceeding/$proceedingId/citations/create': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCreateRoute
  '/author/translation/$translationId/citations/create': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCreateRoute
  '/research-center/$researchCenterId/lab/$labId': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutIndexRoute
  '/author/abstract/$abstractId/citations': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsIndexRoute
  '/author/article/$articleId/citations': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsIndexRoute
  '/author/book/$bookId/citations': typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsIndexRoute
  '/author/chapter/$chapterId/citations': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsIndexRoute
  '/author/proceeding/$proceedingId/citations': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsIndexRoute
  '/author/translation/$translationId/citations': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsIndexRoute
  '/author/abstract/$abstractId/citations/$citationId': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutIndexRoute
  '/author/article/$articleId/citations/$citationId': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutIndexRoute
  '/author/book/$bookId/citations/$citationId': typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutIndexRoute
  '/author/chapter/$chapterId/citations/$citationId': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutIndexRoute
  '/author/proceeding/$proceedingId/citations/$citationId': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutIndexRoute
  '/author/translation/$translationId/citations/$citationId': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutIndexRoute
  '/evaluation/$evaluationId/report/gather/$orderNo': typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexRoute
  '/research-center/$researchCenterId/lab/$labId/edit': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutEditRoute
  '/research-perf-eval/$evaluationId/report/gather/$orderNo': typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexRoute
  '/author/abstract/$abstractId/citations/$citationId/edit': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutEditRoute
  '/author/article/$articleId/citations/$citationId/edit': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutEditRoute
  '/author/book/$bookId/citations/$citationId/edit': typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutEditRoute
  '/author/chapter/$chapterId/citations/$citationId/edit': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutEditRoute
  '/author/proceeding/$proceedingId/citations/$citationId/edit': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutEditRoute
  '/author/translation/$translationId/citations/$citationId/edit': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutEditRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_auth': typeof AuthRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/login': typeof LoginRoute
  '/_auth/sync-bibtex': typeof AuthSyncBibtexRoute
  '/_auth/sync-scopus': typeof AuthSyncScopusRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/administration': typeof AuthAdministrationRouteWithChildren
  '/_auth/administration/_administration': typeof AuthAdministrationAdministrationRouteWithChildren
  '/_auth/author': typeof AuthAuthorRouteWithChildren
  '/_auth/author/_author': typeof AuthAuthorAuthorRouteWithChildren
  '/_auth/conference': typeof AuthConferenceRouteWithChildren
  '/_auth/conference/_conference': typeof AuthConferenceConferenceRouteWithChildren
  '/_auth/evaluation': typeof AuthEvaluationRouteWithChildren
  '/_auth/evaluation/_layout': typeof AuthEvaluationLayoutRouteWithChildren
  '/_auth/gov-evaluation': typeof AuthGovEvaluationRouteWithChildren
  '/_auth/gov-evaluation/_layout': typeof AuthGovEvaluationLayoutRouteWithChildren
  '/_auth/journal': typeof AuthJournalRouteWithChildren
  '/_auth/journal/_journal': typeof AuthJournalJournalRouteWithChildren
  '/_auth/minimal-standards': typeof AuthMinimalStandardsRouteWithChildren
  '/_auth/minimal-standards/_layout': typeof AuthMinimalStandardsLayoutRouteWithChildren
  '/_auth/publisher': typeof AuthPublisherRouteWithChildren
  '/_auth/publisher/_publisher': typeof AuthPublisherPublisherRouteWithChildren
  '/_auth/report': typeof AuthReportRouteWithChildren
  '/_auth/report/_report': typeof AuthReportReportRouteWithChildren
  '/_auth/research-center': typeof AuthResearchCenterRouteWithChildren
  '/_auth/research-center/_research-center': typeof AuthResearchCenterResearchCenterRouteWithChildren
  '/_auth/research-perf-eval': typeof AuthResearchPerfEvalRouteWithChildren
  '/_auth/research-perf-eval/_layout': typeof AuthResearchPerfEvalLayoutRouteWithChildren
  '/_auth/travel': typeof AuthTravelRouteWithChildren
  '/_auth/travel/_travel': typeof AuthTravelTravelRouteWithChildren
  '/_auth/author/_author/wos-isi-report': typeof AuthAuthorAuthorWosIsiReportRoute
  '/_auth/conference/_conference/create': typeof AuthConferenceConferenceCreateRoute
  '/_auth/journal/_journal/create': typeof AuthJournalJournalCreateRoute
  '/_auth/publisher/_publisher/create': typeof AuthPublisherPublisherCreateRoute
  '/_auth/report/_report/analytics': typeof AuthReportReportAnalyticsRoute
  '/_auth/research-center/_research-center/create': typeof AuthResearchCenterResearchCenterCreateRoute
  '/_auth/administration/_administration/': typeof AuthAdministrationAdministrationIndexRoute
  '/_auth/author/_author/': typeof AuthAuthorAuthorIndexRoute
  '/_auth/conference/_conference/': typeof AuthConferenceConferenceIndexRoute
  '/_auth/evaluation/_layout/': typeof AuthEvaluationLayoutIndexRoute
  '/_auth/gov-evaluation/_layout/': typeof AuthGovEvaluationLayoutIndexRoute
  '/_auth/journal/_journal/': typeof AuthJournalJournalIndexRoute
  '/_auth/minimal-standards/_layout/': typeof AuthMinimalStandardsLayoutIndexRoute
  '/_auth/publisher/_publisher/': typeof AuthPublisherPublisherIndexRoute
  '/_auth/report/_report/': typeof AuthReportReportIndexRoute
  '/_auth/research-center/_research-center/': typeof AuthResearchCenterResearchCenterIndexRoute
  '/_auth/research-perf-eval/_layout/': typeof AuthResearchPerfEvalLayoutIndexRoute
  '/_auth/travel/_travel/': typeof AuthTravelTravelIndexRoute
  '/_auth/administration/_administration/department': typeof AuthAdministrationAdministrationDepartmentRouteWithChildren
  '/_auth/administration/_administration/department/_department': typeof AuthAdministrationAdministrationDepartmentDepartmentRouteWithChildren
  '/_auth/administration/_administration/discipline': typeof AuthAdministrationAdministrationDisciplineRouteWithChildren
  '/_auth/administration/_administration/discipline/_discipline': typeof AuthAdministrationAdministrationDisciplineDisciplineRouteWithChildren
  '/_auth/administration/_administration/faculty': typeof AuthAdministrationAdministrationFacultyRouteWithChildren
  '/_auth/administration/_administration/faculty/_faculty': typeof AuthAdministrationAdministrationFacultyFacultyRouteWithChildren
  '/_auth/administration/_administration/legal-holiday': typeof AuthAdministrationAdministrationLegalHolidayRouteWithChildren
  '/_auth/administration/_administration/legal-holiday/_legal-holiday': typeof AuthAdministrationAdministrationLegalHolidayLegalHolidayRouteWithChildren
  '/_auth/administration/_administration/local-accounts': typeof AuthAdministrationAdministrationLocalAccountsRouteWithChildren
  '/_auth/administration/_administration/local-accounts/_local-accounts': typeof AuthAdministrationAdministrationLocalAccountsLocalAccountsRouteWithChildren
  '/_auth/administration/_administration/university-config': typeof AuthAdministrationAdministrationUniversityConfigRouteWithChildren
  '/_auth/administration/_administration/university-config/_university-config': typeof AuthAdministrationAdministrationUniversityConfigUniversityConfigRouteWithChildren
  '/_auth/administration/_administration/user-documents': typeof AuthAdministrationAdministrationUserDocumentsRouteWithChildren
  '/_auth/administration/_administration/user-documents/_user-documents': typeof AuthAdministrationAdministrationUserDocumentsUserDocumentsRouteWithChildren
  '/_auth/author/_author/abstract': typeof AuthAuthorAuthorAbstractRouteWithChildren
  '/_auth/author/_author/abstract/_abstract': typeof AuthAuthorAuthorAbstractAbstractRouteWithChildren
  '/_auth/author/_author/article': typeof AuthAuthorAuthorArticleRouteWithChildren
  '/_auth/author/_author/article/_article': typeof AuthAuthorAuthorArticleArticleRouteWithChildren
  '/_auth/author/_author/award': typeof AuthAuthorAuthorAwardRouteWithChildren
  '/_auth/author/_author/award/_award': typeof AuthAuthorAuthorAwardAwardRouteWithChildren
  '/_auth/author/_author/book': typeof AuthAuthorAuthorBookRouteWithChildren
  '/_auth/author/_author/book/_book': typeof AuthAuthorAuthorBookBookRouteWithChildren
  '/_auth/author/_author/chapter': typeof AuthAuthorAuthorChapterRouteWithChildren
  '/_auth/author/_author/chapter/_chapter': typeof AuthAuthorAuthorChapterChapterRouteWithChildren
  '/_auth/author/_author/committee': typeof AuthAuthorAuthorCommitteeRouteWithChildren
  '/_auth/author/_author/committee/_committee': typeof AuthAuthorAuthorCommitteeCommitteeRouteWithChildren
  '/_auth/author/_author/course': typeof AuthAuthorAuthorCourseRouteWithChildren
  '/_auth/author/_author/course/_course': typeof AuthAuthorAuthorCourseCourseRouteWithChildren
  '/_auth/author/_author/dictionary': typeof AuthAuthorAuthorDictionaryRouteWithChildren
  '/_auth/author/_author/dictionary/_dictionary': typeof AuthAuthorAuthorDictionaryDictionaryRouteWithChildren
  '/_auth/author/_author/doctoral-committee': typeof AuthAuthorAuthorDoctoralCommitteeRouteWithChildren
  '/_auth/author/_author/doctoral-committee/_doctoralCommittee': typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeRouteWithChildren
  '/_auth/author/_author/editorial-team': typeof AuthAuthorAuthorEditorialTeamRouteWithChildren
  '/_auth/author/_author/editorial-team/_editorialTeam': typeof AuthAuthorAuthorEditorialTeamEditorialTeamRouteWithChildren
  '/_auth/author/_author/mobility': typeof AuthAuthorAuthorMobilityRouteWithChildren
  '/_auth/author/_author/mobility/_mobility': typeof AuthAuthorAuthorMobilityMobilityRouteWithChildren
  '/_auth/author/_author/patent': typeof AuthAuthorAuthorPatentRouteWithChildren
  '/_auth/author/_author/patent/_patent': typeof AuthAuthorAuthorPatentPatentRouteWithChildren
  '/_auth/author/_author/presentation': typeof AuthAuthorAuthorPresentationRouteWithChildren
  '/_auth/author/_author/presentation/_presentation': typeof AuthAuthorAuthorPresentationPresentationRouteWithChildren
  '/_auth/author/_author/proceeding': typeof AuthAuthorAuthorProceedingRouteWithChildren
  '/_auth/author/_author/proceeding/_proceeding': typeof AuthAuthorAuthorProceedingProceedingRouteWithChildren
  '/_auth/author/_author/project': typeof AuthAuthorAuthorProjectRouteWithChildren
  '/_auth/author/_author/project/_project': typeof AuthAuthorAuthorProjectProjectRouteWithChildren
  '/_auth/author/_author/review': typeof AuthAuthorAuthorReviewRouteWithChildren
  '/_auth/author/_author/review/_review': typeof AuthAuthorAuthorReviewReviewRouteWithChildren
  '/_auth/author/_author/technological-transfer': typeof AuthAuthorAuthorTechnologicalTransferRouteWithChildren
  '/_auth/author/_author/technological-transfer/_technologicalTransfer': typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferRouteWithChildren
  '/_auth/author/_author/translation': typeof AuthAuthorAuthorTranslationRouteWithChildren
  '/_auth/author/_author/translation/_translation': typeof AuthAuthorAuthorTranslationTranslationRouteWithChildren
  '/_auth/conference/_conference/$conferenceId': typeof AuthConferenceConferenceConferenceIdRouteWithChildren
  '/_auth/conference/_conference/$conferenceId/_layout': typeof AuthConferenceConferenceConferenceIdLayoutRouteWithChildren
  '/_auth/evaluation/_layout/$evaluationId': typeof AuthEvaluationLayoutEvaluationIdRouteWithChildren
  '/_auth/evaluation/_layout/$evaluationId/_layout': typeof AuthEvaluationLayoutEvaluationIdLayoutRouteWithChildren
  '/_auth/evaluation/_layout/$evaluationId/department-summary-results': typeof AuthEvaluationLayoutEvaluationIdDepartmentSummaryResultsRoute
  '/_auth/evaluation/_layout/$evaluationId/faculty-summary-results': typeof AuthEvaluationLayoutEvaluationIdFacultySummaryResultsRoute
  '/_auth/gov-evaluation/_layout/$evaluationId': typeof AuthGovEvaluationLayoutEvaluationIdRouteWithChildren
  '/_auth/gov-evaluation/_layout/$evaluationId/_layout': typeof AuthGovEvaluationLayoutEvaluationIdLayoutRouteWithChildren
  '/_auth/journal/_journal/$journalId': typeof AuthJournalJournalJournalIdRouteWithChildren
  '/_auth/journal/_journal/$journalId/_layout': typeof AuthJournalJournalJournalIdLayoutRouteWithChildren
  '/_auth/publisher/_publisher/$publisherId': typeof AuthPublisherPublisherPublisherIdRouteWithChildren
  '/_auth/publisher/_publisher/$publisherId/_layout': typeof AuthPublisherPublisherPublisherIdLayoutRouteWithChildren
  '/_auth/research-center/_research-center/$researchCenterId': typeof AuthResearchCenterResearchCenterResearchCenterIdRouteWithChildren
  '/_auth/research-center/_research-center/$researchCenterId/_layout': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutRouteWithChildren
  '/_auth/research-perf-eval/_layout/$evaluationId': typeof AuthResearchPerfEvalLayoutEvaluationIdRouteWithChildren
  '/_auth/research-perf-eval/_layout/$evaluationId/_layout': typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutRouteWithChildren
  '/_auth/travel/_travel/requests/create': typeof AuthTravelTravelRequestsCreateRoute
  '/_auth/travel/_travel/analytics/': typeof AuthTravelTravelAnalyticsIndexRoute
  '/_auth/travel/_travel/approvals/': typeof AuthTravelTravelApprovalsIndexRoute
  '/_auth/travel/_travel/board-requests/': typeof AuthTravelTravelBoardRequestsIndexRoute
  '/_auth/travel/_travel/days/': typeof AuthTravelTravelDaysIndexRoute
  '/_auth/travel/_travel/documents/': typeof AuthTravelTravelDocumentsIndexRoute
  '/_auth/travel/_travel/registry/': typeof AuthTravelTravelRegistryIndexRoute
  '/_auth/travel/_travel/requests/': typeof AuthTravelTravelRequestsIndexRoute
  '/_auth/travel/_travel/settings/': typeof AuthTravelTravelSettingsIndexRoute
  '/_auth/administration/_administration/department/_department/create': typeof AuthAdministrationAdministrationDepartmentDepartmentCreateRoute
  '/_auth/administration/_administration/discipline/_discipline/create': typeof AuthAdministrationAdministrationDisciplineDisciplineCreateRoute
  '/_auth/administration/_administration/faculty/_faculty/create': typeof AuthAdministrationAdministrationFacultyFacultyCreateRoute
  '/_auth/author/_author/abstract/_abstract/create': typeof AuthAuthorAuthorAbstractAbstractCreateRoute
  '/_auth/author/_author/abstract/_abstract/search-claimable': typeof AuthAuthorAuthorAbstractAbstractSearchClaimableRoute
  '/_auth/author/_author/article/_article/create': typeof AuthAuthorAuthorArticleArticleCreateRoute
  '/_auth/author/_author/article/_article/search-claimable': typeof AuthAuthorAuthorArticleArticleSearchClaimableRoute
  '/_auth/author/_author/award/_award/create': typeof AuthAuthorAuthorAwardAwardCreateRoute
  '/_auth/author/_author/book/_book/create': typeof AuthAuthorAuthorBookBookCreateRoute
  '/_auth/author/_author/book/_book/search-claimable': typeof AuthAuthorAuthorBookBookSearchClaimableRoute
  '/_auth/author/_author/chapter/_chapter/create': typeof AuthAuthorAuthorChapterChapterCreateRoute
  '/_auth/author/_author/chapter/_chapter/search-claimable': typeof AuthAuthorAuthorChapterChapterSearchClaimableRoute
  '/_auth/author/_author/committee/_committee/create': typeof AuthAuthorAuthorCommitteeCommitteeCreateRoute
  '/_auth/author/_author/course/_course/create': typeof AuthAuthorAuthorCourseCourseCreateRoute
  '/_auth/author/_author/dictionary/_dictionary/create': typeof AuthAuthorAuthorDictionaryDictionaryCreateRoute
  '/_auth/author/_author/doctoral-committee/_doctoralCommittee/create': typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeCreateRoute
  '/_auth/author/_author/editorial-team/_editorialTeam/create': typeof AuthAuthorAuthorEditorialTeamEditorialTeamCreateRoute
  '/_auth/author/_author/mobility/_mobility/create': typeof AuthAuthorAuthorMobilityMobilityCreateRoute
  '/_auth/author/_author/patent/_patent/create': typeof AuthAuthorAuthorPatentPatentCreateRoute
  '/_auth/author/_author/patent/_patent/search-claimable': typeof AuthAuthorAuthorPatentPatentSearchClaimableRoute
  '/_auth/author/_author/presentation/_presentation/create': typeof AuthAuthorAuthorPresentationPresentationCreateRoute
  '/_auth/author/_author/proceeding/_proceeding/create': typeof AuthAuthorAuthorProceedingProceedingCreateRoute
  '/_auth/author/_author/proceeding/_proceeding/search-claimable': typeof AuthAuthorAuthorProceedingProceedingSearchClaimableRoute
  '/_auth/author/_author/project/_project/create': typeof AuthAuthorAuthorProjectProjectCreateRoute
  '/_auth/author/_author/project/_project/search-claimable': typeof AuthAuthorAuthorProjectProjectSearchClaimableRoute
  '/_auth/author/_author/review/_review/create': typeof AuthAuthorAuthorReviewReviewCreateRoute
  '/_auth/author/_author/review/_review/search-claimable': typeof AuthAuthorAuthorReviewReviewSearchClaimableRoute
  '/_auth/author/_author/technological-transfer/_technologicalTransfer/create': typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferCreateRoute
  '/_auth/author/_author/technological-transfer/_technologicalTransfer/search-claimable': typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferSearchClaimableRoute
  '/_auth/author/_author/translation/_translation/create': typeof AuthAuthorAuthorTranslationTranslationCreateRoute
  '/_auth/author/_author/translation/_translation/search-claimable': typeof AuthAuthorAuthorTranslationTranslationSearchClaimableRoute
  '/_auth/conference/_conference/$conferenceId/_layout/edit': typeof AuthConferenceConferenceConferenceIdLayoutEditRoute
  '/_auth/journal/_journal/$journalId/_layout/article-influence-score': typeof AuthJournalJournalJournalIdLayoutArticleInfluenceScoreRoute
  '/_auth/journal/_journal/$journalId/_layout/edit': typeof AuthJournalJournalJournalIdLayoutEditRoute
  '/_auth/journal/_journal/$journalId/_layout/impact-factor': typeof AuthJournalJournalJournalIdLayoutImpactFactorRoute
  '/_auth/minimal-standards/_layout/report/gather': typeof AuthMinimalStandardsLayoutReportGatherRouteWithChildren
  '/_auth/minimal-standards/_layout/report/gather/_gather': typeof AuthMinimalStandardsLayoutReportGatherGatherRouteWithChildren
  '/_auth/publisher/_publisher/$publisherId/_layout/edit': typeof AuthPublisherPublisherPublisherIdLayoutEditRoute
  '/_auth/research-center/_research-center/$researchCenterId/_layout/create': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutCreateRoute
  '/_auth/research-center/_research-center/$researchCenterId/_layout/edit': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutEditRoute
  '/_auth/travel/_travel/requests/$requestId': typeof AuthTravelTravelRequestsRequestIdRouteWithChildren
  '/_auth/travel/_travel/requests/$requestId/_layout': typeof AuthTravelTravelRequestsRequestIdLayoutRouteWithChildren
  '/_auth/administration/_administration/department/_department/': typeof AuthAdministrationAdministrationDepartmentDepartmentIndexRoute
  '/_auth/administration/_administration/discipline/_discipline/': typeof AuthAdministrationAdministrationDisciplineDisciplineIndexRoute
  '/_auth/administration/_administration/faculty/_faculty/': typeof AuthAdministrationAdministrationFacultyFacultyIndexRoute
  '/_auth/administration/_administration/legal-holiday/_legal-holiday/': typeof AuthAdministrationAdministrationLegalHolidayLegalHolidayIndexRoute
  '/_auth/administration/_administration/local-accounts/_local-accounts/': typeof AuthAdministrationAdministrationLocalAccountsLocalAccountsIndexRoute
  '/_auth/administration/_administration/university-config/_university-config/': typeof AuthAdministrationAdministrationUniversityConfigUniversityConfigIndexRoute
  '/_auth/administration/_administration/user-documents/_user-documents/': typeof AuthAdministrationAdministrationUserDocumentsUserDocumentsIndexRoute
  '/_auth/author/_author/abstract/_abstract/': typeof AuthAuthorAuthorAbstractAbstractIndexRoute
  '/_auth/author/_author/article/_article/': typeof AuthAuthorAuthorArticleArticleIndexRoute
  '/_auth/author/_author/award/_award/': typeof AuthAuthorAuthorAwardAwardIndexRoute
  '/_auth/author/_author/book/_book/': typeof AuthAuthorAuthorBookBookIndexRoute
  '/_auth/author/_author/chapter/_chapter/': typeof AuthAuthorAuthorChapterChapterIndexRoute
  '/_auth/author/_author/committee/_committee/': typeof AuthAuthorAuthorCommitteeCommitteeIndexRoute
  '/_auth/author/_author/course/_course/': typeof AuthAuthorAuthorCourseCourseIndexRoute
  '/_auth/author/_author/dictionary/_dictionary/': typeof AuthAuthorAuthorDictionaryDictionaryIndexRoute
  '/_auth/author/_author/doctoral-committee/_doctoralCommittee/': typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeIndexRoute
  '/_auth/author/_author/editorial-team/_editorialTeam/': typeof AuthAuthorAuthorEditorialTeamEditorialTeamIndexRoute
  '/_auth/author/_author/mobility/_mobility/': typeof AuthAuthorAuthorMobilityMobilityIndexRoute
  '/_auth/author/_author/patent/_patent/': typeof AuthAuthorAuthorPatentPatentIndexRoute
  '/_auth/author/_author/presentation/_presentation/': typeof AuthAuthorAuthorPresentationPresentationIndexRoute
  '/_auth/author/_author/proceeding/_proceeding/': typeof AuthAuthorAuthorProceedingProceedingIndexRoute
  '/_auth/author/_author/project/_project/': typeof AuthAuthorAuthorProjectProjectIndexRoute
  '/_auth/author/_author/review/_review/': typeof AuthAuthorAuthorReviewReviewIndexRoute
  '/_auth/author/_author/technological-transfer/_technologicalTransfer/': typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferIndexRoute
  '/_auth/author/_author/translation/_translation/': typeof AuthAuthorAuthorTranslationTranslationIndexRoute
  '/_auth/conference/_conference/$conferenceId/_layout/': typeof AuthConferenceConferenceConferenceIdLayoutIndexRoute
  '/_auth/evaluation/_layout/$evaluationId/_layout/': typeof AuthEvaluationLayoutEvaluationIdLayoutIndexRoute
  '/_auth/gov-evaluation/_layout/$evaluationId/_layout/': typeof AuthGovEvaluationLayoutEvaluationIdLayoutIndexRoute
  '/_auth/journal/_journal/$journalId/_layout/': typeof AuthJournalJournalJournalIdLayoutIndexRoute
  '/_auth/publisher/_publisher/$publisherId/_layout/': typeof AuthPublisherPublisherPublisherIdLayoutIndexRoute
  '/_auth/research-center/_research-center/$researchCenterId/_layout/': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutIndexRoute
  '/_auth/research-perf-eval/_layout/$evaluationId/_layout/': typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutIndexRoute
  '/_auth/administration/_administration/department/_department/$departmentId': typeof AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdRouteWithChildren
  '/_auth/administration/_administration/department/_department/$departmentId/_layout': typeof AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutRouteWithChildren
  '/_auth/administration/_administration/discipline/_discipline/$disciplineId': typeof AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdRouteWithChildren
  '/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout': typeof AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutRouteWithChildren
  '/_auth/administration/_administration/faculty/_faculty/$facultyId': typeof AuthAdministrationAdministrationFacultyFacultyFacultyIdRouteWithChildren
  '/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout': typeof AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutRouteWithChildren
  '/_auth/author/_author/abstract/_abstract/$abstractId': typeof AuthAuthorAuthorAbstractAbstractAbstractIdRouteWithChildren
  '/_auth/author/_author/abstract/_abstract/$abstractId/_layout': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutRouteWithChildren
  '/_auth/author/_author/article/_article/$articleId': typeof AuthAuthorAuthorArticleArticleArticleIdRouteWithChildren
  '/_auth/author/_author/article/_article/$articleId/_layout': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutRouteWithChildren
  '/_auth/author/_author/award/_award/$awardId': typeof AuthAuthorAuthorAwardAwardAwardIdRouteWithChildren
  '/_auth/author/_author/award/_award/$awardId/_layout': typeof AuthAuthorAuthorAwardAwardAwardIdLayoutRouteWithChildren
  '/_auth/author/_author/book/_book/$bookId': typeof AuthAuthorAuthorBookBookBookIdRouteWithChildren
  '/_auth/author/_author/book/_book/$bookId/_layout': typeof AuthAuthorAuthorBookBookBookIdLayoutRouteWithChildren
  '/_auth/author/_author/chapter/_chapter/$chapterId': typeof AuthAuthorAuthorChapterChapterChapterIdRouteWithChildren
  '/_auth/author/_author/chapter/_chapter/$chapterId/_layout': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutRouteWithChildren
  '/_auth/author/_author/committee/_committee/$committeeId': typeof AuthAuthorAuthorCommitteeCommitteeCommitteeIdRouteWithChildren
  '/_auth/author/_author/committee/_committee/$committeeId/_layout': typeof AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutRouteWithChildren
  '/_auth/author/_author/course/_course/$courseId': typeof AuthAuthorAuthorCourseCourseCourseIdRouteWithChildren
  '/_auth/author/_author/course/_course/$courseId/_layout': typeof AuthAuthorAuthorCourseCourseCourseIdLayoutRouteWithChildren
  '/_auth/author/_author/dictionary/_dictionary/$dictionaryId': typeof AuthAuthorAuthorDictionaryDictionaryDictionaryIdRouteWithChildren
  '/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout': typeof AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutRouteWithChildren
  '/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId': typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdRouteWithChildren
  '/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout': typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutRouteWithChildren
  '/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId': typeof AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdRouteWithChildren
  '/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout': typeof AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutRouteWithChildren
  '/_auth/author/_author/mobility/_mobility/$mobilityId': typeof AuthAuthorAuthorMobilityMobilityMobilityIdRouteWithChildren
  '/_auth/author/_author/mobility/_mobility/$mobilityId/_layout': typeof AuthAuthorAuthorMobilityMobilityMobilityIdLayoutRouteWithChildren
  '/_auth/author/_author/patent/_patent/$patentId': typeof AuthAuthorAuthorPatentPatentPatentIdRouteWithChildren
  '/_auth/author/_author/patent/_patent/$patentId/_layout': typeof AuthAuthorAuthorPatentPatentPatentIdLayoutRouteWithChildren
  '/_auth/author/_author/presentation/_presentation/$presentationId': typeof AuthAuthorAuthorPresentationPresentationPresentationIdRouteWithChildren
  '/_auth/author/_author/presentation/_presentation/$presentationId/_layout': typeof AuthAuthorAuthorPresentationPresentationPresentationIdLayoutRouteWithChildren
  '/_auth/author/_author/proceeding/_proceeding/$proceedingId': typeof AuthAuthorAuthorProceedingProceedingProceedingIdRouteWithChildren
  '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutRouteWithChildren
  '/_auth/author/_author/project/_project/$projectId': typeof AuthAuthorAuthorProjectProjectProjectIdRouteWithChildren
  '/_auth/author/_author/project/_project/$projectId/_layout': typeof AuthAuthorAuthorProjectProjectProjectIdLayoutRouteWithChildren
  '/_auth/author/_author/review/_review/$reviewId': typeof AuthAuthorAuthorReviewReviewReviewIdRouteWithChildren
  '/_auth/author/_author/review/_review/$reviewId/_layout': typeof AuthAuthorAuthorReviewReviewReviewIdLayoutRouteWithChildren
  '/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId': typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdRouteWithChildren
  '/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout': typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutRouteWithChildren
  '/_auth/author/_author/translation/_translation/$translationId': typeof AuthAuthorAuthorTranslationTranslationTranslationIdRouteWithChildren
  '/_auth/author/_author/translation/_translation/$translationId/_layout': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutRouteWithChildren
  '/_auth/research-center/_research-center/$researchCenterId/_layout/lab': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabRouteWithChildren
  '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutRouteWithChildren
  '/_auth/travel/_travel/requests/$requestId/_layout/edit': typeof AuthTravelTravelRequestsRequestIdLayoutEditRoute
  '/_auth/minimal-standards/_layout/report/gather/_gather/': typeof AuthMinimalStandardsLayoutReportGatherGatherIndexRoute
  '/_auth/travel/_travel/requests/$requestId/_layout/': typeof AuthTravelTravelRequestsRequestIdLayoutIndexRoute
  '/_auth/administration/_administration/department/_department/$departmentId/_layout/edit': typeof AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutEditRoute
  '/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout/edit': typeof AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutEditRoute
  '/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout/edit': typeof AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutEditRoute
  '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/edit': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutEditRoute
  '/_auth/author/_author/article/_article/$articleId/_layout/edit': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutEditRoute
  '/_auth/author/_author/award/_award/$awardId/_layout/edit': typeof AuthAuthorAuthorAwardAwardAwardIdLayoutEditRoute
  '/_auth/author/_author/book/_book/$bookId/_layout/edit': typeof AuthAuthorAuthorBookBookBookIdLayoutEditRoute
  '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/edit': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutEditRoute
  '/_auth/author/_author/committee/_committee/$committeeId/_layout/edit': typeof AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutEditRoute
  '/_auth/author/_author/course/_course/$courseId/_layout/edit': typeof AuthAuthorAuthorCourseCourseCourseIdLayoutEditRoute
  '/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout/edit': typeof AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutEditRoute
  '/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout/edit': typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutEditRoute
  '/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout/edit': typeof AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutEditRoute
  '/_auth/author/_author/mobility/_mobility/$mobilityId/_layout/edit': typeof AuthAuthorAuthorMobilityMobilityMobilityIdLayoutEditRoute
  '/_auth/author/_author/patent/_patent/$patentId/_layout/edit': typeof AuthAuthorAuthorPatentPatentPatentIdLayoutEditRoute
  '/_auth/author/_author/presentation/_presentation/$presentationId/_layout/edit': typeof AuthAuthorAuthorPresentationPresentationPresentationIdLayoutEditRoute
  '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/edit': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutEditRoute
  '/_auth/author/_author/project/_project/$projectId/_layout/edit': typeof AuthAuthorAuthorProjectProjectProjectIdLayoutEditRoute
  '/_auth/author/_author/review/_review/$reviewId/_layout/edit': typeof AuthAuthorAuthorReviewReviewReviewIdLayoutEditRoute
  '/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout/edit': typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutEditRoute
  '/_auth/author/_author/translation/_translation/$translationId/_layout/edit': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutEditRoute
  '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather': typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherRouteWithChildren
  '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather': typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherRouteWithChildren
  '/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode': typeof AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeRouteWithChildren
  '/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode/_layout': typeof AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutRouteWithChildren
  '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather': typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherRouteWithChildren
  '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather': typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherRouteWithChildren
  '/_auth/administration/_administration/department/_department/$departmentId/_layout/': typeof AuthAdministrationAdministrationDepartmentDepartmentDepartmentIdLayoutIndexRoute
  '/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout/': typeof AuthAdministrationAdministrationDisciplineDisciplineDisciplineIdLayoutIndexRoute
  '/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout/': typeof AuthAdministrationAdministrationFacultyFacultyFacultyIdLayoutIndexRoute
  '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutIndexRoute
  '/_auth/author/_author/article/_article/$articleId/_layout/': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutIndexRoute
  '/_auth/author/_author/award/_award/$awardId/_layout/': typeof AuthAuthorAuthorAwardAwardAwardIdLayoutIndexRoute
  '/_auth/author/_author/book/_book/$bookId/_layout/': typeof AuthAuthorAuthorBookBookBookIdLayoutIndexRoute
  '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutIndexRoute
  '/_auth/author/_author/committee/_committee/$committeeId/_layout/': typeof AuthAuthorAuthorCommitteeCommitteeCommitteeIdLayoutIndexRoute
  '/_auth/author/_author/course/_course/$courseId/_layout/': typeof AuthAuthorAuthorCourseCourseCourseIdLayoutIndexRoute
  '/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout/': typeof AuthAuthorAuthorDictionaryDictionaryDictionaryIdLayoutIndexRoute
  '/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout/': typeof AuthAuthorAuthorDoctoralCommitteeDoctoralCommitteeDoctoralCommitteeIdLayoutIndexRoute
  '/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout/': typeof AuthAuthorAuthorEditorialTeamEditorialTeamEditorialTeamIdLayoutIndexRoute
  '/_auth/author/_author/mobility/_mobility/$mobilityId/_layout/': typeof AuthAuthorAuthorMobilityMobilityMobilityIdLayoutIndexRoute
  '/_auth/author/_author/patent/_patent/$patentId/_layout/': typeof AuthAuthorAuthorPatentPatentPatentIdLayoutIndexRoute
  '/_auth/author/_author/presentation/_presentation/$presentationId/_layout/': typeof AuthAuthorAuthorPresentationPresentationPresentationIdLayoutIndexRoute
  '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutIndexRoute
  '/_auth/author/_author/project/_project/$projectId/_layout/': typeof AuthAuthorAuthorProjectProjectProjectIdLayoutIndexRoute
  '/_auth/author/_author/review/_review/$reviewId/_layout/': typeof AuthAuthorAuthorReviewReviewReviewIdLayoutIndexRoute
  '/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout/': typeof AuthAuthorAuthorTechnologicalTransferTechnologicalTransferTechnologicalTransferIdLayoutIndexRoute
  '/_auth/author/_author/translation/_translation/$translationId/_layout/': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutIndexRoute
  '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutIndexRoute
  '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/create': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCreateRoute
  '/_auth/author/_author/article/_article/$articleId/_layout/citations/create': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCreateRoute
  '/_auth/author/_author/book/_book/$bookId/_layout/citations/create': typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCreateRoute
  '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/create': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCreateRoute
  '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/create': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCreateRoute
  '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/create': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCreateRoute
  '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdRouteWithChildren
  '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutRouteWithChildren
  '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsIndexRoute
  '/_auth/author/_author/article/_article/$articleId/_layout/citations/': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsIndexRoute
  '/_auth/author/_author/book/_book/$bookId/_layout/citations/': typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsIndexRoute
  '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsIndexRoute
  '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsIndexRoute
  '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsIndexRoute
  '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/': typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherIndexRoute
  '/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode/_layout/': typeof AuthMinimalStandardsLayoutReportGatherGatherIndicatorCodeLayoutIndexRoute
  '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/': typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherIndexRoute
  '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdRouteWithChildren
  '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutRouteWithChildren
  '/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdRouteWithChildren
  '/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutRouteWithChildren
  '/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId': typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdRouteWithChildren
  '/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout': typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutRouteWithChildren
  '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdRouteWithChildren
  '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutRouteWithChildren
  '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdRouteWithChildren
  '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutRouteWithChildren
  '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdRouteWithChildren
  '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutRouteWithChildren
  '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo': typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoRouteWithChildren
  '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout': typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRouteWithChildren
  '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout/edit': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutEditRoute
  '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo': typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoRouteWithChildren
  '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout': typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutRouteWithChildren
  '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout/': typeof AuthResearchCenterResearchCenterResearchCenterIdLayoutLabLayoutLabIdLayoutIndexRoute
  '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout/edit': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutEditRoute
  '/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout/edit': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutEditRoute
  '/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout/edit': typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutEditRoute
  '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout/edit': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutEditRoute
  '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout/edit': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutEditRoute
  '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout/edit': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutEditRoute
  '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout/': typeof AuthAuthorAuthorAbstractAbstractAbstractIdLayoutCitationsCitationIdLayoutIndexRoute
  '/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout/': typeof AuthAuthorAuthorArticleArticleArticleIdLayoutCitationsCitationIdLayoutIndexRoute
  '/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout/': typeof AuthAuthorAuthorBookBookBookIdLayoutCitationsCitationIdLayoutIndexRoute
  '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout/': typeof AuthAuthorAuthorChapterChapterChapterIdLayoutCitationsCitationIdLayoutIndexRoute
  '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout/': typeof AuthAuthorAuthorProceedingProceedingProceedingIdLayoutCitationsCitationIdLayoutIndexRoute
  '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout/': typeof AuthAuthorAuthorTranslationTranslationTranslationIdLayoutCitationsCitationIdLayoutIndexRoute
  '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout/': typeof AuthEvaluationLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexRoute
  '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout/': typeof AuthResearchPerfEvalLayoutEvaluationIdLayoutReportGatherGatherOrderNoLayoutIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/change-password'
    | '/login'
    | '/sync-bibtex'
    | '/sync-scopus'
    | '/'
    | '/administration'
    | '/author'
    | '/conference'
    | '/evaluation'
    | '/gov-evaluation'
    | '/journal'
    | '/minimal-standards'
    | '/publisher'
    | '/report'
    | '/research-center'
    | '/research-perf-eval'
    | '/travel'
    | '/author/wos-isi-report'
    | '/conference/create'
    | '/journal/create'
    | '/publisher/create'
    | '/report/analytics'
    | '/research-center/create'
    | '/administration/'
    | '/author/'
    | '/conference/'
    | '/evaluation/'
    | '/gov-evaluation/'
    | '/journal/'
    | '/minimal-standards/'
    | '/publisher/'
    | '/report/'
    | '/research-center/'
    | '/research-perf-eval/'
    | '/travel/'
    | '/administration/department'
    | '/administration/discipline'
    | '/administration/faculty'
    | '/administration/legal-holiday'
    | '/administration/local-accounts'
    | '/administration/university-config'
    | '/administration/user-documents'
    | '/author/abstract'
    | '/author/article'
    | '/author/award'
    | '/author/book'
    | '/author/chapter'
    | '/author/committee'
    | '/author/course'
    | '/author/dictionary'
    | '/author/doctoral-committee'
    | '/author/editorial-team'
    | '/author/mobility'
    | '/author/patent'
    | '/author/presentation'
    | '/author/proceeding'
    | '/author/project'
    | '/author/review'
    | '/author/technological-transfer'
    | '/author/translation'
    | '/conference/$conferenceId'
    | '/evaluation/$evaluationId'
    | '/evaluation/$evaluationId/department-summary-results'
    | '/evaluation/$evaluationId/faculty-summary-results'
    | '/gov-evaluation/$evaluationId'
    | '/journal/$journalId'
    | '/publisher/$publisherId'
    | '/research-center/$researchCenterId'
    | '/research-perf-eval/$evaluationId'
    | '/travel/requests/create'
    | '/travel/analytics'
    | '/travel/approvals'
    | '/travel/board-requests'
    | '/travel/days'
    | '/travel/documents'
    | '/travel/registry'
    | '/travel/requests'
    | '/travel/settings'
    | '/administration/department/create'
    | '/administration/discipline/create'
    | '/administration/faculty/create'
    | '/author/abstract/create'
    | '/author/abstract/search-claimable'
    | '/author/article/create'
    | '/author/article/search-claimable'
    | '/author/award/create'
    | '/author/book/create'
    | '/author/book/search-claimable'
    | '/author/chapter/create'
    | '/author/chapter/search-claimable'
    | '/author/committee/create'
    | '/author/course/create'
    | '/author/dictionary/create'
    | '/author/doctoral-committee/create'
    | '/author/editorial-team/create'
    | '/author/mobility/create'
    | '/author/patent/create'
    | '/author/patent/search-claimable'
    | '/author/presentation/create'
    | '/author/proceeding/create'
    | '/author/proceeding/search-claimable'
    | '/author/project/create'
    | '/author/project/search-claimable'
    | '/author/review/create'
    | '/author/review/search-claimable'
    | '/author/technological-transfer/create'
    | '/author/technological-transfer/search-claimable'
    | '/author/translation/create'
    | '/author/translation/search-claimable'
    | '/conference/$conferenceId/edit'
    | '/journal/$journalId/article-influence-score'
    | '/journal/$journalId/edit'
    | '/journal/$journalId/impact-factor'
    | '/minimal-standards/report/gather'
    | '/publisher/$publisherId/edit'
    | '/research-center/$researchCenterId/create'
    | '/research-center/$researchCenterId/edit'
    | '/travel/requests/$requestId'
    | '/administration/department/'
    | '/administration/discipline/'
    | '/administration/faculty/'
    | '/administration/legal-holiday/'
    | '/administration/local-accounts/'
    | '/administration/university-config/'
    | '/administration/user-documents/'
    | '/author/abstract/'
    | '/author/article/'
    | '/author/award/'
    | '/author/book/'
    | '/author/chapter/'
    | '/author/committee/'
    | '/author/course/'
    | '/author/dictionary/'
    | '/author/doctoral-committee/'
    | '/author/editorial-team/'
    | '/author/mobility/'
    | '/author/patent/'
    | '/author/presentation/'
    | '/author/proceeding/'
    | '/author/project/'
    | '/author/review/'
    | '/author/technological-transfer/'
    | '/author/translation/'
    | '/conference/$conferenceId/'
    | '/evaluation/$evaluationId/'
    | '/gov-evaluation/$evaluationId/'
    | '/journal/$journalId/'
    | '/publisher/$publisherId/'
    | '/research-center/$researchCenterId/'
    | '/research-perf-eval/$evaluationId/'
    | '/administration/department/$departmentId'
    | '/administration/discipline/$disciplineId'
    | '/administration/faculty/$facultyId'
    | '/author/abstract/$abstractId'
    | '/author/article/$articleId'
    | '/author/award/$awardId'
    | '/author/book/$bookId'
    | '/author/chapter/$chapterId'
    | '/author/committee/$committeeId'
    | '/author/course/$courseId'
    | '/author/dictionary/$dictionaryId'
    | '/author/doctoral-committee/$doctoralCommitteeId'
    | '/author/editorial-team/$editorialTeamId'
    | '/author/mobility/$mobilityId'
    | '/author/patent/$patentId'
    | '/author/presentation/$presentationId'
    | '/author/proceeding/$proceedingId'
    | '/author/project/$projectId'
    | '/author/review/$reviewId'
    | '/author/technological-transfer/$technologicalTransferId'
    | '/author/translation/$translationId'
    | '/research-center/$researchCenterId/lab'
    | '/travel/requests/$requestId/edit'
    | '/minimal-standards/report/gather/'
    | '/travel/requests/$requestId/'
    | '/administration/department/$departmentId/edit'
    | '/administration/discipline/$disciplineId/edit'
    | '/administration/faculty/$facultyId/edit'
    | '/author/abstract/$abstractId/edit'
    | '/author/article/$articleId/edit'
    | '/author/award/$awardId/edit'
    | '/author/book/$bookId/edit'
    | '/author/chapter/$chapterId/edit'
    | '/author/committee/$committeeId/edit'
    | '/author/course/$courseId/edit'
    | '/author/dictionary/$dictionaryId/edit'
    | '/author/doctoral-committee/$doctoralCommitteeId/edit'
    | '/author/editorial-team/$editorialTeamId/edit'
    | '/author/mobility/$mobilityId/edit'
    | '/author/patent/$patentId/edit'
    | '/author/presentation/$presentationId/edit'
    | '/author/proceeding/$proceedingId/edit'
    | '/author/project/$projectId/edit'
    | '/author/review/$reviewId/edit'
    | '/author/technological-transfer/$technologicalTransferId/edit'
    | '/author/translation/$translationId/edit'
    | '/evaluation/$evaluationId/report/gather'
    | '/minimal-standards/report/gather/$indicatorCode'
    | '/research-perf-eval/$evaluationId/report/gather'
    | '/administration/department/$departmentId/'
    | '/administration/discipline/$disciplineId/'
    | '/administration/faculty/$facultyId/'
    | '/author/abstract/$abstractId/'
    | '/author/article/$articleId/'
    | '/author/award/$awardId/'
    | '/author/book/$bookId/'
    | '/author/chapter/$chapterId/'
    | '/author/committee/$committeeId/'
    | '/author/course/$courseId/'
    | '/author/dictionary/$dictionaryId/'
    | '/author/doctoral-committee/$doctoralCommitteeId/'
    | '/author/editorial-team/$editorialTeamId/'
    | '/author/mobility/$mobilityId/'
    | '/author/patent/$patentId/'
    | '/author/presentation/$presentationId/'
    | '/author/proceeding/$proceedingId/'
    | '/author/project/$projectId/'
    | '/author/review/$reviewId/'
    | '/author/technological-transfer/$technologicalTransferId/'
    | '/author/translation/$translationId/'
    | '/research-center/$researchCenterId/lab/'
    | '/author/abstract/$abstractId/citations/create'
    | '/author/article/$articleId/citations/create'
    | '/author/book/$bookId/citations/create'
    | '/author/chapter/$chapterId/citations/create'
    | '/author/proceeding/$proceedingId/citations/create'
    | '/author/translation/$translationId/citations/create'
    | '/research-center/$researchCenterId/lab/$labId'
    | '/author/abstract/$abstractId/citations'
    | '/author/article/$articleId/citations'
    | '/author/book/$bookId/citations'
    | '/author/chapter/$chapterId/citations'
    | '/author/proceeding/$proceedingId/citations'
    | '/author/translation/$translationId/citations'
    | '/evaluation/$evaluationId/report/gather/'
    | '/minimal-standards/report/gather/$indicatorCode/'
    | '/research-perf-eval/$evaluationId/report/gather/'
    | '/author/abstract/$abstractId/citations/$citationId'
    | '/author/article/$articleId/citations/$citationId'
    | '/author/book/$bookId/citations/$citationId'
    | '/author/chapter/$chapterId/citations/$citationId'
    | '/author/proceeding/$proceedingId/citations/$citationId'
    | '/author/translation/$translationId/citations/$citationId'
    | '/evaluation/$evaluationId/report/gather/$orderNo'
    | '/research-center/$researchCenterId/lab/$labId/edit'
    | '/research-perf-eval/$evaluationId/report/gather/$orderNo'
    | '/research-center/$researchCenterId/lab/$labId/'
    | '/author/abstract/$abstractId/citations/$citationId/edit'
    | '/author/article/$articleId/citations/$citationId/edit'
    | '/author/book/$bookId/citations/$citationId/edit'
    | '/author/chapter/$chapterId/citations/$citationId/edit'
    | '/author/proceeding/$proceedingId/citations/$citationId/edit'
    | '/author/translation/$translationId/citations/$citationId/edit'
    | '/author/abstract/$abstractId/citations/$citationId/'
    | '/author/article/$articleId/citations/$citationId/'
    | '/author/book/$bookId/citations/$citationId/'
    | '/author/chapter/$chapterId/citations/$citationId/'
    | '/author/proceeding/$proceedingId/citations/$citationId/'
    | '/author/translation/$translationId/citations/$citationId/'
    | '/evaluation/$evaluationId/report/gather/$orderNo/'
    | '/research-perf-eval/$evaluationId/report/gather/$orderNo/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/change-password'
    | '/login'
    | '/sync-bibtex'
    | '/sync-scopus'
    | '/'
    | '/administration'
    | '/author'
    | '/conference'
    | '/evaluation'
    | '/gov-evaluation'
    | '/journal'
    | '/minimal-standards'
    | '/publisher'
    | '/report'
    | '/research-center'
    | '/research-perf-eval'
    | '/travel'
    | '/author/wos-isi-report'
    | '/conference/create'
    | '/journal/create'
    | '/publisher/create'
    | '/report/analytics'
    | '/research-center/create'
    | '/administration/department'
    | '/administration/discipline'
    | '/administration/faculty'
    | '/administration/legal-holiday'
    | '/administration/local-accounts'
    | '/administration/university-config'
    | '/administration/user-documents'
    | '/author/abstract'
    | '/author/article'
    | '/author/award'
    | '/author/book'
    | '/author/chapter'
    | '/author/committee'
    | '/author/course'
    | '/author/dictionary'
    | '/author/doctoral-committee'
    | '/author/editorial-team'
    | '/author/mobility'
    | '/author/patent'
    | '/author/presentation'
    | '/author/proceeding'
    | '/author/project'
    | '/author/review'
    | '/author/technological-transfer'
    | '/author/translation'
    | '/conference/$conferenceId'
    | '/evaluation/$evaluationId'
    | '/evaluation/$evaluationId/department-summary-results'
    | '/evaluation/$evaluationId/faculty-summary-results'
    | '/gov-evaluation/$evaluationId'
    | '/journal/$journalId'
    | '/publisher/$publisherId'
    | '/research-center/$researchCenterId'
    | '/research-perf-eval/$evaluationId'
    | '/travel/requests/create'
    | '/travel/analytics'
    | '/travel/approvals'
    | '/travel/board-requests'
    | '/travel/days'
    | '/travel/documents'
    | '/travel/registry'
    | '/travel/requests'
    | '/travel/settings'
    | '/administration/department/create'
    | '/administration/discipline/create'
    | '/administration/faculty/create'
    | '/author/abstract/create'
    | '/author/abstract/search-claimable'
    | '/author/article/create'
    | '/author/article/search-claimable'
    | '/author/award/create'
    | '/author/book/create'
    | '/author/book/search-claimable'
    | '/author/chapter/create'
    | '/author/chapter/search-claimable'
    | '/author/committee/create'
    | '/author/course/create'
    | '/author/dictionary/create'
    | '/author/doctoral-committee/create'
    | '/author/editorial-team/create'
    | '/author/mobility/create'
    | '/author/patent/create'
    | '/author/patent/search-claimable'
    | '/author/presentation/create'
    | '/author/proceeding/create'
    | '/author/proceeding/search-claimable'
    | '/author/project/create'
    | '/author/project/search-claimable'
    | '/author/review/create'
    | '/author/review/search-claimable'
    | '/author/technological-transfer/create'
    | '/author/technological-transfer/search-claimable'
    | '/author/translation/create'
    | '/author/translation/search-claimable'
    | '/conference/$conferenceId/edit'
    | '/journal/$journalId/article-influence-score'
    | '/journal/$journalId/edit'
    | '/journal/$journalId/impact-factor'
    | '/minimal-standards/report/gather'
    | '/publisher/$publisherId/edit'
    | '/research-center/$researchCenterId/create'
    | '/research-center/$researchCenterId/edit'
    | '/travel/requests/$requestId'
    | '/administration/department/$departmentId'
    | '/administration/discipline/$disciplineId'
    | '/administration/faculty/$facultyId'
    | '/author/abstract/$abstractId'
    | '/author/article/$articleId'
    | '/author/award/$awardId'
    | '/author/book/$bookId'
    | '/author/chapter/$chapterId'
    | '/author/committee/$committeeId'
    | '/author/course/$courseId'
    | '/author/dictionary/$dictionaryId'
    | '/author/doctoral-committee/$doctoralCommitteeId'
    | '/author/editorial-team/$editorialTeamId'
    | '/author/mobility/$mobilityId'
    | '/author/patent/$patentId'
    | '/author/presentation/$presentationId'
    | '/author/proceeding/$proceedingId'
    | '/author/project/$projectId'
    | '/author/review/$reviewId'
    | '/author/technological-transfer/$technologicalTransferId'
    | '/author/translation/$translationId'
    | '/research-center/$researchCenterId/lab'
    | '/travel/requests/$requestId/edit'
    | '/administration/department/$departmentId/edit'
    | '/administration/discipline/$disciplineId/edit'
    | '/administration/faculty/$facultyId/edit'
    | '/author/abstract/$abstractId/edit'
    | '/author/article/$articleId/edit'
    | '/author/award/$awardId/edit'
    | '/author/book/$bookId/edit'
    | '/author/chapter/$chapterId/edit'
    | '/author/committee/$committeeId/edit'
    | '/author/course/$courseId/edit'
    | '/author/dictionary/$dictionaryId/edit'
    | '/author/doctoral-committee/$doctoralCommitteeId/edit'
    | '/author/editorial-team/$editorialTeamId/edit'
    | '/author/mobility/$mobilityId/edit'
    | '/author/patent/$patentId/edit'
    | '/author/presentation/$presentationId/edit'
    | '/author/proceeding/$proceedingId/edit'
    | '/author/project/$projectId/edit'
    | '/author/review/$reviewId/edit'
    | '/author/technological-transfer/$technologicalTransferId/edit'
    | '/author/translation/$translationId/edit'
    | '/evaluation/$evaluationId/report/gather'
    | '/minimal-standards/report/gather/$indicatorCode'
    | '/research-perf-eval/$evaluationId/report/gather'
    | '/author/abstract/$abstractId/citations/create'
    | '/author/article/$articleId/citations/create'
    | '/author/book/$bookId/citations/create'
    | '/author/chapter/$chapterId/citations/create'
    | '/author/proceeding/$proceedingId/citations/create'
    | '/author/translation/$translationId/citations/create'
    | '/research-center/$researchCenterId/lab/$labId'
    | '/author/abstract/$abstractId/citations'
    | '/author/article/$articleId/citations'
    | '/author/book/$bookId/citations'
    | '/author/chapter/$chapterId/citations'
    | '/author/proceeding/$proceedingId/citations'
    | '/author/translation/$translationId/citations'
    | '/author/abstract/$abstractId/citations/$citationId'
    | '/author/article/$articleId/citations/$citationId'
    | '/author/book/$bookId/citations/$citationId'
    | '/author/chapter/$chapterId/citations/$citationId'
    | '/author/proceeding/$proceedingId/citations/$citationId'
    | '/author/translation/$translationId/citations/$citationId'
    | '/evaluation/$evaluationId/report/gather/$orderNo'
    | '/research-center/$researchCenterId/lab/$labId/edit'
    | '/research-perf-eval/$evaluationId/report/gather/$orderNo'
    | '/author/abstract/$abstractId/citations/$citationId/edit'
    | '/author/article/$articleId/citations/$citationId/edit'
    | '/author/book/$bookId/citations/$citationId/edit'
    | '/author/chapter/$chapterId/citations/$citationId/edit'
    | '/author/proceeding/$proceedingId/citations/$citationId/edit'
    | '/author/translation/$translationId/citations/$citationId/edit'
  id:
    | '__root__'
    | '/_auth'
    | '/change-password'
    | '/login'
    | '/_auth/sync-bibtex'
    | '/_auth/sync-scopus'
    | '/_auth/'
    | '/_auth/administration'
    | '/_auth/administration/_administration'
    | '/_auth/author'
    | '/_auth/author/_author'
    | '/_auth/conference'
    | '/_auth/conference/_conference'
    | '/_auth/evaluation'
    | '/_auth/evaluation/_layout'
    | '/_auth/gov-evaluation'
    | '/_auth/gov-evaluation/_layout'
    | '/_auth/journal'
    | '/_auth/journal/_journal'
    | '/_auth/minimal-standards'
    | '/_auth/minimal-standards/_layout'
    | '/_auth/publisher'
    | '/_auth/publisher/_publisher'
    | '/_auth/report'
    | '/_auth/report/_report'
    | '/_auth/research-center'
    | '/_auth/research-center/_research-center'
    | '/_auth/research-perf-eval'
    | '/_auth/research-perf-eval/_layout'
    | '/_auth/travel'
    | '/_auth/travel/_travel'
    | '/_auth/author/_author/wos-isi-report'
    | '/_auth/conference/_conference/create'
    | '/_auth/journal/_journal/create'
    | '/_auth/publisher/_publisher/create'
    | '/_auth/report/_report/analytics'
    | '/_auth/research-center/_research-center/create'
    | '/_auth/administration/_administration/'
    | '/_auth/author/_author/'
    | '/_auth/conference/_conference/'
    | '/_auth/evaluation/_layout/'
    | '/_auth/gov-evaluation/_layout/'
    | '/_auth/journal/_journal/'
    | '/_auth/minimal-standards/_layout/'
    | '/_auth/publisher/_publisher/'
    | '/_auth/report/_report/'
    | '/_auth/research-center/_research-center/'
    | '/_auth/research-perf-eval/_layout/'
    | '/_auth/travel/_travel/'
    | '/_auth/administration/_administration/department'
    | '/_auth/administration/_administration/department/_department'
    | '/_auth/administration/_administration/discipline'
    | '/_auth/administration/_administration/discipline/_discipline'
    | '/_auth/administration/_administration/faculty'
    | '/_auth/administration/_administration/faculty/_faculty'
    | '/_auth/administration/_administration/legal-holiday'
    | '/_auth/administration/_administration/legal-holiday/_legal-holiday'
    | '/_auth/administration/_administration/local-accounts'
    | '/_auth/administration/_administration/local-accounts/_local-accounts'
    | '/_auth/administration/_administration/university-config'
    | '/_auth/administration/_administration/university-config/_university-config'
    | '/_auth/administration/_administration/user-documents'
    | '/_auth/administration/_administration/user-documents/_user-documents'
    | '/_auth/author/_author/abstract'
    | '/_auth/author/_author/abstract/_abstract'
    | '/_auth/author/_author/article'
    | '/_auth/author/_author/article/_article'
    | '/_auth/author/_author/award'
    | '/_auth/author/_author/award/_award'
    | '/_auth/author/_author/book'
    | '/_auth/author/_author/book/_book'
    | '/_auth/author/_author/chapter'
    | '/_auth/author/_author/chapter/_chapter'
    | '/_auth/author/_author/committee'
    | '/_auth/author/_author/committee/_committee'
    | '/_auth/author/_author/course'
    | '/_auth/author/_author/course/_course'
    | '/_auth/author/_author/dictionary'
    | '/_auth/author/_author/dictionary/_dictionary'
    | '/_auth/author/_author/doctoral-committee'
    | '/_auth/author/_author/doctoral-committee/_doctoralCommittee'
    | '/_auth/author/_author/editorial-team'
    | '/_auth/author/_author/editorial-team/_editorialTeam'
    | '/_auth/author/_author/mobility'
    | '/_auth/author/_author/mobility/_mobility'
    | '/_auth/author/_author/patent'
    | '/_auth/author/_author/patent/_patent'
    | '/_auth/author/_author/presentation'
    | '/_auth/author/_author/presentation/_presentation'
    | '/_auth/author/_author/proceeding'
    | '/_auth/author/_author/proceeding/_proceeding'
    | '/_auth/author/_author/project'
    | '/_auth/author/_author/project/_project'
    | '/_auth/author/_author/review'
    | '/_auth/author/_author/review/_review'
    | '/_auth/author/_author/technological-transfer'
    | '/_auth/author/_author/technological-transfer/_technologicalTransfer'
    | '/_auth/author/_author/translation'
    | '/_auth/author/_author/translation/_translation'
    | '/_auth/conference/_conference/$conferenceId'
    | '/_auth/conference/_conference/$conferenceId/_layout'
    | '/_auth/evaluation/_layout/$evaluationId'
    | '/_auth/evaluation/_layout/$evaluationId/_layout'
    | '/_auth/evaluation/_layout/$evaluationId/department-summary-results'
    | '/_auth/evaluation/_layout/$evaluationId/faculty-summary-results'
    | '/_auth/gov-evaluation/_layout/$evaluationId'
    | '/_auth/gov-evaluation/_layout/$evaluationId/_layout'
    | '/_auth/journal/_journal/$journalId'
    | '/_auth/journal/_journal/$journalId/_layout'
    | '/_auth/publisher/_publisher/$publisherId'
    | '/_auth/publisher/_publisher/$publisherId/_layout'
    | '/_auth/research-center/_research-center/$researchCenterId'
    | '/_auth/research-center/_research-center/$researchCenterId/_layout'
    | '/_auth/research-perf-eval/_layout/$evaluationId'
    | '/_auth/research-perf-eval/_layout/$evaluationId/_layout'
    | '/_auth/travel/_travel/requests/create'
    | '/_auth/travel/_travel/analytics/'
    | '/_auth/travel/_travel/approvals/'
    | '/_auth/travel/_travel/board-requests/'
    | '/_auth/travel/_travel/days/'
    | '/_auth/travel/_travel/documents/'
    | '/_auth/travel/_travel/registry/'
    | '/_auth/travel/_travel/requests/'
    | '/_auth/travel/_travel/settings/'
    | '/_auth/administration/_administration/department/_department/create'
    | '/_auth/administration/_administration/discipline/_discipline/create'
    | '/_auth/administration/_administration/faculty/_faculty/create'
    | '/_auth/author/_author/abstract/_abstract/create'
    | '/_auth/author/_author/abstract/_abstract/search-claimable'
    | '/_auth/author/_author/article/_article/create'
    | '/_auth/author/_author/article/_article/search-claimable'
    | '/_auth/author/_author/award/_award/create'
    | '/_auth/author/_author/book/_book/create'
    | '/_auth/author/_author/book/_book/search-claimable'
    | '/_auth/author/_author/chapter/_chapter/create'
    | '/_auth/author/_author/chapter/_chapter/search-claimable'
    | '/_auth/author/_author/committee/_committee/create'
    | '/_auth/author/_author/course/_course/create'
    | '/_auth/author/_author/dictionary/_dictionary/create'
    | '/_auth/author/_author/doctoral-committee/_doctoralCommittee/create'
    | '/_auth/author/_author/editorial-team/_editorialTeam/create'
    | '/_auth/author/_author/mobility/_mobility/create'
    | '/_auth/author/_author/patent/_patent/create'
    | '/_auth/author/_author/patent/_patent/search-claimable'
    | '/_auth/author/_author/presentation/_presentation/create'
    | '/_auth/author/_author/proceeding/_proceeding/create'
    | '/_auth/author/_author/proceeding/_proceeding/search-claimable'
    | '/_auth/author/_author/project/_project/create'
    | '/_auth/author/_author/project/_project/search-claimable'
    | '/_auth/author/_author/review/_review/create'
    | '/_auth/author/_author/review/_review/search-claimable'
    | '/_auth/author/_author/technological-transfer/_technologicalTransfer/create'
    | '/_auth/author/_author/technological-transfer/_technologicalTransfer/search-claimable'
    | '/_auth/author/_author/translation/_translation/create'
    | '/_auth/author/_author/translation/_translation/search-claimable'
    | '/_auth/conference/_conference/$conferenceId/_layout/edit'
    | '/_auth/journal/_journal/$journalId/_layout/article-influence-score'
    | '/_auth/journal/_journal/$journalId/_layout/edit'
    | '/_auth/journal/_journal/$journalId/_layout/impact-factor'
    | '/_auth/minimal-standards/_layout/report/gather'
    | '/_auth/minimal-standards/_layout/report/gather/_gather'
    | '/_auth/publisher/_publisher/$publisherId/_layout/edit'
    | '/_auth/research-center/_research-center/$researchCenterId/_layout/create'
    | '/_auth/research-center/_research-center/$researchCenterId/_layout/edit'
    | '/_auth/travel/_travel/requests/$requestId'
    | '/_auth/travel/_travel/requests/$requestId/_layout'
    | '/_auth/administration/_administration/department/_department/'
    | '/_auth/administration/_administration/discipline/_discipline/'
    | '/_auth/administration/_administration/faculty/_faculty/'
    | '/_auth/administration/_administration/legal-holiday/_legal-holiday/'
    | '/_auth/administration/_administration/local-accounts/_local-accounts/'
    | '/_auth/administration/_administration/university-config/_university-config/'
    | '/_auth/administration/_administration/user-documents/_user-documents/'
    | '/_auth/author/_author/abstract/_abstract/'
    | '/_auth/author/_author/article/_article/'
    | '/_auth/author/_author/award/_award/'
    | '/_auth/author/_author/book/_book/'
    | '/_auth/author/_author/chapter/_chapter/'
    | '/_auth/author/_author/committee/_committee/'
    | '/_auth/author/_author/course/_course/'
    | '/_auth/author/_author/dictionary/_dictionary/'
    | '/_auth/author/_author/doctoral-committee/_doctoralCommittee/'
    | '/_auth/author/_author/editorial-team/_editorialTeam/'
    | '/_auth/author/_author/mobility/_mobility/'
    | '/_auth/author/_author/patent/_patent/'
    | '/_auth/author/_author/presentation/_presentation/'
    | '/_auth/author/_author/proceeding/_proceeding/'
    | '/_auth/author/_author/project/_project/'
    | '/_auth/author/_author/review/_review/'
    | '/_auth/author/_author/technological-transfer/_technologicalTransfer/'
    | '/_auth/author/_author/translation/_translation/'
    | '/_auth/conference/_conference/$conferenceId/_layout/'
    | '/_auth/evaluation/_layout/$evaluationId/_layout/'
    | '/_auth/gov-evaluation/_layout/$evaluationId/_layout/'
    | '/_auth/journal/_journal/$journalId/_layout/'
    | '/_auth/publisher/_publisher/$publisherId/_layout/'
    | '/_auth/research-center/_research-center/$researchCenterId/_layout/'
    | '/_auth/research-perf-eval/_layout/$evaluationId/_layout/'
    | '/_auth/administration/_administration/department/_department/$departmentId'
    | '/_auth/administration/_administration/department/_department/$departmentId/_layout'
    | '/_auth/administration/_administration/discipline/_discipline/$disciplineId'
    | '/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout'
    | '/_auth/administration/_administration/faculty/_faculty/$facultyId'
    | '/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout'
    | '/_auth/author/_author/abstract/_abstract/$abstractId'
    | '/_auth/author/_author/abstract/_abstract/$abstractId/_layout'
    | '/_auth/author/_author/article/_article/$articleId'
    | '/_auth/author/_author/article/_article/$articleId/_layout'
    | '/_auth/author/_author/award/_award/$awardId'
    | '/_auth/author/_author/award/_award/$awardId/_layout'
    | '/_auth/author/_author/book/_book/$bookId'
    | '/_auth/author/_author/book/_book/$bookId/_layout'
    | '/_auth/author/_author/chapter/_chapter/$chapterId'
    | '/_auth/author/_author/chapter/_chapter/$chapterId/_layout'
    | '/_auth/author/_author/committee/_committee/$committeeId'
    | '/_auth/author/_author/committee/_committee/$committeeId/_layout'
    | '/_auth/author/_author/course/_course/$courseId'
    | '/_auth/author/_author/course/_course/$courseId/_layout'
    | '/_auth/author/_author/dictionary/_dictionary/$dictionaryId'
    | '/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout'
    | '/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId'
    | '/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout'
    | '/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId'
    | '/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout'
    | '/_auth/author/_author/mobility/_mobility/$mobilityId'
    | '/_auth/author/_author/mobility/_mobility/$mobilityId/_layout'
    | '/_auth/author/_author/patent/_patent/$patentId'
    | '/_auth/author/_author/patent/_patent/$patentId/_layout'
    | '/_auth/author/_author/presentation/_presentation/$presentationId'
    | '/_auth/author/_author/presentation/_presentation/$presentationId/_layout'
    | '/_auth/author/_author/proceeding/_proceeding/$proceedingId'
    | '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout'
    | '/_auth/author/_author/project/_project/$projectId'
    | '/_auth/author/_author/project/_project/$projectId/_layout'
    | '/_auth/author/_author/review/_review/$reviewId'
    | '/_auth/author/_author/review/_review/$reviewId/_layout'
    | '/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId'
    | '/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout'
    | '/_auth/author/_author/translation/_translation/$translationId'
    | '/_auth/author/_author/translation/_translation/$translationId/_layout'
    | '/_auth/research-center/_research-center/$researchCenterId/_layout/lab'
    | '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout'
    | '/_auth/travel/_travel/requests/$requestId/_layout/edit'
    | '/_auth/minimal-standards/_layout/report/gather/_gather/'
    | '/_auth/travel/_travel/requests/$requestId/_layout/'
    | '/_auth/administration/_administration/department/_department/$departmentId/_layout/edit'
    | '/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout/edit'
    | '/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout/edit'
    | '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/edit'
    | '/_auth/author/_author/article/_article/$articleId/_layout/edit'
    | '/_auth/author/_author/award/_award/$awardId/_layout/edit'
    | '/_auth/author/_author/book/_book/$bookId/_layout/edit'
    | '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/edit'
    | '/_auth/author/_author/committee/_committee/$committeeId/_layout/edit'
    | '/_auth/author/_author/course/_course/$courseId/_layout/edit'
    | '/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout/edit'
    | '/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout/edit'
    | '/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout/edit'
    | '/_auth/author/_author/mobility/_mobility/$mobilityId/_layout/edit'
    | '/_auth/author/_author/patent/_patent/$patentId/_layout/edit'
    | '/_auth/author/_author/presentation/_presentation/$presentationId/_layout/edit'
    | '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/edit'
    | '/_auth/author/_author/project/_project/$projectId/_layout/edit'
    | '/_auth/author/_author/review/_review/$reviewId/_layout/edit'
    | '/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout/edit'
    | '/_auth/author/_author/translation/_translation/$translationId/_layout/edit'
    | '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather'
    | '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather'
    | '/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode'
    | '/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode/_layout'
    | '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather'
    | '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather'
    | '/_auth/administration/_administration/department/_department/$departmentId/_layout/'
    | '/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout/'
    | '/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout/'
    | '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/'
    | '/_auth/author/_author/article/_article/$articleId/_layout/'
    | '/_auth/author/_author/award/_award/$awardId/_layout/'
    | '/_auth/author/_author/book/_book/$bookId/_layout/'
    | '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/'
    | '/_auth/author/_author/committee/_committee/$committeeId/_layout/'
    | '/_auth/author/_author/course/_course/$courseId/_layout/'
    | '/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout/'
    | '/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout/'
    | '/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout/'
    | '/_auth/author/_author/mobility/_mobility/$mobilityId/_layout/'
    | '/_auth/author/_author/patent/_patent/$patentId/_layout/'
    | '/_auth/author/_author/presentation/_presentation/$presentationId/_layout/'
    | '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/'
    | '/_auth/author/_author/project/_project/$projectId/_layout/'
    | '/_auth/author/_author/review/_review/$reviewId/_layout/'
    | '/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout/'
    | '/_auth/author/_author/translation/_translation/$translationId/_layout/'
    | '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/'
    | '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/create'
    | '/_auth/author/_author/article/_article/$articleId/_layout/citations/create'
    | '/_auth/author/_author/book/_book/$bookId/_layout/citations/create'
    | '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/create'
    | '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/create'
    | '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/create'
    | '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId'
    | '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout'
    | '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/'
    | '/_auth/author/_author/article/_article/$articleId/_layout/citations/'
    | '/_auth/author/_author/book/_book/$bookId/_layout/citations/'
    | '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/'
    | '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/'
    | '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/'
    | '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/'
    | '/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode/_layout/'
    | '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/'
    | '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId'
    | '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout'
    | '/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId'
    | '/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout'
    | '/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId'
    | '/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout'
    | '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId'
    | '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout'
    | '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId'
    | '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout'
    | '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId'
    | '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout'
    | '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo'
    | '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout'
    | '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout/edit'
    | '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo'
    | '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout'
    | '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout/'
    | '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout/edit'
    | '/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout/edit'
    | '/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout/edit'
    | '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout/edit'
    | '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout/edit'
    | '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout/edit'
    | '/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout/'
    | '/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout/'
    | '/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout/'
    | '/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout/'
    | '/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout/'
    | '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout/'
    | '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout/'
    | '/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  ChangePasswordRoute: typeof ChangePasswordRoute
  LoginRoute: typeof LoginRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  LoginRoute: LoginRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_auth",
        "/change-password",
        "/login"
      ]
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/sync-bibtex",
        "/_auth/sync-scopus",
        "/_auth/",
        "/_auth/administration",
        "/_auth/author",
        "/_auth/conference",
        "/_auth/evaluation",
        "/_auth/gov-evaluation",
        "/_auth/journal",
        "/_auth/minimal-standards",
        "/_auth/publisher",
        "/_auth/report",
        "/_auth/research-center",
        "/_auth/research-perf-eval",
        "/_auth/travel"
      ]
    },
    "/change-password": {
      "filePath": "change-password.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/_auth/sync-bibtex": {
      "filePath": "_auth/sync-bibtex.tsx",
      "parent": "/_auth"
    },
    "/_auth/sync-scopus": {
      "filePath": "_auth/sync-scopus.tsx",
      "parent": "/_auth"
    },
    "/_auth/": {
      "filePath": "_auth/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/administration": {
      "filePath": "_auth/administration",
      "parent": "/_auth",
      "children": [
        "/_auth/administration/_administration"
      ]
    },
    "/_auth/administration/_administration": {
      "filePath": "_auth/administration/_administration.tsx",
      "parent": "/_auth/administration",
      "children": [
        "/_auth/administration/_administration/",
        "/_auth/administration/_administration/department",
        "/_auth/administration/_administration/discipline",
        "/_auth/administration/_administration/faculty",
        "/_auth/administration/_administration/legal-holiday",
        "/_auth/administration/_administration/local-accounts",
        "/_auth/administration/_administration/university-config",
        "/_auth/administration/_administration/user-documents"
      ]
    },
    "/_auth/author": {
      "filePath": "_auth/author",
      "parent": "/_auth",
      "children": [
        "/_auth/author/_author"
      ]
    },
    "/_auth/author/_author": {
      "filePath": "_auth/author/_author.tsx",
      "parent": "/_auth/author",
      "children": [
        "/_auth/author/_author/wos-isi-report",
        "/_auth/author/_author/",
        "/_auth/author/_author/abstract",
        "/_auth/author/_author/article",
        "/_auth/author/_author/award",
        "/_auth/author/_author/book",
        "/_auth/author/_author/chapter",
        "/_auth/author/_author/committee",
        "/_auth/author/_author/course",
        "/_auth/author/_author/dictionary",
        "/_auth/author/_author/doctoral-committee",
        "/_auth/author/_author/editorial-team",
        "/_auth/author/_author/mobility",
        "/_auth/author/_author/patent",
        "/_auth/author/_author/presentation",
        "/_auth/author/_author/proceeding",
        "/_auth/author/_author/project",
        "/_auth/author/_author/review",
        "/_auth/author/_author/technological-transfer",
        "/_auth/author/_author/translation"
      ]
    },
    "/_auth/conference": {
      "filePath": "_auth/conference",
      "parent": "/_auth",
      "children": [
        "/_auth/conference/_conference"
      ]
    },
    "/_auth/conference/_conference": {
      "filePath": "_auth/conference/_conference.tsx",
      "parent": "/_auth/conference",
      "children": [
        "/_auth/conference/_conference/create",
        "/_auth/conference/_conference/",
        "/_auth/conference/_conference/$conferenceId"
      ]
    },
    "/_auth/evaluation": {
      "filePath": "_auth/evaluation",
      "parent": "/_auth",
      "children": [
        "/_auth/evaluation/_layout"
      ]
    },
    "/_auth/evaluation/_layout": {
      "filePath": "_auth/evaluation/_layout.tsx",
      "parent": "/_auth/evaluation",
      "children": [
        "/_auth/evaluation/_layout/",
        "/_auth/evaluation/_layout/$evaluationId"
      ]
    },
    "/_auth/gov-evaluation": {
      "filePath": "_auth/gov-evaluation",
      "parent": "/_auth",
      "children": [
        "/_auth/gov-evaluation/_layout"
      ]
    },
    "/_auth/gov-evaluation/_layout": {
      "filePath": "_auth/gov-evaluation/_layout.tsx",
      "parent": "/_auth/gov-evaluation",
      "children": [
        "/_auth/gov-evaluation/_layout/",
        "/_auth/gov-evaluation/_layout/$evaluationId"
      ]
    },
    "/_auth/journal": {
      "filePath": "_auth/journal",
      "parent": "/_auth",
      "children": [
        "/_auth/journal/_journal"
      ]
    },
    "/_auth/journal/_journal": {
      "filePath": "_auth/journal/_journal.tsx",
      "parent": "/_auth/journal",
      "children": [
        "/_auth/journal/_journal/create",
        "/_auth/journal/_journal/",
        "/_auth/journal/_journal/$journalId"
      ]
    },
    "/_auth/minimal-standards": {
      "filePath": "_auth/minimal-standards",
      "parent": "/_auth",
      "children": [
        "/_auth/minimal-standards/_layout"
      ]
    },
    "/_auth/minimal-standards/_layout": {
      "filePath": "_auth/minimal-standards/_layout.tsx",
      "parent": "/_auth/minimal-standards",
      "children": [
        "/_auth/minimal-standards/_layout/",
        "/_auth/minimal-standards/_layout/report/gather"
      ]
    },
    "/_auth/publisher": {
      "filePath": "_auth/publisher",
      "parent": "/_auth",
      "children": [
        "/_auth/publisher/_publisher"
      ]
    },
    "/_auth/publisher/_publisher": {
      "filePath": "_auth/publisher/_publisher.tsx",
      "parent": "/_auth/publisher",
      "children": [
        "/_auth/publisher/_publisher/create",
        "/_auth/publisher/_publisher/",
        "/_auth/publisher/_publisher/$publisherId"
      ]
    },
    "/_auth/report": {
      "filePath": "_auth/report",
      "parent": "/_auth",
      "children": [
        "/_auth/report/_report"
      ]
    },
    "/_auth/report/_report": {
      "filePath": "_auth/report/_report.tsx",
      "parent": "/_auth/report",
      "children": [
        "/_auth/report/_report/analytics",
        "/_auth/report/_report/"
      ]
    },
    "/_auth/research-center": {
      "filePath": "_auth/research-center",
      "parent": "/_auth",
      "children": [
        "/_auth/research-center/_research-center"
      ]
    },
    "/_auth/research-center/_research-center": {
      "filePath": "_auth/research-center/_research-center.tsx",
      "parent": "/_auth/research-center",
      "children": [
        "/_auth/research-center/_research-center/create",
        "/_auth/research-center/_research-center/",
        "/_auth/research-center/_research-center/$researchCenterId"
      ]
    },
    "/_auth/research-perf-eval": {
      "filePath": "_auth/research-perf-eval",
      "parent": "/_auth",
      "children": [
        "/_auth/research-perf-eval/_layout"
      ]
    },
    "/_auth/research-perf-eval/_layout": {
      "filePath": "_auth/research-perf-eval/_layout.tsx",
      "parent": "/_auth/research-perf-eval",
      "children": [
        "/_auth/research-perf-eval/_layout/",
        "/_auth/research-perf-eval/_layout/$evaluationId"
      ]
    },
    "/_auth/travel": {
      "filePath": "_auth/travel",
      "parent": "/_auth",
      "children": [
        "/_auth/travel/_travel"
      ]
    },
    "/_auth/travel/_travel": {
      "filePath": "_auth/travel/_travel.tsx",
      "parent": "/_auth/travel",
      "children": [
        "/_auth/travel/_travel/",
        "/_auth/travel/_travel/requests/create",
        "/_auth/travel/_travel/analytics/",
        "/_auth/travel/_travel/approvals/",
        "/_auth/travel/_travel/board-requests/",
        "/_auth/travel/_travel/days/",
        "/_auth/travel/_travel/documents/",
        "/_auth/travel/_travel/registry/",
        "/_auth/travel/_travel/requests/",
        "/_auth/travel/_travel/settings/",
        "/_auth/travel/_travel/requests/$requestId"
      ]
    },
    "/_auth/author/_author/wos-isi-report": {
      "filePath": "_auth/author/_author/wos-isi-report.tsx",
      "parent": "/_auth/author/_author"
    },
    "/_auth/conference/_conference/create": {
      "filePath": "_auth/conference/_conference/create.tsx",
      "parent": "/_auth/conference/_conference"
    },
    "/_auth/journal/_journal/create": {
      "filePath": "_auth/journal/_journal/create.tsx",
      "parent": "/_auth/journal/_journal"
    },
    "/_auth/publisher/_publisher/create": {
      "filePath": "_auth/publisher/_publisher/create.tsx",
      "parent": "/_auth/publisher/_publisher"
    },
    "/_auth/report/_report/analytics": {
      "filePath": "_auth/report/_report/analytics.tsx",
      "parent": "/_auth/report/_report"
    },
    "/_auth/research-center/_research-center/create": {
      "filePath": "_auth/research-center/_research-center/create.tsx",
      "parent": "/_auth/research-center/_research-center"
    },
    "/_auth/administration/_administration/": {
      "filePath": "_auth/administration/_administration/index.tsx",
      "parent": "/_auth/administration/_administration"
    },
    "/_auth/author/_author/": {
      "filePath": "_auth/author/_author/index.tsx",
      "parent": "/_auth/author/_author"
    },
    "/_auth/conference/_conference/": {
      "filePath": "_auth/conference/_conference/index.tsx",
      "parent": "/_auth/conference/_conference"
    },
    "/_auth/evaluation/_layout/": {
      "filePath": "_auth/evaluation/_layout/index.tsx",
      "parent": "/_auth/evaluation/_layout"
    },
    "/_auth/gov-evaluation/_layout/": {
      "filePath": "_auth/gov-evaluation/_layout/index.tsx",
      "parent": "/_auth/gov-evaluation/_layout"
    },
    "/_auth/journal/_journal/": {
      "filePath": "_auth/journal/_journal/index.tsx",
      "parent": "/_auth/journal/_journal"
    },
    "/_auth/minimal-standards/_layout/": {
      "filePath": "_auth/minimal-standards/_layout/index.tsx",
      "parent": "/_auth/minimal-standards/_layout"
    },
    "/_auth/publisher/_publisher/": {
      "filePath": "_auth/publisher/_publisher/index.tsx",
      "parent": "/_auth/publisher/_publisher"
    },
    "/_auth/report/_report/": {
      "filePath": "_auth/report/_report/index.tsx",
      "parent": "/_auth/report/_report"
    },
    "/_auth/research-center/_research-center/": {
      "filePath": "_auth/research-center/_research-center/index.tsx",
      "parent": "/_auth/research-center/_research-center"
    },
    "/_auth/research-perf-eval/_layout/": {
      "filePath": "_auth/research-perf-eval/_layout/index.tsx",
      "parent": "/_auth/research-perf-eval/_layout"
    },
    "/_auth/travel/_travel/": {
      "filePath": "_auth/travel/_travel/index.tsx",
      "parent": "/_auth/travel/_travel"
    },
    "/_auth/administration/_administration/department": {
      "filePath": "_auth/administration/_administration/department",
      "parent": "/_auth/administration/_administration",
      "children": [
        "/_auth/administration/_administration/department/_department"
      ]
    },
    "/_auth/administration/_administration/department/_department": {
      "filePath": "_auth/administration/_administration/department/_department.tsx",
      "parent": "/_auth/administration/_administration/department",
      "children": [
        "/_auth/administration/_administration/department/_department/create",
        "/_auth/administration/_administration/department/_department/",
        "/_auth/administration/_administration/department/_department/$departmentId"
      ]
    },
    "/_auth/administration/_administration/discipline": {
      "filePath": "_auth/administration/_administration/discipline",
      "parent": "/_auth/administration/_administration",
      "children": [
        "/_auth/administration/_administration/discipline/_discipline"
      ]
    },
    "/_auth/administration/_administration/discipline/_discipline": {
      "filePath": "_auth/administration/_administration/discipline/_discipline.tsx",
      "parent": "/_auth/administration/_administration/discipline",
      "children": [
        "/_auth/administration/_administration/discipline/_discipline/create",
        "/_auth/administration/_administration/discipline/_discipline/",
        "/_auth/administration/_administration/discipline/_discipline/$disciplineId"
      ]
    },
    "/_auth/administration/_administration/faculty": {
      "filePath": "_auth/administration/_administration/faculty",
      "parent": "/_auth/administration/_administration",
      "children": [
        "/_auth/administration/_administration/faculty/_faculty"
      ]
    },
    "/_auth/administration/_administration/faculty/_faculty": {
      "filePath": "_auth/administration/_administration/faculty/_faculty.tsx",
      "parent": "/_auth/administration/_administration/faculty",
      "children": [
        "/_auth/administration/_administration/faculty/_faculty/create",
        "/_auth/administration/_administration/faculty/_faculty/",
        "/_auth/administration/_administration/faculty/_faculty/$facultyId"
      ]
    },
    "/_auth/administration/_administration/legal-holiday": {
      "filePath": "_auth/administration/_administration/legal-holiday",
      "parent": "/_auth/administration/_administration",
      "children": [
        "/_auth/administration/_administration/legal-holiday/_legal-holiday"
      ]
    },
    "/_auth/administration/_administration/legal-holiday/_legal-holiday": {
      "filePath": "_auth/administration/_administration/legal-holiday/_legal-holiday.tsx",
      "parent": "/_auth/administration/_administration/legal-holiday",
      "children": [
        "/_auth/administration/_administration/legal-holiday/_legal-holiday/"
      ]
    },
    "/_auth/administration/_administration/local-accounts": {
      "filePath": "_auth/administration/_administration/local-accounts",
      "parent": "/_auth/administration/_administration",
      "children": [
        "/_auth/administration/_administration/local-accounts/_local-accounts"
      ]
    },
    "/_auth/administration/_administration/local-accounts/_local-accounts": {
      "filePath": "_auth/administration/_administration/local-accounts/_local-accounts.tsx",
      "parent": "/_auth/administration/_administration/local-accounts",
      "children": [
        "/_auth/administration/_administration/local-accounts/_local-accounts/"
      ]
    },
    "/_auth/administration/_administration/university-config": {
      "filePath": "_auth/administration/_administration/university-config",
      "parent": "/_auth/administration/_administration",
      "children": [
        "/_auth/administration/_administration/university-config/_university-config"
      ]
    },
    "/_auth/administration/_administration/university-config/_university-config": {
      "filePath": "_auth/administration/_administration/university-config/_university-config.tsx",
      "parent": "/_auth/administration/_administration/university-config",
      "children": [
        "/_auth/administration/_administration/university-config/_university-config/"
      ]
    },
    "/_auth/administration/_administration/user-documents": {
      "filePath": "_auth/administration/_administration/user-documents",
      "parent": "/_auth/administration/_administration",
      "children": [
        "/_auth/administration/_administration/user-documents/_user-documents"
      ]
    },
    "/_auth/administration/_administration/user-documents/_user-documents": {
      "filePath": "_auth/administration/_administration/user-documents/_user-documents.tsx",
      "parent": "/_auth/administration/_administration/user-documents",
      "children": [
        "/_auth/administration/_administration/user-documents/_user-documents/"
      ]
    },
    "/_auth/author/_author/abstract": {
      "filePath": "_auth/author/_author/abstract",
      "parent": "/_auth/author/_author",
      "children": [
        "/_auth/author/_author/abstract/_abstract"
      ]
    },
    "/_auth/author/_author/abstract/_abstract": {
      "filePath": "_auth/author/_author/abstract/_abstract.tsx",
      "parent": "/_auth/author/_author/abstract",
      "children": [
        "/_auth/author/_author/abstract/_abstract/create",
        "/_auth/author/_author/abstract/_abstract/search-claimable",
        "/_auth/author/_author/abstract/_abstract/",
        "/_auth/author/_author/abstract/_abstract/$abstractId"
      ]
    },
    "/_auth/author/_author/article": {
      "filePath": "_auth/author/_author/article",
      "parent": "/_auth/author/_author",
      "children": [
        "/_auth/author/_author/article/_article"
      ]
    },
    "/_auth/author/_author/article/_article": {
      "filePath": "_auth/author/_author/article/_article.tsx",
      "parent": "/_auth/author/_author/article",
      "children": [
        "/_auth/author/_author/article/_article/create",
        "/_auth/author/_author/article/_article/search-claimable",
        "/_auth/author/_author/article/_article/",
        "/_auth/author/_author/article/_article/$articleId"
      ]
    },
    "/_auth/author/_author/award": {
      "filePath": "_auth/author/_author/award",
      "parent": "/_auth/author/_author",
      "children": [
        "/_auth/author/_author/award/_award"
      ]
    },
    "/_auth/author/_author/award/_award": {
      "filePath": "_auth/author/_author/award/_award.tsx",
      "parent": "/_auth/author/_author/award",
      "children": [
        "/_auth/author/_author/award/_award/create",
        "/_auth/author/_author/award/_award/",
        "/_auth/author/_author/award/_award/$awardId"
      ]
    },
    "/_auth/author/_author/book": {
      "filePath": "_auth/author/_author/book",
      "parent": "/_auth/author/_author",
      "children": [
        "/_auth/author/_author/book/_book"
      ]
    },
    "/_auth/author/_author/book/_book": {
      "filePath": "_auth/author/_author/book/_book.tsx",
      "parent": "/_auth/author/_author/book",
      "children": [
        "/_auth/author/_author/book/_book/create",
        "/_auth/author/_author/book/_book/search-claimable",
        "/_auth/author/_author/book/_book/",
        "/_auth/author/_author/book/_book/$bookId"
      ]
    },
    "/_auth/author/_author/chapter": {
      "filePath": "_auth/author/_author/chapter",
      "parent": "/_auth/author/_author",
      "children": [
        "/_auth/author/_author/chapter/_chapter"
      ]
    },
    "/_auth/author/_author/chapter/_chapter": {
      "filePath": "_auth/author/_author/chapter/_chapter.tsx",
      "parent": "/_auth/author/_author/chapter",
      "children": [
        "/_auth/author/_author/chapter/_chapter/create",
        "/_auth/author/_author/chapter/_chapter/search-claimable",
        "/_auth/author/_author/chapter/_chapter/",
        "/_auth/author/_author/chapter/_chapter/$chapterId"
      ]
    },
    "/_auth/author/_author/committee": {
      "filePath": "_auth/author/_author/committee",
      "parent": "/_auth/author/_author",
      "children": [
        "/_auth/author/_author/committee/_committee"
      ]
    },
    "/_auth/author/_author/committee/_committee": {
      "filePath": "_auth/author/_author/committee/_committee.tsx",
      "parent": "/_auth/author/_author/committee",
      "children": [
        "/_auth/author/_author/committee/_committee/create",
        "/_auth/author/_author/committee/_committee/",
        "/_auth/author/_author/committee/_committee/$committeeId"
      ]
    },
    "/_auth/author/_author/course": {
      "filePath": "_auth/author/_author/course",
      "parent": "/_auth/author/_author",
      "children": [
        "/_auth/author/_author/course/_course"
      ]
    },
    "/_auth/author/_author/course/_course": {
      "filePath": "_auth/author/_author/course/_course.tsx",
      "parent": "/_auth/author/_author/course",
      "children": [
        "/_auth/author/_author/course/_course/create",
        "/_auth/author/_author/course/_course/",
        "/_auth/author/_author/course/_course/$courseId"
      ]
    },
    "/_auth/author/_author/dictionary": {
      "filePath": "_auth/author/_author/dictionary",
      "parent": "/_auth/author/_author",
      "children": [
        "/_auth/author/_author/dictionary/_dictionary"
      ]
    },
    "/_auth/author/_author/dictionary/_dictionary": {
      "filePath": "_auth/author/_author/dictionary/_dictionary.tsx",
      "parent": "/_auth/author/_author/dictionary",
      "children": [
        "/_auth/author/_author/dictionary/_dictionary/create",
        "/_auth/author/_author/dictionary/_dictionary/",
        "/_auth/author/_author/dictionary/_dictionary/$dictionaryId"
      ]
    },
    "/_auth/author/_author/doctoral-committee": {
      "filePath": "_auth/author/_author/doctoral-committee",
      "parent": "/_auth/author/_author",
      "children": [
        "/_auth/author/_author/doctoral-committee/_doctoralCommittee"
      ]
    },
    "/_auth/author/_author/doctoral-committee/_doctoralCommittee": {
      "filePath": "_auth/author/_author/doctoral-committee/_doctoralCommittee.tsx",
      "parent": "/_auth/author/_author/doctoral-committee",
      "children": [
        "/_auth/author/_author/doctoral-committee/_doctoralCommittee/create",
        "/_auth/author/_author/doctoral-committee/_doctoralCommittee/",
        "/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId"
      ]
    },
    "/_auth/author/_author/editorial-team": {
      "filePath": "_auth/author/_author/editorial-team",
      "parent": "/_auth/author/_author",
      "children": [
        "/_auth/author/_author/editorial-team/_editorialTeam"
      ]
    },
    "/_auth/author/_author/editorial-team/_editorialTeam": {
      "filePath": "_auth/author/_author/editorial-team/_editorialTeam.tsx",
      "parent": "/_auth/author/_author/editorial-team",
      "children": [
        "/_auth/author/_author/editorial-team/_editorialTeam/create",
        "/_auth/author/_author/editorial-team/_editorialTeam/",
        "/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId"
      ]
    },
    "/_auth/author/_author/mobility": {
      "filePath": "_auth/author/_author/mobility",
      "parent": "/_auth/author/_author",
      "children": [
        "/_auth/author/_author/mobility/_mobility"
      ]
    },
    "/_auth/author/_author/mobility/_mobility": {
      "filePath": "_auth/author/_author/mobility/_mobility.tsx",
      "parent": "/_auth/author/_author/mobility",
      "children": [
        "/_auth/author/_author/mobility/_mobility/create",
        "/_auth/author/_author/mobility/_mobility/",
        "/_auth/author/_author/mobility/_mobility/$mobilityId"
      ]
    },
    "/_auth/author/_author/patent": {
      "filePath": "_auth/author/_author/patent",
      "parent": "/_auth/author/_author",
      "children": [
        "/_auth/author/_author/patent/_patent"
      ]
    },
    "/_auth/author/_author/patent/_patent": {
      "filePath": "_auth/author/_author/patent/_patent.tsx",
      "parent": "/_auth/author/_author/patent",
      "children": [
        "/_auth/author/_author/patent/_patent/create",
        "/_auth/author/_author/patent/_patent/search-claimable",
        "/_auth/author/_author/patent/_patent/",
        "/_auth/author/_author/patent/_patent/$patentId"
      ]
    },
    "/_auth/author/_author/presentation": {
      "filePath": "_auth/author/_author/presentation",
      "parent": "/_auth/author/_author",
      "children": [
        "/_auth/author/_author/presentation/_presentation"
      ]
    },
    "/_auth/author/_author/presentation/_presentation": {
      "filePath": "_auth/author/_author/presentation/_presentation.tsx",
      "parent": "/_auth/author/_author/presentation",
      "children": [
        "/_auth/author/_author/presentation/_presentation/create",
        "/_auth/author/_author/presentation/_presentation/",
        "/_auth/author/_author/presentation/_presentation/$presentationId"
      ]
    },
    "/_auth/author/_author/proceeding": {
      "filePath": "_auth/author/_author/proceeding",
      "parent": "/_auth/author/_author",
      "children": [
        "/_auth/author/_author/proceeding/_proceeding"
      ]
    },
    "/_auth/author/_author/proceeding/_proceeding": {
      "filePath": "_auth/author/_author/proceeding/_proceeding.tsx",
      "parent": "/_auth/author/_author/proceeding",
      "children": [
        "/_auth/author/_author/proceeding/_proceeding/create",
        "/_auth/author/_author/proceeding/_proceeding/search-claimable",
        "/_auth/author/_author/proceeding/_proceeding/",
        "/_auth/author/_author/proceeding/_proceeding/$proceedingId"
      ]
    },
    "/_auth/author/_author/project": {
      "filePath": "_auth/author/_author/project",
      "parent": "/_auth/author/_author",
      "children": [
        "/_auth/author/_author/project/_project"
      ]
    },
    "/_auth/author/_author/project/_project": {
      "filePath": "_auth/author/_author/project/_project.tsx",
      "parent": "/_auth/author/_author/project",
      "children": [
        "/_auth/author/_author/project/_project/create",
        "/_auth/author/_author/project/_project/search-claimable",
        "/_auth/author/_author/project/_project/",
        "/_auth/author/_author/project/_project/$projectId"
      ]
    },
    "/_auth/author/_author/review": {
      "filePath": "_auth/author/_author/review",
      "parent": "/_auth/author/_author",
      "children": [
        "/_auth/author/_author/review/_review"
      ]
    },
    "/_auth/author/_author/review/_review": {
      "filePath": "_auth/author/_author/review/_review.tsx",
      "parent": "/_auth/author/_author/review",
      "children": [
        "/_auth/author/_author/review/_review/create",
        "/_auth/author/_author/review/_review/search-claimable",
        "/_auth/author/_author/review/_review/",
        "/_auth/author/_author/review/_review/$reviewId"
      ]
    },
    "/_auth/author/_author/technological-transfer": {
      "filePath": "_auth/author/_author/technological-transfer",
      "parent": "/_auth/author/_author",
      "children": [
        "/_auth/author/_author/technological-transfer/_technologicalTransfer"
      ]
    },
    "/_auth/author/_author/technological-transfer/_technologicalTransfer": {
      "filePath": "_auth/author/_author/technological-transfer/_technologicalTransfer.tsx",
      "parent": "/_auth/author/_author/technological-transfer",
      "children": [
        "/_auth/author/_author/technological-transfer/_technologicalTransfer/create",
        "/_auth/author/_author/technological-transfer/_technologicalTransfer/search-claimable",
        "/_auth/author/_author/technological-transfer/_technologicalTransfer/",
        "/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId"
      ]
    },
    "/_auth/author/_author/translation": {
      "filePath": "_auth/author/_author/translation",
      "parent": "/_auth/author/_author",
      "children": [
        "/_auth/author/_author/translation/_translation"
      ]
    },
    "/_auth/author/_author/translation/_translation": {
      "filePath": "_auth/author/_author/translation/_translation.tsx",
      "parent": "/_auth/author/_author/translation",
      "children": [
        "/_auth/author/_author/translation/_translation/create",
        "/_auth/author/_author/translation/_translation/search-claimable",
        "/_auth/author/_author/translation/_translation/",
        "/_auth/author/_author/translation/_translation/$translationId"
      ]
    },
    "/_auth/conference/_conference/$conferenceId": {
      "filePath": "_auth/conference/_conference/$conferenceId",
      "parent": "/_auth/conference/_conference",
      "children": [
        "/_auth/conference/_conference/$conferenceId/_layout"
      ]
    },
    "/_auth/conference/_conference/$conferenceId/_layout": {
      "filePath": "_auth/conference/_conference/$conferenceId/_layout.tsx",
      "parent": "/_auth/conference/_conference/$conferenceId",
      "children": [
        "/_auth/conference/_conference/$conferenceId/_layout/edit",
        "/_auth/conference/_conference/$conferenceId/_layout/"
      ]
    },
    "/_auth/evaluation/_layout/$evaluationId": {
      "filePath": "_auth/evaluation/_layout/$evaluationId",
      "parent": "/_auth/evaluation/_layout",
      "children": [
        "/_auth/evaluation/_layout/$evaluationId/_layout",
        "/_auth/evaluation/_layout/$evaluationId/department-summary-results",
        "/_auth/evaluation/_layout/$evaluationId/faculty-summary-results"
      ]
    },
    "/_auth/evaluation/_layout/$evaluationId/_layout": {
      "filePath": "_auth/evaluation/_layout/$evaluationId/_layout.tsx",
      "parent": "/_auth/evaluation/_layout/$evaluationId",
      "children": [
        "/_auth/evaluation/_layout/$evaluationId/_layout/",
        "/_auth/evaluation/_layout/$evaluationId/_layout/report/gather"
      ]
    },
    "/_auth/evaluation/_layout/$evaluationId/department-summary-results": {
      "filePath": "_auth/evaluation/_layout/$evaluationId/department-summary-results.tsx",
      "parent": "/_auth/evaluation/_layout/$evaluationId"
    },
    "/_auth/evaluation/_layout/$evaluationId/faculty-summary-results": {
      "filePath": "_auth/evaluation/_layout/$evaluationId/faculty-summary-results.tsx",
      "parent": "/_auth/evaluation/_layout/$evaluationId"
    },
    "/_auth/gov-evaluation/_layout/$evaluationId": {
      "filePath": "_auth/gov-evaluation/_layout/$evaluationId",
      "parent": "/_auth/gov-evaluation/_layout",
      "children": [
        "/_auth/gov-evaluation/_layout/$evaluationId/_layout"
      ]
    },
    "/_auth/gov-evaluation/_layout/$evaluationId/_layout": {
      "filePath": "_auth/gov-evaluation/_layout/$evaluationId/_layout.tsx",
      "parent": "/_auth/gov-evaluation/_layout/$evaluationId",
      "children": [
        "/_auth/gov-evaluation/_layout/$evaluationId/_layout/"
      ]
    },
    "/_auth/journal/_journal/$journalId": {
      "filePath": "_auth/journal/_journal/$journalId",
      "parent": "/_auth/journal/_journal",
      "children": [
        "/_auth/journal/_journal/$journalId/_layout"
      ]
    },
    "/_auth/journal/_journal/$journalId/_layout": {
      "filePath": "_auth/journal/_journal/$journalId/_layout.tsx",
      "parent": "/_auth/journal/_journal/$journalId",
      "children": [
        "/_auth/journal/_journal/$journalId/_layout/article-influence-score",
        "/_auth/journal/_journal/$journalId/_layout/edit",
        "/_auth/journal/_journal/$journalId/_layout/impact-factor",
        "/_auth/journal/_journal/$journalId/_layout/"
      ]
    },
    "/_auth/publisher/_publisher/$publisherId": {
      "filePath": "_auth/publisher/_publisher/$publisherId",
      "parent": "/_auth/publisher/_publisher",
      "children": [
        "/_auth/publisher/_publisher/$publisherId/_layout"
      ]
    },
    "/_auth/publisher/_publisher/$publisherId/_layout": {
      "filePath": "_auth/publisher/_publisher/$publisherId/_layout.tsx",
      "parent": "/_auth/publisher/_publisher/$publisherId",
      "children": [
        "/_auth/publisher/_publisher/$publisherId/_layout/edit",
        "/_auth/publisher/_publisher/$publisherId/_layout/"
      ]
    },
    "/_auth/research-center/_research-center/$researchCenterId": {
      "filePath": "_auth/research-center/_research-center/$researchCenterId",
      "parent": "/_auth/research-center/_research-center",
      "children": [
        "/_auth/research-center/_research-center/$researchCenterId/_layout"
      ]
    },
    "/_auth/research-center/_research-center/$researchCenterId/_layout": {
      "filePath": "_auth/research-center/_research-center/$researchCenterId/_layout.tsx",
      "parent": "/_auth/research-center/_research-center/$researchCenterId",
      "children": [
        "/_auth/research-center/_research-center/$researchCenterId/_layout/create",
        "/_auth/research-center/_research-center/$researchCenterId/_layout/edit",
        "/_auth/research-center/_research-center/$researchCenterId/_layout/",
        "/_auth/research-center/_research-center/$researchCenterId/_layout/lab"
      ]
    },
    "/_auth/research-perf-eval/_layout/$evaluationId": {
      "filePath": "_auth/research-perf-eval/_layout/$evaluationId",
      "parent": "/_auth/research-perf-eval/_layout",
      "children": [
        "/_auth/research-perf-eval/_layout/$evaluationId/_layout"
      ]
    },
    "/_auth/research-perf-eval/_layout/$evaluationId/_layout": {
      "filePath": "_auth/research-perf-eval/_layout/$evaluationId/_layout.tsx",
      "parent": "/_auth/research-perf-eval/_layout/$evaluationId",
      "children": [
        "/_auth/research-perf-eval/_layout/$evaluationId/_layout/",
        "/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather"
      ]
    },
    "/_auth/travel/_travel/requests/create": {
      "filePath": "_auth/travel/_travel/requests/create.tsx",
      "parent": "/_auth/travel/_travel"
    },
    "/_auth/travel/_travel/analytics/": {
      "filePath": "_auth/travel/_travel/analytics/index.tsx",
      "parent": "/_auth/travel/_travel"
    },
    "/_auth/travel/_travel/approvals/": {
      "filePath": "_auth/travel/_travel/approvals/index.tsx",
      "parent": "/_auth/travel/_travel"
    },
    "/_auth/travel/_travel/board-requests/": {
      "filePath": "_auth/travel/_travel/board-requests/index.tsx",
      "parent": "/_auth/travel/_travel"
    },
    "/_auth/travel/_travel/days/": {
      "filePath": "_auth/travel/_travel/days/index.tsx",
      "parent": "/_auth/travel/_travel"
    },
    "/_auth/travel/_travel/documents/": {
      "filePath": "_auth/travel/_travel/documents/index.tsx",
      "parent": "/_auth/travel/_travel"
    },
    "/_auth/travel/_travel/registry/": {
      "filePath": "_auth/travel/_travel/registry/index.tsx",
      "parent": "/_auth/travel/_travel"
    },
    "/_auth/travel/_travel/requests/": {
      "filePath": "_auth/travel/_travel/requests/index.tsx",
      "parent": "/_auth/travel/_travel"
    },
    "/_auth/travel/_travel/settings/": {
      "filePath": "_auth/travel/_travel/settings/index.tsx",
      "parent": "/_auth/travel/_travel"
    },
    "/_auth/administration/_administration/department/_department/create": {
      "filePath": "_auth/administration/_administration/department/_department/create.tsx",
      "parent": "/_auth/administration/_administration/department/_department"
    },
    "/_auth/administration/_administration/discipline/_discipline/create": {
      "filePath": "_auth/administration/_administration/discipline/_discipline/create.tsx",
      "parent": "/_auth/administration/_administration/discipline/_discipline"
    },
    "/_auth/administration/_administration/faculty/_faculty/create": {
      "filePath": "_auth/administration/_administration/faculty/_faculty/create.tsx",
      "parent": "/_auth/administration/_administration/faculty/_faculty"
    },
    "/_auth/author/_author/abstract/_abstract/create": {
      "filePath": "_auth/author/_author/abstract/_abstract/create.tsx",
      "parent": "/_auth/author/_author/abstract/_abstract"
    },
    "/_auth/author/_author/abstract/_abstract/search-claimable": {
      "filePath": "_auth/author/_author/abstract/_abstract/search-claimable.tsx",
      "parent": "/_auth/author/_author/abstract/_abstract"
    },
    "/_auth/author/_author/article/_article/create": {
      "filePath": "_auth/author/_author/article/_article/create.tsx",
      "parent": "/_auth/author/_author/article/_article"
    },
    "/_auth/author/_author/article/_article/search-claimable": {
      "filePath": "_auth/author/_author/article/_article/search-claimable.tsx",
      "parent": "/_auth/author/_author/article/_article"
    },
    "/_auth/author/_author/award/_award/create": {
      "filePath": "_auth/author/_author/award/_award/create.tsx",
      "parent": "/_auth/author/_author/award/_award"
    },
    "/_auth/author/_author/book/_book/create": {
      "filePath": "_auth/author/_author/book/_book/create.tsx",
      "parent": "/_auth/author/_author/book/_book"
    },
    "/_auth/author/_author/book/_book/search-claimable": {
      "filePath": "_auth/author/_author/book/_book/search-claimable.tsx",
      "parent": "/_auth/author/_author/book/_book"
    },
    "/_auth/author/_author/chapter/_chapter/create": {
      "filePath": "_auth/author/_author/chapter/_chapter/create.tsx",
      "parent": "/_auth/author/_author/chapter/_chapter"
    },
    "/_auth/author/_author/chapter/_chapter/search-claimable": {
      "filePath": "_auth/author/_author/chapter/_chapter/search-claimable.tsx",
      "parent": "/_auth/author/_author/chapter/_chapter"
    },
    "/_auth/author/_author/committee/_committee/create": {
      "filePath": "_auth/author/_author/committee/_committee/create.tsx",
      "parent": "/_auth/author/_author/committee/_committee"
    },
    "/_auth/author/_author/course/_course/create": {
      "filePath": "_auth/author/_author/course/_course/create.tsx",
      "parent": "/_auth/author/_author/course/_course"
    },
    "/_auth/author/_author/dictionary/_dictionary/create": {
      "filePath": "_auth/author/_author/dictionary/_dictionary/create.tsx",
      "parent": "/_auth/author/_author/dictionary/_dictionary"
    },
    "/_auth/author/_author/doctoral-committee/_doctoralCommittee/create": {
      "filePath": "_auth/author/_author/doctoral-committee/_doctoralCommittee/create.tsx",
      "parent": "/_auth/author/_author/doctoral-committee/_doctoralCommittee"
    },
    "/_auth/author/_author/editorial-team/_editorialTeam/create": {
      "filePath": "_auth/author/_author/editorial-team/_editorialTeam/create.tsx",
      "parent": "/_auth/author/_author/editorial-team/_editorialTeam"
    },
    "/_auth/author/_author/mobility/_mobility/create": {
      "filePath": "_auth/author/_author/mobility/_mobility/create.tsx",
      "parent": "/_auth/author/_author/mobility/_mobility"
    },
    "/_auth/author/_author/patent/_patent/create": {
      "filePath": "_auth/author/_author/patent/_patent/create.tsx",
      "parent": "/_auth/author/_author/patent/_patent"
    },
    "/_auth/author/_author/patent/_patent/search-claimable": {
      "filePath": "_auth/author/_author/patent/_patent/search-claimable.tsx",
      "parent": "/_auth/author/_author/patent/_patent"
    },
    "/_auth/author/_author/presentation/_presentation/create": {
      "filePath": "_auth/author/_author/presentation/_presentation/create.tsx",
      "parent": "/_auth/author/_author/presentation/_presentation"
    },
    "/_auth/author/_author/proceeding/_proceeding/create": {
      "filePath": "_auth/author/_author/proceeding/_proceeding/create.tsx",
      "parent": "/_auth/author/_author/proceeding/_proceeding"
    },
    "/_auth/author/_author/proceeding/_proceeding/search-claimable": {
      "filePath": "_auth/author/_author/proceeding/_proceeding/search-claimable.tsx",
      "parent": "/_auth/author/_author/proceeding/_proceeding"
    },
    "/_auth/author/_author/project/_project/create": {
      "filePath": "_auth/author/_author/project/_project/create.tsx",
      "parent": "/_auth/author/_author/project/_project"
    },
    "/_auth/author/_author/project/_project/search-claimable": {
      "filePath": "_auth/author/_author/project/_project/search-claimable.tsx",
      "parent": "/_auth/author/_author/project/_project"
    },
    "/_auth/author/_author/review/_review/create": {
      "filePath": "_auth/author/_author/review/_review/create.tsx",
      "parent": "/_auth/author/_author/review/_review"
    },
    "/_auth/author/_author/review/_review/search-claimable": {
      "filePath": "_auth/author/_author/review/_review/search-claimable.tsx",
      "parent": "/_auth/author/_author/review/_review"
    },
    "/_auth/author/_author/technological-transfer/_technologicalTransfer/create": {
      "filePath": "_auth/author/_author/technological-transfer/_technologicalTransfer/create.tsx",
      "parent": "/_auth/author/_author/technological-transfer/_technologicalTransfer"
    },
    "/_auth/author/_author/technological-transfer/_technologicalTransfer/search-claimable": {
      "filePath": "_auth/author/_author/technological-transfer/_technologicalTransfer/search-claimable.tsx",
      "parent": "/_auth/author/_author/technological-transfer/_technologicalTransfer"
    },
    "/_auth/author/_author/translation/_translation/create": {
      "filePath": "_auth/author/_author/translation/_translation/create.tsx",
      "parent": "/_auth/author/_author/translation/_translation"
    },
    "/_auth/author/_author/translation/_translation/search-claimable": {
      "filePath": "_auth/author/_author/translation/_translation/search-claimable.tsx",
      "parent": "/_auth/author/_author/translation/_translation"
    },
    "/_auth/conference/_conference/$conferenceId/_layout/edit": {
      "filePath": "_auth/conference/_conference/$conferenceId/_layout/edit.tsx",
      "parent": "/_auth/conference/_conference/$conferenceId/_layout"
    },
    "/_auth/journal/_journal/$journalId/_layout/article-influence-score": {
      "filePath": "_auth/journal/_journal/$journalId/_layout/article-influence-score.tsx",
      "parent": "/_auth/journal/_journal/$journalId/_layout"
    },
    "/_auth/journal/_journal/$journalId/_layout/edit": {
      "filePath": "_auth/journal/_journal/$journalId/_layout/edit.tsx",
      "parent": "/_auth/journal/_journal/$journalId/_layout"
    },
    "/_auth/journal/_journal/$journalId/_layout/impact-factor": {
      "filePath": "_auth/journal/_journal/$journalId/_layout/impact-factor.tsx",
      "parent": "/_auth/journal/_journal/$journalId/_layout"
    },
    "/_auth/minimal-standards/_layout/report/gather": {
      "filePath": "_auth/minimal-standards/_layout/report/gather",
      "parent": "/_auth/minimal-standards/_layout",
      "children": [
        "/_auth/minimal-standards/_layout/report/gather/_gather"
      ]
    },
    "/_auth/minimal-standards/_layout/report/gather/_gather": {
      "filePath": "_auth/minimal-standards/_layout/report/gather/_gather.tsx",
      "parent": "/_auth/minimal-standards/_layout/report/gather",
      "children": [
        "/_auth/minimal-standards/_layout/report/gather/_gather/",
        "/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode"
      ]
    },
    "/_auth/publisher/_publisher/$publisherId/_layout/edit": {
      "filePath": "_auth/publisher/_publisher/$publisherId/_layout/edit.tsx",
      "parent": "/_auth/publisher/_publisher/$publisherId/_layout"
    },
    "/_auth/research-center/_research-center/$researchCenterId/_layout/create": {
      "filePath": "_auth/research-center/_research-center/$researchCenterId/_layout/create.tsx",
      "parent": "/_auth/research-center/_research-center/$researchCenterId/_layout"
    },
    "/_auth/research-center/_research-center/$researchCenterId/_layout/edit": {
      "filePath": "_auth/research-center/_research-center/$researchCenterId/_layout/edit.tsx",
      "parent": "/_auth/research-center/_research-center/$researchCenterId/_layout"
    },
    "/_auth/travel/_travel/requests/$requestId": {
      "filePath": "_auth/travel/_travel/requests/$requestId",
      "parent": "/_auth/travel/_travel",
      "children": [
        "/_auth/travel/_travel/requests/$requestId/_layout"
      ]
    },
    "/_auth/travel/_travel/requests/$requestId/_layout": {
      "filePath": "_auth/travel/_travel/requests/$requestId/_layout.tsx",
      "parent": "/_auth/travel/_travel/requests/$requestId",
      "children": [
        "/_auth/travel/_travel/requests/$requestId/_layout/edit",
        "/_auth/travel/_travel/requests/$requestId/_layout/"
      ]
    },
    "/_auth/administration/_administration/department/_department/": {
      "filePath": "_auth/administration/_administration/department/_department/index.tsx",
      "parent": "/_auth/administration/_administration/department/_department"
    },
    "/_auth/administration/_administration/discipline/_discipline/": {
      "filePath": "_auth/administration/_administration/discipline/_discipline/index.tsx",
      "parent": "/_auth/administration/_administration/discipline/_discipline"
    },
    "/_auth/administration/_administration/faculty/_faculty/": {
      "filePath": "_auth/administration/_administration/faculty/_faculty/index.tsx",
      "parent": "/_auth/administration/_administration/faculty/_faculty"
    },
    "/_auth/administration/_administration/legal-holiday/_legal-holiday/": {
      "filePath": "_auth/administration/_administration/legal-holiday/_legal-holiday/index.tsx",
      "parent": "/_auth/administration/_administration/legal-holiday/_legal-holiday"
    },
    "/_auth/administration/_administration/local-accounts/_local-accounts/": {
      "filePath": "_auth/administration/_administration/local-accounts/_local-accounts/index.tsx",
      "parent": "/_auth/administration/_administration/local-accounts/_local-accounts"
    },
    "/_auth/administration/_administration/university-config/_university-config/": {
      "filePath": "_auth/administration/_administration/university-config/_university-config/index.tsx",
      "parent": "/_auth/administration/_administration/university-config/_university-config"
    },
    "/_auth/administration/_administration/user-documents/_user-documents/": {
      "filePath": "_auth/administration/_administration/user-documents/_user-documents/index.tsx",
      "parent": "/_auth/administration/_administration/user-documents/_user-documents"
    },
    "/_auth/author/_author/abstract/_abstract/": {
      "filePath": "_auth/author/_author/abstract/_abstract/index.tsx",
      "parent": "/_auth/author/_author/abstract/_abstract"
    },
    "/_auth/author/_author/article/_article/": {
      "filePath": "_auth/author/_author/article/_article/index.tsx",
      "parent": "/_auth/author/_author/article/_article"
    },
    "/_auth/author/_author/award/_award/": {
      "filePath": "_auth/author/_author/award/_award/index.tsx",
      "parent": "/_auth/author/_author/award/_award"
    },
    "/_auth/author/_author/book/_book/": {
      "filePath": "_auth/author/_author/book/_book/index.tsx",
      "parent": "/_auth/author/_author/book/_book"
    },
    "/_auth/author/_author/chapter/_chapter/": {
      "filePath": "_auth/author/_author/chapter/_chapter/index.tsx",
      "parent": "/_auth/author/_author/chapter/_chapter"
    },
    "/_auth/author/_author/committee/_committee/": {
      "filePath": "_auth/author/_author/committee/_committee/index.tsx",
      "parent": "/_auth/author/_author/committee/_committee"
    },
    "/_auth/author/_author/course/_course/": {
      "filePath": "_auth/author/_author/course/_course/index.tsx",
      "parent": "/_auth/author/_author/course/_course"
    },
    "/_auth/author/_author/dictionary/_dictionary/": {
      "filePath": "_auth/author/_author/dictionary/_dictionary/index.tsx",
      "parent": "/_auth/author/_author/dictionary/_dictionary"
    },
    "/_auth/author/_author/doctoral-committee/_doctoralCommittee/": {
      "filePath": "_auth/author/_author/doctoral-committee/_doctoralCommittee/index.tsx",
      "parent": "/_auth/author/_author/doctoral-committee/_doctoralCommittee"
    },
    "/_auth/author/_author/editorial-team/_editorialTeam/": {
      "filePath": "_auth/author/_author/editorial-team/_editorialTeam/index.tsx",
      "parent": "/_auth/author/_author/editorial-team/_editorialTeam"
    },
    "/_auth/author/_author/mobility/_mobility/": {
      "filePath": "_auth/author/_author/mobility/_mobility/index.tsx",
      "parent": "/_auth/author/_author/mobility/_mobility"
    },
    "/_auth/author/_author/patent/_patent/": {
      "filePath": "_auth/author/_author/patent/_patent/index.tsx",
      "parent": "/_auth/author/_author/patent/_patent"
    },
    "/_auth/author/_author/presentation/_presentation/": {
      "filePath": "_auth/author/_author/presentation/_presentation/index.tsx",
      "parent": "/_auth/author/_author/presentation/_presentation"
    },
    "/_auth/author/_author/proceeding/_proceeding/": {
      "filePath": "_auth/author/_author/proceeding/_proceeding/index.tsx",
      "parent": "/_auth/author/_author/proceeding/_proceeding"
    },
    "/_auth/author/_author/project/_project/": {
      "filePath": "_auth/author/_author/project/_project/index.tsx",
      "parent": "/_auth/author/_author/project/_project"
    },
    "/_auth/author/_author/review/_review/": {
      "filePath": "_auth/author/_author/review/_review/index.tsx",
      "parent": "/_auth/author/_author/review/_review"
    },
    "/_auth/author/_author/technological-transfer/_technologicalTransfer/": {
      "filePath": "_auth/author/_author/technological-transfer/_technologicalTransfer/index.tsx",
      "parent": "/_auth/author/_author/technological-transfer/_technologicalTransfer"
    },
    "/_auth/author/_author/translation/_translation/": {
      "filePath": "_auth/author/_author/translation/_translation/index.tsx",
      "parent": "/_auth/author/_author/translation/_translation"
    },
    "/_auth/conference/_conference/$conferenceId/_layout/": {
      "filePath": "_auth/conference/_conference/$conferenceId/_layout/index.tsx",
      "parent": "/_auth/conference/_conference/$conferenceId/_layout"
    },
    "/_auth/evaluation/_layout/$evaluationId/_layout/": {
      "filePath": "_auth/evaluation/_layout/$evaluationId/_layout/index.tsx",
      "parent": "/_auth/evaluation/_layout/$evaluationId/_layout"
    },
    "/_auth/gov-evaluation/_layout/$evaluationId/_layout/": {
      "filePath": "_auth/gov-evaluation/_layout/$evaluationId/_layout/index.tsx",
      "parent": "/_auth/gov-evaluation/_layout/$evaluationId/_layout"
    },
    "/_auth/journal/_journal/$journalId/_layout/": {
      "filePath": "_auth/journal/_journal/$journalId/_layout/index.tsx",
      "parent": "/_auth/journal/_journal/$journalId/_layout"
    },
    "/_auth/publisher/_publisher/$publisherId/_layout/": {
      "filePath": "_auth/publisher/_publisher/$publisherId/_layout/index.tsx",
      "parent": "/_auth/publisher/_publisher/$publisherId/_layout"
    },
    "/_auth/research-center/_research-center/$researchCenterId/_layout/": {
      "filePath": "_auth/research-center/_research-center/$researchCenterId/_layout/index.tsx",
      "parent": "/_auth/research-center/_research-center/$researchCenterId/_layout"
    },
    "/_auth/research-perf-eval/_layout/$evaluationId/_layout/": {
      "filePath": "_auth/research-perf-eval/_layout/$evaluationId/_layout/index.tsx",
      "parent": "/_auth/research-perf-eval/_layout/$evaluationId/_layout"
    },
    "/_auth/administration/_administration/department/_department/$departmentId": {
      "filePath": "_auth/administration/_administration/department/_department/$departmentId",
      "parent": "/_auth/administration/_administration/department/_department",
      "children": [
        "/_auth/administration/_administration/department/_department/$departmentId/_layout"
      ]
    },
    "/_auth/administration/_administration/department/_department/$departmentId/_layout": {
      "filePath": "_auth/administration/_administration/department/_department/$departmentId/_layout.tsx",
      "parent": "/_auth/administration/_administration/department/_department/$departmentId",
      "children": [
        "/_auth/administration/_administration/department/_department/$departmentId/_layout/edit",
        "/_auth/administration/_administration/department/_department/$departmentId/_layout/"
      ]
    },
    "/_auth/administration/_administration/discipline/_discipline/$disciplineId": {
      "filePath": "_auth/administration/_administration/discipline/_discipline/$disciplineId",
      "parent": "/_auth/administration/_administration/discipline/_discipline",
      "children": [
        "/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout"
      ]
    },
    "/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout": {
      "filePath": "_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout.tsx",
      "parent": "/_auth/administration/_administration/discipline/_discipline/$disciplineId",
      "children": [
        "/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout/edit",
        "/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout/"
      ]
    },
    "/_auth/administration/_administration/faculty/_faculty/$facultyId": {
      "filePath": "_auth/administration/_administration/faculty/_faculty/$facultyId",
      "parent": "/_auth/administration/_administration/faculty/_faculty",
      "children": [
        "/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout"
      ]
    },
    "/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout": {
      "filePath": "_auth/administration/_administration/faculty/_faculty/$facultyId/_layout.tsx",
      "parent": "/_auth/administration/_administration/faculty/_faculty/$facultyId",
      "children": [
        "/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout/edit",
        "/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout/"
      ]
    },
    "/_auth/author/_author/abstract/_abstract/$abstractId": {
      "filePath": "_auth/author/_author/abstract/_abstract/$abstractId",
      "parent": "/_auth/author/_author/abstract/_abstract",
      "children": [
        "/_auth/author/_author/abstract/_abstract/$abstractId/_layout"
      ]
    },
    "/_auth/author/_author/abstract/_abstract/$abstractId/_layout": {
      "filePath": "_auth/author/_author/abstract/_abstract/$abstractId/_layout.tsx",
      "parent": "/_auth/author/_author/abstract/_abstract/$abstractId",
      "children": [
        "/_auth/author/_author/abstract/_abstract/$abstractId/_layout/edit",
        "/_auth/author/_author/abstract/_abstract/$abstractId/_layout/",
        "/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/create",
        "/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/",
        "/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId"
      ]
    },
    "/_auth/author/_author/article/_article/$articleId": {
      "filePath": "_auth/author/_author/article/_article/$articleId",
      "parent": "/_auth/author/_author/article/_article",
      "children": [
        "/_auth/author/_author/article/_article/$articleId/_layout"
      ]
    },
    "/_auth/author/_author/article/_article/$articleId/_layout": {
      "filePath": "_auth/author/_author/article/_article/$articleId/_layout.tsx",
      "parent": "/_auth/author/_author/article/_article/$articleId",
      "children": [
        "/_auth/author/_author/article/_article/$articleId/_layout/edit",
        "/_auth/author/_author/article/_article/$articleId/_layout/",
        "/_auth/author/_author/article/_article/$articleId/_layout/citations/create",
        "/_auth/author/_author/article/_article/$articleId/_layout/citations/",
        "/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId"
      ]
    },
    "/_auth/author/_author/award/_award/$awardId": {
      "filePath": "_auth/author/_author/award/_award/$awardId",
      "parent": "/_auth/author/_author/award/_award",
      "children": [
        "/_auth/author/_author/award/_award/$awardId/_layout"
      ]
    },
    "/_auth/author/_author/award/_award/$awardId/_layout": {
      "filePath": "_auth/author/_author/award/_award/$awardId/_layout.tsx",
      "parent": "/_auth/author/_author/award/_award/$awardId",
      "children": [
        "/_auth/author/_author/award/_award/$awardId/_layout/edit",
        "/_auth/author/_author/award/_award/$awardId/_layout/"
      ]
    },
    "/_auth/author/_author/book/_book/$bookId": {
      "filePath": "_auth/author/_author/book/_book/$bookId",
      "parent": "/_auth/author/_author/book/_book",
      "children": [
        "/_auth/author/_author/book/_book/$bookId/_layout"
      ]
    },
    "/_auth/author/_author/book/_book/$bookId/_layout": {
      "filePath": "_auth/author/_author/book/_book/$bookId/_layout.tsx",
      "parent": "/_auth/author/_author/book/_book/$bookId",
      "children": [
        "/_auth/author/_author/book/_book/$bookId/_layout/edit",
        "/_auth/author/_author/book/_book/$bookId/_layout/",
        "/_auth/author/_author/book/_book/$bookId/_layout/citations/create",
        "/_auth/author/_author/book/_book/$bookId/_layout/citations/",
        "/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId"
      ]
    },
    "/_auth/author/_author/chapter/_chapter/$chapterId": {
      "filePath": "_auth/author/_author/chapter/_chapter/$chapterId",
      "parent": "/_auth/author/_author/chapter/_chapter",
      "children": [
        "/_auth/author/_author/chapter/_chapter/$chapterId/_layout"
      ]
    },
    "/_auth/author/_author/chapter/_chapter/$chapterId/_layout": {
      "filePath": "_auth/author/_author/chapter/_chapter/$chapterId/_layout.tsx",
      "parent": "/_auth/author/_author/chapter/_chapter/$chapterId",
      "children": [
        "/_auth/author/_author/chapter/_chapter/$chapterId/_layout/edit",
        "/_auth/author/_author/chapter/_chapter/$chapterId/_layout/",
        "/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/create",
        "/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/",
        "/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId"
      ]
    },
    "/_auth/author/_author/committee/_committee/$committeeId": {
      "filePath": "_auth/author/_author/committee/_committee/$committeeId",
      "parent": "/_auth/author/_author/committee/_committee",
      "children": [
        "/_auth/author/_author/committee/_committee/$committeeId/_layout"
      ]
    },
    "/_auth/author/_author/committee/_committee/$committeeId/_layout": {
      "filePath": "_auth/author/_author/committee/_committee/$committeeId/_layout.tsx",
      "parent": "/_auth/author/_author/committee/_committee/$committeeId",
      "children": [
        "/_auth/author/_author/committee/_committee/$committeeId/_layout/edit",
        "/_auth/author/_author/committee/_committee/$committeeId/_layout/"
      ]
    },
    "/_auth/author/_author/course/_course/$courseId": {
      "filePath": "_auth/author/_author/course/_course/$courseId",
      "parent": "/_auth/author/_author/course/_course",
      "children": [
        "/_auth/author/_author/course/_course/$courseId/_layout"
      ]
    },
    "/_auth/author/_author/course/_course/$courseId/_layout": {
      "filePath": "_auth/author/_author/course/_course/$courseId/_layout.tsx",
      "parent": "/_auth/author/_author/course/_course/$courseId",
      "children": [
        "/_auth/author/_author/course/_course/$courseId/_layout/edit",
        "/_auth/author/_author/course/_course/$courseId/_layout/"
      ]
    },
    "/_auth/author/_author/dictionary/_dictionary/$dictionaryId": {
      "filePath": "_auth/author/_author/dictionary/_dictionary/$dictionaryId",
      "parent": "/_auth/author/_author/dictionary/_dictionary",
      "children": [
        "/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout"
      ]
    },
    "/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout": {
      "filePath": "_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout.tsx",
      "parent": "/_auth/author/_author/dictionary/_dictionary/$dictionaryId",
      "children": [
        "/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout/edit",
        "/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout/"
      ]
    },
    "/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId": {
      "filePath": "_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId",
      "parent": "/_auth/author/_author/doctoral-committee/_doctoralCommittee",
      "children": [
        "/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout"
      ]
    },
    "/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout": {
      "filePath": "_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout.tsx",
      "parent": "/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId",
      "children": [
        "/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout/edit",
        "/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout/"
      ]
    },
    "/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId": {
      "filePath": "_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId",
      "parent": "/_auth/author/_author/editorial-team/_editorialTeam",
      "children": [
        "/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout"
      ]
    },
    "/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout": {
      "filePath": "_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout.tsx",
      "parent": "/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId",
      "children": [
        "/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout/edit",
        "/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout/"
      ]
    },
    "/_auth/author/_author/mobility/_mobility/$mobilityId": {
      "filePath": "_auth/author/_author/mobility/_mobility/$mobilityId",
      "parent": "/_auth/author/_author/mobility/_mobility",
      "children": [
        "/_auth/author/_author/mobility/_mobility/$mobilityId/_layout"
      ]
    },
    "/_auth/author/_author/mobility/_mobility/$mobilityId/_layout": {
      "filePath": "_auth/author/_author/mobility/_mobility/$mobilityId/_layout.tsx",
      "parent": "/_auth/author/_author/mobility/_mobility/$mobilityId",
      "children": [
        "/_auth/author/_author/mobility/_mobility/$mobilityId/_layout/edit",
        "/_auth/author/_author/mobility/_mobility/$mobilityId/_layout/"
      ]
    },
    "/_auth/author/_author/patent/_patent/$patentId": {
      "filePath": "_auth/author/_author/patent/_patent/$patentId",
      "parent": "/_auth/author/_author/patent/_patent",
      "children": [
        "/_auth/author/_author/patent/_patent/$patentId/_layout"
      ]
    },
    "/_auth/author/_author/patent/_patent/$patentId/_layout": {
      "filePath": "_auth/author/_author/patent/_patent/$patentId/_layout.tsx",
      "parent": "/_auth/author/_author/patent/_patent/$patentId",
      "children": [
        "/_auth/author/_author/patent/_patent/$patentId/_layout/edit",
        "/_auth/author/_author/patent/_patent/$patentId/_layout/"
      ]
    },
    "/_auth/author/_author/presentation/_presentation/$presentationId": {
      "filePath": "_auth/author/_author/presentation/_presentation/$presentationId",
      "parent": "/_auth/author/_author/presentation/_presentation",
      "children": [
        "/_auth/author/_author/presentation/_presentation/$presentationId/_layout"
      ]
    },
    "/_auth/author/_author/presentation/_presentation/$presentationId/_layout": {
      "filePath": "_auth/author/_author/presentation/_presentation/$presentationId/_layout.tsx",
      "parent": "/_auth/author/_author/presentation/_presentation/$presentationId",
      "children": [
        "/_auth/author/_author/presentation/_presentation/$presentationId/_layout/edit",
        "/_auth/author/_author/presentation/_presentation/$presentationId/_layout/"
      ]
    },
    "/_auth/author/_author/proceeding/_proceeding/$proceedingId": {
      "filePath": "_auth/author/_author/proceeding/_proceeding/$proceedingId",
      "parent": "/_auth/author/_author/proceeding/_proceeding",
      "children": [
        "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout"
      ]
    },
    "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout": {
      "filePath": "_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout.tsx",
      "parent": "/_auth/author/_author/proceeding/_proceeding/$proceedingId",
      "children": [
        "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/edit",
        "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/",
        "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/create",
        "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/",
        "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId"
      ]
    },
    "/_auth/author/_author/project/_project/$projectId": {
      "filePath": "_auth/author/_author/project/_project/$projectId",
      "parent": "/_auth/author/_author/project/_project",
      "children": [
        "/_auth/author/_author/project/_project/$projectId/_layout"
      ]
    },
    "/_auth/author/_author/project/_project/$projectId/_layout": {
      "filePath": "_auth/author/_author/project/_project/$projectId/_layout.tsx",
      "parent": "/_auth/author/_author/project/_project/$projectId",
      "children": [
        "/_auth/author/_author/project/_project/$projectId/_layout/edit",
        "/_auth/author/_author/project/_project/$projectId/_layout/"
      ]
    },
    "/_auth/author/_author/review/_review/$reviewId": {
      "filePath": "_auth/author/_author/review/_review/$reviewId",
      "parent": "/_auth/author/_author/review/_review",
      "children": [
        "/_auth/author/_author/review/_review/$reviewId/_layout"
      ]
    },
    "/_auth/author/_author/review/_review/$reviewId/_layout": {
      "filePath": "_auth/author/_author/review/_review/$reviewId/_layout.tsx",
      "parent": "/_auth/author/_author/review/_review/$reviewId",
      "children": [
        "/_auth/author/_author/review/_review/$reviewId/_layout/edit",
        "/_auth/author/_author/review/_review/$reviewId/_layout/"
      ]
    },
    "/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId": {
      "filePath": "_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId",
      "parent": "/_auth/author/_author/technological-transfer/_technologicalTransfer",
      "children": [
        "/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout"
      ]
    },
    "/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout": {
      "filePath": "_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout.tsx",
      "parent": "/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId",
      "children": [
        "/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout/edit",
        "/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout/"
      ]
    },
    "/_auth/author/_author/translation/_translation/$translationId": {
      "filePath": "_auth/author/_author/translation/_translation/$translationId",
      "parent": "/_auth/author/_author/translation/_translation",
      "children": [
        "/_auth/author/_author/translation/_translation/$translationId/_layout"
      ]
    },
    "/_auth/author/_author/translation/_translation/$translationId/_layout": {
      "filePath": "_auth/author/_author/translation/_translation/$translationId/_layout.tsx",
      "parent": "/_auth/author/_author/translation/_translation/$translationId",
      "children": [
        "/_auth/author/_author/translation/_translation/$translationId/_layout/edit",
        "/_auth/author/_author/translation/_translation/$translationId/_layout/",
        "/_auth/author/_author/translation/_translation/$translationId/_layout/citations/create",
        "/_auth/author/_author/translation/_translation/$translationId/_layout/citations/",
        "/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId"
      ]
    },
    "/_auth/research-center/_research-center/$researchCenterId/_layout/lab": {
      "filePath": "_auth/research-center/_research-center/$researchCenterId/_layout/lab",
      "parent": "/_auth/research-center/_research-center/$researchCenterId/_layout",
      "children": [
        "/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout"
      ]
    },
    "/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout": {
      "filePath": "_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout.tsx",
      "parent": "/_auth/research-center/_research-center/$researchCenterId/_layout/lab",
      "children": [
        "/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/",
        "/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId"
      ]
    },
    "/_auth/travel/_travel/requests/$requestId/_layout/edit": {
      "filePath": "_auth/travel/_travel/requests/$requestId/_layout/edit.tsx",
      "parent": "/_auth/travel/_travel/requests/$requestId/_layout"
    },
    "/_auth/minimal-standards/_layout/report/gather/_gather/": {
      "filePath": "_auth/minimal-standards/_layout/report/gather/_gather/index.tsx",
      "parent": "/_auth/minimal-standards/_layout/report/gather/_gather"
    },
    "/_auth/travel/_travel/requests/$requestId/_layout/": {
      "filePath": "_auth/travel/_travel/requests/$requestId/_layout/index.tsx",
      "parent": "/_auth/travel/_travel/requests/$requestId/_layout"
    },
    "/_auth/administration/_administration/department/_department/$departmentId/_layout/edit": {
      "filePath": "_auth/administration/_administration/department/_department/$departmentId/_layout/edit.tsx",
      "parent": "/_auth/administration/_administration/department/_department/$departmentId/_layout"
    },
    "/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout/edit": {
      "filePath": "_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout/edit.tsx",
      "parent": "/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout"
    },
    "/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout/edit": {
      "filePath": "_auth/administration/_administration/faculty/_faculty/$facultyId/_layout/edit.tsx",
      "parent": "/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout"
    },
    "/_auth/author/_author/abstract/_abstract/$abstractId/_layout/edit": {
      "filePath": "_auth/author/_author/abstract/_abstract/$abstractId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/abstract/_abstract/$abstractId/_layout"
    },
    "/_auth/author/_author/article/_article/$articleId/_layout/edit": {
      "filePath": "_auth/author/_author/article/_article/$articleId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/article/_article/$articleId/_layout"
    },
    "/_auth/author/_author/award/_award/$awardId/_layout/edit": {
      "filePath": "_auth/author/_author/award/_award/$awardId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/award/_award/$awardId/_layout"
    },
    "/_auth/author/_author/book/_book/$bookId/_layout/edit": {
      "filePath": "_auth/author/_author/book/_book/$bookId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/book/_book/$bookId/_layout"
    },
    "/_auth/author/_author/chapter/_chapter/$chapterId/_layout/edit": {
      "filePath": "_auth/author/_author/chapter/_chapter/$chapterId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/chapter/_chapter/$chapterId/_layout"
    },
    "/_auth/author/_author/committee/_committee/$committeeId/_layout/edit": {
      "filePath": "_auth/author/_author/committee/_committee/$committeeId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/committee/_committee/$committeeId/_layout"
    },
    "/_auth/author/_author/course/_course/$courseId/_layout/edit": {
      "filePath": "_auth/author/_author/course/_course/$courseId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/course/_course/$courseId/_layout"
    },
    "/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout/edit": {
      "filePath": "_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout"
    },
    "/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout/edit": {
      "filePath": "_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout"
    },
    "/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout/edit": {
      "filePath": "_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout"
    },
    "/_auth/author/_author/mobility/_mobility/$mobilityId/_layout/edit": {
      "filePath": "_auth/author/_author/mobility/_mobility/$mobilityId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/mobility/_mobility/$mobilityId/_layout"
    },
    "/_auth/author/_author/patent/_patent/$patentId/_layout/edit": {
      "filePath": "_auth/author/_author/patent/_patent/$patentId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/patent/_patent/$patentId/_layout"
    },
    "/_auth/author/_author/presentation/_presentation/$presentationId/_layout/edit": {
      "filePath": "_auth/author/_author/presentation/_presentation/$presentationId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/presentation/_presentation/$presentationId/_layout"
    },
    "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/edit": {
      "filePath": "_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout"
    },
    "/_auth/author/_author/project/_project/$projectId/_layout/edit": {
      "filePath": "_auth/author/_author/project/_project/$projectId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/project/_project/$projectId/_layout"
    },
    "/_auth/author/_author/review/_review/$reviewId/_layout/edit": {
      "filePath": "_auth/author/_author/review/_review/$reviewId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/review/_review/$reviewId/_layout"
    },
    "/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout/edit": {
      "filePath": "_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout"
    },
    "/_auth/author/_author/translation/_translation/$translationId/_layout/edit": {
      "filePath": "_auth/author/_author/translation/_translation/$translationId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/translation/_translation/$translationId/_layout"
    },
    "/_auth/evaluation/_layout/$evaluationId/_layout/report/gather": {
      "filePath": "_auth/evaluation/_layout/$evaluationId/_layout/report/gather",
      "parent": "/_auth/evaluation/_layout/$evaluationId/_layout",
      "children": [
        "/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather"
      ]
    },
    "/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather": {
      "filePath": "_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather.tsx",
      "parent": "/_auth/evaluation/_layout/$evaluationId/_layout/report/gather",
      "children": [
        "/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/",
        "/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo"
      ]
    },
    "/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode": {
      "filePath": "_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode",
      "parent": "/_auth/minimal-standards/_layout/report/gather/_gather",
      "children": [
        "/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode/_layout"
      ]
    },
    "/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode/_layout": {
      "filePath": "_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode/_layout.tsx",
      "parent": "/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode",
      "children": [
        "/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode/_layout/"
      ]
    },
    "/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather": {
      "filePath": "_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather",
      "parent": "/_auth/research-perf-eval/_layout/$evaluationId/_layout",
      "children": [
        "/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather"
      ]
    },
    "/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather": {
      "filePath": "_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather.tsx",
      "parent": "/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather",
      "children": [
        "/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/",
        "/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo"
      ]
    },
    "/_auth/administration/_administration/department/_department/$departmentId/_layout/": {
      "filePath": "_auth/administration/_administration/department/_department/$departmentId/_layout/index.tsx",
      "parent": "/_auth/administration/_administration/department/_department/$departmentId/_layout"
    },
    "/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout/": {
      "filePath": "_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout/index.tsx",
      "parent": "/_auth/administration/_administration/discipline/_discipline/$disciplineId/_layout"
    },
    "/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout/": {
      "filePath": "_auth/administration/_administration/faculty/_faculty/$facultyId/_layout/index.tsx",
      "parent": "/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout"
    },
    "/_auth/author/_author/abstract/_abstract/$abstractId/_layout/": {
      "filePath": "_auth/author/_author/abstract/_abstract/$abstractId/_layout/index.tsx",
      "parent": "/_auth/author/_author/abstract/_abstract/$abstractId/_layout"
    },
    "/_auth/author/_author/article/_article/$articleId/_layout/": {
      "filePath": "_auth/author/_author/article/_article/$articleId/_layout/index.tsx",
      "parent": "/_auth/author/_author/article/_article/$articleId/_layout"
    },
    "/_auth/author/_author/award/_award/$awardId/_layout/": {
      "filePath": "_auth/author/_author/award/_award/$awardId/_layout/index.tsx",
      "parent": "/_auth/author/_author/award/_award/$awardId/_layout"
    },
    "/_auth/author/_author/book/_book/$bookId/_layout/": {
      "filePath": "_auth/author/_author/book/_book/$bookId/_layout/index.tsx",
      "parent": "/_auth/author/_author/book/_book/$bookId/_layout"
    },
    "/_auth/author/_author/chapter/_chapter/$chapterId/_layout/": {
      "filePath": "_auth/author/_author/chapter/_chapter/$chapterId/_layout/index.tsx",
      "parent": "/_auth/author/_author/chapter/_chapter/$chapterId/_layout"
    },
    "/_auth/author/_author/committee/_committee/$committeeId/_layout/": {
      "filePath": "_auth/author/_author/committee/_committee/$committeeId/_layout/index.tsx",
      "parent": "/_auth/author/_author/committee/_committee/$committeeId/_layout"
    },
    "/_auth/author/_author/course/_course/$courseId/_layout/": {
      "filePath": "_auth/author/_author/course/_course/$courseId/_layout/index.tsx",
      "parent": "/_auth/author/_author/course/_course/$courseId/_layout"
    },
    "/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout/": {
      "filePath": "_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout/index.tsx",
      "parent": "/_auth/author/_author/dictionary/_dictionary/$dictionaryId/_layout"
    },
    "/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout/": {
      "filePath": "_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout/index.tsx",
      "parent": "/_auth/author/_author/doctoral-committee/_doctoralCommittee/$doctoralCommitteeId/_layout"
    },
    "/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout/": {
      "filePath": "_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout/index.tsx",
      "parent": "/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout"
    },
    "/_auth/author/_author/mobility/_mobility/$mobilityId/_layout/": {
      "filePath": "_auth/author/_author/mobility/_mobility/$mobilityId/_layout/index.tsx",
      "parent": "/_auth/author/_author/mobility/_mobility/$mobilityId/_layout"
    },
    "/_auth/author/_author/patent/_patent/$patentId/_layout/": {
      "filePath": "_auth/author/_author/patent/_patent/$patentId/_layout/index.tsx",
      "parent": "/_auth/author/_author/patent/_patent/$patentId/_layout"
    },
    "/_auth/author/_author/presentation/_presentation/$presentationId/_layout/": {
      "filePath": "_auth/author/_author/presentation/_presentation/$presentationId/_layout/index.tsx",
      "parent": "/_auth/author/_author/presentation/_presentation/$presentationId/_layout"
    },
    "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/": {
      "filePath": "_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/index.tsx",
      "parent": "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout"
    },
    "/_auth/author/_author/project/_project/$projectId/_layout/": {
      "filePath": "_auth/author/_author/project/_project/$projectId/_layout/index.tsx",
      "parent": "/_auth/author/_author/project/_project/$projectId/_layout"
    },
    "/_auth/author/_author/review/_review/$reviewId/_layout/": {
      "filePath": "_auth/author/_author/review/_review/$reviewId/_layout/index.tsx",
      "parent": "/_auth/author/_author/review/_review/$reviewId/_layout"
    },
    "/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout/": {
      "filePath": "_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout/index.tsx",
      "parent": "/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout"
    },
    "/_auth/author/_author/translation/_translation/$translationId/_layout/": {
      "filePath": "_auth/author/_author/translation/_translation/$translationId/_layout/index.tsx",
      "parent": "/_auth/author/_author/translation/_translation/$translationId/_layout"
    },
    "/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/": {
      "filePath": "_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/index.tsx",
      "parent": "/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout"
    },
    "/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/create": {
      "filePath": "_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/create.tsx",
      "parent": "/_auth/author/_author/abstract/_abstract/$abstractId/_layout"
    },
    "/_auth/author/_author/article/_article/$articleId/_layout/citations/create": {
      "filePath": "_auth/author/_author/article/_article/$articleId/_layout/citations/create.tsx",
      "parent": "/_auth/author/_author/article/_article/$articleId/_layout"
    },
    "/_auth/author/_author/book/_book/$bookId/_layout/citations/create": {
      "filePath": "_auth/author/_author/book/_book/$bookId/_layout/citations/create.tsx",
      "parent": "/_auth/author/_author/book/_book/$bookId/_layout"
    },
    "/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/create": {
      "filePath": "_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/create.tsx",
      "parent": "/_auth/author/_author/chapter/_chapter/$chapterId/_layout"
    },
    "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/create": {
      "filePath": "_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/create.tsx",
      "parent": "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout"
    },
    "/_auth/author/_author/translation/_translation/$translationId/_layout/citations/create": {
      "filePath": "_auth/author/_author/translation/_translation/$translationId/_layout/citations/create.tsx",
      "parent": "/_auth/author/_author/translation/_translation/$translationId/_layout"
    },
    "/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId": {
      "filePath": "_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId",
      "parent": "/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout",
      "children": [
        "/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout"
      ]
    },
    "/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout": {
      "filePath": "_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout.tsx",
      "parent": "/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId",
      "children": [
        "/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout/edit",
        "/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout/"
      ]
    },
    "/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/": {
      "filePath": "_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/index.tsx",
      "parent": "/_auth/author/_author/abstract/_abstract/$abstractId/_layout"
    },
    "/_auth/author/_author/article/_article/$articleId/_layout/citations/": {
      "filePath": "_auth/author/_author/article/_article/$articleId/_layout/citations/index.tsx",
      "parent": "/_auth/author/_author/article/_article/$articleId/_layout"
    },
    "/_auth/author/_author/book/_book/$bookId/_layout/citations/": {
      "filePath": "_auth/author/_author/book/_book/$bookId/_layout/citations/index.tsx",
      "parent": "/_auth/author/_author/book/_book/$bookId/_layout"
    },
    "/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/": {
      "filePath": "_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/index.tsx",
      "parent": "/_auth/author/_author/chapter/_chapter/$chapterId/_layout"
    },
    "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/": {
      "filePath": "_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/index.tsx",
      "parent": "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout"
    },
    "/_auth/author/_author/translation/_translation/$translationId/_layout/citations/": {
      "filePath": "_auth/author/_author/translation/_translation/$translationId/_layout/citations/index.tsx",
      "parent": "/_auth/author/_author/translation/_translation/$translationId/_layout"
    },
    "/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/": {
      "filePath": "_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/index.tsx",
      "parent": "/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather"
    },
    "/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode/_layout/": {
      "filePath": "_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode/_layout/index.tsx",
      "parent": "/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode/_layout"
    },
    "/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/": {
      "filePath": "_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/index.tsx",
      "parent": "/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather"
    },
    "/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId": {
      "filePath": "_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId",
      "parent": "/_auth/author/_author/abstract/_abstract/$abstractId/_layout",
      "children": [
        "/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout"
      ]
    },
    "/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout": {
      "filePath": "_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout.tsx",
      "parent": "/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId",
      "children": [
        "/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout/edit",
        "/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout/"
      ]
    },
    "/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId": {
      "filePath": "_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId",
      "parent": "/_auth/author/_author/article/_article/$articleId/_layout",
      "children": [
        "/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout"
      ]
    },
    "/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout": {
      "filePath": "_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout.tsx",
      "parent": "/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId",
      "children": [
        "/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout/edit",
        "/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout/"
      ]
    },
    "/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId": {
      "filePath": "_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId",
      "parent": "/_auth/author/_author/book/_book/$bookId/_layout",
      "children": [
        "/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout"
      ]
    },
    "/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout": {
      "filePath": "_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout.tsx",
      "parent": "/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId",
      "children": [
        "/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout/edit",
        "/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout/"
      ]
    },
    "/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId": {
      "filePath": "_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId",
      "parent": "/_auth/author/_author/chapter/_chapter/$chapterId/_layout",
      "children": [
        "/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout"
      ]
    },
    "/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout": {
      "filePath": "_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout.tsx",
      "parent": "/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId",
      "children": [
        "/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout/edit",
        "/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout/"
      ]
    },
    "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId": {
      "filePath": "_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId",
      "parent": "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout",
      "children": [
        "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout"
      ]
    },
    "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout": {
      "filePath": "_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout.tsx",
      "parent": "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId",
      "children": [
        "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout/edit",
        "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout/"
      ]
    },
    "/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId": {
      "filePath": "_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId",
      "parent": "/_auth/author/_author/translation/_translation/$translationId/_layout",
      "children": [
        "/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout"
      ]
    },
    "/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout": {
      "filePath": "_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout.tsx",
      "parent": "/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId",
      "children": [
        "/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout/edit",
        "/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout/"
      ]
    },
    "/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo": {
      "filePath": "_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo",
      "parent": "/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather",
      "children": [
        "/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout"
      ]
    },
    "/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout": {
      "filePath": "_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout.tsx",
      "parent": "/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo",
      "children": [
        "/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout/"
      ]
    },
    "/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout/edit": {
      "filePath": "_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout/edit.tsx",
      "parent": "/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout"
    },
    "/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo": {
      "filePath": "_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo",
      "parent": "/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather",
      "children": [
        "/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout"
      ]
    },
    "/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout": {
      "filePath": "_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout.tsx",
      "parent": "/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo",
      "children": [
        "/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout/"
      ]
    },
    "/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout/": {
      "filePath": "_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout/index.tsx",
      "parent": "/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout"
    },
    "/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout/edit": {
      "filePath": "_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout"
    },
    "/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout/edit": {
      "filePath": "_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout"
    },
    "/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout/edit": {
      "filePath": "_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout"
    },
    "/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout/edit": {
      "filePath": "_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout"
    },
    "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout/edit": {
      "filePath": "_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout"
    },
    "/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout/edit": {
      "filePath": "_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout/edit.tsx",
      "parent": "/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout"
    },
    "/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout/": {
      "filePath": "_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout/index.tsx",
      "parent": "/_auth/author/_author/abstract/_abstract/$abstractId/_layout/citations/$citationId/_layout"
    },
    "/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout/": {
      "filePath": "_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout/index.tsx",
      "parent": "/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout"
    },
    "/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout/": {
      "filePath": "_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout/index.tsx",
      "parent": "/_auth/author/_author/book/_book/$bookId/_layout/citations/$citationId/_layout"
    },
    "/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout/": {
      "filePath": "_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout/index.tsx",
      "parent": "/_auth/author/_author/chapter/_chapter/$chapterId/_layout/citations/$citationId/_layout"
    },
    "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout/": {
      "filePath": "_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout/index.tsx",
      "parent": "/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/citations/$citationId/_layout"
    },
    "/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout/": {
      "filePath": "_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout/index.tsx",
      "parent": "/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout"
    },
    "/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout/": {
      "filePath": "_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout/index.tsx",
      "parent": "/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout"
    },
    "/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout/": {
      "filePath": "_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout/index.tsx",
      "parent": "/_auth/research-perf-eval/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
